const STATES = {
  AK: {
    cities: {
      98791: [98791],
      Akhiok: [99615],
      Akiachak: [99551],
      Akiak: [99552],
      Akutan: [99553],
      Alakanuk: [99554],
      Aleknagik: [99555],
      Allakaket: [99720],
      Ambler: [99786],
      'Anaktuvuk Pass': [99721],
      Anchorage: [
        99501, 99502, 99503, 99504, 99507, 99508, 99515, 99516, 99517, 99518,
      ],
      Anderson: [99744],
      Angoon: [99820],
      Anvik: [99558],
      'Arctic Village': [99722],
      Atmautluak: [99559],
      Barrow: [99723],
      Beaver: [99724],
      'Bettles Field': [99726],
      Border: [99780],
      'Brevig Mission': [99785],
      Buckland: [99727],
      Butte: [99645],
      Cantwell: [99729],
      Central: [99730],
      Chalkyitsik: [99788],
      Chefornak: [99561],
      'Chenega Bay': [99574],
      Chevak: [99563],
      Chignik: [99564],
      'Chignik Lagoon': [99565],
      Chuathbaluk: [99557],
      Chugiak: [99567],
      Circle: [99733],
      'Clam Gulch': [99568],
      'Clarks Point': [99569],
      Clear: [99704],
      Coldfoot: [99701],
      'Cooper Landing': [99572],
      'Copper Center': [99573],
      Craig: [99921],
      'Crooked Creek': [99575],
      Deering: [99736],
      'Denali National': [99755],
      'Dot Lake': [99737],
      Douglas: [99824],
      'Dutch Harbor': [99692],
      'Eagle River': [99577],
      Eek: [99578],
      Egegik: [99579],
      'Eielson Afb': [99702],
      Ekwok: [99580],
      Elim: [99739],
      'Elmendorf Afb': [99506],
      Emmonak: [99581],
      Fairbanks: [99709, 99712],
      'False Pass': [99583],
      'Fort Richardson': [99505],
      'Fort Wainwright': [99703],
      'Fort Yukon': [99740],
      Galena: [99741],
      Gambell: [99742],
      Glennallen: [99588],
      Golovin: [99762],
      'Goodnews Bay': [99589],
      Grayling: [99590],
      Gustavus: [99826],
      Haines: [99827],
      Healy: [99743],
      'Holy Cross': [99602],
      Hoonah: [99829],
      'Hooper Bay': [99604],
      Hughes: [99745],
      Huslia: [99746],
      Hydaburg: [99922],
      Hyder: [99923],
      Igiugig: [99613],
      Juneau: [99801],
      Kaktovik: [99747],
      Kalskag: [99607],
      Kaltag: [99748],
      Kasilof: [99610],
      Kenai: [99611],
      Ketchikan: [99901, 99950],
      Kiana: [99749],
      'King Cove': [99612],
      Kipnuk: [99614],
      Kivalina: [99750],
      Klawock: [99925],
      Kobuk: [99751],
      Kokhanok: [99606],
      Koliganek: [99576],
      Kotlik: [99620],
      Kotzebue: [99752],
      Koyuk: [99753],
      Kwethluk: [99621],
      Kwigillingok: [99622],
      'Lake Minchumina': [99757],
      Levelock: [99625],
      'Lower Kalskag': [99626],
      'Manley Hot Sprin': [99756],
      Manokotak: [99628],
      Marshall: [99585],
      'Mc Grath': [99627],
      Mekoryuk: [99630],
      Metlakatla: [99926],
      Minto: [99758],
      'Moose Pass': [99631],
      'Mountain Village': [99632],
      Naknek: [99633],
      Napakiak: [99634],
      'Nelson Lagoon': [99571],
      Nenana: [99760],
      'New Stuyahok': [99636],
      Nikolaevsk: [99556],
      Nikolai: [99691],
      Nikolski: [99638],
      Ninilchik: [99639],
      Noatak: [99761],
      Nondalton: [99640],
      Noorvik: [99763],
      'North Pole': [99705],
      Nuiqsut: [99789],
      Nulato: [99765],
      'Pedro Bay': [99647],
      Perryville: [99648],
      Petersburg: [99833],
      'Pilot Point': [99649],
      'Pilot Station': [99650],
      Platinum: [99651],
      'Point Baker': [99927],
      'Point Hope': [99766],
      'Point Lay': [99759],
      'Port Alsworth': [99653],
      'Port Graham': [99603],
      'Port Heiden': [99549],
      'Prudhoe Bay': [99734],
      Quinhagak: [99655],
      Rampart: [99767],
      'Red Devil': [99656],
      Ruby: [99768],
      'Russian Mission': [99657],
      'Saint George Isl': [99591],
      'Saint Marys': [99658],
      'Saint Michael': [99659],
      'Saint Paul Islan': [99660],
      Salcha: [99714],
      'Sand Point': [99661],
      Savoonga: [99769],
      'Scammon Bay': [99662],
      Selawik: [99770],
      Seward: [99664],
      Shageluk: [99665],
      Shaktoolik: [99771],
      Shishmaref: [99772],
      Shungnak: [99773],
      Sitka: [99835],
      Skagway: [99840],
      Slana: [99586],
      Sleetmute: [99668],
      Soldotna: [99669],
      'South Naknek': [99670],
      Stebbins: [99671],
      Sterling: [99672],
      'Stevens Village': [99774],
      Talkeetna: [99676],
      Tanana: [99777],
      Teller: [99778],
      'Thorne Bay': [99919],
      'Trapper Creek': [99683],
      Tuluksak: [99679],
      Tununak: [99681],
      Tyonek: [99682],
      Unalakleet: [99684],
      Unalaska: [99685],
      Valdez: [99686],
      Venetie: [99781],
      Wainwright: [99782],
      Wales: [99783],
      Wasilla: [99654, 99687],
      'White Mountain': [99784],
      Willow: [99688],
      Wrangell: [99929],
      Yakutat: [99689],
    },
    name: 'Alaska',
  },
  AL: {
    cities: {
      Abbeville: [36310],
      Acmar: [35004],
      Adamsville: [35005],
      Addison: [35540],
      Adger: [35006],
      Alberta: [36720],
      Albertville: [35950],
      Alden: [35073],
      Alexandria: [36250],
      Aliceville: [35442],
      Allen: [36419],
      Alpine: [35014],
      Andalusia: [36420],
      Anderson: [35610],
      Anniston: [36201, 36206],
      Arab: [35016],
      Ardmore: [35739],
      Ariton: [36311],
      Arley: [35541],
      Arlington: [36722],
      Ashford: [36312],
      Ashland: [36251],
      Ashville: [35953],
      Athens: [35611],
      Atmore: [36502],
      Attalla: [35954],
      Auburn: [36830],
      Autaugaville: [36003],
      Axis: [36505],
      Baileyton: [35019],
      Banks: [36005],
      Bankston: [35542],
      'Bay Minette': [36507],
      'Bayou La Batre': [36509],
      'Bear Creek': [35543],
      Beatrice: [36425],
      Beaverton: [35544],
      Benton: [36785],
      Berry: [35546],
      Bessemer: [35020],
      'Big Cove': [35763],
      Bigbee: [36510],
      Billingsley: [36006],
      Birmingham: [
        35203, 35204, 35205, 35206, 35207, 35208, 35211, 35212, 35214, 35217,
        35218, 35221, 35222, 35224, 35233, 35234,
      ],
      Black: [36314],
      Blountsville: [35031],
      'Bluff Park': [35226],
      Boaz: [35957],
      Boligee: [35443],
      'Bon Secour': [36511],
      'Boys Ranch': [36761],
      Brantley: [36009],
      Bremen: [35033],
      Brent: [35034],
      Bridgeport: [35740],
      Brierfield: [35035],
      Brilliant: [35548],
      'Brookley Field': [36615],
      Brookwood: [35444],
      Brownsboro: [35741],
      Brundidge: [36010],
      Bryant: [35958],
      Buhl: [35446],
      Burkville: [36752],
      Butler: [36904],
      'Cahaba Heights': [35243],
      Calera: [35040],
      Camden: [36726],
      'Camp Hill': [36850],
      Campbell: [36727],
      'Carbon Hill': [35549],
      Carlton: [36515],
      Carrollton: [35447],
      Castleberry: [36432],
      Catherine: [36728],
      Cecil: [36013],
      'Cedar Bluff': [35959],
      'Center Point': [35215, 35235],
      Centre: [35960],
      Centreville: [35042],
      Chancellor: [36316],
      Chatom: [36518],
      Chelsea: [35043],
      Cherokee: [35616],
      Chickasaw: [36611],
      Chunchula: [36521],
      Citronelle: [36522],
      Clanton: [35045],
      Clayton: [36016],
      Cleveland: [35049],
      Clio: [36017],
      Clopton: [36317],
      Coalburg: [35068],
      Coatopa: [35470],
      Coden: [36523],
      'Coffee Springs': [36318],
      Coffeeville: [36524],
      Coker: [35452],
      Collinsville: [35961],
      Columbia: [36319],
      Columbiana: [35051],
      'Coosa Pines': [35044],
      Cordova: [35550],
      Cottondale: [35453],
      Cottonwood: [36320],
      Courtland: [35618],
      Coy: [36435],
      Cragford: [36255],
      'Crane Hill': [35053],
      Creola: [36525],
      'Crestline Height': [35213],
      Cropwell: [35054],
      Crossville: [35962],
      Cuba: [36907],
      Cullman: [35055],
      Cusseta: [36852],
      Cypress: [35474],
      Dadeville: [36853],
      Daleville: [36322],
      Danville: [35619],
      Daphne: [36526],
      'Dauphin Island': [36528],
      Daviston: [36256],
      Dawson: [35963],
      Deatsville: [36022],
      Decatur: [35601, 35603],
      'Deer Park': [36529],
      Delta: [36258],
      Demopolis: [36732],
      Detroit: [35552],
      Dickinson: [36436],
      Dixiana: [35126],
      'Dixons Mills': [36736],
      Dolomite: [35061],
      Dora: [35062],
      'Double Springs': [35553],
      Dozier: [36028],
      Duncanville: [35456],
      Dutton: [35744],
      'East Brewton': [36426],
      Eastaboga: [36260],
      Echola: [35457],
      Eclectic: [36024],
      'Eight Mile': [36613],
      Elba: [36323],
      Elberta: [36530],
      Eldridge: [35554],
      Elkmont: [35620],
      Elmore: [36025],
      Elrod: [35458],
      Emelle: [35459],
      Empire: [35063],
      Enterprise: [36330],
      Epes: [35460],
      Equality: [36026],
      Estillfork: [35745],
      Ethelsville: [35461],
      Eufaula: [36004, 36027],
      Eutaw: [35462],
      Eva: [35621],
      Evergreen: [36401],
      Fackler: [35746],
      Fairfield: [35064],
      Fairhope: [36532],
      Falkville: [35622],
      Faunsdale: [36738],
      Fayette: [35555],
      Fitzpatrick: [36029],
      'Five Points': [36855],
      'Flat Rock': [35966],
      Flomaton: [36441],
      Florala: [36442],
      Florence: [35630, 35633],
      Foley: [36535],
      'Forest Home': [36030],
      Forkland: [36740],
      'Fort Davis': [36031],
      'Fort Deposit': [36032],
      'Fort Mc Clellan': [36205],
      'Fort Morgan': [36542],
      'Fort Payne': [35967],
      'Fort Rucker': [36362],
      Fosters: [35463],
      Franklin: [36444],
      Frankville: [36538],
      'Frisco City': [36445],
      Fruitdale: [36539],
      Fruithurst: [36262],
      Fulton: [36446],
      Fyffe: [35971],
      Gadsden: [35904],
      Gainestown: [36540],
      Gainesville: [35464],
      Gallant: [35972],
      Gallion: [36742],
      Gantt: [36038],
      Gardendale: [35071],
      Gaylesville: [35973],
      Geneva: [36340],
      Georgiana: [36033],
      Geraldine: [35974],
      Gilbertown: [36908],
      Glencoe: [35905],
      Glenwood: [36034],
      Goodwater: [35072],
      Gordo: [35466],
      Gordon: [36343],
      Goshen: [36035],
      Grady: [36036],
      Graham: [36263],
      'Grand Bay': [36541],
      Grant: [35747],
      Greensboro: [36744],
      Greenville: [36037],
      'Grove Hill': [36451],
      Groveoak: [35975],
      Guin: [35563],
      'Gunter Afs': [36115],
      Guntersville: [35976],
      Gurley: [35748],
      Hackleburg: [35564],
      Haleyville: [35565],
      Hamilton: [35570],
      Hanceville: [35077],
      Hardaway: [36039],
      Harpersville: [35078],
      Hartford: [36344],
      Hartselle: [35640],
      Harvest: [35749],
      Hatchechubbee: [36858],
      Hayden: [35079],
      Hayneville: [36040],
      'Hazel Green': [35750],
      Headland: [36345],
      Heflin: [36264],
      Helena: [35080],
      Henagar: [35978],
      Higdon: [35979],
      'Highland Home': [36041],
      Hillsboro: [35643],
      Hodges: [35571],
      'Hokes Bluff': [35903],
      'Holly Pond': [35083],
      Hollytree: [35751],
      Hollywood: [35752],
      Holt: [35404],
      Homewood: [35209],
      Honoraville: [36042],
      Hoover: [35244],
      'Hope Hull': [36043],
      Horton: [35980],
      Houston: [35572],
      Hueytown: [35023],
      Huntsville: [
        35801, 35802, 35803, 35805, 35806, 35808, 35810, 35811, 35816, 35824,
      ],
      Hurtsboro: [36860],
      Hytop: [35768],
      Ider: [35981],
      'Indian Springs': [35124],
      Irondale: [35210],
      Irvington: [36544],
      Jachin: [36910],
      Jack: [36346],
      Jackson: [36545],
      'Jacksons Gap': [36861],
      Jacksonville: [36265],
      Jasper: [35501],
      Jemison: [35085],
      Jones: [36749],
      Joppa: [35087],
      Kellyton: [35089],
      Kennedy: [35574],
      Keystone: [35007],
      Killen: [35645],
      Kimberly: [35091],
      Kinston: [36453],
      Knoxville: [35469],
      'Laceys Spring': [35754],
      Lafayette: [36862],
      Lanett: [36863],
      Langston: [35755],
      Lapine: [36046],
      Lawley: [36793],
      Leeds: [35094],
      Leesburg: [35983],
      Leighton: [35646],
      Lenox: [36454],
      Leroy: [36548],
      Lester: [35647],
      Letohatchee: [36047],
      Lexington: [35648],
      Lillian: [36549],
      Lincoln: [35096],
      Linden: [36748],
      Lineville: [36266],
      Lisman: [36912],
      'Little River': [36550],
      Logan: [35098],
      Louisville: [36048],
      'Lower Peach Tree': [36751],
      Loxley: [36551],
      Luverne: [36049],
      Lynn: [35575],
      Magnolia: [36754],
      'Magnolia Springs': [36555],
      Malvern: [36349],
      Maplesville: [36750],
      Marbury: [36051],
      Marion: [36756],
      'Marion Junction': [36759],
      Mathews: [36052],
      'Maxwell A F B': [36113],
      Maylene: [35114],
      'Mc Calla': [35111],
      'Mc Intosh': [36553],
      'Mc Kenzie': [36456],
      Mentone: [35984],
      Meridianville: [35759],
      Midfield: [35228],
      'Midland City': [36350],
      Midway: [36053],
      Millbrook: [36054],
      Millerville: [36267],
      Millport: [35576],
      Millry: [36558],
      Mobile: [
        36602, 36603, 36604, 36605, 36606, 36607, 36608, 36609, 36612, 36617,
        36618, 36619, 36693, 36695,
      ],
      Monroeville: [36460],
      Montevallo: [35115],
      Montgomery: [
        36104, 36105, 36106, 36107, 36108, 36109, 36110, 36111, 36116, 36117,
      ],
      Morris: [35116],
      Morvin: [36762],
      Moulton: [35650],
      'Mount Hope': [35651],
      'Mount Olive': [35117],
      'Mount Vernon': [36560],
      'Mountain Brook': [35223],
      Munford: [36268],
      Muscadine: [36269],
      'Muscle Shoals': [35661],
      'Napier Field': [36303],
      Nauvoo: [35578],
      Needham: [36915],
      'New Brockton': [36351],
      'New Hope': [35760],
      'New Market': [35761],
      'New Site': [35010],
      Newbern: [36765],
      Newell: [36270],
      Newton: [36352],
      Newville: [36353],
      Northport: [35476],
      Notasulga: [36866],
      Oakman: [35579],
      Odenville: [35120],
      Ohatchee: [36271],
      Oneonta: [35121],
      Opelika: [36801],
      Opp: [36467],
      'Orange Beach': [36561],
      Orrville: [36767],
      Oxford: [36203],
      Ozark: [36360],
      'Paint Rock': [35764],
      Pansey: [36370],
      Parrish: [35580],
      'Pell City': [35125],
      Pennington: [36916],
      Perdido: [36562],
      Perote: [36061],
      Peterman: [36471],
      'Phenix City': [36867, 36869],
      'Phil Campbell': [35581],
      Piedmont: [36272],
      'Pike Road': [36064],
      'Pine Apple': [36768],
      'Pine Hill': [36769],
      Pisgah: [35765],
      Pittsview: [36871],
      Plantersville: [36758],
      'Pleasant Grove': [35127],
      Prairie: [36771],
      Prattville: [36066, 36067],
      Prichard: [36610],
      Princeton: [35766],
      Quinton: [35130],
      Ragland: [35131],
      Rainsville: [35986],
      Ralph: [35480],
      Ramer: [36069],
      Ranburne: [36273],
      Randolph: [36792],
      Range: [36473],
      'Red Bay': [35582],
      'Red Level': [36474],
      Reform: [35481],
      Remlap: [35133],
      Repton: [36475],
      Riverside: [35135],
      Robertsdale: [36567],
      'Rock Mills': [36274],
      Rockford: [35136],
      Rogersville: [35652],
      Russellville: [35653],
      Rutledge: [36071],
      Safford: [36773],
      'Saint Stephens': [36569],
      Salem: [36874],
      Salitpa: [36570],
      Samson: [36477],
      Saraland: [36571],
      Sardis: [36775],
      Satsuma: [36572],
      Sawyerville: [36776],
      Seale: [36875],
      Section: [35771],
      Selma: [36701, 36703],
      Seminole: [36574],
      Semmes: [36575],
      Sheffield: [35660],
      Shelby: [35143],
      'Shoal Creek': [35242],
      Shorter: [36075],
      Shorterville: [36373],
      Silas: [36919],
      Silverhill: [36576],
      Skipperville: [36374],
      Slocomb: [36375],
      Smiths: [36877],
      Snead: [35952],
      Somerville: [35670],
      Southside: [35901],
      'Spanish Fort': [36527],
      Springville: [35146],
      Sprott: [36779],
      'Spruce Pine': [35585],
      Stanton: [36790],
      Steele: [35987],
      Sterrett: [35147],
      Stevenson: [35772],
      Stewart: [35441],
      Stockton: [36579],
      Sulligent: [35586],
      Sumiton: [35148],
      Summerdale: [36580],
      'Sweet Water': [36782],
      Sylacauga: [35150],
      'Sylvan Springs': [35118],
      Sylvania: [35988],
      Talladega: [35160],
      Tallassee: [36078],
      Tanner: [35671],
      Taylor: [36301],
      Theodore: [36582],
      Thomaston: [36783],
      Thomasville: [36784],
      Thorsby: [35171],
      Tibbie: [36583],
      Titus: [36080],
      Toney: [35773],
      'Town Creek': [35672],
      Townley: [35587],
      Toxey: [36921],
      Trafford: [35172],
      Trenton: [35774],
      Triana: [35758],
      Trinity: [35673],
      Troy: [36081],
      Trussville: [35173],
      Tuscaloosa: [35401, 35405, 35406],
      Tuscumbia: [35674],
      Tuskegee: [36083],
      'Tuskegee Institu': [36088],
      'Union Grove': [35175],
      'Union Springs': [36089],
      Uniontown: [36786],
      Uriah: [36480],
      'Valhermoso Sprin': [35775],
      Valley: [36854],
      'Valley Head': [35989],
      Vance: [35490],
      Vandiver: [35176],
      Verbena: [36091],
      Vernon: [35592],
      'Vestavia Hills': [35216],
      Vina: [35593],
      Vincent: [35178],
      'Vinegar Bend': [36584],
      Vinemont: [35179],
      Vredenburgh: [36481],
      Wadley: [36276],
      Wagarville: [36585],
      'Walker Springs': [36586],
      Ward: [36922],
      Warrior: [35180],
      Waterloo: [35677],
      Waverly: [36879],
      Weaver: [36277],
      Webb: [36376],
      Wedowee: [36278],
      Wellington: [36279],
      Weogufka: [35183],
      'West Blocton': [35184],
      Wetumpka: [36092],
      Whatley: [36482],
      Wilmer: [36587],
      Wilsonville: [35186],
      Winfield: [35594],
      Wing: [36483],
      Woodland: [36280],
      Woodstock: [35188],
      Woodville: [35776],
      York: [36925],
    },
    name: 'Alabama',
  },
  AR: {
    cities: {
      Adona: [72001],
      Agnos: [72513],
      Alco: [72610],
      Alexander: [72002],
      Alicia: [72410],
      Alix: [72820],
      Alma: [72921],
      Almyra: [72003],
      Alpena: [72611],
      Altheimer: [72004],
      Altus: [72821],
      Amagon: [72005],
      Amity: [71921],
      Antoine: [71922],
      Arkadelphia: [71923],
      'Arkansas City': [71630],
      Armorel: [72310],
      Ashdown: [71822],
      Atkins: [72823],
      Aubrey: [72311],
      Augusta: [72006],
      Austin: [72007],
      'Bald Knob': [72010],
      Banks: [71631],
      Barling: [72923],
      Bass: [72612],
      Bassett: [72313],
      Bates: [72924],
      Batesville: [72501],
      Bauxite: [72011],
      Bay: [72411],
      Bearden: [71720],
      'Bee Branch': [72013],
      Beebe: [72012],
      'Beech Grove': [72412],
      Beedeville: [72014],
      'Bella Vista': [72714],
      Belleville: [72824],
      Benton: [72015],
      Bentonville: [72712],
      Berryville: [72616],
      'Bethel Heights': [72764],
      Bexar: [72515],
      'Big Flat': [72617],
      Bigelow: [72016],
      Biggers: [72413],
      Birdeye: [72314],
      Biscoe: [72017],
      Bismarck: [71929],
      'Black Oak': [72414],
      'Black Rock': [72415],
      Blakely: [71931],
      Blevins: [71825],
      'Blue Mountain': [72826],
      'Bluff City': [71722],
      Bluffton: [72827],
      'Blytheville A F': [72315],
      Boles: [72926],
      Bonnerdale: [71933],
      Bono: [72416],
      Booneville: [72927],
      Boswell: [72516],
      Bradford: [72020],
      Bradley: [71826],
      Branch: [72928],
      Brickeys: [72320],
      Briggsville: [72828],
      Brinkley: [72021],
      Brockwell: [72517],
      Brookland: [72417],
      Bruno: [72618],
      Bryant: [72022],
      Buckner: [71827],
      Buckville: [71956],
      'Bull Shoals': [72619],
      Burdette: [72321],
      Byron: [72576],
      Cabot: [72023],
      'Caddo Gap': [71935],
      Calamine: [72469],
      Cale: [71828],
      Camp: [72520],
      'Camp Joseph T Ro': [72118],
      Canehill: [72717],
      Caraway: [72419],
      Carlisle: [72024],
      Carthage: [71725],
      Casa: [72025],
      Cash: [72421],
      Casscoe: [72026],
      'Cave City': [72521],
      'Cave Springs': [72718],
      Cecil: [72930],
      Cedarville: [72932],
      'Center Ridge': [72027],
      Centerton: [72719],
      'Central City': [72941],
      Charleston: [72933],
      Charlotte: [72522],
      'Cherokee Village': [72529],
      'Cherry Valley': [72324],
      Chester: [72934],
      Choctaw: [72028],
      Clarendon: [72029],
      Clarkridge: [72623],
      Clarksville: [72830],
      Cleveland: [72030],
      Clinton: [72031],
      'Coal Hill': [72832],
      'College City': [72476],
      Colt: [72326],
      Columbus: [71831],
      Combs: [72721],
      Compton: [72624],
      Concord: [72523],
      Conway: [72032],
      Cord: [72524],
      Corning: [72422],
      Cotter: [72626],
      'Cotton Plant': [72036],
      Cove: [71937],
      Crawfordsville: [72327],
      'Crocketts Bluff': [72038],
      Crumrod: [72328],
      Cushman: [72526],
      Danville: [72833],
      Dardanelle: [72834],
      Datto: [72424],
      'De Queen': [71832],
      'De Valls Bluff': [72041],
      'De Witt': [72042],
      Decatur: [72722],
      Deer: [72628],
      Delaplaine: [72425],
      Delaware: [72835],
      Delight: [71940],
      Dell: [72426],
      Dennard: [72629],
      Dermott: [71638],
      'Des Arc': [72040],
      Desha: [72527],
      Dierks: [71833],
      Doddridge: [71834],
      Dogpatch: [72648],
      Dollarway: [71602],
      Dolph: [72528],
      Donaldson: [71941],
      Dover: [72837],
      Drasco: [72530],
      Driver: [72329],
      Dumas: [71639],
      Dyess: [72330],
      Earle: [72331],
      'East Camden': [71701],
      Edgemont: [72044],
      Edmondson: [72332],
      'El Dorado': [71730],
      'El Paso': [72045],
      Elaine: [72333],
      Elizabeth: [72531],
      Elkins: [72727],
      Emerson: [71740],
      Emmet: [71835],
      England: [72046],
      Enola: [72047],
      Ethel: [72048],
      Etowah: [72428],
      Eudora: [71640],
      'Eureka Springs': [72632],
      Evansville: [72729],
      'Evening Shade': [72532],
      Everton: [72633],
      'Fair Oaks': [72397],
      Farmington: [72730],
      Fayetteville: [72701, 72703],
      Ferndale: [72208],
      'Fifty Six': [72533],
      Fisher: [72429],
      Flippin: [72634],
      Floral: [72534],
      Fordyce: [71742],
      Foreman: [71836],
      'Forrest City': [72335],
      'Fort Chaffee': [72905],
      'Fort Smith': [72901, 72903, 72904, 72916],
      Fouke: [71837],
      'Fountain Hill': [71642],
      Fox: [72051],
      Franklin: [72536],
      'Frenchmans Bayou': [72338],
      Friendship: [71942],
      Fulton: [71838],
      Gamaliel: [72537],
      Garfield: [72732],
      'Garland City': [71839],
      Garner: [72052],
      Gassville: [72635],
      Gateway: [72733],
      Gentry: [72734],
      Georgetown: [72143],
      Gepp: [72538],
      Gillett: [72055],
      Gillham: [71841],
      Gilmore: [72339],
      Glencoe: [72539],
      Glenwood: [71943],
      Goodwin: [72340],
      Goshen: [72735],
      Gould: [71643],
      Grannis: [71944],
      Grapevine: [72057],
      'Gravel Ridge': [72076],
      Gravelly: [72838],
      Gravette: [72736],
      'Green Forest': [72638],
      Greenbrier: [72058],
      Greenway: [72430],
      Greenwood: [72936],
      'Greers Ferry': [72067],
      Griffithville: [72060],
      Guion: [72540],
      Gurdon: [71743],
      Guy: [72061],
      Hackett: [72937],
      Hagarville: [72839],
      Hamburg: [71646],
      Hampton: [71744],
      Hanover: [72560],
      Hardy: [72542],
      Harrell: [71745],
      Harriet: [72639],
      Harrisburg: [72432],
      Harrison: [72601],
      Hartford: [72938],
      Hartman: [72840],
      Harvey: [72841],
      Hasty: [72640],
      Hatfield: [71945],
      Hattieville: [72063],
      Haynes: [72341],
      Hazen: [72064],
      'Heber Springs': [72543],
      Hector: [72843],
      Helena: [72342],
      Henderson: [72544],
      Hensley: [72065],
      Heth: [72346],
      'Hickory Plains': [72066],
      'Hickory Ridge': [72347],
      Higginson: [72068],
      Hindsville: [72738],
      Hiwasse: [72739],
      'Holly Grove': [72069],
      Horatio: [71842],
      'Horseshoe Bend': [72512],
      'Hot Springs Vill': [71909],
      Houston: [72070],
      Hoxie: [72433],
      Hughes: [72348],
      Humnoke: [72072],
      Humphrey: [72073],
      Huntington: [72940],
      Huntsville: [72740],
      Huttig: [71747],
      Ida: [72546],
      Imboden: [72434],
      Ingalls: [71647],
      Ivan: [71748],
      Jasper: [72641],
      Jefferson: [72079],
      Jersey: [71651],
      Jerusalem: [72080],
      Jessieville: [71949],
      Joiner: [72350],
      'Jones Mills': [72105],
      Jonesboro: [72401],
      Jordan: [72519],
      Judsonia: [72081],
      'Junction City': [71749],
      Keiser: [72351],
      Kensett: [72082],
      Keo: [72083],
      Kingsland: [71652],
      Kingston: [72742],
      Kirby: [71950],
      Knobel: [72435],
      Knoxville: [72845],
      Lafe: [72436],
      'Lake Catherine': [71901],
      'Lake City': [72437],
      'Lake Hamilton': [71913],
      'Lake Village': [71653],
      Lakeview: [72642],
      Lamar: [72846],
      Langley: [71952],
      Leachville: [72438],
      'Lead Hill': [72644],
      Leola: [72084],
      Lepanto: [72354],
      Leslie: [72645],
      Lewisville: [71845],
      Lexa: [72355],
      Lincoln: [72744],
      'Little Rock': [
        72201, 72202, 72204, 72205, 72206, 72207, 72209, 72210, 72211, 72212,
      ],
      Lockesburg: [71846],
      'Locust Grove': [72550],
      London: [72847],
      Lonoke: [72086],
      Lonsdale: [72087],
      Louann: [71751],
      Lowell: [72745],
      Luxora: [72358],
      Lynn: [72440],
      Magazine: [72943],
      Magness: [72553],
      Magnolia: [71753],
      Malvern: [72104],
      'Mammoth Spring': [72554],
      Manning: [71763],
      Mansfield: [72944],
      Marcella: [72555],
      Marianna: [72360],
      Marion: [72364],
      'Marked Tree': [72365],
      Marmaduke: [72443],
      Marshall: [72650],
      Marvell: [72366],
      Maumelle: [72113],
      Mayflower: [72106],
      Maynard: [72444],
      Maysville: [72747],
      'Mc Caskill': [71847],
      'Mc Crory': [72101],
      'Mc Dougal': [72441],
      'Mc Gehee': [71654],
      'Mc Neil': [71752],
      'Mc Rae': [72102],
      Mellwood: [72367],
      Mena: [71953],
      Midway: [72651],
      'Mineral Springs': [71851],
      Minturn: [72445],
      Moko: [72557],
      Monette: [72447],
      Monticello: [71655],
      Montrose: [71658],
      Moro: [72368],
      Morrilton: [72110],
      Morrow: [72749],
      'Mount Holly': [71758],
      'Mount Ida': [71957],
      'Mount Judea': [72655],
      'Mount Pleasant': [72561],
      'Mount Vernon': [72111],
      'Mountain Home': [72653],
      Mountainburg: [72946],
      Mulberry: [72947],
      Murfreesboro: [71958],
      Nashville: [71852],
      'Natural Dam': [72948],
      'New Blaine': [72851],
      'New Edinburg': [71660],
      Newark: [72562],
      Newhope: [71959],
      Newnata: [72680],
      Newport: [72112],
      Norfork: [72658],
      Norman: [71960],
      Norphlet: [71759],
      North: [71635],
      'North Cedar': [71601],
      'North Little Roc': [72114, 72117, 72120],
      'O Kean': [72449],
      'Oak Grove': [72660],
      Oakland: [72661],
      Oark: [72852],
      Oden: [71961],
      Ogden: [71853],
      'Oil Trough': [72564],
      Okolona: [71962],
      Ola: [72853],
      Omaha: [72662],
      Oneida: [72369],
      Onia: [72663],
      Osceola: [72370],
      Oxford: [72565],
      Ozan: [71855],
      Ozark: [72949],
      Ozone: [72854],
      Palestine: [72372],
      Pangburn: [72121],
      Paragould: [72450],
      Paris: [72855],
      Parkdale: [71661],
      Parkin: [72373],
      Parks: [72950],
      Paron: [72122],
      Parthenon: [72666],
      Payneway: [72472],
      'Pea Ridge': [72751],
      'Peach Orchard': [72453],
      Pearcy: [71964],
      Peel: [72668],
      Pelsor: [72856],
      'Pencil Bluff': [71965],
      Perry: [72125],
      Perrytown: [71801],
      Perryville: [72126],
      Pettigrew: [72752],
      Pickens: [71662],
      Piggott: [72454],
      Pindall: [72669],
      'Pine Bluff': [71603],
      Pineville: [72566],
      Plainview: [72857],
      'Pleasant Grove': [72567],
      'Pleasant Plains': [72568],
      Plumerville: [72127],
      Pocahontas: [72455],
      Pollard: [72456],
      Ponca: [72670],
      'Poplar Grove': [72374],
      Portia: [72457],
      Portland: [71663],
      Pottsville: [72858],
      Poughkeepsie: [72569],
      Powhatan: [72458],
      Poyen: [72128],
      'Prairie Grove': [72753],
      Prattsville: [72129],
      Prescott: [71857],
      Prim: [72130],
      Proctor: [72376],
      Quitman: [72131],
      Ratcliff: [72951],
      Ravenden: [72459],
      'Ravenden Springs': [72460],
      Reader: [71726],
      Rector: [72461],
      Redfield: [72132],
      Reed: [71670],
      Reydell: [72133],
      Rison: [71665],
      Roe: [72134],
      Rogers: [72756],
      Rohwer: [71666],
      Roland: [72135],
      Romance: [72136],
      'Rose Bud': [72137],
      Roseland: [72442],
      Rosie: [72571],
      Rosston: [71858],
      Rover: [72860],
      Royal: [71968],
      Rudy: [72952],
      Russellville: [72801],
      Saffell: [72572],
      Sage: [72573],
      'Saint Charles': [72140],
      'Saint Francis': [72464],
      'Saint Joe': [72675],
      'Saint Paul': [72760],
      Salado: [72575],
      Saratoga: [71859],
      Scotland: [72141],
      Scott: [72142],
      Scranton: [72863],
      Sedgwick: [72465],
      'Shannon Hills': [72103],
      Sheridan: [72150],
      Sherrill: [72152],
      Sherwood: [72116],
      Shirley: [72153],
      Sidney: [72577],
      'Siloam Springs': [72761],
      Sims: [71969],
      Smackover: [71762],
      Smithville: [72466],
      'Snow Lake': [72379],
      Solgohachia: [72156],
      Springdale: [72762],
      Springfield: [72157],
      Stamps: [71860],
      'Star City': [71667],
      'State University': [72467],
      Stephens: [71764],
      Story: [71970],
      Strong: [71765],
      Sturkie: [72578],
      Stuttgart: [72160],
      Subiaco: [72865],
      Success: [72470],
      'Sulphur Rock': [72579],
      'Sulphur Springs': [72768],
      Summers: [72769],
      Swifton: [72471],
      Tamo: [71644],
      Taylor: [71861],
      Texarkana: [75502],
      Thida: [72165],
      Thornton: [71766],
      Tichnor: [72166],
      Tilly: [72679],
      Timbo: [72657],
      Tinsman: [71767],
      Tomato: [72381],
      Traskwood: [72167],
      Tucker: [72168],
      Tuckerman: [72473],
      'Tumbling Shoals': [72581],
      Turrell: [72384],
      'Twin Groves': [72039],
      Tyronza: [72386],
      Ulm: [72170],
      Umpire: [71971],
      Uniontown: [72955],
      'Valley Springs': [72682],
      'Van Buren': [72956],
      Vandervoort: [71972],
      Vendor: [72683],
      Village: [71769],
      Vilonia: [72173],
      Viola: [72583],
      'Violet Hill': [72584],
      Wabbaseka: [72175],
      'Wal-Mart Inc': [72716],
      Waldo: [71770],
      Waldron: [72958],
      Ward: [72176],
      'Warm Springs': [72478],
      Warren: [71671],
      Washington: [71862],
      Watson: [71674],
      Waveland: [72842],
      Weiner: [72479],
      Wesley: [72773],
      'West Fork': [72774],
      'West Helena': [72390],
      'West Memphis': [72301],
      'Western Grove': [72685],
      Wheatley: [72392],
      Wickes: [71973],
      Wideman: [72585],
      Widener: [72394],
      Wilburn: [72179],
      Williford: [72482],
      Willisville: [71864],
      Wilmar: [71675],
      Wilmot: [71676],
      Wilson: [72395],
      Wilton: [71865],
      Winchester: [71677],
      Winslow: [72959],
      Winthrop: [71866],
      Wiseman: [72587],
      Witter: [72776],
      'Witts Springs': [72686],
      Wooster: [72181],
      Wright: [72182],
      Wynne: [72396],
      Yellville: [72687],
      Yorktown: [71678],
      Zion: [72556],
    },
    name: 'Arkansas',
  },
  AZ: {
    cities: {
      Alpine: [85920],
      Amado: [85640, 85645],
      'Apache Junction': [85220],
      'Arizona Boys Ran': [85242],
      Arlington: [85322],
      'Ash Fork': [86320],
      Avondale: [85323],
      Bagdad: [86321],
      Benson: [85602],
      Bisbee: [85603],
      Blue: [85922],
      Buckeye: [85326],
      'Bullhead City': [86430, 86442],
      Bylas: [85530],
      'Camp Verde': [86322],
      'Casas Adobes': [85704],
      'Cave Creek': [85331],
      Chambers: [86502],
      Chandler: [85224, 85225, 85226, 85249],
      Chinle: [86503],
      'Chino Valley': [86323],
      Cibola: [85328],
      Clarkdale: [86324],
      Clifton: [85533],
      Cochise: [85606],
      'Colorado City': [86021],
      Concho: [85924],
      Congress: [85332],
      Coolidge: [85228],
      Cornville: [86325],
      Cottonwood: [86326],
      'Crown King': [86343],
      Dateland: [85333],
      Dennehotso: [86535],
      'Desert Hills': [86403],
      Dewey: [86327],
      'Dolan Springs': [86441],
      Douglas: [85607],
      Eagar: [85925],
      Eden: [85535],
      'El Mirage': [85335],
      'Eleven Mile Corn': [85222],
      Elfrida: [85610],
      Elgin: [85611],
      Eloy: [85231],
      'Empire Landing': [85344],
      Flagstaff: [86001, 86004],
      Florence: [85232],
      'Fort Huachuca': [85613],
      'Fort Mcdowell': [85264],
      'Fountain Hills': [85268],
      Franklin: [85534],
      Fredonia: [86022],
      Ganado: [86505],
      'Gila Bend': [85337],
      Gilbert: [85234],
      Glendale: [85301, 85302, 85303, 85304, 85305, 85306, 85308, 85310],
      Globe: [85501],
      'Gold Canyon': [85219],
      Goodyear: [85338],
      'Green Valley': [85614],
      Greenehaven: [86040],
      'Groom Creek': [86303],
      Heber: [85928],
      Hereford: [85615],
      Higley: [85236],
      Holbrook: [86025],
      Hotevilla: [86030],
      'Huachuca City': [85616],
      Hualapai: [86412],
      Kaibito: [86053],
      Kayenta: [86033],
      'Keams Canyon': [86034],
      Kearny: [85237],
      Kingman: [86401],
      Kirkland: [86332],
      'Kykotsmovi Villa': [86039],
      Lakeside: [85929],
      Laveen: [85339],
      Leupp: [86035],
      'Litchfield Park': [85340],
      Littlefield: [86432],
      Lukachukai: [86507],
      'Luke Afb': [85307, 85309],
      Mammoth: [85618],
      'Many Farms': [86538],
      Marana: [85653],
      'Marble Canyon': [86036],
      Mayer: [86333],
      'Mc Neal': [85617],
      Meadview: [86444],
      Mesa: [
        85201, 85202, 85203, 85204, 85205, 85206, 85207, 85208, 85210, 85213,
      ],
      Miami: [85539],
      Mobile: [85239],
      'Mohave Valley': [86440],
      Morenci: [85540],
      'Mormon Lake': [86038],
      Morristown: [85342],
      Navajo: [86509],
      'New River Stage': [85027],
      Nogales: [85621],
      Oracle: [85623],
      'Oro Valley': [85737],
      'Palo Verde': [85343],
      'Paradise Valley': [85253],
      Patagonia: [85624],
      Paulden: [86334],
      Payson: [85541],
      'Peach Springs': [86434],
      Pearce: [85625],
      Peoria: [85345, 85381, 85382],
      Peridot: [85542],
      Phoenix: [
        85003, 85004, 85006, 85007, 85008, 85009, 85012, 85013, 85014, 85015,
        85016, 85017, 85018, 85019, 85020, 85021, 85022, 85023, 85024, 85028,
        85029, 85031, 85032, 85033, 85034, 85035, 85037, 85039, 85040, 85041,
        85043, 85044, 85051,
      ],
      Pima: [85543],
      Pinetop: [85935],
      Pinon: [86510],
      Pisinemo: [85634],
      Polacca: [86042],
      Portal: [85632],
      Prescott: [86301],
      'Prescott Valley': [86314],
      Rimrock: [86335],
      'Rock Springs': [85324],
      Roll: [85347],
      Roosevelt: [85545],
      Sacaton: [85247],
      Safford: [85546],
      Sahuarita: [85629],
      'Saint David': [85630],
      'Saint Johns': [85936],
      Salome: [85348],
      'San Carlos': [85550],
      'San Manuel': [85631],
      Scottsdale: [
        85250, 85251, 85254, 85255, 85256, 85257, 85258, 85259, 85260, 85262,
      ],
      'Second Mesa': [86043],
      Sedona: [86336],
      Seligman: [86337],
      Shonto: [86054],
      'Show Low': [85901],
      'Sierra Vista': [85635],
      Snowflake: [85937],
      Somerton: [85350],
      Sonoita: [85637],
      Springerville: [85938],
      Stanfield: [85272],
      Strawberry: [85544],
      'Sun City': [85351, 85373],
      'Sun City West': [85375],
      'Sun Lakes': [85248],
      Supai: [86435],
      Superior: [85273],
      Surprise: [85374],
      'Teec Nos Pos': [86514],
      Tempe: [85281, 85282, 85283, 85284],
      Thatcher: [85552],
      Tolleson: [85353],
      Tombstone: [85638],
      Tonalea: [86044],
      Tonopah: [85354],
      Topock: [86436],
      Tsaile: [86556],
      'Tuba City': [86045],
      Tucson: [
        85701, 85705, 85706, 85708, 85710, 85711, 85712, 85713, 85714, 85715,
        85716, 85718, 85719, 85730, 85735, 85736, 85741, 85743, 85745, 85746,
        85747, 85748, 85749,
      ],
      Vail: [85641],
      Waddell: [85355],
      Wellton: [85356],
      Why: [85321],
      Wickenburg: [85390],
      Willcox: [85643],
      Williams: [86046],
      'Williams Afb': [85240],
      Winkelman: [85292],
      Winslow: [86047],
      Wittmann: [85361],
      Yarnell: [85362],
      Youngtown: [85363],
      Yuma: [85364],
      'Yuma Proving Gro': [85365],
    },
    name: 'Arizona',
  },
  CA: {
    cities: {
      95411: [95411],
      95414: [95414],
      95440: [95440],
      95455: [95455],
      95467: [95467],
      95489: [95489],
      95495: [95495],
      Acampo: [95220],
      Acton: [93510],
      Adelaide: [93446],
      Adelanto: [92301],
      Adin: [96006],
      'Agua Dulce': [91350],
      Aguanga: [92536],
      Ahwahnee: [93601],
      Alamo: [94507],
      Albany: [94706],
      Albion: [95410],
      Alhambra: [91801, 91803],
      'Aliso Viejo': [92656],
      Alleghany: [95910],
      Alpine: [91901],
      Alta: [95701],
      'Alta Loma': [91701, 91737],
      Altadena: [91001],
      Alturas: [96101],
      Alviso: [95002],
      Amboy: [92304],
      'American Canyon': [94589],
      Anaheim: [92801, 92802, 92804, 92805, 92806, 92807, 92808],
      Anderson: [96007],
      'Angels Camp': [95222],
      'Angelus Oaks': [92305],
      Angwin: [94508],
      Annapolis: [95412],
      Antioch: [94509],
      Anza: [92539],
      'Apple Valley': [92307, 92308],
      Applegate: [95703],
      Aptos: [95003],
      Arbuckle: [95912],
      Arcadia: [91006, 91007],
      Argus: [93562],
      Arleta: [91331],
      Armona: [93202],
      Aromas: [95004],
      Arvin: [93203],
      Atascadero: [93422],
      Atherton: [94027],
      Atwater: [95301],
      Auberry: [93602],
      Auburn: [95603],
      Avalon: [90704],
      Avenal: [93204],
      Azusa: [91702],
      Baker: [92309],
      Bakersfield: [93301, 93304, 93306, 93307, 93308, 93309, 93311, 93313],
      Ballard: [93463],
      Ballico: [95303],
      Bangor: [95914],
      Banning: [92220],
      Bardsdale: [93015],
      Barstow: [92311],
      'Bass Lake': [93604],
      Bassett: [91746],
      Bayside: [95524],
      'Bear Valley': [95223],
      'Bear Valley Spri': [93561],
      Beaumont: [92223],
      Belden: [95915],
      'Bell Gardens': [90201],
      'Bella Vista': [96008],
      Bellflower: [90706],
      Belmont: [94002],
      Belvedere: [94920],
      'Ben Lomond': [95005],
      Benicia: [94510],
      Benton: [93512],
      Berkeley: [94702, 94703, 94704, 94705, 94709, 94710],
      'Berry Creek': [95916],
      'Beverly Hills': [90210, 90211, 90212],
      'Big Bar': [96010],
      'Big Bear City': [92314],
      'Big Pine': [93513],
      'Big River': [92242],
      'Big Sur': [93920],
      Biggs: [95917],
      'Birds Landing': [94512],
      Bloomington: [92316],
      'Blue Lake': [95525],
      Blythe: [92272],
      Bodega: [94922],
      'Bodega Bay': [94923],
      Bodfish: [93205],
      Bolinas: [94924],
      Bonita: [91902],
      Bonsall: [92003],
      Boonville: [95415],
      Boron: [93516],
      'Borrego Springs': [92004],
      'Boulder Creek': [95006],
      Boulevard: [91905],
      Bradbury: [91010],
      Bradley: [93426],
      Branscomb: [95417],
      Brawley: [92227],
      Brea: [92621],
      Brentwood: [94513],
      Bridgeport: [93517],
      Brisbane: [94005],
      Brooks: [95606],
      'Browns Valley': [95918],
      Brownsville: [95919],
      Bryte: [95605],
      Buellton: [93427],
      'Buena Park': [90620, 90621],
      Burbank: [91501, 91502, 91504, 91505, 91506],
      Burney: [96013],
      'Burnt Ranch': [95527],
      'Butte City': [95920],
      'Butte Meadows': [95942],
      Buttonwillow: [93206],
      Byron: [94514],
      Cabazon: [92230],
      Calabasas: [91302],
      Calexico: [92231],
      'California City': [93505],
      'California Hot S': [93207],
      'California State': [91330],
      'California Valle': [93453],
      Calimesa: [92320],
      Calipatria: [92233],
      Calistoga: [94515],
      Callahan: [96014],
      Calpine: [96124],
      Calwa: [93725],
      Camarillo: [93010, 93012],
      Cambria: [93428],
      'Cameron Park': [95682],
      Camino: [95709],
      Campbell: [95008],
      Campo: [91906],
      Camptonville: [95922],
      Canby: [96015],
      'Canoga Park': [91303, 91304],
      Cantil: [93519],
      'Cantua Creek': [93608],
      'Canyon Country': [91351],
      'Canyon Lake': [92587],
      Canyondam: [95923],
      Capay: [95607],
      'Capistrano Beach': [92624],
      Capitola: [95010],
      'Cardiff By The S': [92007],
      Carlotta: [95528],
      Carlsbad: [92008, 92009],
      Carmel: [93923],
      'Carmel Valley': [93924],
      Carmichael: [95608],
      'Carnelian Bay': [96140],
      Carpinteria: [93013],
      Carson: [90745, 90746, 90810],
      Caruthers: [93609],
      Caspar: [95420],
      Cassel: [96016],
      Castaic: [91384],
      'Castro Valley': [94546, 94552],
      Castroville: [95012],
      'Cathedral City': [92234],
      'Catheys Valley': [95306],
      Cayucos: [93430],
      Cazadero: [95421],
      Cedarville: [96104],
      Ceres: [95307],
      Cerritos: [90623, 90701],
      Chatsworth: [91311],
      Chester: [96020],
      Chico: [95928],
      Chilcoot: [96105],
      'China Lake Nwc': [93555],
      'Chinese Camp': [95309],
      Chino: [91710],
      'Chino Hills': [91709],
      'Chiriaco Summit': [92201],
      Cholame: [93431],
      Chowchilla: [93610],
      Chualar: [93925],
      'Chula Vista': [91910, 91911, 91913, 91914, 91915],
      'Citrus Heights': [95610, 95621],
      'City Of Commerce': [90040],
      'Civic Center': [94903],
      Claremont: [91711],
      Clarksburg: [95612],
      Clayton: [94517],
      Clearlake: [95422],
      'Clearlake Oaks': [95423],
      Clio: [96106],
      Cloverdale: [95425],
      Clovis: [93612],
      Coachella: [92236],
      Coalinga: [93210],
      Coarsegold: [93614],
      'Coast Guard Isla': [94501],
      Cohasset: [95926],
      'Cold Springs': [95335],
      Cole: [90046],
      Coleville: [96107],
      'College Heights': [93305],
      Colma: [94014],
      Columbia: [95310],
      Colusa: [95932],
      Comptche: [95427],
      Concord: [94518, 94519, 94520, 94521],
      Cool: [95614],
      Copperopolis: [95228],
      Corcoran: [93212],
      Corning: [96021],
      Corona: [91719, 91720],
      'Corona Del Mar': [92625],
      Coronado: [92118],
      'Corte Madera': [94925],
      'Costa Mesa': [92626, 92627],
      Cotati: [94931],
      'Coto De Caza': [92679],
      Cottonwood: [96022],
      Coulterville: [95311],
      Courtland: [95615],
      Covelo: [95428],
      Covina: [91722, 91723, 91724],
      'Cowan Heights': [92705],
      Coyote: [95013],
      'Crescent City': [95531],
      'Crescent Mills': [95934],
      Creston: [93432],
      Crockett: [94525],
      Cromberg: [96103],
      'Crowley Lake': [93546],
      'Crows Landing': [95313],
      Crystalaire: [93544],
      'Culver City': [90230, 90232],
      Cutler: [93615],
      Cuyama: [93214],
      Cypress: [90630],
      Daggett: [92327],
      'Daly City': [94015],
      Danville: [94526],
      Davenport: [95017],
      Davis: [95616],
      'Davis Creek': [96108],
      'Death Valley': [92328],
      'Del Mar': [92014],
      'Del Rey': [93616],
      'Del Rey Oaks': [93940],
      Delano: [93215],
      Delhi: [95315],
      Denair: [95316],
      Descanso: [91916],
      'Desert Hot Sprin': [92240],
      'Di Giorgio': [93217],
      Diablo: [94528],
      'Diamond Bar': [91765, 91789],
      'Diamond Springs': [95619],
      Dinuba: [93618],
      Dobbins: [95935],
      'Dos Palos': [93620],
      'Dos Rios': [95429],
      'Douglas City': [96024],
      Downey: [90240, 90241, 90242],
      Downieville: [95936],
      Doyle: [96109],
      Dublin: [94568],
      Dulzura: [91917],
      Dunlap: [93621],
      Dunnigan: [95937],
      Dunsmuir: [96025],
      Durham: [95938],
      'Dutch Flat': [95714],
      'Eagle Mountain': [92239],
      Earlimart: [93219],
      'East Highland': [92346],
      'East Los Angeles': [90022],
      'East Palo Alto': [94303],
      'East Rancho Domi': [90221],
      Easton: [93706],
      'Echo Lake': [95721],
      Edgewood: [96094],
      'El Cajon': [92019, 92020, 92021],
      'El Centro': [92243],
      'El Cerrito': [94530],
      'El Dorado Hills': [95630],
      'El Macero': [95618],
      'El Monte': [91731, 91732],
      'El Nido': [95317],
      'El Segundo': [90245],
      'El Sobrante': [94803],
      'El Toro Marine C': [92709],
      'Elizabeth Lake': [93532],
      Elk: [95432],
      'Elk Creek': [95939],
      'Elk Grove': [95624, 95758],
      Elverta: [95626],
      Emeryville: [94608],
      'Emigrant Gap': [95715],
      Encinitas: [92024],
      Encino: [91316, 91436],
      Escalon: [95320],
      Escondido: [92025, 92026, 92027, 92029],
      Esparto: [95627],
      Essex: [92332],
      Etiwanda: [91739],
      Eureka: [95501],
      Exeter: [93221],
      'Fair Oaks': [95628],
      Fairfax: [94930],
      Fairfield: [94533],
      'Fall River Mills': [96028],
      Fallbrook: [92028],
      Farmersville: [93223],
      Farmington: [95230],
      Felicity: [92283],
      Fellows: [93224],
      Felton: [95018],
      Ferndale: [95536],
      Fiddletown: [95629],
      'Fig Garden Villa': [93704],
      Firebaugh: [93622],
      'Fish Camp': [93623],
      Flintridge: [91011],
      Floriston: [96111],
      Fontana: [92335, 92336],
      'Foothill Ranch': [92610],
      Forbestown: [95941],
      'Forest Falls': [92339],
      'Forest Knolls': [94933],
      Foresthill: [95631],
      Forestville: [95436],
      'Forks Of Salmon': [96031],
      'Fort Bidwell': [96112],
      'Fort Bragg': [95437],
      'Fort Irwin': [92310],
      'Fort Jones': [96032],
      'Fort Ord': [93941],
      Fortuna: [95540],
      'Foster City': [94404],
      'Fountain Valley': [92708],
      Fowler: [93625],
      'Frazier Park': [93225],
      Freedom: [95019],
      Freestone: [95472],
      Fremont: [94536, 94538, 94539, 94555],
      'French Camp': [95231],
      'French Gulch': [96033],
      Fresno: [
        93701, 93702, 93703, 93705, 93710, 93711, 93720, 93721, 93722, 93726,
        93727, 93728,
      ],
      Friant: [93626],
      Fullerton: [92631, 92632, 92633, 92635],
      Fulton: [95439],
      Galt: [95632],
      'Garden Grove': [92640, 92641, 92643, 92644, 92645],
      'Garden Valley': [95633],
      Gardena: [90247, 90248, 90249],
      Gasquet: [95543],
      Gazelle: [96034],
      'George Afb': [92394],
      Georgetown: [95634],
      Gerber: [96035],
      Geyserville: [95441],
      'Giant Forest': [93262],
      'Gilman Hot Sprin': [92583],
      Gilroy: [95020],
      'Glen Ellen': [95442],
      Glencoe: [95232],
      Glendale: [91201, 91202, 91203, 91204, 91205, 91206, 91207, 91208],
      Glendora: [91740],
      Glenhaven: [95443],
      Glenn: [95943],
      Glennville: [93226],
      'Gold River': [95670],
      'Gold Run': [95717],
      Goleta: [93117],
      Gonzales: [93926],
      'Goodyears Bar': [95944],
      Gorman: [93243],
      'Granada Hills': [91344],
      'Grand Terrace': [92324],
      'Grass Valley': [95945, 95949],
      Graton: [95444],
      Greenacres: [93312],
      Greenfield: [93927],
      Greenville: [95947],
      Greenwood: [95635],
      Grenada: [96038],
      Gridley: [95948],
      'Grizzly Flats': [95636],
      Groveland: [95321],
      'Grover Beach': [93433],
      Guadalupe: [93434],
      Gualala: [95445],
      Guerneville: [95446],
      Guinda: [95637],
      Gustine: [95322],
      'Hacienda Heights': [91745],
      Halcyon: [93420],
      'Half Moon Bay': [94019],
      Hanford: [93230],
      'Happy Camp': [96039],
      'Harbor City': [90710],
      'Hat Creek': [96040],
      Havilah: [93518],
      'Hawaiian Gardens': [90716],
      Hayfork: [96041],
      Hayward: [94541, 94542, 94544, 94545],
      Hazard: [90063],
      Healdsburg: [95448],
      Heber: [92249],
      Helena: [96048],
      Helendale: [92342],
      Helm: [93627],
      Hemet: [92543, 92544, 92545],
      Herald: [95638],
      Hercules: [94547],
      Herlong: [96113],
      'Hermosa Beach': [90254],
      Hesperia: [92345],
      'Hi Vista': [93535],
      Hickman: [95323],
      Hillsborough: [94010],
      Hilmar: [95324],
      Hinkley: [92347],
      Hollister: [95023],
      'Holly Park': [90250],
      Holtville: [92250],
      Homeland: [92548],
      Homewood: [96141],
      Hoopa: [95546],
      'Hope Valley': [96120],
      Hopland: [95449],
      Hornbrook: [96044],
      Hornitos: [95325],
      'Horse Creek': [96045],
      Hughson: [95326],
      'Huntington Beach': [92646, 92647, 92648, 92649],
      'Huntington Park': [90255],
      Huron: [93234],
      Hydesville: [95547],
      Idyllwild: [92549],
      Igo: [96047],
      Imperial: [92251],
      'Imperial Beach': [91932],
      Independence: [93526],
      'Indian Wells': [92210],
      Industry: [91744],
      Inglewood: [90301, 90302, 90303, 90305],
      Inverness: [94937],
      Ione: [95640],
      'Iowa Hill': [95713],
      Irvine: [92714, 92715, 92718, 92720],
      Irwindale: [91706],
      Isleton: [95641],
      Ivanhoe: [93235],
      Jackson: [95642],
      Jacumba: [91934],
      Jamestown: [95327],
      Jamul: [91935],
      Janesville: [96114],
      Jenner: [95450],
      Johannesburg: [93528],
      'Joshua Tree': [92252],
      Julian: [92036],
      'June Lake': [93529],
      'Juniper Hills': [93543, 93553],
      Keene: [93531],
      Kelsey: [95643],
      Kelseyville: [95451],
      Kelso: [92351],
      Kensington: [94707, 94708],
      Kentfield: [94904],
      Kenwood: [95452],
      Kerman: [93630],
      Kernville: [93238],
      'Kettleman City': [93239],
      'King City': [93930],
      'Kings Beach': [96143],
      'Kings Canyon Nat': [93633],
      Kingsburg: [93631],
      Klamath: [95548],
      'Klamath River': [96050],
      Kneeland: [95549],
      'Knights Ferry': [95361],
      'Knights Landing': [95645],
      Knightsen: [94548],
      Korbel: [95550],
      Kyburz: [95720],
      'La Crescenta': [91214],
      'La Grange': [95329],
      'La Habra Heights': [90631],
      'La Honda': [94020],
      'La Jolla': [92037],
      'La Mesa': [91941, 91942],
      'La Mirada': [90638],
      'La Porte': [95981],
      'La Quinta': [92253],
      'La Selva Beach': [95076],
      'La Verne': [91750],
      Ladera: [94028],
      Lafayette: [94549],
      'Laguna Hills': [92653],
      'Laguna Niguel': [92651, 92677],
      Lagunitas: [94938],
      'Lake City': [96115],
      'Lake Elsinore': [92530, 92532],
      'Lake Forest': [92630],
      'Lake Los Angeles': [93550],
      Lakehead: [96051],
      Lakeport: [95453],
      Lakeside: [92040],
      Lakeview: [92567],
      Lakewood: [90712, 90713, 90715],
      Lamont: [93241],
      Lancaster: [93534],
      Larkspur: [94939],
      Lathrop: [95330],
      Laton: [93242],
      Lawndale: [90260],
      Laytonville: [95454],
      'Le Grand': [95333],
      'Lee Vining': [93541],
      'Lemon Grove': [91945],
      Lemoncove: [93244],
      'Lemoore Naval Ai': [93245],
      Lennox: [90304],
      'Leona Valley': [93551],
      Lewiston: [96052],
      'Liberty Farms': [95620],
      Lincoln: [95648],
      Linden: [95236],
      Lindsay: [93247],
      Litchfield: [96117],
      Littleriver: [95456],
      'Live Oak': [95953],
      Livermore: [94550],
      Livingston: [95334],
      Lockeford: [95237],
      Lockwood: [93932],
      Lodi: [95240, 95242],
      Loleta: [95551],
      'Loma Linda': [92354],
      'Loma Mar': [94021],
      Lompoc: [93436, 93437],
      'Lone Pine': [93545],
      'Long Beach': [90802, 90803, 90805, 90808, 90813, 90814, 90815, 90822],
      Loomis: [95650],
      'Los Altos': [94022, 94024],
      'Los Angeles': [
        90001, 90002, 90003, 90004, 90005, 90006, 90007, 90008, 90010, 90011,
        90012, 90013, 90014, 90015, 90016, 90017, 90018, 90019, 90020, 90021,
        90023, 90024, 90025, 90026, 90027, 90028, 90029, 90031, 90032, 90033,
        90034, 90035, 90036, 90037, 90038, 90039, 90041, 90042, 90043, 90044,
        90045, 90047, 90048, 90049, 90056, 90057, 90059, 90061, 90062, 90064,
        90065, 90066, 90067, 90068, 90071, 90077,
      ],
      'Los Banos': [93635],
      'Los Gatos': [95032],
      'Los Molinos': [96055],
      'Los Nietos': [90606],
      'Los Osos': [93402],
      'Lost Hills': [93249],
      'Lost Lake': [92225],
      Lotus: [95651],
      'Lower Lake': [95457],
      Loyalton: [96118],
      Lucerne: [95458],
      'Lucerne Valley': [92356],
      Ludlow: [92338],
      Lynwood: [90262],
      'Lytle Creek': [92358],
      Macdoel: [96058],
      'Mad River': [95552],
      Madera: [93637, 93638],
      Madison: [95653],
      Magalia: [95954],
      Malibu: [90265],
      Manchester: [95459],
      'Manhattan Beach': [90266],
      Manteca: [95336],
      Manton: [96059],
      'Mare Island': [94592],
      Maricopa: [93252],
      Marina: [93933],
      'Marina Del Rey': [90292],
      'Marine Corp Base': [92055],
      Mariposa: [95338],
      Marshall: [94940],
      Marysville: [95901],
      'Mather Afb': [95655],
      Maxwell: [95955],
      Maywood: [90270],
      'Mc Farland': [93250],
      'Mc Kinleyville': [95521],
      'Mc Kittrick': [93251],
      Mcarthur: [96056],
      'Mcclellan Afb': [95652],
      Mccloud: [96057],
      'Mead Valley': [92570],
      'Meadow Valley': [95956],
      'Meadow Vista': [95722],
      Mendocino: [95460],
      Mendota: [93640],
      Menifee: [92584],
      Mentone: [92359],
      Merced: [95348],
      Meridian: [95957],
      'Mi Wuk Village': [95346],
      Middletown: [95461],
      Midpines: [95345],
      'Midway City': [92655],
      Milford: [96121],
      'Mill Valley': [94941],
      Millbrae: [94030],
      Millville: [96062],
      Milpitas: [95035],
      Mineral: [96063],
      'Mira Loma': [91752],
      Miramonte: [93641],
      'Mission Hills': [91345],
      'Mission Viejo': [92675, 92691, 92692],
      Modesto: [95350, 95351, 95354, 95355, 95356],
      'Moffett Field': [94035],
      Mojave: [93501],
      'Mokelumne Hill': [95245],
      'Monarch Bay': [92629],
      Monrovia: [91016],
      Montague: [96064],
      Montclair: [91763],
      'Monte Sereno': [95030],
      'Monte Vista': [95014],
      Montebello: [90640],
      Montecito: [93108],
      'Monterey Park': [91754],
      'Montgomery Creek': [96065],
      Montrose: [91020],
      Moorpark: [93021],
      Moraga: [94556],
      'Moreno Valley': [92553, 92555, 92557],
      'Morgan Hill': [95037],
      'Morongo Valley': [92256],
      'Morro Bay': [93442],
      'Moss Beach': [94038],
      'Mount Hamilton': [95140],
      'Mount Shasta': [96067],
      'Mountain Center': [92561],
      'Mountain Mesa': [93240],
      'Mountain Ranch': [95246],
      'Mountain View': [94040, 94041, 94043],
      'Mt Baldy': [91759],
      Murphys: [95247],
      Murrieta: [92562, 92563],
      Muscoy: [92405],
      'Myers Flat': [95554],
      Napa: [94559],
      'National City': [91950],
      Needles: [92363],
      'Nevada City': [95959],
      'New Cuyama': [93254],
      Newark: [94560],
      'Newberry Springs': [92365],
      'Newbury Park': [91320],
      Newcastle: [95658],
      Newhall: [91321, 91381],
      Newman: [95360],
      'Newport Beach': [92657, 92660, 92661, 92662, 92663],
      Nicasio: [94946],
      Nice: [95464],
      Niland: [92257],
      Nipomo: [93444],
      Nipton: [92364],
      Norco: [91760],
      Norden: [95724],
      'North Edwards': [93523],
      'North Fork': [93643],
      'North Highlands': [95660],
      'North Hills': [91343],
      'North Hollywood': [91601, 91605, 91606],
      'North San Juan': [95960],
      Northridge: [91324, 91325],
      Norwalk: [90650],
      Novato: [94945, 94947, 94949],
      'O Neals': [93645],
      'Oak Park': [91301],
      'Oak Run': [96069],
      'Oak View': [93022],
      Oakhurst: [93644],
      Oakland: [
        94601, 94602, 94603, 94605, 94606, 94607, 94609, 94610, 94612, 94613,
        94619, 94621,
      ],
      Oakley: [94561],
      Occidental: [95465],
      Oceano: [93445],
      Oceanside: [92054, 92056, 92057],
      Ojai: [93023],
      'Old Station': [96071],
      Olivehurst: [95961],
      Ontario: [91761, 91762, 91764],
      Onyx: [93255],
      Orange: [92665, 92666, 92668, 92669],
      'Orange Cove': [93646],
      Orangevale: [95662],
      Orcutt: [93455],
      'Oregon House': [95962],
      Orick: [95555],
      Orinda: [94563],
      Orland: [95963],
      Orleans: [95556],
      'Oro Grande': [92368],
      Orosi: [93647],
      Oroville: [95966],
      Oxnard: [93030, 93033, 93035],
      Pacheco: [94553],
      'Pacific Grove': [93950],
      'Pacific House': [95726],
      'Pacific Palisade': [90272],
      Pacifica: [94044],
      Paicines: [95043],
      Pala: [92059],
      Palermo: [95968],
      'Palm City': [92260],
      'Palm Springs': [92262, 92264],
      'Palo Alto': [94301, 94304, 94306],
      'Palo Cedro': [96073],
      'Palos Verdes Est': [90274],
      'Panorama City': [91402],
      Paradise: [95969],
      Paramount: [90723],
      'Parker Dam': [92267],
      Parkfield: [93451],
      Parlier: [93648],
      Pasadena: [91101, 91103, 91104, 91105, 91106, 91107],
      Patterson: [95363],
      'Pauma Valley': [92061],
      'Paynes Creek': [96075],
      Pearsonville: [93527],
      'Pebble Beach': [93953],
      'Peninsula Villag': [96137],
      'Penn Valley': [95946],
      Penngrove: [94951],
      Penryn: [95663],
      Perris: [92571],
      Pescadero: [94060],
      Petaluma: [94952, 94954],
      Petrolia: [95558],
      Phelan: [92371],
      'Phillips Ranch': [91766],
      Philo: [95466],
      'Pico Rivera': [90660],
      Piedmont: [94611, 94618],
      'Pilot Hill': [95664],
      'Pine Grove': [95665],
      'Pine Valley': [91962],
      Pinecrest: [95364],
      Pinedale: [93650],
      Pinole: [94564],
      'Pinon Hills': [92372],
      Pioneer: [95666],
      Pixley: [93256],
      Placentia: [92670],
      Placerville: [95667],
      'Playa Del Rey': [90293],
      'Pleasant Grove': [95668],
      'Pleasant Hill': [94523],
      Pleasanton: [94566, 94588],
      Plymouth: [95669],
      'Point Arena': [95468],
      'Point Mugu Nawc': [93042],
      'Point Reyes Stat': [94956],
      Pomona: [91767, 91768],
      Pond: [93280],
      'Pope Valley': [94567],
      'Port Costa': [94569],
      'Port Hueneme': [93041],
      'Port Hueneme Cbc': [93043],
      'Porter Ranch': [91326],
      Porterville: [93257],
      Portola: [96122],
      Posey: [93260],
      Potrero: [91963],
      'Potter Valley': [95469],
      Poway: [92064],
      Prather: [93651],
      Princeton: [95970],
      Prunedale: [93907],
      Pulga: [95965],
      'Quartz Hill': [93536],
      Quincy: [95971],
      Rackerby: [95972],
      Raisin: [93652],
      Ramona: [92065],
      Ranchita: [92066],
      'Rancho Cordova': [95742],
      'Rancho Cucamonga': [91730],
      'Rancho Dominguez': [90220],
      'Rancho Mirage': [92270],
      'Rancho Murieta': [95683],
      'Rancho Palos Ver': [90717, 90732],
      'Rancho Santa Mar': [92688],
      Randsburg: [93554],
      Ravendale: [96123],
      Raymond: [93653],
      'Red Bluff': [96080],
      'Red Top': [95340],
      Redcrest: [95569],
      Redding: [96001, 96002, 96003],
      Redlands: [92373, 92374],
      'Redondo Beach': [90277, 90278],
      Redway: [95560],
      'Redwood City': [94061, 94063, 94065],
      'Redwood Valley': [95470],
      Reedley: [93654],
      Rescue: [95672],
      Reseda: [91335],
      Rialto: [92376],
      Richmond: [94801, 94804, 94805],
      'Rio Dell': [95562],
      'Rio Linda': [95673],
      'Rio Oso': [95674],
      'Rio Vista': [94571],
      Ripon: [95366],
      Riverbank: [95367],
      Riverdale: [93656],
      Riverside: [92501, 92503, 92504, 92505, 92506, 92507, 92508],
      Rocklin: [95677],
      Rodeo: [94572],
      'Rohnert Park': [94928],
      Romoland: [92585],
      Rosemead: [91770],
      Roseville: [95661, 95678],
      Rosewood: [90222],
      Rossmoor: [90720],
      'Rough And Ready': [95975],
      'Rowland Heights': [91748],
      Rubidoux: [92509],
      Rumsey: [95679],
      'Russian River': [94401],
      'Russian River Md': [95462],
      Ruth: [95526],
      Sacramento: [
        95814, 95815, 95816, 95817, 95818, 95819, 95820, 95821, 95822, 95823,
        95824, 95825, 95826, 95827, 95828, 95829, 95830, 95831, 95832, 95833,
        95834, 95835, 95836, 95837, 95838, 95841, 95842, 95864,
      ],
      'Saint Helena': [94574],
      Salida: [95368],
      Salinas: [93901, 93905, 93906, 93908],
      'Salton City': [92274],
      Salyer: [95563],
      Samoa: [95564],
      'San Andreas': [95249],
      'San Anselmo': [94960],
      'San Ardo': [93450],
      'San Bernardino': [92401, 92404, 92407, 92408, 92409, 92410, 92411],
      'San Bruno': [94066],
      'San Buenaventura': [93001, 93003, 93004],
      'San Carlos': [94070],
      'San Clemente': [92672],
      'San Diego': [
        92101, 92102, 92103, 92104, 92105, 92106, 92107, 92108, 92109, 92110,
        92111, 92113, 92114, 92115, 92116, 92117, 92119, 92120, 92121, 92122,
        92123, 92124, 92126, 92127, 92128, 92129, 92130, 92131, 92135, 92136,
        92139, 92145, 92154, 92155,
      ],
      'San Dimas': [91773],
      'San Fernando': [91340],
      'San Francisco': [
        94102, 94103, 94104, 94105, 94107, 94108, 94109, 94110, 94111, 94112,
        94114, 94115, 94116, 94117, 94118, 94121, 94122, 94123, 94124, 94127,
        94129, 94130, 94131, 94132, 94133, 94134,
      ],
      'San Gabriel': [91775, 91776],
      'San Geronimo': [94963],
      'San Gregorio': [94074],
      'San Jacinto': [92582],
      'San Joaquin': [93660],
      'San Jose': [
        95110, 95111, 95112, 95113, 95116, 95117, 95118, 95119, 95120, 95121,
        95122, 95123, 95124, 95125, 95126, 95127, 95128, 95129, 95130, 95131,
        95132, 95133, 95134, 95135, 95136, 95138, 95139, 95141, 95148,
      ],
      'San Juan Bautist': [95045],
      'San Leandro': [94577, 94578, 94579],
      'San Lorenzo': [94580],
      'San Luis Obispo': [93401, 93405],
      'San Luis Rey': [92068],
      'San Marcos': [92069],
      'San Marino': [91108],
      'San Martin': [95046],
      'San Mateo': [94402, 94403],
      'San Pablo': [94806],
      'San Pedro': [90731],
      'San Rafael': [94901],
      'San Ramon': [94583],
      'San Simeon': [93452],
      'San Ysidro': [92173],
      'Sand City': [93955],
      Sanger: [93657],
      'Santa Ana': [92701, 92703, 92704, 92706],
      'Santa Ana Height': [92707],
      'Santa Barbara': [93101, 93103, 93105, 93109, 93110, 93111],
      'Santa Clara': [95050, 95051, 95054],
      'Santa Cruz': [95062, 95064, 95065],
      'Santa Fe Springs': [90670],
      'Santa Maria': [93454],
      'Santa Monica': [90401, 90402, 90403, 90404, 90405],
      'Santa Paula': [93060],
      'Santa Rosa': [95401, 95403, 95404, 95405, 95407, 95409],
      'Santa Susana': [93063],
      'Santa Ynez': [93460],
      'Santa Ysabel': [92070],
      Santee: [92071],
      Saratoga: [95070],
      Sausalito: [94965],
      'Sawyers Bar': [96027],
      Scotia: [95565],
      'Scott Bar': [96085],
      'Scotts Valley': [95060, 95066],
      'Seal Beach': [90740],
      'Seiad Valley': [96086],
      Selma: [93662],
      'Shadow Hills': [91040],
      Shafter: [93263],
      Shandon: [93461],
      Shasta: [96087],
      'Shasta Lake': [96019],
      'Shaver Lake': [93664],
      'Shell Beach': [93449],
      Sheridan: [95681],
      'Sherman Oaks': [91403, 91423],
      Shingletown: [96088],
      'Shore Acres': [94565],
      Shoshone: [92384],
      'Sierra City': [96125],
      'Sierra Madre': [91024],
      Sierraville: [96126],
      'Signal Hill': [90804, 90806, 90807],
      'Simi Valley': [93065],
      Smartville: [95977],
      'Smith River': [95567],
      Snelling: [95369],
      'Soda Springs': [95728],
      'Solana Beach': [92075],
      Soledad: [93960],
      Somerset: [95684],
      'Somes Bar': [95568],
      Somis: [93066],
      Sonoma: [95476],
      Sonora: [95370],
      Soquel: [95073],
      Soulsbyville: [95372],
      'South El Monte': [91733],
      'South Gate': [90280],
      'South Lake Tahoe': [96150],
      'South Pasadena': [91030],
      'South San Franci': [94080],
      'Spanish Flat': [94558],
      'Spring Valley': [91977, 91978],
      'Spring Valley La': [92392],
      Springville: [93265],
      'Squaw Valley': [93675],
      Standish: [96128],
      Stanford: [94305],
      Stanton: [90680],
      Stevinson: [95374],
      'Stinson Beach': [94970],
      Stockton: [
        95202, 95203, 95204, 95205, 95206, 95207, 95209, 95210, 95212, 95215,
        95219,
      ],
      Stonyford: [95979],
      Stratford: [93266],
      Strathmore: [93267],
      'Studio City': [91604],
      'Suisun City': [94585],
      Summerland: [93067],
      'Sun City': [92586],
      'Sun Valley': [91352],
      Sunnyvale: [94086, 94087, 94089],
      Sunol: [94586],
      Susanville: [96130],
      Sutter: [95982],
      'Sutter Creek': [95685],
      Sylmar: [91342],
      Taft: [93268],
      'Tahoe City': [96145],
      'Tahoe Vista': [96148],
      Tahoma: [96142],
      Tarzana: [91356],
      Taylorsville: [95983],
      Tecate: [91980],
      Tecopa: [92389],
      Temecula: [92590, 92591, 92592],
      'Temple City': [91780],
      Templeton: [93465],
      Termo: [96132],
      'Terra Bella': [93270],
      'The Sea Ranch': [95497],
      'Thousand Oaks': [91360],
      'Thousand Palms': [92276],
      'Three Rivers': [93271],
      Tipton: [93272],
      Tollhouse: [93667],
      'Toluca Lake': [91602],
      'Toms Place': [93514],
      Topanga: [90290],
      Topaz: [96133],
      Torrance: [90501, 90502, 90503, 90504, 90505, 90506],
      Tracy: [95376],
      Tranquillity: [93668],
      'Travis Afb': [94535],
      'Trinity Center': [96091],
      Trowbridge: [95659],
      Truckee: [96161, 96162],
      Tujunga: [91042],
      Tulare: [93274],
      Tulelake: [96134],
      Tuolumne: [95379],
      Tupman: [93276],
      Turlock: [95380],
      Tustin: [92680],
      Twain: [95984],
      'Twain Harte': [95383],
      'Twentynine Palms': [92277, 92278],
      'Twin Bridges': [95735],
      Ukiah: [95482],
      'Union City': [94587],
      'Univ Of The Paci': [95211],
      Upland: [91786],
      'Upper Lake': [95485],
      Vacaville: [95687, 95688],
      Valencia: [91354, 91355],
      Vallecito: [95251],
      Vallejo: [94590, 94591],
      'Valley Center': [92082],
      'Valley Ford': [94972],
      'Valley Springs': [95252],
      'Valley Village': [91607],
      Valyermo: [93563],
      'Van Nuys': [91401, 91405, 91406, 91411],
      Venice: [90291],
      Vernon: [90058],
      Vidal: [92280],
      'Villa Park': [92667],
      Vinton: [96135],
      Visalia: [93277, 93291],
      Vista: [92083, 92084],
      Volcano: [95689],
      'Walnut Creek': [94595, 94596, 94598],
      'Walnut Grove': [95690],
      'Warner Springs': [92086],
      Waterford: [95386],
      Weaverville: [96093],
      Weldon: [93283],
      Wendel: [96136],
      'West Covina': [91790, 91791, 91792],
      'West Hills': [91307],
      'West Hollywood': [90069],
      'West Menlo Park': [94025],
      'West Point': [95255],
      'West Sacramento': [95691],
      Westhaven: [95570],
      'Westlake Village': [91361, 91362],
      Westminster: [92683],
      Westmorland: [92281],
      Westport: [95488],
      Wheatland: [95692],
      'White Water': [92282],
      Whitmore: [96096],
      Whittier: [90601, 90602, 90603, 90604, 90605],
      Wildomar: [92595],
      Wildwood: [96076],
      Williams: [95987],
      Willits: [95490],
      'Willow Creek': [95573],
      'Willow Springs': [93560],
      Willows: [95988],
      Wilmington: [90744],
      Wilseyville: [95257],
      Wilton: [95693],
      Winchester: [92596],
      Windsor: [95492],
      Winnetka: [91306],
      Winters: [95694],
      Winton: [95388],
      Wishon: [93669],
      'Witter Springs': [95493],
      'Wofford Heights': [93285],
      Woodacre: [94973],
      Woodbridge: [95258],
      Woodlake: [93286],
      Woodland: [95695],
      'Woodland Hills': [91364, 91367],
      Woodside: [94062],
      Woody: [93287],
      Wrightwood: [92397],
      'Yorba Linda': [92686, 92687],
      Yorkville: [95494],
      Yountville: [94599],
      Yreka: [96097],
      'Yuba City': [95991, 95993],
      Yucaipa: [92399],
      'Yucca Valley': [92284],
      Zamora: [95698],
    },
    name: 'California',
  },
  CO: {
    cities: {
      81080: [81080],
      81250: [81250],
      Agate: [80101],
      Aguilar: [81020],
      Akron: [80720],
      Alamosa: [81101],
      Allenspark: [80510],
      Almont: [81210],
      Amherst: [80721],
      Anton: [80801],
      Antonito: [81120],
      Arapahoe: [80802],
      Arboles: [81121],
      Arlington: [81021],
      Arriba: [80804],
      Arvada: [80002, 80003, 80004, 80005],
      Aspen: [81611],
      Atwood: [80722],
      Ault: [80610],
      Aurora: [
        80010, 80011, 80012, 80013, 80014, 80015, 80016, 80017, 80018, 80019,
        80045,
      ],
      Austin: [81410],
      Bailey: [80421],
      Basalt: [81621],
      'Battlement Mesa': [81635],
      Bayfield: [81122],
      Bedrock: [81411],
      Bellvue: [80512],
      Bennett: [80102],
      Berthoud: [80513],
      Bethune: [80805],
      Beulah: [81023],
      'Black Hawk': [80422],
      Blanca: [81123],
      Bond: [80423],
      Boone: [81025],
      Boulder: [80301, 80302, 80303, 80304],
      'Bow Mar': [80123],
      Brandon: [81026],
      Branson: [81027],
      Briggsdale: [80611],
      Bristol: [81028],
      Broomfield: [80020],
      Brush: [80723],
      'Buena Vista': [81211],
      Burlington: [80807],
      Byers: [80103],
      Caddoa: [81044],
      Cahone: [81320],
      Calhan: [80808],
      Campo: [81029],
      'Canon City': [81212],
      Carr: [80612],
      'Castle Rock': [80104],
      Cedaredge: [81413],
      Center: [81125],
      'Cherry Hills Vil': [80110, 80111],
      'Cheyenne Mtn Afb': [80914],
      'Cheyenne Wells': [80810],
      Chivington: [81036],
      Cimarron: [81220],
      Clark: [80428],
      Clifton: [81520],
      Climax: [80429],
      Coalmont: [80430],
      Collbran: [81624],
      'Colorado Springs': [
        80903, 80904, 80905, 80906, 80907, 80908, 80909, 80910, 80911, 80915,
        80916, 80917, 80918, 80919, 80920, 80921, 80922, 80925, 80926, 80928,
        80929, 80930,
      ],
      'Commerce City': [80022],
      Conifer: [80433],
      Cope: [80812],
      Cortez: [81321],
      Craig: [81625],
      Crawford: [81415],
      Creede: [81130],
      'Crested Butte': [81224],
      Crook: [80726],
      Cuchara: [81055],
      Dacono: [80514],
      'De Beque': [81630],
      Deckers: [80135],
      'Deer Trail': [80105],
      Delhi: [81059],
      Delta: [81416],
      Denver: [
        80202, 80203, 80204, 80205, 80206, 80207, 80209, 80210, 80211, 80216,
        80218, 80219, 80220, 80223, 80224, 80227, 80231, 80235, 80236, 80237,
        80239, 80249,
      ],
      Deora: [81054],
      Dinosaur: [81610],
      Divide: [80814],
      Dolores: [81323],
      'Dove Creek': [81324],
      Drake: [80515],
      Durango: [81301],
      Eagle: [81631],
      Eaton: [80615],
      Eckert: [81418],
      Eckley: [80727],
      Edgewater: [80214],
      Egnar: [81325],
      Elbert: [80106],
      Elizabeth: [80107],
      'Elk Springs': [81633],
      Englewood: [80112],
      Erie: [80516],
      'Estes Park': [80517],
      Evans: [80620],
      Evergreen: [80439],
      Fairplay: [80440],
      Farisita: [81040],
      Farista: [81089],
      'Federal Heights': [80221],
      Flagler: [80815],
      Fleming: [80728],
      Florence: [81226],
      Florissant: [80816],
      'Fort Carson': [80913],
      'Fort Collins': [80521, 80524, 80525, 80526],
      'Fort Garland': [81133],
      'Fort Morgan': [80701],
      Fountain: [80817],
      Fowler: [81039],
      Foxton: [80441],
      Franktown: [80116],
      Fruita: [81521],
      Fruitvale: [81504],
      Galeton: [80622],
      'Garden City': [80631],
      Gateway: [81522],
      Genoa: [80818],
      Gill: [80624],
      Glendale: [80222],
      'Glenwood Springs': [81601],
      Golden: [80401, 80403],
      Granada: [81041],
      Granby: [80446],
      'Grand Junction': [81501, 81503, 81505, 81506],
      'Grand Lake': [80447],
      Granite: [81228],
      Greeley: [80634],
      'Greenwood Villag': [80121],
      Grover: [80729],
      Guffey: [80820],
      Gunnison: [81230],
      Gypsum: [81637],
      Hale: [80735],
      Hamilton: [81638],
      Hartman: [81043],
      Haswell: [81045],
      Haxtun: [80731],
      Hayden: [81639],
      Henderson: [80640],
      Hesperus: [81326],
      'Highlands Ranch': [80126],
      Hillrose: [80733],
      Holly: [81047],
      Holyoke: [80734],
      Hooper: [81136],
      Hotchkiss: [81419],
      Howard: [81233],
      Hoyt: [80654],
      Hudson: [80642],
      Hugo: [80821],
      'Idaho Springs': [80452],
      Ignacio: [81137],
      Iliff: [80736],
      Jamestown: [80455],
      Jansen: [81082],
      Jefferson: [80456],
      Joes: [80822],
      Johnstown: [80534],
      Julesburg: [80737],
      Karval: [80823],
      Keenesburg: [80643],
      Kersey: [80644],
      Keystone: [80435],
      Kiowa: [80117],
      Kirk: [80824],
      'Kit Carson': [80825],
      Kremmling: [80459],
      'La Garita': [81132],
      'La Jara': [81140],
      'La Salle': [80645],
      Lafayette: [80026],
      Laird: [80758],
      'Lake City': [81235],
      'Lake George': [80827],
      Lakewood: [80215, 80226, 80228, 80232],
      Lamar: [81052],
      Laporte: [80535],
      Larkspur: [80118],
      'Last Chance': [80757],
      Leadville: [80461],
      Lewis: [81327],
      Limon: [80828],
      Lindon: [80740],
      Littleton: [80120, 80122, 80124, 80125, 80127],
      Lochbui: [80601],
      Loma: [81524],
      Longmont: [80501, 80503, 80504],
      Louisville: [80027],
      Loveland: [80537, 80538],
      Lycan: [81084],
      Lyons: [80540],
      Mack: [81525],
      Mancos: [81328],
      'Manitou Springs': [80829],
      Manzanola: [81058],
      Marble: [81623],
      Matheson: [80830],
      Maybell: [81640],
      'Mc Clave': [81057],
      'Mc Coy': [80463],
      Meeker: [81641],
      Meredith: [81642],
      Mesa: [81643],
      Mesita: [81152],
      Milliken: [80543],
      Moffat: [81143],
      'Monte Vista': [81144],
      Montrose: [81401],
      Monument: [80132],
      Morrison: [80465],
      Mosca: [81146],
      'Mountain View': [80212],
      Nathrop: [81236],
      Naturita: [81422],
      Nederland: [80466],
      'New Castle': [81647],
      'New Raymer': [80742],
      'North Avondale': [81022],
      'North Pole': [80809],
      Northglenn: [80233, 80234, 80241],
      Norwood: [81423],
      Nucla: [81424],
      Nunn: [80648],
      'Oak Creek': [80467],
      Olathe: [81425],
      'Olney Springs': [81062],
      Ophir: [81426],
      Orchard: [80649],
      Ordway: [81063],
      Otis: [80743],
      Ouray: [81427],
      Ovid: [80744],
      Padroni: [80745],
      'Pagosa Springs': [81147],
      Palisade: [81526],
      'Palmer Lake': [80133],
      Paonia: [81428],
      Parker: [80134],
      Parlin: [81239],
      Parshall: [80468],
      Peetz: [80747],
      Penrose: [81240],
      Peyton: [80831],
      Pierce: [80650],
      Pine: [80470],
      Pinecliffe: [80471],
      Pitkin: [81241],
      Placerville: [81430],
      Platteville: [80651],
      'Pleasant View': [81331],
      Powderhorn: [81243],
      Pueblo: [81001, 81003, 81004, 81005, 81006, 81008],
      'Pueblo West': [81007],
      Ramah: [80832],
      Rangely: [81648],
      'Red Feather Lake': [80545],
      Redvale: [81431],
      Ridgway: [81432],
      Rifle: [81650],
      'Rocky Ford': [81067],
      Roggen: [80652],
      Rollinsville: [80474],
      Rush: [80833],
      Rye: [81069],
      Saguache: [81149],
      Salida: [81201],
      'San Acacio': [81150],
      'San Pablo': [81153],
      Sanford: [81151],
      Sedgwick: [80749],
      Seibert: [80834],
      Silt: [81652],
      Silverton: [81433],
      Simla: [80835],
      Slater: [81653],
      Snowmass: [81654],
      Snyder: [80750],
      Somerset: [81434],
      'South Fork': [81154],
      Springfield: [81073],
      'Steamboat Spring': [80487],
      Sterling: [80751],
      Stoneham: [80754],
      Strasburg: [80136],
      Stratton: [80836],
      'Sugar City': [81076],
      Telluride: [81435],
      Thornton: [80229],
      Timpas: [81050],
      Toponas: [80479],
      Towaoc: [81334],
      Towner: [81071],
      Trinchera: [81081],
      'Twin Lakes': [81251],
      'United States Ai': [80840],
      Utleyville: [81064],
      Vail: [81657],
      Vernon: [80755],
      Vilas: [81087],
      'Villa Grove': [81155],
      Villegreen: [81049],
      'Virginia Dale': [80536],
      Vona: [80861],
      Walden: [80480],
      Walsh: [81090],
      Ward: [80481],
      Watkins: [80137],
      Wattenburg: [80621],
      Weldona: [80653],
      Wellington: [80549],
      Westcliffe: [81252],
      Westminster: [80021, 80030],
      Weston: [81091],
      Wetmore: [81253],
      'Wheat Ridge': [80033],
      Whitewater: [81527],
      Wiley: [81092],
      Willard: [80741],
      Windsor: [80550],
      'Woodland Park': [80863],
      'Yellow Jacket': [81335],
      Yoder: [80864],
      Yuma: [80759],
    },
    name: 'Colorado',
  },
  CT: {
    cities: {
      Amston: ['06231'],
      Andover: ['06232'],
      Ansonia: ['06401'],
      Avon: ['06001'],
      Baltic: ['06330'],
      Bantam: ['06750'],
      'Beacon Falls': ['06403'],
      Berlin: ['06037'],
      Bethany: ['06524'],
      Bethel: ['06801'],
      Bethlehem: ['06751'],
      Bloomfield: ['06002'],
      Bolton: ['06043'],
      Bozrah: ['06334'],
      Branford: ['06405'],
      Bridgeport: ['06604', '06605', '06606', '06607', '06608', '06610'],
      Bridgewater: ['06752'],
      Bristol: ['06010'],
      Brookfield: ['06804'],
      Brooklyn: ['06234'],
      Burlington: ['06013'],
      Byram: ['06830'],
      Canaan: ['06018'],
      Canterbury: ['06331'],
      Canton: ['06019'],
      'Canton Center': ['06020'],
      Centerbrook: ['06409'],
      Chaplin: ['06235'],
      Cheshire: ['06410'],
      Chester: ['06412'],
      Clinton: ['06413'],
      Colchester: ['06415'],
      Colebrook: ['06021'],
      Collinsville: ['06022'],
      Columbia: ['06237'],
      'Cos Cob': ['06807'],
      Coventry: ['06238'],
      Cromwell: ['06416'],
      Danbury: ['06810', '06811'],
      Danielson: ['06239'],
      Darien: ['06820'],
      Dayville: ['06241'],
      'Deep River': ['06417'],
      Derby: ['06418'],
      Durham: ['06422'],
      'East Berlin': ['06023'],
      'East Canaan': ['06024'],
      'East Granby': ['06026'],
      'East Haddam': ['06423'],
      'East Hampton': ['06424'],
      'East Hartford': ['06108', '06118'],
      'East Hartland': ['06027'],
      'East Haven': ['06512', '06513'],
      'East Killingly': ['06243'],
      'East Lyme': ['06333'],
      'East Windsor': ['06088'],
      Eastford: ['06242'],
      Easton: ['06612'],
      Ellington: ['06029'],
      Enfield: ['06082'],
      Essex: ['06426'],
      Fairfield: ['06430', '06432'],
      'Falls Village': ['06031'],
      Farmington: ['06032'],
      'Gales Ferry': ['06335'],
      Gaylordsville: ['06755'],
      Gilman: ['06336'],
      Glastonbury: ['06033'],
      Goshen: ['06756'],
      Granby: ['06035'],
      Greenwich: ['06831'],
      Groton: ['06340', '06349'],
      Guilford: ['06437'],
      Haddam: ['06438'],
      Hamden: ['06514', '06517', '06518'],
      Hampton: ['06247'],
      Hartford: ['06103', '06105', '06106', '06112', '06114', '06120'],
      Harwinton: ['06791'],
      Hebron: ['06248'],
      Higganum: ['06441'],
      Ivoryton: ['06442'],
      'Jewett City': ['06351'],
      Kent: ['06757'],
      Killingworth: ['06419'],
      Lakeside: ['06758'],
      Lakeville: ['06039'],
      Lebanon: ['06249'],
      Ledyard: ['06339'],
      Litchfield: ['06759'],
      Madison: ['06443'],
      Manchester: ['06040'],
      'Mansfield Center': ['06250'],
      'Maple Hill': ['06111'],
      Marlborough: ['06447'],
      Meriden: ['06450'],
      Middlebury: ['06762'],
      Middlefield: ['06455'],
      Middletown: ['06457'],
      Milford: ['06460'],
      Monroe: ['06468'],
      Montville: ['06353'],
      Moodus: ['06469'],
      Moosup: ['06354'],
      Morris: ['06763'],
      Mystic: ['06355'],
      Naugatuck: ['06770'],
      'New Britain': ['06051', '06052', '06053'],
      'New Canaan': ['06840'],
      'New Fairfield': ['06812'],
      'New Hartford': ['06057'],
      'New Haven': ['06510', '06511', '06515', '06519'],
      'New London': ['06320'],
      'New Milford': ['06776'],
      'New Preston Marb': ['06777'],
      Newtown: ['06470'],
      Niantic: ['06357'],
      Norfolk: ['06058'],
      'North Branford': ['06471'],
      'North Canton': ['06059'],
      'North Franklin': ['06254'],
      'North Granby': ['06060'],
      'North Grosvenord': ['06255'],
      'North Haven': ['06473'],
      'North Stonington': ['06359'],
      'North Windham': ['06256'],
      Northfield: ['06778'],
      Northford: ['06472'],
      Norwalk: ['06850', '06851', '06853', '06854', '06855'],
      Norwich: ['06360'],
      Oakdale: ['06370'],
      Oakville: ['06779'],
      'Old Greenwich': ['06870'],
      'Old Lyme': ['06371'],
      'Old Saybrook': ['06475'],
      Orange: ['06477'],
      Oxford: ['06478'],
      Pawcatuck: ['06379'],
      Plainfield: ['06374'],
      Plainville: ['06062'],
      Plantsville: ['06479'],
      'Pleasant Valley': ['06063'],
      Plymouth: ['06782'],
      'Pomfret Center': ['06259'],
      Portland: ['06480'],
      Preston: ['06365'],
      Prospect: ['06712'],
      Putnam: ['06260'],
      'Quaker Hill': ['06375'],
      Quinebaug: ['06262'],
      Ridgefield: ['06877'],
      Ridgeway: ['06905'],
      Riverside: ['06878'],
      Riverton: ['06065'],
      Rockfall: ['06481'],
      'Rocky Hill': ['06067'],
      Roxbury: ['06783'],
      Salem: ['06420'],
      Salisbury: ['06068'],
      'Sandy Hook': ['06482'],
      Scotland: ['06264'],
      Seymour: ['06483'],
      Sharon: ['06069'],
      Shelton: ['06484'],
      Sherman: ['06784'],
      Simsbury: ['06070'],
      Somers: ['06071'],
      'South Glastonbur': ['06073'],
      'South Kent': ['06785'],
      'South Windham': ['06266'],
      'South Windsor': ['06074'],
      Southbury: ['06488'],
      Southington: ['06489'],
      Southport: ['06490'],
      'Stafford Springs': ['06076'],
      Stamford: ['06901', '06902', '06903', '06906', '06907'],
      Sterling: ['06377'],
      Stonington: ['06378'],
      'Storrs Mansfield': ['06268'],
      Stratford: ['06497'],
      Suffield: ['06078'],
      Taftville: ['06380'],
      Tariffville: ['06081'],
      Terryville: ['06786'],
      Thomaston: ['06787'],
      Thompson: ['06277'],
      Tolland: ['06084'],
      Torrington: ['06790'],
      Trumbull: ['06611'],
      Uncasville: ['06382'],
      Unionville: ['06085'],
      'Vernon Rockville': ['06066'],
      Voluntown: ['06384'],
      'W Hartford': ['06107', '06110', '06117', '06119'],
      Wallingford: ['06492'],
      Warren: ['06754'],
      Warrenville: ['06278'],
      'Washington Depot': ['06793', '06794'],
      Waterbury: ['06702', '06704', '06705', '06706', '06708', '06710'],
      Waterford: ['06385'],
      Watertown: ['06795'],
      Weatogue: ['06089'],
      'West Cornwall': ['06796'],
      'West Granby': ['06090'],
      'West Haven': ['06516'],
      'West Redding': ['06896'],
      'West Simsbury': ['06092'],
      'West Suffield': ['06093'],
      'West Willington': ['06279'],
      Westbrook: ['06498'],
      Weston: ['06883'],
      Westport: ['06880'],
      Wethersfield: ['06109'],
      Willimantic: ['06226'],
      Wilton: ['06897'],
      Windham: ['06280'],
      Windsor: ['06095'],
      'Windsor Locks': ['06096'],
      Windsorville: ['06016'],
      Winsted: ['06098'],
      Wolcott: ['06716'],
      Woodbridge: ['06525'],
      Woodbury: ['06798'],
      Woodstock: ['06281'],
      'Woodstock Valley': ['06282'],
    },
    name: 'Connecticut',
  },
  DC: {
    cities: {
      Pentagon: [20301],
      Washington: [
        20001, 20002, 20003, 20004, 20005, 20006, 20007, 20008, 20009, 20010,
        20011, 20012, 20015, 20016, 20017, 20018, 20019, 20020, 20024, 20032,
        20036, 20037, 20336,
      ],
    },
    name: 'District Of Columbia',
  },
  DE: {
    cities: {
      Bear: [19701],
      'Bethany Beach': [19930],
      Bethel: [19931],
      Bridgeville: [19933],
      'Camden Wyoming': [19934],
      Claymont: [19703],
      Clayton: [19938],
      Dagsboro: [19939],
      Delmar: [19940],
      'Dewey Beach': [19971],
      Dover: [19901],
      'Dover Afb': [19902],
      Edgemoor: [19809, 19810],
      Ellendale: [19941],
      Felton: [19943],
      Frankford: [19945],
      Frederica: [19946],
      Georgetown: [19947],
      Greenville: [19807],
      Greenwood: [19950],
      Harbeson: [19951],
      Harrington: [19952],
      Hartly: [19953],
      Hockessin: [19707],
      Houston: [19954],
      Laurel: [19956],
      Lewes: [19958],
      Lincoln: [19960],
      'Long Neck': [19966],
      Magnolia: [19962],
      Manor: [19720],
      Marshallton: [19808],
      Marydel: [19964],
      Middletown: [19709],
      Milford: [19963],
      Millville: [19967, 19970],
      Milton: [19968],
      Newark: [19702, 19711, 19713],
      Newport: [19804],
      Seaford: [19973],
      Selbyville: [19975],
      Smyrna: [19977],
      Talleyville: [19803],
      Townsend: [19734],
      Viola: [19979],
      Wilmington: [19801, 19802, 19805, 19806],
    },
    name: 'Delaware',
  },
  FL: {
    cities: {
      32620: [32620],
      32629: [32629],
      32630: [32630],
      32636: [32636],
      32642: [32642],
      32646: [32646],
      32649: [32649],
      32650: [32650],
      32652: [32652],
      32661: [32661],
      32665: [32665],
      32670: [32670],
      32671: [32671],
      32672: [32672],
      32673: [32673],
      32674: [32674],
      32675: [32675],
      32676: [32676],
      32684: [32684],
      32688: [32688],
      32691: [32691],
      32698: [32698],
      Airport: [34622],
      Alford: [32420],
      Aloma: [32792],
      'Altamonte Spring': [32701],
      Altha: [32421],
      Altoona: [32702],
      Alva: [33920],
      'Amelia Island': [32034],
      Anthony: [32617],
      Apalachicola: [32320],
      'Apollo Beach': [33572],
      Apopka: [32712],
      Arcadia: [33821],
      Archer: [32618],
      Astatula: [34705],
      Astor: [32102],
      'Atlantic Beach': [32233],
      Auburndale: [33823],
      'Avon Park': [33825],
      'Azalea Park': [32807],
      'Babson Park': [33827],
      Baker: [32531],
      'Bal Harbour': [33154],
      Baldwin: [32234],
      'Barefoot Bay': [32976],
      Bartow: [33830],
      Bascom: [32423],
      Basinger: [34972],
      Bell: [32619],
      'Belle Glade': [33430],
      'Belleair Beach': [34635],
      'Belleair Bluffs': [34640],
      'Big Pine Key': [33043],
      Blountstown: [32424],
      'Boca Raton': [33428, 33431, 33432, 33433, 33434, 33486, 33496, 33498],
      Bokeelia: [33922],
      Bonifay: [32425],
      'Bonita Springs': [33923],
      'Boynton Beach': [33426, 33437],
      'Boys Ranch': [32060],
      'Braden River': [34202, 34203, 34208],
      Bradenton: [34210],
      'Bradenton Beach': [34217],
      Brandon: [33510, 33511],
      Branford: [32008],
      'Briny Breezes': [33435],
      Bristol: [32321],
      Bronson: [32621],
      Brooker: [32622],
      Brooksville: [34601, 34613, 34614],
      Bryceville: [32009],
      'Buena Ventura La': [34743],
      Bunnell: [32110],
      Bushnell: [33513],
      Callahan: [32011],
      Campbellton: [32426],
      'Canal Point': [33438],
      Cantonment: [32533],
      'Cape Canaveral': [32920],
      'Cape Coral Centr': [33904, 33909, 33914, 33990, 33991],
      Captiva: [33924],
      'Carl Fisher': [33139],
      'Carol City': [33055, 33056],
      Carrabelle: [32322],
      Carrollwood: [33618, 33624],
      Caryville: [32427],
      Casselberry: [32707],
      'Cecil Field Nas': [32215],
      'Cedar Key': [32625],
      'Center Hill': [33514],
      Century: [32535],
      Chattahoochee: [32324],
      Chiefland: [32626],
      Chipley: [32428],
      Christmas: [32709],
      Chuluota: [32766],
      Citra: [32113],
      'City Of Sunrise': [33313],
      Clarksville: [32430],
      Clearwater: [
        34615, 34616, 34619, 34620, 34621, 34623, 34624, 34625, 34630,
      ],
      Clermont: [34711],
      Clewiston: [33440],
      Cocoa: [32922, 32926],
      'Cocoa Beach': [32931],
      'College Parkway': [33919],
      'College Plaza': [34207],
      'Coral Gables': [33133, 33134, 33145, 33146],
      'Coral Springs': [33065],
      Cortez: [34215],
      Cottondale: [32431],
      Crawfordville: [32327],
      'Crescent Beach': [34242],
      'Crescent City': [32112],
      Crestview: [32536],
      'Cypress Gardens': [33884],
      Dania: [33004],
      Davenport: [33837],
      Davie: [33314, 33325, 33326, 33328, 33330, 33331, 33332],
      Day: [32013],
      'Daytona Beach': [32114, 32118],
      'De Funiak Spring': [32433],
      'De Leon Springs': [32130],
      Debary: [32713],
      'Deerfield Beach': [33441, 33442],
      Deland: [32720, 32724],
      'Delray Beach': [33444, 33445, 33446, 33483, 33484],
      Deltona: [32725, 32738],
      'Dona Vista': [32784],
      Dover: [33527],
      Duette: [33834],
      Dundee: [33838],
      Dunedin: [34698],
      Dunlawton: [32119],
      'Eagle Lake': [33839],
      Earleton: [32631],
      'East Palatka': [32131],
      Eatonville: [32751],
      'Eau Gallie': [32934],
      Ebro: [32437],
      Edgewater: [32132, 32141],
      'Eglin A F B': [32542],
      'El Jobean': [33927],
      Elkton: [32033],
      Ellenton: [34222],
      Eloise: [33880],
      Englewood: [34223],
      Estero: [33928],
      Eustis: [32726],
      Fairvilla: [32804],
      Fellsmere: [32948],
      'Fern Park': [32730],
      'Flagler Beach': [32136],
      Florahome: [32140],
      'Florida City': [33034],
      'Forest City': [32714],
      'Forest Lakes': [34232],
      'Fort Lauderdale': [
        33301, 33309, 33311, 33312, 33315, 33316, 33327, 33388,
      ],
      'Fort Meade': [33841],
      'Fort Myers': [33901, 33903, 33907, 33908, 33912, 33913, 33916, 33917],
      'Fort Myers Beach': [33931],
      'Fort Pierce': [34945, 34946, 34947, 34949, 34950, 34951, 34981, 34982],
      'Fort Walton Beac': [32547, 32548],
      'Fort White': [32038],
      Fountain: [32438],
      Freeport: [32439],
      Frostproof: [33843],
      'Fruitland Park': [34731],
      Gainesville: [32601, 32603, 32605, 32606, 32607, 32608, 32609, 32611],
      Geneva: [32732],
      Georgetown: [32139],
      Gibsonton: [33534],
      'Glen Ridge': [33406],
      'Glen Saint Mary': [32040],
      Graceville: [32440],
      'Grand Island': [32735],
      'Grand Ridge': [32442],
      'Green Cove Sprin': [32043],
      Greenacres: [33463],
      Greenville: [32331],
      Greenwood: [32443],
      Grenelefe: [33844],
      'Grove City': [34224],
      Groveland: [34736],
      'Gulf Breeze': [32561],
      'Haines Creek': [34788],
      Hallandale: [33009],
      Hampton: [32044],
      Hastings: [32145],
      Havana: [32333],
      Haverhill: [33409, 33415, 33417],
      Hawthorne: [32640],
      Heathrow: [32746],
      Hialeah: [33010, 33012, 33013, 33014, 33015, 33016],
      'High Springs': [32643],
      'Highland Beach': [33487],
      Hilliard: [32046],
      'Hobe Sound': [33455],
      Holiday: [34690, 34691],
      'Holly Hill': [32117],
      Hollywood: [33019, 33020, 33021, 33025, 33026, 33027, 33028],
      Holt: [32564],
      Homestead: [33030, 33031, 33033, 33035],
      'Homestead Air Fo': [33039],
      'Horseshoe Beach': [32648],
      Hosford: [32334],
      'Howey In The Hil': [34737],
      Hudson: [34667, 34669],
      'Hunt Club': [32703],
      Immokalee: [33934],
      Indialantic: [32903],
      'Indian Harbor Be': [32937],
      'Indian River Sho': [32963],
      Indiantown: [34956],
      Interlachen: [32148],
      Islamorada: [33036],
      Jacksonville: [
        32202, 32204, 32205, 32206, 32207, 32208, 32209, 32210, 32211, 32216,
        32217, 32218, 32219, 32220, 32221, 32222, 32223, 32224, 32225, 32226,
        32244, 32256, 32257, 32258, 32259,
      ],
      'Jacksonville Bea': [32227, 32250],
      'Jacksonville N A': [32212],
      Jasper: [32052],
      Jay: [32565],
      Jennings: [32053],
      'Jensen Beach': [34957],
      Jupiter: [33458, 33477, 33478],
      Kathleen: [33849],
      Kenansville: [34739],
      Kendall: [33156],
      'Kennedy Space Ce': [32815],
      'Kenneth City': [33709],
      'Key Biscayne': [33149],
      'Keystone Heights': [32656],
      Kinard: [32449],
      Kissimmee: [34741, 34744, 34746, 34758],
      Labelle: [33935],
      'Lady Lake': [32159],
      'Lake Alfred': [33850],
      'Lake Buena Vista': [32830],
      'Lake Butler': [32054],
      'Lake City': [32055],
      'Lake Helen': [32744],
      'Lake Panasoffkee': [33538],
      'Lake Park': [33403],
      'Lake Placid': [33852],
      'Lake Tarpon': [34684],
      'Lake Wales': [33853],
      'Lake Worth': [33460, 33461, 33467],
      Lakeland: [33801, 33803, 33805, 33809],
      Lamont: [32336],
      'Land O Lakes': [34639],
      Lantana: [33462],
      Largo: [34641, 34643, 34644, 34646, 34647, 34648],
      'Laurel Hill': [32567],
      Lawtey: [32058],
      Lee: [32059],
      Leesburg: [34748],
      'Lehigh Acres': [33936, 33971],
      'Lighthouse Point': [33064],
      Lithia: [33547],
      Lockhart: [32810],
      Longwood: [32750],
      Lorida: [33857],
      Loxahatchee: [33470],
      Lulu: [32061],
      Lutz: [33549],
      'Lynn Haven': [32444],
      Macclenny: [32063],
      'Madeira Beach': [33708],
      Madison: [32340],
      Malone: [32445],
      Marathon: [33050],
      'Marco Island': [33937],
      Margate: [33063, 33066],
      Marianna: [32446],
      'Mary Esther': [32569],
      Mayo: [32066],
      'Mc Alpin': [32062],
      'Meadows Village': [34234],
      Melbourne: [32901, 32935, 32940],
      'Melbourne Beach': [32951],
      'Melbourne Villag': [32904],
      Melrose: [32666],
      'Merritt Island': [32952, 32953],
      Miami: [
        33122, 33125, 33126, 33127, 33128, 33129, 33130, 33131, 33132, 33135,
        33136, 33137, 33140, 33142, 33144, 33147, 33150, 33155, 33158, 33167,
        33168, 33169, 33172, 33173, 33174, 33176, 33178, 33179, 33182, 33183,
        33184, 33186, 33193, 33196,
      ],
      'Miami Shores': [33138],
      'Miami Springs': [33166],
      Micanopy: [32667],
      'Mid Venice': [34292],
      Middleburg: [32068],
      Milton: [32570, 32583],
      Mims: [32754],
      Miramar: [33023],
      Monticello: [32344],
      Montverde: [34756],
      'Moore Haven': [33471],
      Morriston: [32668],
      'Mount Dora': [32757],
      Mulberry: [33860],
      'Myakka City': [34251],
      Naples: [33940, 33942, 33961, 33962, 33963, 33964, 33999],
      'Naval Air Statio': [33040],
      'Naval Training C': [32813],
      Navarre: [32566],
      'Neptune Beach': [32266],
      'New Port Richey': [34652, 34653, 34654, 34655],
      'New Smyrna Beach': [32168, 32169],
      Newberry: [32669],
      Niceville: [32578],
      Nokomis: [34275],
      'North Bay Villag': [33141],
      'North Coral Spri': [33067],
      'North Miami': [33161],
      'North Miami Beac': [33160, 33162, 33181],
      'North Palm Beach': [33408],
      'North Port': [34287],
      'O Brien': [32071],
      'Oak Hill': [32759],
      'Oakland Park': [33304, 33305, 33306, 33308, 33334],
      'Ocean Reef': [33037],
      Ochopee: [33943],
      Ocklawaha: [32179],
      Ocoee: [34761],
      Odessa: [33556],
      Ojus: [33180],
      Okahumpka: [34762],
      Okeechobee: [34974],
      'Old Town': [32680],
      Oldsmar: [34677],
      'Olympia Heights': [33165, 33175, 33185],
      Ona: [33865],
      'Opa Locka': [33054],
      'Orange City': [32763],
      'Orange Park': [32065, 32073],
      Orlando: [
        32801, 32803, 32805, 32806, 32812, 32818, 32821, 32824, 32825, 32826,
        32827, 32828, 32829, 32831, 32832, 32835, 32836, 32837, 32839,
      ],
      'Orlo Vista': [32811],
      'Ormond Beach': [32174, 32176],
      Osprey: [34229],
      Osteen: [32764],
      Oviedo: [32765],
      Pace: [32571],
      Pahokee: [33476],
      Paisley: [32767],
      Palatka: [32177],
      'Palm Bay': [32905, 32907, 32908, 32909],
      'Palm Beach': [33480],
      'Palm Beach Garde': [33410, 33418],
      'Palm City': [34990],
      'Palm Coast': [32137],
      'Palm Harbor': [34683, 34685],
      'Palma Sola': [34209],
      Palmetto: [34221],
      Panacea: [32346],
      'Panama City': [32401, 32403, 32404, 32405],
      'Panama City Beac': [32407, 32408, 32413],
      Parrish: [34219],
      'Patrick A F B': [32925],
      'Pembroke Pines': [33024, 33029],
      Pensacola: [
        32501, 32503, 32504, 32505, 32506, 32507, 32508, 32514, 32526, 32534,
      ],
      Perrine: [33157],
      Perry: [32347],
      Pierson: [32180],
      'Pine Castle': [32809],
      'Pine Hills': [32808],
      'Pinellas Park': [34665, 34666],
      Pinetta: [32350],
      Placida: [33946, 33947],
      'Plant City': [33565, 33566, 33567],
      Plantation: [33317, 33324],
      Poinciana: [34759],
      'Polk City': [33868],
      'Pomona Park': [32181],
      'Pompano Beach': [33060, 33062, 33068, 33069, 33071, 33073, 33076],
      'Ponce De Leon': [32455],
      'Ponte Vedra Beac': [32082],
      'Port Charlotte': [33948, 33952, 33953, 33954, 33980, 33981],
      'Port Orange': [32124, 32127],
      'Port Richey': [34668],
      'Port Saint Joe': [32456],
      'Port Saint John': [32927],
      'Port Saint Lucie': [34952, 34953, 34983, 34984, 34986, 34987, 34988],
      Princeton: [33032],
      'Punta Gorda': [33950, 33955, 33982, 33983],
      'Quail Heights': [33170, 33177, 33187, 33189, 33190],
      Quincy: [32351],
      Raiford: [32083],
      Reddick: [32686],
      'Ridge Manor': [33525],
      'Ridge Manor Esta': [33597],
      'Ridge Manor West': [34602],
      Riverview: [33569],
      'Riviera Beach': [33404],
      Rockledge: [32955],
      'Royal Palm Beach': [33411],
      Ruskin: [33570],
      'Safety Harbor': [34695],
      'Saint Augustine': [32084, 32086, 32092, 32095],
      'Saint Cloud': [34769, 34771, 34772, 34773],
      'Saint George Isl': [32328],
      'Saint James City': [33956],
      'Saint Petersburg': [
        33701, 33702, 33703, 33704, 33705, 33706, 33707, 33710, 33711, 33712,
        33713, 33714, 33716,
      ],
      Salem: [32356],
      'Salt Springs': [32134],
      'San Antonio': [33576],
      'San Mateo': [32187],
      'Sand Lake': [32819],
      Sanderson: [32087],
      Sandestin: [32541],
      Sanford: [32771, 32773],
      Sanibel: [33957],
      'Santa Fe': [32615],
      'Santa Rosa Beach': [32459],
      Sarasota: [34233, 34235, 34236, 34237, 34239, 34240, 34241, 34243],
      'Sarasota Square': [34238],
      Satsuma: [32189],
      Sebastian: [32958],
      Sebring: [33870, 33872],
      Seffner: [33584],
      Seminole: [34642],
      Seville: [32190],
      'Shady Hills': [34610],
      Shalimar: [32579],
      Sneads: [32460],
      Sopchoppy: [32358],
      Sorrento: [32776],
      'South Bay': [33493],
      'South Miami': [33143],
      'South Trail': [34231],
      'South Venice': [34293],
      Southport: [32409],
      Southside: [33811, 33813],
      'Spring Hill': [34606, 34607, 34608, 34609],
      'Springs Plaza': [32779],
      Starke: [32091],
      Steinhatchee: [32359],
      Stuart: [34994, 34996, 34997],
      'Summerland Key': [33042],
      'Sun City Center': [33573],
      Sunrise: [33322, 33323],
      Tallahassee: [32301, 32303, 32304, 32306, 32308, 32310, 32311, 32312],
      Tamarac: [33319, 33321, 33351],
      Tampa: [
        33602, 33603, 33604, 33605, 33606, 33607, 33608, 33609, 33610, 33611,
        33612, 33613, 33614, 33615, 33616, 33617, 33619, 33620, 33625, 33626,
        33629, 33634, 33635, 33637, 33647,
      ],
      'Tarpon Springs': [34689],
      Tavares: [32778],
      Tavernier: [33070],
      Tequesta: [33469],
      Thonotosassa: [33592],
      Tice: [33905],
      'Tierra Verde': [33715],
      Titusville: [32780, 32796],
      Trenton: [32693],
      'Union Park': [32817, 32820, 32833],
      Valparaiso: [32580],
      Valrico: [33594],
      Venice: [34285],
      Ventura: [32822],
      Venus: [33960],
      Vernon: [32462],
      'Vero Beach': [32960, 32962, 32966, 32967, 32968],
      'Village Of Golf': [33436],
      Waldo: [32694],
      'Walnut Hill': [32568],
      Wauchula: [33873],
      Weirsdale: [32195],
      Wellborn: [32094],
      'Wesley Chapel': [33543],
      'West Palm Beach': [33401, 33405, 33407, 33412, 33413, 33414],
      Westgate: [34205],
      Westville: [32464],
      Wewahitchka: [32465],
      'White Springs': [32096],
      'Whitney Beach': [34228],
      Wildwood: [34785],
      Williston: [32696],
      Wimauma: [33598],
      Windermere: [34786],
      'Winter Garden': [34787],
      'Winter Haven': [33881],
      'Winter Park': [32789],
      'Winter Springs': [32708],
      Yalaha: [34797],
      Youngstown: [32466],
      Yulee: [32097],
      Zellwood: [32798],
      Zephyrhills: [33540, 33541, 33544],
      'Zolfo Springs': [33890],
    },
    name: 'Florida',
  },
  GA: {
    cities: {
      Abac: [31794],
      Abbeville: [31001],
      Acworth: [30101],
      Adairsville: [30103],
      Adel: [31620],
      Adrian: [31002],
      Ailey: [30410],
      Alamo: [30411],
      Alapaha: [31622],
      Albany: [31701, 31707],
      Allenhurst: [31301],
      Allentown: [31003],
      Alma: [31510],
      Alpharetta: [30201, 30202],
      Alto: [30510],
      Alvaton: [30218],
      Ambrose: [31512],
      Andersonville: [31711],
      Appling: [30802],
      Arabi: [31712],
      Aragon: [30104],
      Arlington: [31713],
      Armuchee: [30105],
      Arnoldsville: [30619],
      Ashburn: [31714],
      Athens: [30601, 30605, 30606, 30607],
      Atlanta: [
        30303, 30305, 30306, 30307, 30308, 30309, 30310, 30311, 30312, 30313,
        30314, 30315, 30316, 30317, 30318, 30319, 30324, 30326, 30327, 30329,
        30330, 30331, 30334, 30336, 30339, 30342, 30345, 30346, 30349, 30350,
        30360,
      ],
      Attapulgus: [31715],
      Auburn: [30203],
      Augusta: [30901, 30904],
      Austell: [30001],
      Avera: [30803],
      'Avondale Estates': [30002],
      Axson: [31624],
      Baconton: [31716],
      Bainbridge: [31717],
      Baldwin: [30511],
      'Ball Ground': [30107],
      Barnesville: [30204],
      Barney: [31625],
      Bartow: [30413],
      Baxley: [31513],
      Bemiss: [31602],
      Bethlehem: [30620],
      Bishop: [30621],
      Blackshear: [31516],
      Blairsville: [30512],
      Blakely: [31723],
      Bloomingdale: [31302],
      'Blue Ridge': [30513],
      Bluffton: [31724],
      Blythe: [30805],
      Bogart: [30622],
      Bonaire: [31005],
      Boston: [31626],
      Bowdon: [30108],
      Bowersville: [30516],
      Bowman: [30624],
      Braselton: [30517],
      Bremen: [30110],
      Bridgeboro: [31705],
      Brinson: [31725],
      Bristol: [31518],
      Bronwood: [31726],
      Brooklet: [30415],
      Brooks: [30205],
      Broxton: [31519],
      Brunswick: [31525],
      Buchanan: [30113],
      Buckhead: [30625],
      Buford: [30518],
      Butler: [31006],
      Byromville: [31007],
      Cadwell: [31009],
      Cairo: [31728],
      Calhoun: [30701],
      Calvary: [31729],
      Camilla: [31730],
      Canon: [30520],
      Canton: [30114],
      Carlton: [30627],
      Carnesville: [30521],
      Carrollton: [30117],
      Cartersville: [30120],
      Cataula: [31804],
      'Cave Spring': [30124],
      Cedartown: [30125],
      Centerville: [31028],
      'Centerville Gwin': [30058],
      Chamblee: [30341],
      Chatsworth: [30705],
      Chauncey: [31011],
      Cherrylog: [30522],
      Chester: [31012],
      Chickamauga: [30707],
      Chula: [31733],
      Cisco: [30708],
      Clarkesville: [30523],
      Clarkston: [30021],
      Claxton: [30417],
      Clayton: [30525],
      Clermont: [30527],
      Cleveland: [30528],
      Climax: [31734],
      Cloudland: [30731],
      Clyattville: [31601],
      Clyo: [31303],
      Cobb: [31735],
      Cobbtown: [30420],
      Cochran: [31014],
      Cogdell: [31634],
      Cohutta: [30710],
      Colbert: [30628],
      Coleman: [31736],
      'College Park': [30337],
      Collins: [30421],
      Colquitt: [31737],
      Columbus: [31901, 31903, 31904, 31906, 31907, 31909],
      Comer: [30629],
      Commerce: [30529],
      Concord: [30206],
      Conley: [30027],
      Conyers: [30207, 30208],
      Coolidge: [31738],
      Cordele: [31015],
      Cornelia: [30531],
      Crandall: [30711],
      Crawford: [30630],
      Crawfordville: [30631],
      Crescent: [31304],
      Culloden: [31016],
      Cumming: [30130],
      Cusseta: [31805],
      'Custer Terrace': [31905],
      Cuthbert: [31740],
      Dacula: [30211],
      Dahlonega: [30533],
      Dallas: [30132],
      Dalton: [30720, 30721],
      Damascus: [31741],
      Danburg: [30668],
      Danielsville: [30633],
      Danville: [31017],
      Darien: [31305],
      Davisboro: [31018],
      'De Soto': [31743],
      Dearing: [30808],
      Decatur: [30030, 30032, 30033, 30034, 30035],
      Deepstep: [31082],
      Demorest: [30535],
      Denton: [31532],
      Devereux: [31087],
      'Dewy Rose': [30634],
      Dexter: [31019],
      Dixie: [31629],
      Doerun: [31744],
      Donalsonville: [31745],
      Doraville: [30340],
      Douglas: [31533],
      Douglasville: [30134, 30135],
      'Dry Branch': [31020],
      'Du Pont': [31630],
      Dudley: [31022],
      Duluth: [30136],
      Dunwoody: [30338],
      'East Dublin': [31021],
      'East Ellijay': [30539],
      'East Point': [30344],
      Eastanollee: [30538],
      Eastman: [31023],
      Eatonton: [31024],
      Edison: [31746],
      Elberton: [30635],
      Elko: [31025],
      Ellabell: [31308],
      Ellaville: [31806],
      Ellenwood: [30049],
      Ellerslie: [31807],
      Ellijay: [30540],
      Emerson: [30137],
      Enigma: [31749],
      Epworth: [30541],
      Evans: [30809],
      Fairburn: [30213],
      Fairmount: [30139],
      Fargo: [31631],
      Felton: [30140],
      Fitzgerald: [31750],
      Fleming: [31309],
      Flintstone: [30725],
      Flovilla: [30216],
      'Flowery Branch': [30542],
      Folkston: [31537],
      'Forest Hills': [30909],
      'Forest Park': [30050],
      Forsyth: [31029],
      'Fort Gaines': [31751],
      'Fort Gordon': [30905],
      'Fort Oglethorpe': [30742],
      'Fort Stewart': [31314],
      'Fort Valley': [31030],
      Fortson: [31808],
      Gainesville: [30501, 30504, 30506, 30507],
      'Garden City': [31408],
      Garfield: [30425],
      Georgetown: [31754],
      'Georgia Southwes': [31709],
      Gibson: [30810],
      Gillsville: [30543],
      Girard: [30426],
      Glenn: [30217],
      Glennville: [30427],
      Glenwood: [30428],
      Glynco: [31520],
      'Good Hope': [30641],
      Grantville: [30220],
      Graves: [31742],
      Gray: [31032],
      Grayson: [30221],
      Greensboro: [30642],
      Griffin: [30223],
      Grovetown: [30813],
      Guyton: [31312],
      Haddock: [31033],
      Hahira: [31632],
      Hamilton: [31811],
      Hampton: [30228],
      Hapeville: [30354],
      Harlem: [30814],
      Harrison: [31035],
      Hartsfield: [31756],
      Hartwell: [30643],
      Hawkinsville: [31036],
      Hazlehurst: [31539],
      Helen: [30545],
      Helena: [31037],
      Hephzibah: [30815],
      Hiawassee: [30546],
      'Hill City': [30735],
      Hiltonia: [30467],
      Hinesville: [31313],
      Hiram: [30141],
      Hoboken: [31542],
      Hogansville: [30230],
      Homer: [30547],
      Hortense: [31543],
      Hoschton: [30548],
      Huber: [31201],
      Hull: [30646],
      Ideal: [31041],
      'Iron City': [31759],
      Irwinton: [31042],
      Irwinville: [31760],
      Jackson: [30233],
      Jacksonville: [31544],
      Jakin: [31761],
      Jasper: [30143],
      Jefferson: [30549],
      Jeffersonville: [31044],
      'Jekyll Island': [31527],
      Jenkinsburg: [30234],
      Jesup: [31545],
      Jewell: [31045],
      Jonesboro: [30236],
      Juliette: [31046],
      'Junction City': [31812],
      Juniper: [31801],
      Juno: [30534],
      Kathleen: [31047],
      Kennesaw: [30144],
      Keysville: [30816],
      Kingsland: [31548],
      Kingston: [30145],
      Kite: [31049],
      Knoxville: [31050],
      'La Fayette': [30728],
      'La Grange': [30240],
      'Lake Park': [31636],
      Lakeland: [31635],
      Lakemont: [30552],
      Lavonia: [30553],
      Lawrenceville: [30243, 30244, 30245],
      Leary: [31762],
      Leesburg: [31763],
      Lenox: [31637],
      Leslie: [31764],
      Lexington: [30648],
      Lilburn: [30247],
      Lincolnton: [30817],
      Lindale: [30147],
      'Lithia Springs': [30057],
      Lithonia: [30038],
      Lizella: [31052],
      'Locust Grove': [30248],
      Loganville: [30249],
      'Lookout Mountain': [30750],
      Louisville: [30434],
      Ludowici: [31316],
      Lula: [30554],
      'Lumber City': [31549],
      Lumpkin: [31815],
      Luthersville: [30251],
      Lyerly: [30730],
      Lyons: [30436],
      'M M': [31419],
      Mableton: [30059],
      Macon: [31204, 31210, 31211],
      Madison: [30650],
      Manassas: [30438],
      Manchester: [31816],
      Manor: [31550],
      Mansfield: [30255],
      'Marble Hill': [30148],
      Marietta: [30060, 30062, 30064, 30066, 30067, 30068],
      'Marine Corps Log': [31704],
      Marshallville: [31057],
      Martin: [30557],
      Martinez: [30907],
      Matthews: [30818],
      Mauk: [31058],
      Maysville: [30558],
      'Mc Caysville': [30555],
      'Mc Donough': [30253],
      'Mc Intyre': [31054],
      'Mc Rae': [31055],
      Meansville: [30256],
      Meigs: [31765],
      Meridian: [31319],
      Mershon: [31551],
      Metter: [30439],
      Midland: [31820],
      Midville: [30441],
      Midway: [31320],
      Milan: [31060],
      Milledgeville: [31061],
      Millen: [30442],
      Millwood: [31552],
      Milner: [30257],
      'Mineral Bluff': [30559],
      Mitchell: [30820],
      Molena: [30258],
      Monroe: [30655],
      Montezuma: [31063],
      Monticello: [31064],
      Montrose: [31065],
      Moreland: [30259],
      Morgan: [31766],
      Morganton: [30560],
      Morrow: [30260],
      Morven: [31638],
      Moultrie: [31768],
      'Mount Airy': [30563],
      'Mount Vernon': [30445],
      Murrayville: [30564],
      Musella: [31066],
      Nahunta: [31553],
      Nashville: [31639],
      Naylor: [31641],
      Newborn: [30262],
      Newington: [30446],
      Newnan: [30265],
      Newton: [31770],
      Nicholls: [31554],
      Nicholson: [30565],
      Norcross: [30071, 30092, 30093],
      'Norman Park': [31771],
      Norwood: [30821],
      'Oak Park': [30401],
      Oakfield: [31772],
      Oakwood: [30566],
      Ochlocknee: [31773],
      Ocilla: [31774],
      Odum: [31555],
      Oglethorpe: [31068],
      Okefenokee: [31501],
      Omaha: [31821],
      Omega: [31775],
      Oxford: [30267],
      Palmetto: [30268],
      Parrott: [31777],
      Patterson: [31557],
      Pavo: [31778],
      'Peach Orchard': [30906],
      'Peachtree City': [30269],
      Pearson: [31642],
      Pelham: [31779],
      Pembroke: [31321],
      Pendergrass: [30567],
      Perkins: [30822],
      Perry: [31069],
      Philomath: [30660],
      'Pine Log': [30171],
      'Pine Mountain': [31822],
      'Pine Mountain Va': [31823],
      Pinehurst: [31070],
      Pinetta: [32350],
      Pineview: [31071],
      Pitts: [31072],
      Plains: [31780],
      Plainville: [30733],
      Pooler: [31322],
      'Port Wentworth': [31407],
      Portal: [30450],
      Poulan: [31781],
      'Powder Springs': [30073],
      Powersville: [31008],
      Preston: [31824],
      Quitman: [31643],
      'Rabun Gap': [30568],
      Ranger: [30734],
      'Ray City': [31645],
      Raymond: [30263],
      Rebecca: [31783],
      Register: [30452],
      Reidsville: [30453],
      Rentz: [31075],
      Rex: [30273],
      Reynolds: [31076],
      Rhine: [31077],
      Riceboro: [31323],
      Richland: [31825],
      'Richmond Hill': [31324],
      Rincon: [31326],
      Ringgold: [30736],
      'Rising Fawn': [30738],
      Riverdale: [30274, 30296],
      Roberta: [31078],
      'Robins A F B': [31098],
      Rochelle: [31079],
      'Rock Spring': [30739],
      Rockledge: [30454],
      Rockmart: [30153],
      'Rocky Face': [30740],
      'Rocky Ford': [30455],
      Rome: [30161, 30165],
      Roopville: [30170],
      Rossville: [30741],
      Roswell: [30075, 30076],
      'Round Oak': [31038],
      Royston: [30662],
      Rupert: [31081],
      Rutledge: [30663],
      'Saint George': [31646],
      'Saint Marys': [31558],
      'Saint Simons Isl': [31522],
      'Sale City': [31784],
      'Sandy Springs': [30328],
      'Sapelo Island': [31327],
      Sardis: [30456],
      'Sautee Nacoochee': [30571],
      Savannah: [31401, 31405, 31406, 31409, 31410, 31411],
      Scottdale: [30079],
      Screven: [31560],
      Senoia: [30276],
      'Shady Dale': [31085],
      Sharpsburg: [30277],
      Shellman: [31786],
      Shiloh: [31826],
      'Silver Creek': [30173],
      'Sky Valley': [30537],
      Smithville: [31787],
      Smyrna: [30080, 30082],
      Snellville: [30278],
      'Social Circle': [30279],
      Soperton: [30457],
      Sparks: [31647],
      Springvale: [31767],
      Stapleton: [30823],
      Starrsville: [30209],
      'State College': [31404],
      Statenville: [31648],
      Statesboro: [30458],
      Statham: [30666],
      Stephens: [30667],
      'Stevens Pottery': [31031],
      Stillwell: [31329],
      Stockbridge: [30281],
      Stockton: [31649],
      'Stone Mountain': [30083, 30087, 30088],
      Stovall: [30222],
      Suches: [30572],
      'Sugar Valley': [30746],
      Summerville: [30747],
      Sumner: [31789],
      Surrency: [31563],
      Suwanee: [30174],
      Sycamore: [31790],
      Sylvester: [31791],
      Talbotton: [31827],
      'Talking Rock': [30175],
      Tallapoosa: [30176],
      Talmo: [30575],
      Tarrytown: [30470],
      Tate: [30177],
      Taylorsville: [30178],
      Tazewell: [31803],
      Temple: [30179],
      Tennille: [31089],
      'The Rock': [30285],
      Thomaston: [30286],
      Thomasville: [31792],
      Thomson: [30824],
      Tiger: [30576],
      Toccoa: [30577],
      Toomsboro: [31090],
      Townsend: [31331],
      Trenton: [30752],
      Trion: [30753],
      Tucker: [30084],
      'Tunnel Hill': [30755],
      'Twin City': [30471],
      'Ty Ty': [31795],
      'Tybee Island': [31328],
      Tyrone: [30290],
      Unadilla: [31091],
      'Union City': [30291],
      'Union Point': [30669],
      Upatoi: [31829],
      Uvalda: [30473],
      Vidalia: [30474],
      Vienna: [31092],
      'Villa Rica': [30180],
      Waco: [30182],
      Wadley: [30477],
      Waleska: [30183],
      'Warm Springs': [31830],
      'Warner Robins': [31088, 31093],
      Warrenton: [30828],
      Warthen: [31094],
      Warwick: [31796],
      Washington: [30673],
      Watkinsville: [30677],
      Waverly: [31565],
      'Waverly Hall': [31831],
      Waynesboro: [30830],
      Waynesville: [31566],
      'West Green': [31567],
      'West Point': [31833],
      Weston: [31832],
      Whigham: [31797],
      White: [30184],
      'White Oak': [31568],
      'White Plains': [30678],
      Whitesburg: [30185],
      Wildwood: [30757],
      Willacoochee: [31650],
      Williamson: [30292],
      'Wilson Airport': [31206],
      Winder: [30680],
      Winston: [30187],
      Winterville: [30683],
      Woodbine: [31569],
      Woodbury: [30293],
      Woodland: [31836],
      Woodstock: [30188],
      Woolsey: [30214],
      Wray: [31798],
      Wrens: [30833],
      Wrightsville: [31096],
      Yatesville: [31097],
      'Young Harris': [30582],
      Zebulon: [30295],
    },
    name: 'Georgia',
  },
  HI: {
    cities: {
      Aiea: [96701],
      'Captain Cook': [96704],
      Eleele: [96705],
      'Ewa Beach': [96706],
      Haiku: [96708],
      Hakalau: [96710],
      Haleiwa: [96712],
      Hana: [96713],
      Hanapepe: [96716],
      Hauula: [96717],
      'Hawaii National': [96718],
      Hawi: [96719],
      Hilo: [96720],
      Holualoa: [96725],
      Honaunau: [96726],
      Honokaa: [96727],
      Honolulu: [
        96813, 96814, 96815, 96816, 96817, 96818, 96819, 96821, 96822, 96825,
        96826,
      ],
      Honomu: [96728],
      Hoolehua: [96729],
      Kaaawa: [96730],
      Kahului: [96732],
      Kailua: [96734],
      'Kailua Kona': [96740],
      Kalaupapa: [96742],
      Kamuela: [96743],
      Kaneohe: [96744],
      Kapaa: [96746],
      Kapaau: [96755],
      Kapolei: [96707],
      Kaumakani: [96747],
      Kaunakakai: [96748],
      Keaau: [96749],
      Kealakekua: [96750],
      Kekaha: [96752],
      Kihei: [96753],
      Koloa: [96756],
      Kualapuu: [96757],
      Kula: [96790],
      Kurtistown: [96760],
      Lahaina: [96761],
      Laie: [96762],
      'Lanai City': [96763],
      Laupahoehoe: [96764],
      Lihue: [96766],
      Makawao: [96768],
      Makaweli: [96769],
      Maunaloa: [96770],
      Mililani: [96789],
      'Mountain View': [96771],
      Naalehu: [96772],
      Ninole: [96773],
      Ookala: [96774],
      Paauhau: [96775],
      Paauilo: [96776],
      Pahala: [96777],
      Pahoa: [96778],
      Paia: [96779],
      Papaaloa: [96780],
      Papaikou: [96781],
      'Pearl City': [96782],
      Pepeekeo: [96783],
      Princeville: [96722],
      Volcano: [96785],
      Wahiawa: [96786],
      Waialua: [96791],
      Waianae: [96792],
      Wailuku: [96793],
      Waimanalo: [96795],
      Waimea: [96796],
      Waipahu: [96797],
    },
    name: 'Hawaii',
  },
  IA: {
    cities: {
      50855: [50855],
      Ackley: [50601],
      Ackworth: [50001],
      Adair: [50002],
      Adel: [50003],
      Afton: [50830],
      Agency: [52530],
      Ainsworth: [52201],
      Akron: [51001],
      'Albert City': [50510],
      Albia: [52531],
      Albion: [50005],
      Alburnett: [52202],
      Alden: [50006],
      Alexander: [50420],
      Algona: [50511],
      Alleman: [50007],
      Allerton: [50008],
      Allison: [50602],
      Alta: [51002],
      'Alta Vista': [50603],
      Alton: [51003],
      Altoona: [50009],
      Alvord: [51230],
      Amana: [52203],
      Ames: [50010],
      Anamosa: [52205],
      Andover: [52701],
      Andrew: [52030],
      Anita: [50020],
      Ankeny: [50021],
      Anthon: [51004],
      Aplington: [50604],
      Arcadia: [51430],
      Archer: [51231],
      Aredale: [50605],
      Argyle: [52619],
      Arion: [51520],
      Arlington: [50606],
      Armstrong: [50514],
      'Arnolds Park': [51331],
      Arthur: [51431],
      Ashton: [51232],
      Aspinwall: [51432],
      Atalissa: [52720],
      Atkins: [52206],
      Atlantic: [50022],
      Audubon: [50025],
      Aurelia: [51005],
      Aurora: [50607],
      Austinville: [50608],
      Avoca: [51521],
      Ayrshire: [50515],
      Badger: [50516],
      Bagley: [50026],
      Baldwin: [52207],
      Bancroft: [50517],
      'Barnes City': [50027],
      Barnum: [50518],
      Batavia: [52533],
      'Battle Creek': [51006],
      Baxter: [50028],
      Bayard: [50029],
      Beacon: [52534],
      Beaconsfield: [50030],
      Beaman: [50609],
      Beaver: [50031],
      Bedford: [50833],
      'Belle Plaine': [52208],
      Bellevue: [52031],
      Belmond: [50421],
      Bennett: [52721],
      Benton: [50835],
      Bernard: [52032],
      Bettendorf: [52722],
      Bevington: [50033],
      'Big Rock': [52745],
      Birmingham: [52535],
      Blairsburg: [50034],
      Blairstown: [52209],
      Blakesburg: [52536],
      Blanchard: [51630],
      Blencoe: [51523],
      Blockton: [50836],
      Bloomfield: [52537],
      'Blue Grass': [52726],
      Bode: [50519],
      Bonaparte: [52620],
      Bondurant: [50035],
      Boone: [50036],
      Booneville: [50038],
      Bouton: [50039],
      Boxholm: [50040],
      Boyden: [51234],
      Braddyville: [51631],
      Bradford: [50041],
      Bradgate: [50520],
      Brandon: [52210],
      Brayton: [50042],
      Breda: [51436],
      Bremer: [50677],
      Bridgewater: [50837],
      Brighton: [52540],
      Bristow: [50611],
      Britt: [50423],
      Bronson: [51007],
      Brooklyn: [52211],
      Bryant: [52727],
      Buckingham: [50612],
      'Buffalo Center': [50424],
      Burlington: [52601],
      Burnside: [50521],
      'Burr Oak': [52131],
      Burt: [50522],
      Bussey: [50044],
      Calamus: [52729],
      Callender: [50523],
      Calmar: [52132],
      Calumet: [51009],
      Camanche: [52730],
      Cambridge: [50046],
      Cantril: [52542],
      Carlisle: [50047],
      Carroll: [51401],
      Carson: [51525],
      'Carter Lake': [51510],
      Cascade: [52033],
      Casey: [50048],
      Castalia: [52133],
      Castana: [51010],
      Cedar: [52543],
      'Cedar Falls': [50613],
      'Cedar Rapids': [52401, 52402, 52403, 52404, 52405],
      'Center Junction': [52212],
      'Center Point': [52213],
      Centerville: [52544],
      'Central City': [52214],
      Chariton: [50049],
      'Charles City': [50616],
      Charlotte: [52731],
      'Charter Oak': [51439],
      Chelsea: [52215],
      Cherokee: [51012],
      Chester: [52134],
      Chillicothe: [52548],
      Churdan: [50050],
      Cincinnati: [52549],
      Clare: [50524],
      Clarence: [52216],
      Clarinda: [51632],
      Clarion: [50525],
      Clarksville: [50619],
      'Clear Lake': [50428],
      Clearfield: [50840],
      Cleghorn: [51014],
      Clemons: [50051],
      Clermont: [52135],
      Clinton: [52732],
      Clio: [50052],
      Clive: [50325],
      Clutier: [52217],
      Coggon: [52218],
      Coin: [51636],
      Colesburg: [52035],
      Colfax: [50054],
      'College Springs': [51637],
      Collins: [50055],
      Colo: [50056],
      Columbia: [50057],
      'Columbus Junctio': [52738],
      Conesville: [52739],
      Conrad: [50621],
      Conroy: [52220],
      'Coon Rapids': [50058],
      Cooper: [50059],
      Coralville: [52241],
      Corning: [50841],
      Correctionville: [51016],
      Corwith: [50430],
      'Council Bluffs': [51503],
      Crawfordsville: [52621],
      Crescent: [51526],
      Cresco: [52136],
      'Crystal Lake': [50432],
      Cumberland: [50843],
      Cumming: [50061],
      Curlew: [50527],
      Cushing: [51018],
      Cylinder: [50528],
      Dallas: [50062],
      'Dallas Center': [50063],
      Dana: [50064],
      Danbury: [51019],
      Danville: [52623],
      Davenport: [52802, 52803, 52804, 52806, 52807],
      Dawson: [50066],
      Dayton: [50530],
      'De Soto': [50069],
      'De Witt': [52742],
      Decatur: [50067],
      Decorah: [52101],
      Dedham: [51440],
      'Deep River': [52222],
      Delaware: [52036],
      Delhi: [52223],
      Delmar: [52037],
      Deloit: [51441],
      Delphos: [50844],
      Delta: [52550],
      Denison: [51442],
      Denmark: [52624],
      Denver: [50622],
      Derby: [50068],
      'Des Moines': [
        50309, 50310, 50312, 50313, 50314, 50315, 50316, 50320, 50321,
      ],
      Dexter: [50070],
      Diagonal: [50845],
      Dickens: [51333],
      Dike: [50624],
      Dolliver: [50531],
      Donahue: [52746],
      Donnellson: [52625],
      Doon: [51235],
      Dorchester: [52140],
      Douds: [52551],
      Dougherty: [50433],
      'Dow City': [51528],
      Dows: [50071],
      Drakesville: [52552],
      Dubuque: [52001, 52002, 52003],
      Dumont: [50625],
      Duncombe: [50532],
      Dundee: [52038],
      Dunkerton: [50626],
      Durango: [52039],
      Durant: [52747],
      Dyersville: [52040],
      Dysart: [52224],
      'Eagle Grove': [50533],
      Earlham: [50072],
      Earling: [51527, 51529, 51530],
      Earlville: [52041],
      Early: [50535],
      Eddyville: [52553],
      Edgewood: [52042],
      Elberon: [52225],
      Eldon: [52554],
      Eldora: [50627],
      Eldorado: [52175],
      Eldridge: [52748],
      Elgin: [52141],
      'Elk Horn': [51531],
      Elkader: [52043],
      Elkhart: [50073],
      Elkport: [52044],
      Elliott: [51532],
      Ellston: [50074],
      Ellsworth: [50075],
      Elma: [50628],
      Elwood: [52226],
      Ely: [52227],
      Emerson: [51533],
      Emmetsburg: [50536],
      Epworth: [52045],
      Essex: [51638],
      Estherville: [51334],
      Evansdale: [50707],
      Everly: [51338],
      Exira: [50076],
      Exline: [52555],
      Fairbank: [50629],
      Fairfax: [52228],
      Fairfield: [52556],
      Farley: [52046],
      Farmersburg: [52047],
      Farmington: [52626],
      Farnhamville: [50538],
      Farragut: [51639],
      Fayette: [52142],
      Fenton: [50539],
      Fertile: [50434],
      Floris: [52560],
      Floyd: [50435],
      Fonda: [50540],
      Fontanelle: [50846],
      'Forest City': [50436],
      'Fort Atkinson': [52144],
      'Fort Dodge': [50501],
      'Fort Madison': [52627],
      Fostoria: [51340],
      Fredericksburg: [50630],
      Fremont: [52561],
      Galt: [50101],
      Galva: [51020],
      Garber: [52048],
      'Garden City': [50102],
      'Garden Grove': [50103],
      Garnavillo: [52049],
      Garner: [50438],
      Garrison: [52229],
      Garwin: [50632],
      Geneva: [50633],
      George: [51237],
      Gibson: [50104],
      Gilman: [50106],
      'Gilmore City': [50541],
      Gladbrook: [50635],
      Glenwood: [51534],
      Glidden: [51443],
      Goldfield: [50542],
      Goodell: [50439],
      'Goose Lake': [52750],
      Gowrie: [50543],
      Graettinger: [51342],
      Grafton: [50440],
      'Grand Junction': [50107],
      'Grand Mound': [52751],
      'Grand River': [50108],
      Granger: [50109],
      Grant: [50847],
      Granville: [51022],
      Gravity: [50848],
      Gray: [50110],
      Greeley: [52050],
      Greene: [50636],
      Greenfield: [50849],
      Greenville: [51343],
      Grimes: [50111],
      Grinnell: [50112],
      Griswold: [51535],
      'Grundy Center': [50638],
      Guernsey: [50172],
      'Guthrie Center': [50115],
      Guttenberg: [52052],
      Halbur: [51444],
      Hamburg: [51640],
      Hamilton: [50116],
      Hamlin: [50117],
      Hampton: [50441],
      Hancock: [51536],
      Hanlontown: [50444],
      Hansell: [50640],
      Harcourt: [50544],
      Hardy: [50545],
      Harlan: [51537],
      Harper: [52231],
      'Harpers Ferry': [52146],
      Harris: [51345],
      Hartford: [50118],
      Hartley: [51346],
      Hartwick: [52232],
      Harvey: [50119],
      Hastings: [51540],
      Havelock: [50546],
      Haverhill: [50120],
      Hawarden: [51023],
      Hawkeye: [52147],
      Hazleton: [50641],
      Hedrick: [52563],
      Henderson: [51541],
      Hiawatha: [52233],
      'Highland Center': [52501],
      Hillsboro: [52630],
      Hinton: [51024],
      Holland: [50642],
      Holstein: [51025],
      'Holy Cross': [52053],
      Homestead: [52236],
      'Honey Creek': [51542],
      Hopkinton: [52237],
      Hornick: [51026],
      Hospers: [51238],
      Houghton: [52631],
      Hubbard: [50122],
      Hudson: [50643],
      Hull: [51239],
      Humboldt: [50548],
      Humeston: [50123],
      Huxley: [50124],
      'Ida Grove': [51445],
      Imogene: [51645],
      Independence: [50644],
      Inwood: [51240],
      Ionia: [50645],
      'Iowa City': [52240, 52245, 52246],
      'Iowa Falls': [50126],
      Ira: [50127],
      Ireton: [51027],
      Irwin: [51446],
      'Jackson Junction': [52150],
      Jamaica: [50128],
      Janesville: [50647],
      Jefferson: [50129],
      Jesup: [50648],
      Jewell: [50130],
      Johnston: [50131],
      Joice: [50446],
      Jolley: [50551],
      Kalona: [52247],
      Kamrar: [50132],
      Kanawha: [50447],
      Kellerton: [50133],
      Kelley: [50134],
      Kellogg: [50135],
      Kensett: [50448],
      Kent: [50850],
      Keokuk: [52632],
      Keosauqua: [52565],
      Keota: [52248],
      Kesley: [50649],
      Keswick: [50136],
      Keystone: [52249],
      Kimballton: [51543],
      Kingsley: [51028],
      Kinross: [52250],
      Kirkman: [51447],
      Kirkville: [52566],
      Kiron: [51448],
      Klemme: [50449],
      Knierim: [50552],
      Knoke: [50553],
      Knoxville: [50138],
      'La Motte': [52054],
      'La Porte City': [50651],
      Lacona: [50139],
      Ladora: [52251],
      'Lake City': [51449],
      'Lake Mills': [50450],
      'Lake Park': [51347],
      'Lake View': [51450],
      Lakota: [50451],
      Lamoni: [50140],
      Lamont: [50650],
      Lanesboro: [51451],
      Lansing: [52151],
      Larchwood: [51241],
      Larrabee: [51029],
      Latimer: [50452],
      Laurel: [50141],
      Laurens: [50554],
      Lawler: [52154],
      Lawton: [51030],
      'Le Claire': [52753],
      'Le Mars': [51031],
      Ledyard: [50556],
      Lehigh: [50557],
      Leighton: [50143],
      Leland: [50453],
      Lenox: [50851],
      Leon: [50144],
      Letts: [52754],
      Lewis: [51544],
      'Liberty Center': [50145],
      Libertyville: [52567],
      Lidderdale: [51452],
      'Lime Springs': [52155],
      Lincoln: [50652],
      Linden: [50146],
      Lineville: [50147],
      'Linn Grove': [51033],
      Lisbon: [52253],
      Liscomb: [50148],
      'Little Cedar': [50454],
      'Little Rock': [51243],
      'Little Sioux': [51545],
      Livermore: [50558],
      Lockridge: [52635],
      Logan: [51546],
      Lohrville: [51453],
      'Lone Rock': [50559],
      'Lone Tree': [52755],
      'Long Grove': [52756],
      Lorimor: [50149],
      'Lost Nation': [52254],
      Lovilia: [50150],
      Lowden: [52255],
      'Lu Verne': [50560],
      Luana: [52156],
      Lucas: [50151],
      Luther: [50152],
      Luzerne: [52257],
      Lynnville: [50153],
      Lytton: [50561],
      Macedonia: [51549],
      Macksburg: [50155],
      Madrid: [50156],
      Magnolia: [51550],
      Malcom: [50157],
      Mallard: [50562],
      Maloy: [50852],
      Malvern: [51551],
      Manawa: [51501],
      Manchester: [52057],
      Manilla: [51454],
      Manly: [50456],
      Manning: [51455],
      Manson: [50563],
      Mapleton: [51034],
      Maquoketa: [52060],
      Marathon: [50565],
      'Marble Rock': [50653],
      Marcus: [51035],
      Marengo: [52301],
      Marion: [52302],
      Marne: [51552],
      Marquette: [52158],
      Marshalltown: [50158],
      Martelle: [52305],
      'Mason City': [50401],
      Masonville: [50654],
      Massena: [50853],
      Maurice: [51036],
      Maxwell: [50161],
      Maynard: [50655],
      'Mc Callsburg': [50154],
      'Mc Clelland': [51548],
      'Mc Gregor': [52157],
      'Mc Intire': [50455],
      Mechanicsville: [52306],
      Mediapolis: [52637],
      Melbourne: [50162],
      'Melcher-Dallas': [50163],
      Melrose: [52569],
      Melvin: [51350],
      Menlo: [50164],
      Meriden: [51037],
      Merrill: [51038],
      Meservey: [50457],
      'Middle Amana': [52307],
      Middletown: [52638],
      Miles: [52064],
      Milford: [51351],
      Millersburg: [52308],
      Millerton: [50165],
      Milo: [50166],
      Milton: [52570],
      Minburn: [50167],
      Minden: [51553],
      Mineola: [51554],
      Mingo: [50168],
      'Missouri Valley': [51555],
      Mitchellville: [50169],
      Modale: [51556],
      Mondamin: [51557],
      Monmouth: [52309],
      Monona: [52159],
      Monroe: [50170],
      Montezuma: [50171],
      Monticello: [52310],
      Montour: [50173],
      Montrose: [52639],
      Moorhead: [51558],
      Moorland: [50566],
      Moravia: [52571],
      'Morning Sun': [52640],
      Moscow: [52760],
      Moulton: [52572],
      'Mount Auburn': [52313],
      'Mount Ayr': [50854],
      'Mount Pleasant': [52641],
      'Mount Sterling': [52573],
      'Mount Union': [52644],
      'Mount Vernon': [52314],
      Moville: [51039],
      Murray: [50174],
      Muscatine: [52761],
      Mystic: [52574],
      Nashua: [50658],
      Nemaha: [50567],
      Neola: [51559],
      Nevada: [50201],
      Nevinville: [50801],
      'New Albin': [52160],
      'New Hampton': [50659],
      'New Hartford': [50660],
      'New Liberty': [52765],
      'New London': [52645],
      'New Market': [51646],
      'New Providence': [50206],
      'New Sharon': [50207],
      'New Vienna': [52065],
      'New Virginia': [50210],
      Newell: [50568],
      Newhall: [52315],
      Newton: [50208],
      Nichols: [52766],
      Nodaway: [50857],
      'Nora Springs': [50458],
      'North Buena Vist': [52066],
      'North English': [52316],
      'North Liberty': [52317],
      Northboro: [51647],
      Northwood: [50459],
      Norwalk: [50211],
      Norway: [52318],
      Numa: [52575],
      Oakland: [51560],
      Oakville: [52646],
      Ocheyedan: [51354],
      Odebolt: [51458],
      Oelwein: [50662],
      Ogden: [50212],
      Okoboji: [51355],
      Olds: [52647],
      Olin: [52320],
      Ollie: [52576],
      Onawa: [51040],
      Onslow: [52321],
      'Orange City': [51041],
      Orchard: [50460],
      Orient: [50858],
      Osage: [50461],
      Osceola: [50213],
      Oskaloosa: [52577],
      Ossian: [52161],
      Otho: [50569],
      Otley: [50214],
      Oto: [51044],
      Ottosen: [50570],
      Oxford: [52322],
      'Oxford Junction': [52323],
      'Pacific Junction': [51561],
      Packwood: [52580],
      Palmer: [50571],
      Palo: [52324],
      Panama: [51562],
      Panora: [50216],
      Parkersburg: [50665],
      Parnell: [52325],
      Paton: [50217],
      Patterson: [50218],
      Paullina: [51046],
      Pella: [50219],
      Peosta: [52068],
      Percival: [51648],
      Perry: [50220],
      Persia: [51563],
      Peru: [50222],
      Peterson: [51047],
      Pierson: [51048],
      'Pilot Mound': [50223],
      Pisgah: [51564],
      Plainfield: [50666],
      Plano: [52581],
      'Pleasant Hill': [50317],
      Pleasanton: [50065],
      Pleasantville: [50225],
      Plover: [50573],
      Plymouth: [50464],
      Pocahontas: [50574],
      'Polk City': [50226],
      Pomeroy: [50575],
      Popejoy: [50227],
      Portsmouth: [51565],
      Postville: [52162],
      'Prairie City': [50228],
      Prescott: [50859],
      Preston: [52069],
      Primghar: [51245],
      Princeton: [52768],
      Prole: [50229],
      'Promise City': [52583],
      Pulaski: [52584],
      Quasqueton: [52326],
      Quimby: [51049],
      Radcliffe: [50230],
      Rake: [50465],
      Ralston: [51459],
      Randalia: [52164],
      Randall: [50231],
      Randolph: [51649],
      Raymond: [50667],
      Readlyn: [50668],
      Reasnor: [50232],
      'Red Oak': [51566],
      Redding: [50860],
      Redfield: [50233],
      Reinbeck: [50669],
      Rembrandt: [50576],
      Remsen: [51050],
      Renwick: [50577],
      Rhodes: [50234],
      Riceville: [50466],
      Richland: [52585],
      Ricketts: [51460],
      Ridgeway: [52165],
      Ringsted: [50578],
      Rippey: [50235],
      Riverside: [52327],
      Riverton: [51650],
      Robins: [52328],
      'Rock Falls': [50467],
      'Rock Rapids': [51246],
      'Rock Valley': [51247],
      Rockford: [50468],
      Rockwell: [50469],
      'Rockwell City': [50579],
      Rodman: [50580],
      Rodney: [51051],
      Roland: [50236],
      Rolfe: [50581],
      'Rose Hill': [52586],
      Rowan: [50470],
      Rowley: [52329],
      Royal: [51357],
      Rudd: [50471],
      Runnells: [50237],
      Russell: [50238],
      Ruthven: [51358],
      Rutland: [50582],
      Ryan: [52330],
      Sabula: [52070],
      'Sac City': [50583],
      'Saint Ansgar': [50472],
      'Saint Anthony': [50239],
      'Saint Charles': [50240],
      'Saint Donatus': [52071],
      'Saint Lucas': [52166],
      'Saint Marys': [50241],
      'Saint Olaf': [52072],
      'Saint Paul': [52657],
      Salem: [52649],
      Salix: [51052],
      Sanborn: [51248],
      Scarville: [50473],
      Schaller: [51053],
      Schleswig: [51461],
      'Scotch Grove': [52331],
      Scranton: [51462],
      Searsboro: [50242],
      Selma: [52588],
      'Sergeant Bluff': [51054],
      Sewal: [50060],
      Seymour: [52590],
      Shambaugh: [51651],
      'Shannon City': [50861],
      Sharpsburg: [50862],
      Sheffield: [50475],
      Shelby: [51570],
      Sheldon: [51201],
      'Shell Rock': [50670],
      Shellsburg: [52332],
      Shenandoah: [51601],
      Sherrill: [52073],
      Sibley: [51249],
      Sidney: [51652],
      Sigourney: [52591],
      'Silver City': [51571],
      'Sioux Center': [51250],
      'Sioux City': [
        51101, 51103, 51104, 51105, 51106, 51107, 51108, 51109, 51110, 51111,
      ],
      'Sioux Rapids': [50585],
      Slater: [50244],
      Sloan: [51055],
      Smithland: [51056],
      Soldier: [51572],
      Solon: [52333],
      Somers: [50586],
      'South Amana': [52334],
      'South English': [52335],
      Spencer: [51301],
      Sperry: [52650],
      'Spirit Lake': [51360],
      Spragueville: [52074],
      'Spring Hill': [50125],
      Springbrook: [52075],
      Springville: [52336],
      Stacyville: [50476],
      Stanhope: [50246],
      Stanley: [50671],
      Stanton: [51573],
      Stanwood: [52337],
      'State Center': [50247],
      'Steamboat Rock': [50672],
      Stockport: [52651],
      Stockton: [52769],
      'Storm Lake': [50588],
      'Story City': [50248],
      Stratford: [50249],
      'Strawberry Point': [52076],
      Stuart: [50250],
      Sully: [50251],
      Sumner: [50674],
      Superior: [51363],
      Sutherland: [51058],
      Swaledale: [50477],
      Swan: [50252],
      'Swea City': [50590],
      Swisher: [52338],
      Tabor: [51653],
      Tama: [52339],
      Templeton: [51463],
      Terril: [51364],
      Thayer: [50254],
      Thompson: [50478],
      Thor: [50591],
      Thornton: [50479],
      Thurman: [51654],
      Tingley: [50863],
      Tipton: [52772],
      Titonka: [50480],
      Toddville: [52341],
      Toledo: [52342],
      Toronto: [52343],
      Tracy: [50256],
      Traer: [50675],
      Treynor: [51575],
      Tripoli: [50676],
      Truro: [50257],
      Turin: [51059],
      Udell: [52593],
      Underwood: [51576],
      Union: [50258],
      Unionville: [52594],
      Urbandale: [50322],
      Ute: [51060],
      Vail: [51465],
      'Van Horne': [52346],
      'Van Meter': [50261],
      'Van Wert': [50262],
      Ventura: [50482],
      Victor: [52347],
      Villisca: [50864],
      Vincent: [50594],
      Vining: [52348],
      Vinton: [52349],
      Volga: [52077],
      Wadena: [52169],
      Walcott: [52773],
      Walker: [52352],
      'Wall Lake': [51466],
      Wallingford: [51365],
      Walnut: [51577],
      Wapello: [52653],
      Washburn: [50706],
      Washington: [52353],
      Washta: [51061],
      Waterloo: [50701, 50702, 50703],
      Waterville: [52170],
      Watkins: [52354],
      Waucoma: [52171],
      Waukee: [50263],
      Waukon: [52172],
      Wayland: [52654],
      Webb: [51366],
      Webster: [52355],
      'Webster City': [50595],
      Weldon: [50264],
      Wellman: [52356],
      Wellsburg: [50680],
      Welton: [52774],
      Wesley: [50483],
      'West Amana': [52357],
      'West Bend': [50597],
      'West Branch': [52358],
      'West Burlington': [52655],
      'West Chester': [52359],
      'West Des Moines': [50265],
      'West Grove': [52538],
      'West Liberty': [52776],
      'West Point': [52656],
      Westfield: [51062],
      Westgate: [50681],
      Westphalia: [51578],
      Westside: [51467],
      Wever: [52658],
      'What Cheer': [50268],
      Wheatland: [52777],
      Whiting: [51063],
      Whittemore: [50598],
      Williams: [50271],
      Williamsburg: [52361],
      Williamson: [50272],
      Wilton: [52778],
      'Windsor Heights': [50311],
      Winfield: [52659],
      Winterset: [50273],
      Winthrop: [50682],
      Wiota: [50274],
      Woden: [50484],
      Woodbine: [51579],
      Woodburn: [50275],
      Woodward: [50276],
      Woolstock: [50599],
      Worthington: [52078],
      Wyoming: [52362],
      Yale: [50277],
      Yarmouth: [52660],
      Yetter: [51433],
      Yorktown: [51656],
      Zearing: [50278],
      Zwingle: [52079],
    },
    name: 'Iowa',
  },
  ID: {
    cities: {
      Acequia: [83350],
      Ahsahka: [83520],
      'American Falls': [83211],
      Ammon: [83401],
      Arbon: [83212],
      Arco: [83213],
      Arimo: [83214],
      Ashton: [83420],
      Athol: [83801],
      Atlanta: [83601],
      Avery: [83802],
      Bancroft: [83217],
      Banks: [83602],
      Bayview: [83803],
      Bellevue: [83313],
      Bern: [83220],
      Blackfoot: [83221],
      Blanchard: [83804],
      Bliss: [83314],
      Boise: [83702, 83703, 83704, 83705, 83706, 83709, 83712],
      'Bonners Ferry': [83805],
      Buhl: [83316],
      Burley: [83318],
      Calder: [83808],
      Caldwell: [83605],
      Cambridge: [83610],
      Carey: [83320],
      Careywood: [83809],
      Carmen: [83462],
      Castleford: [83321],
      Cataldo: [83810],
      Challis: [83226],
      Chubbuck: [83202],
      'Clark Fork': [83811],
      Clarkia: [83812],
      Clayton: [83227],
      Clearwater: [83539],
      Clifton: [83228],
      Cocolalla: [83813],
      'Coeur D Alene': [83814],
      Conda: [83230],
      Coolin: [83821],
      Corral: [83322],
      Cottonwood: [83522],
      Council: [83612],
      Craigmont: [83523],
      Culdesac: [83524],
      Darlington: [83231],
      Dayton: [83232],
      Deary: [83823],
      Declo: [83323],
      Desmet: [83824],
      Dietrich: [83324],
      Dixie: [83525],
      Donnelly: [83615],
      Downey: [83234],
      Driggs: [83422],
      Dubois: [83423],
      Eagle: [83616],
      Eden: [83325],
      Elba: [83326],
      'Elk River': [83827],
      Ellis: [83235],
      Fairfield: [83327],
      Felt: [83424],
      Ferdinand: [83526],
      Fernwood: [83830],
      Filer: [83328],
      Firth: [83236],
      'Fish Haven': [83287],
      'Fort Hall': [83203],
      Franklin: [83237],
      Fruitland: [83619],
      'Garden City': [83714],
      'Garden Valley': [83622],
      Genesee: [83832],
      Geneva: [83238],
      Gibbonsville: [83463],
      'Glenns Ferry': [83623],
      Gooding: [83330],
      Grace: [83241],
      'Grand View': [83624],
      Grangeville: [83530],
      Grasmere: [83604],
      Greencreek: [83533],
      Hagerman: [83332],
      Hailey: [83333],
      Hamer: [83425],
      Hammett: [83627],
      Hansen: [83334],
      Harrison: [83833],
      Harvard: [83834],
      'Hayden Lake': [83835],
      Hazelton: [83335],
      Heyburn: [83336],
      Holbrook: [83243],
      Homedale: [83628],
      Hope: [83836],
      'Horseshoe Bend': [83629],
      'Idaho City': [83631],
      'Idaho Falls': [83402, 83404, 83406],
      'Indian Valley': [83632],
      Inkom: [83245],
      Iona: [83427],
      'Island Park': [83429],
      Jerome: [83338],
      Juliaetta: [83535],
      Kamiah: [83536],
      Kellogg: [83837],
      Kendrick: [83537],
      Keuterville: [83538],
      Kimberly: [83341],
      'King Hill': [83633],
      Kingston: [83839],
      Kuna: [83634],
      Lapwai: [83540],
      'Lava Hot Springs': [83246],
      Leadore: [83464],
      Lenore: [83541],
      Letha: [83636],
      Lewisville: [83431],
      Lowman: [83637],
      Lucile: [83542],
      Mackay: [83251],
      'Malad City': [83252],
      Marsing: [83639],
      'Mc Call': [83638],
      'Mc Cammon': [83250],
      Medimont: [83842],
      Melba: [83641],
      Menan: [83434],
      Meridian: [83642],
      Mesa: [83643],
      Middleton: [83644],
      Midvale: [83645],
      Minidoka: [83343],
      Monteview: [83435],
      Montour: [83617],
      Montpelier: [83254],
      Moore: [83255],
      Moscow: [83843],
      'Mountain Home': [83647],
      'Mountain Home A': [83648],
      'Moyie Springs': [83845],
      Mullan: [83846],
      Murtaugh: [83344],
      Naf: [83342],
      Nampa: [83651, 83686, 83687],
      Naples: [83847],
      'New Meadows': [83654],
      'New Plymouth': [83655],
      Newdale: [83436],
      Nezperce: [83543],
      Nordman: [83848],
      'North Fork': [83466],
      Oakley: [83346],
      Obsidian: [83340],
      Ola: [83657],
      'Old Town': [83822],
      Oreana: [83650],
      Orofino: [83544],
      Ovid: [83260],
      Paris: [83261],
      Parma: [83660],
      Patterson: [83253],
      Paul: [83347],
      Payette: [83661],
      Peck: [83545],
      Picabo: [83348],
      Pierce: [83546],
      Pinehurst: [83850],
      Pingree: [83262],
      Plummer: [83851],
      Pocatello: [83201, 83204],
      Pollock: [83547],
      Porthill: [83853],
      'Post Falls': [83854],
      Potlatch: [83855],
      Preston: [83263],
      'Priest River': [83856],
      Princeton: [83857],
      Rathdrum: [83858],
      Reubens: [83548],
      Rexburg: [83440],
      Richfield: [83349],
      Rigby: [83442],
      Riggins: [83549],
      Ririe: [83443],
      Roberts: [83444],
      Rockland: [83271],
      Rogerson: [83302],
      Sagle: [83860],
      'Saint Anthony': [83445],
      'Saint Charles': [83272],
      'Saint Maries': [83861],
      Salmon: [83467],
      Sandpoint: [83864],
      Shelley: [83274],
      Shoshone: [83352],
      Shoup: [83469],
      Smelterville: [83868],
      'Soda Springs': [83276],
      'South Gate Plaza': [83501],
      Spencer: [83446],
      'Spirit Lake': [83869],
      Stanley: [83278],
      Star: [83669],
      Sterling: [83210],
      Stone: [83280],
      'Sugar City': [83448],
      'Swan Valley': [83449],
      Sweet: [83670],
      Tensed: [83870],
      Terreton: [83450],
      Teton: [83451],
      Tetonia: [83452],
      Thatcher: [83283],
      Troy: [83871],
      'Twin Falls': [83301],
      Victor: [83455],
      Viola: [83872],
      Wallace: [83873],
      Wayan: [83285],
      Weippe: [83553],
      Weiser: [83672],
      Wendell: [83355],
      'West Mountain': [83611],
      Weston: [83286],
      'White Bird': [83554],
      Wilder: [83676],
      Winchester: [83555],
      Worley: [83876],
      'Yellow Pine': [83677],
    },
    name: 'Idaho',
  },
  IL: {
    cities: {
      62020: [62020],
      62064: [62064],
      62296: [62296],
      'Abbott Park': [60064],
      Abingdon: [61410],
      Adair: [61411],
      Addison: [60101],
      Albany: [61230],
      Albers: [62215],
      Albion: [62806],
      Aledo: [61231],
      Alexis: [61412],
      Alhambra: [62001],
      Allen: [62682],
      Allendale: [62410],
      Allerton: [61810],
      Alma: [62807],
      Alorton: [62207],
      Alpha: [61413],
      Alsip: [60658],
      Altamont: [62411],
      'Alto Pass': [62905],
      Alton: [62002],
      Altona: [61414],
      Alvin: [61811],
      Amboy: [61310],
      'Amf Ohare': [60666],
      Anchor: [61720],
      Ancona: [61311],
      Andalusia: [61232],
      Andrew: [62707],
      Anna: [62906],
      Annapolis: [62413],
      Annawan: [61234],
      Antioch: [60002],
      'Apple River': [61001],
      Arcadia: [62650],
      Arcola: [61910],
      Arenzville: [62611],
      Argo: [60501],
      Argonne: [60439],
      Arlington: [61312],
      'Arlington Height': [60004, 60005],
      Armington: [61721],
      Armstrong: [61812],
      'Aroma Park': [60910],
      Arrowsmith: [61722],
      Arthur: [61911],
      Ashkum: [60911],
      Ashley: [62808],
      Ashmore: [61912],
      Ashton: [61006],
      Assumption: [62510],
      Astoria: [61501],
      Atkinson: [61235],
      Atlanta: [61723],
      Atterbury: [62675],
      Atwater: [62511],
      Atwood: [61913],
      Auburn: [62615],
      Augusta: [62311],
      Aurora: [60504, 60505, 60506],
      Ava: [62907],
      Avon: [61415],
      Bader: [62624],
      Baileyville: [61007],
      Baldwin: [62217],
      Barclay: [62684],
      Bardolph: [61416],
      Barnhill: [62809],
      Barr: [62674],
      Barrington: [60010],
      Barry: [62312],
      Bartelso: [62218],
      Bartonville: [61607],
      Basco: [62313],
      Batavia: [60510],
      Batchtown: [62006],
      Bates: [62670],
      Baylis: [62314],
      Beardstown: [62618],
      Bearsdale: [62526],
      Beason: [62512],
      Beaverville: [60912],
      'Bedford Park': [60638],
      Beecher: [60401],
      'Beecher City': [62414],
      Belknap: [62908],
      'Belle Rive': [62810],
      Belleville: [62220, 62221, 62223],
      Bellflower: [61724],
      Bellwood: [60104],
      Belvidere: [61008],
      Bement: [61813],
      Benld: [62009],
      Bensenville: [60106],
      Benson: [61516],
      Benton: [62812],
      Berry: [62563],
      Berwick: [61417],
      Bethalto: [62010],
      Bethany: [61914],
      'Bible Grove': [62858],
      'Big Rock': [60511],
      Biggs: [62633],
      Biggsville: [61418],
      Bingham: [62011],
      Birds: [62415],
      Bismarck: [61814],
      Blackstone: [61313],
      Blandinsville: [61420],
      Bloomingdale: [60108],
      Bloomington: [61701, 61704],
      'Blue Island': [60406],
      'Blue Mound': [62513],
      Bluford: [62814],
      Bolingbrook: [60440],
      Bolivia: [62545],
      'Bone Gap': [62815],
      Bonfield: [60913],
      Bonnie: [62816],
      Boody: [62514],
      Bourbonnais: [60914],
      Bowen: [62316],
      Braceville: [60407],
      Bradford: [61421],
      Bradley: [60915],
      Braidwood: [60408],
      Breese: [62230],
      Bridgeport: [62417],
      Bridgeview: [60455],
      Brighton: [62012],
      Brimfield: [61517],
      Bristol: [60512],
      Broadlands: [61816],
      Broadview: [60153],
      Broadwell: [62634],
      Brocton: [61917],
      Brookfield: [60513],
      Broughton: [62817],
      Brownfield: [62938],
      Browns: [62818],
      Brownstown: [62418],
      Brunswick: [62534],
      Bryant: [61519],
      Buckingham: [60917],
      Buckley: [60918],
      Buckner: [62819],
      Buda: [61314],
      'Buffalo Grove': [60089],
      'Buffalo Hart': [62515],
      Buncombe: [62912],
      'Bunker Hill': [62014],
      Burbank: [60459],
      Burnham: [60633],
      Burnside: [62318],
      'Burnt Prairie': [62820],
      Bushnell: [61422],
      Butler: [62015],
      Byron: [61010],
      Cabery: [60919],
      Cache: [62913],
      Cahokia: [62206],
      Cairo: [62914],
      Caledonia: [61011],
      Calhoun: [62419],
      'Calumet City': [60409],
      'Calumet Park': [60643],
      Camargo: [61919],
      Cambridge: [61238],
      Camden: [62319],
      Cameron: [61423],
      'Camp Point': [62320],
      'Campbell Hill': [62916],
      Canton: [61520],
      Cantrall: [62625],
      Capron: [61012],
      Carbondale: [62901],
      Carlock: [61725],
      Carlyle: [62231],
      Carman: [61425],
      Carmi: [62821],
      'Carol Stream': [60188],
      Carpentersville: [60110],
      'Carrier Mills': [62917],
      Carrollton: [62016],
      Carterville: [62918],
      Carthage: [62321],
      Cary: [60013],
      Casey: [62420],
      Caseyville: [62232],
      Casner: [62552],
      Catlin: [61817],
      'Cave In Rock': [62919],
      Cazenovia: [61545],
      Centralia: [62801],
      'Cerro Gordo': [61818],
      Chadwick: [61014],
      Chambersburg: [62323],
      Champaign: [61820, 61821],
      Chana: [61015],
      Channahon: [60410],
      Chapin: [62628],
      Charleston: [61920],
      Chatham: [62629],
      Chatsworth: [60921],
      Chebanse: [60922],
      Chenoa: [61726],
      'Cherry Valley': [61016],
      Chester: [62233],
      Chestnut: [62518],
      Chicago: [
        60601, 60602, 60603, 60604, 60605, 60606, 60607, 60608, 60609, 60610,
        60611, 60612, 60613, 60614, 60615, 60616, 60617, 60618, 60619, 60620,
        60621, 60622, 60623, 60624, 60625, 60626, 60628, 60629, 60630, 60631,
        60632, 60636, 60637, 60639, 60640, 60641, 60644, 60647, 60648, 60649,
        60651, 60652, 60653, 60654, 60657, 60660, 60661,
      ],
      'Chicago Ridge': [60415],
      Chillicothe: [61523],
      Chrisman: [61924],
      Christopher: [62822],
      Cicero: [60650],
      Cimic: [62530],
      Cisco: [61830],
      Cisne: [62823],
      'Cissna Park': [60924],
      Clare: [60111],
      Claremont: [62421],
      'Clarendon Hills': [60514],
      Clarksburg: [62565],
      Clarksdale: [62556],
      'Clay City': [62824],
      Clayton: [62324],
      Clements: [62638],
      Clifton: [60927],
      Clinton: [61727],
      'Coal City': [60416],
      'Coal Valley': [61240],
      Coatsburg: [62325],
      Cobden: [62920],
      Coffeen: [62017],
      Colchester: [62326],
      Colfax: [61728],
      Collinsville: [62234],
      Collison: [61831],
      Colmar: [62367],
      Columbia: [62236],
      Comer: [62626],
      Compton: [61318],
      Concord: [62631],
      Congerville: [61729],
      Cooksville: [61730],
      Cordova: [61242],
      'Cottage Hills': [62018],
      'Country Club Hil': [60478],
      Cowden: [62422],
      'Creal Springs': [62922],
      'Crescent City': [60928],
      Crestwood: [60445],
      Crete: [60417],
      Cropsey: [61731],
      Crossville: [62827],
      'Crystal Lake': [60012, 60014],
      Cuba: [61427],
      Cullom: [60929],
      'Custer Park': [60481],
      Cutler: [62238],
      Cypress: [62923],
      Dahinda: [61428],
      Dahlgren: [62828],
      Dakota: [61018],
      Dale: [62829],
      'Dalton City': [61925],
      Dalzell: [61320],
      Dana: [61321],
      Danforth: [60930],
      Danvers: [61732],
      Danville: [61832],
      Davis: [61019],
      'Davis Junction': [61020],
      Dawson: [62520],
      'De Kalb': [60115],
      'De Land': [61839],
      'De Soto': [62924],
      Decatur: [62521, 62522, 62523],
      'Deer Creek': [61733],
      'Deer Grove': [61243],
      Deerfield: [60015],
      Delavan: [61734],
      Dennison: [62423],
      'Des Plaines': [60016],
      Detroit: [62332],
      Dewey: [61840],
      Dewitt: [61735],
      Dieterich: [62424],
      Dix: [62830],
      Dixon: [61021],
      Dollville: [62571],
      Dolton: [60419],
      Dongola: [62926],
      Donnellson: [62019],
      Donovan: [60931],
      Dorchester: [62033],
      Dorsey: [62021],
      Dow: [62022],
      'Downers Grove': [60515, 60516],
      'Du Bois': [62831],
      'Du Quoin': [62832],
      Dundas: [62425],
      Dundee: [60118],
      Dunfermline: [61524],
      Dunkel: [62557],
      Dunlap: [61525],
      Dupo: [62239],
      Durand: [61024],
      Dwight: [60420],
      Earlville: [60518],
      'East Alton': [62024],
      'East Carondelet': [62240],
      'East Dubuque': [61025],
      'East Moline': [61244],
      'East Peoria': [61611],
      'East Saint Louis': [62203, 62205],
      Eckard: [62644],
      Eddyville: [62928],
      Edelstein: [61526],
      Edinburg: [62531],
      Edwards: [61528],
      Edwardsville: [62025],
      Effingham: [62401],
      Egan: [61047],
      'El Paso': [61738],
      Elburn: [60119],
      Eldorado: [62930],
      Eldred: [62027],
      Elgin: [60120, 60123],
      Elizabeth: [61028],
      Elizabethtown: [62931],
      'Elk Grove Villag': [60007],
      Elkville: [62932],
      Ellery: [62833],
      'Ellis Grove': [62241],
      Ellisville: [61431],
      Ellsworth: [61737],
      Elmhurst: [60126],
      Elmwood: [61529],
      'Elmwood Park': [60635],
      Elsah: [62028],
      Elvaston: [62334],
      Elwood: [60421],
      Emden: [62635],
      Emington: [60934],
      Enfield: [62835],
      Equality: [62934],
      Erie: [61250],
      Esmond: [60129],
      Essex: [60935],
      Eureka: [61530],
      Evanston: [60201, 60202, 60203],
      Evansville: [62242],
      'Evergreen Park': [60642],
      Ewing: [62836],
      Exeter: [62621],
      Fairbury: [61739],
      Fairfield: [62837],
      Fairmount: [61841],
      Fairview: [61432],
      'Fairview Heights': [62208],
      'Fancy Prairie': [62613],
      Farina: [62838],
      'Farmer City': [61842],
      Farmingdale: [62677],
      Fenton: [61251],
      Fiatt: [61433],
      Fidelity: [62030],
      Fieldon: [62031],
      Fillmore: [62032],
      Fisher: [61843],
      Fithian: [61844],
      Flanagan: [61740],
      'Flat Rock': [62427],
      Flora: [62839],
      Flossmoor: [60422],
      Foosland: [61845],
      'Forest City': [61532],
      'Forest Park': [60130],
      Forrest: [61741],
      Forreston: [61030],
      'Fort Sheridan': [60037],
      Fowler: [62338],
      'Fox Lake': [60020],
      'Fox River Grove': [60021],
      Frankfort: [60423],
      'Frankfort Height': [62840],
      'Franklin Grove': [61031],
      'Franklin Park': [60131],
      Frederick: [62639],
      Freeburg: [62243],
      Freeport: [61032],
      Fulton: [61252],
      Fults: [62244],
      'Gages Lake': [60030],
      Galatia: [62935],
      Gale: [62990],
      Galena: [61036],
      Galesburg: [61401],
      Galva: [61434],
      'Garden Prairie': [61038],
      Gardner: [60424],
      Gays: [61928],
      Geff: [62842],
      Geneseo: [61254],
      Geneva: [60134],
      Genoa: [60135],
      Georgetown: [61846],
      Gerlaw: [61435],
      'German Valley': [61039],
      Germantown: [62245],
      'Gibson City': [60936],
      Gifford: [61847],
      Gilberts: [60136],
      Gilman: [60938],
      Gilson: [61436],
      Gladstone: [61437],
      Glasford: [61533],
      Glasgow: [62694],
      'Glen Carbon': [62034],
      'Glen Ellyn': [60137],
      Glenarm: [62536],
      Glencoe: [60022],
      'Glendale Heights': [60139],
      Glenview: [60025],
      'Glenview Nas': [60026],
      Glenwood: [60425],
      Godfrey: [62035],
      Golden: [62339],
      'Golden Eagle': [62036],
      'Golden Gate': [62843],
      'Good Hope': [61438],
      Goreville: [62939],
      Gorham: [62940],
      Grafton: [62037],
      'Grand Chain': [62941],
      'Grand Ridge': [61325],
      'Grand Tower': [62942],
      Grandview: [62702],
      'Grant Park': [60940],
      Grantsburg: [62943],
      Granville: [61326],
      Graymont: [61743],
      Grayville: [62844],
      'Great Lakes': [60088],
      'Green Rock': [61241],
      'Green Valley': [61534],
      Greenfield: [62044],
      Greenville: [62246],
      Gridley: [61744],
      Griggsville: [62340],
      Gurnee: [60031],
      Hagaman: [62630],
      Hamburg: [62045],
      Hamel: [62046],
      Hamilton: [62341],
      Hammond: [61929],
      Hampshire: [60140],
      Hampton: [61256],
      'Hanna City': [61536],
      Hanover: [61041],
      'Hanover Park': [60103],
      Hardin: [62047],
      Harmon: [61042],
      Harrisburg: [62946],
      Hartford: [62048],
      Hartsburg: [62643],
      Harvard: [60033],
      Harvel: [62538],
      'Harwood Heights': [60656],
      'Hazel Crest': [60429],
      'Hazel Dell': [62428],
      Hebron: [60034],
      Hecker: [62248],
      Heman: [62573],
      Hennepin: [61327],
      Henry: [61537],
      Herald: [62845],
      Herod: [62947],
      Herrick: [62431],
      Herrin: [62948],
      Herscher: [60941],
      'Hervey City': [62549],
      Hettick: [62649],
      Hewittsville: [62568],
      Heyworth: [61745],
      'Hickory Hills': [60457],
      Hidalgo: [62432],
      Highland: [62249],
      'Highland Park': [60035],
      Highwood: [60040],
      Hillsboro: [62049],
      Hillsdale: [61257],
      Hillside: [60162, 60163],
      Hillview: [62050],
      Hinckley: [60520],
      Hindsboro: [61930],
      Hines: [60141],
      Hodgkins: [60525],
      'Hoffman Estates': [60194, 60195],
      Holder: [61736],
      Homer: [61849],
      Hometown: [60456],
      Homewood: [60430],
      Hoopeston: [60942],
      Hopedale: [61747],
      Hoyleton: [62803],
      Hubly: [62642],
      Hudson: [61748],
      Hull: [62343],
      Humboldt: [61931],
      Hume: [61932],
      Huntley: [60142],
      Huntsville: [62344],
      Hutsonville: [62433],
      'Illinois City': [61259],
      Illiopolis: [62539],
      Ina: [62846],
      Indianola: [61850],
      Industry: [61440],
      Ingleside: [60041],
      Ingraham: [62434],
      Ipava: [61441],
      Irving: [62051],
      'Island Lake': [60042],
      Itasca: [60143],
      Iuka: [62849],
      Ivesdale: [61851],
      Jacob: [62950],
      Jerome: [62704],
      Jerseyville: [62052],
      Jewett: [62436],
      Johnsonville: [62850],
      'Johnston City': [62951],
      Joliet: [60431, 60432, 60433],
      Jonesboro: [62952],
      Joppa: [62953],
      Joy: [61260],
      Junction: [62954],
      Justice: [60458],
      Kampsville: [62053],
      Kane: [62054],
      Kankakee: [60901],
      Kansas: [61933],
      'Karbers Ridge': [62955],
      Karnak: [62956],
      Keenes: [62851],
      Keithsburg: [61442],
      Kell: [62853],
      Kempton: [60946],
      Kenilworth: [60043],
      Kenney: [61749],
      Kent: [61044],
      Kewanee: [61443],
      Keyesport: [62253],
      Kilbourne: [62655],
      Kinderhook: [62345],
      Kings: [61045],
      Kingston: [60145],
      'Kingston Mines': [61539],
      Kinmundy: [62854],
      Kinsman: [60437],
      Kirkland: [60146],
      Kirkwood: [61447],
      Knoxville: [61448],
      'La Fayette': [61449],
      'La Harpe': [61450],
      'La Moille': [61330],
      'La Prairie': [62346],
      'La Salle': [61301],
      Laclede: [62426],
      Lacon: [61540],
      'Lake Bluff': [60044],
      'Lake Forest': [60045],
      'Lake In The Hill': [60102],
      Lakewood: [62438],
      Lanark: [61046],
      Lancaster: [62855],
      Lansing: [60438],
      Latham: [62543],
      Laura: [61451],
      Lawrenceville: [62439],
      Layton: [62681],
      'Le Roy': [61752],
      Lebanon: [62254],
      Lee: [60530],
      Leland: [60531],
      Lena: [61048],
      Lenzburg: [62255],
      Leonore: [61332],
      Lerna: [62440],
      Lewistown: [61542],
      Lexington: [61753],
      Liberty: [62347],
      Libertyville: [60048],
      Lima: [62348],
      Lincoln: [62656],
      Lincolnwood: [60645, 60646, 60659],
      Lindenhurst: [60046],
      Lindenwood: [61049],
      Lisle: [60532],
      Litchfield: [62056],
      'Little Indian': [62691],
      'Little York': [61453],
      Littleton: [61452],
      Liverpool: [61543],
      Loami: [62661],
      Loda: [60948],
      Lomax: [61454],
      Lombard: [60148],
      'London Mills': [61544],
      'Long Grove': [60047],
      'Long Point': [61333],
      Longview: [61852],
      Loraine: [62349],
      Lostant: [61334],
      'Loves Park': [61111],
      Lovington: [61937],
      Ludlow: [60949],
      Luther: [62664],
      Lynchburg: [62617],
      Lyndon: [61261],
      'Lynn Center': [61262],
      Lyons: [60534],
      Macedonia: [62860],
      Mackinaw: [61755],
      Macomb: [61455],
      Macon: [62544],
      Madison: [62060],
      Maeystown: [62256],
      Magnolia: [61336],
      Mahomet: [61853],
      Makanda: [62958],
      Malden: [61337],
      Malta: [60150],
      Manhattan: [60442],
      Manito: [61546],
      Mansfield: [61854],
      Manteno: [60950],
      Manville: [61319],
      'Maple Park': [60151],
      Mapleton: [61547],
      Maquon: [61458],
      Marengo: [60152],
      Marietta: [61459],
      Marine: [62061],
      Marion: [62959],
      Marissa: [62257],
      Markham: [60426],
      Maroa: [61756],
      Marseilles: [61341],
      Marshall: [62441],
      Martinsville: [62442],
      Martinton: [60951],
      Mascoutah: [62258],
      Mason: [62443],
      Matherville: [61263],
      Matteson: [60443],
      Mattoon: [61938],
      Mazon: [60444],
      'Mc Clure': [62957],
      'Mc Connell': [61050],
      'Mc Gaw Park': [60085],
      'Mc Henry': [60050],
      'Mc Lean': [61754],
      'Mc Leansboro': [62859],
      'Mc Nabb': [61335],
      Mcvey: [62640],
      Media: [61460],
      Medinah: [60157],
      Medora: [62063],
      'Melrose Park': [60160],
      Melvin: [60952],
      Mendon: [62351],
      Mendota: [61342],
      Meppen: [62013],
      'Merrionette Park': [60655],
      Metamora: [61548],
      Metcalf: [61940],
      Metropolis: [62960],
      Michael: [62065],
      Middlegrove: [61531],
      Middletown: [62666],
      Milan: [61264],
      Milford: [60953],
      'Mill Shoals': [62862],
      Millcreek: [62961],
      Milledgeville: [61051],
      'Miller City': [62962],
      Millstadt: [62260],
      Milmine: [61855],
      Milton: [62352],
      Mineral: [61344],
      Minier: [61759],
      Minonk: [61760],
      Minooka: [60447],
      Mitchell: [62040],
      Modesto: [62667],
      Modoc: [62261],
      Mokena: [60448],
      Moline: [61265],
      Momence: [60954],
      Monee: [60449],
      Monmouth: [61462],
      'Monroe Center': [61052],
      Montgomery: [60538],
      Monticello: [61856],
      Montrose: [62445],
      Mooseheart: [60539],
      Moro: [62067],
      Morris: [60450],
      Morrison: [61270],
      Morrisonville: [62546],
      Morton: [61550],
      'Morton Grove': [60053],
      'Mound City': [62963],
      Mounds: [62964],
      'Mount Auburn': [62547],
      'Mount Carmel': [62863],
      'Mount Carroll': [61053],
      'Mount Erie': [62446],
      'Mount Morris': [61054],
      'Mount Olive': [62069],
      'Mount Prospect': [60056],
      'Mount Pulaski': [62548],
      'Mount Sterling': [62353],
      'Mount Vernon': [62864],
      Mozier: [62070],
      'Mulberry Grove': [62262],
      Mulkeytown: [62865],
      Mundelein: [60060],
      Murphysboro: [62966],
      Naperville: [60540, 60563, 60564, 60565],
      Naples: [62665],
      Nashville: [62263],
      Nason: [62866],
      Nebo: [62355],
      Neoga: [62447],
      Neponset: [61345],
      'New Athens': [62264],
      'New Baden': [62265],
      'New Bedford': [61346],
      'New Boston': [61272],
      'New Burnside': [62967],
      'New Canton': [62356],
      'New Douglas': [62074],
      'New Haven': [62867],
      'New Holland': [62671],
      'New Lenox': [60451],
      'New Liberty': [62910],
      'New Salem': [62357],
      'New Windsor': [61465],
      Newark: [60541],
      Newburg: [62501],
      Newman: [61942],
      Newmansville: [62612],
      Newton: [62448],
      Niantic: [62551],
      Nilwood: [62672],
      Niota: [62358],
      Noble: [62868],
      Nokomis: [62075],
      Normal: [61761],
      Normandy: [61376],
      Norridge: [60634],
      'Norris City': [62869],
      'North Aurora': [60542],
      'North Henderson': [61466],
      'North Riverside': [60546],
      Northbrook: [60062],
      Northfield: [60093],
      Northlake: [60164],
      Nortonville: [62668],
      'Oak Brook': [60521],
      'Oak Forest': [60452],
      'Oak Hill': [61518],
      'Oak Lawn': [60453],
      'Oak Park': [60301, 60302, 60304],
      Oakdale: [62268],
      Oakford: [62673],
      Oakland: [61943],
      Oakwood: [61858],
      Oblong: [62449],
      Oconee: [62553],
      Odell: [60460],
      Odin: [62870],
      Ogden: [61859],
      Oglesby: [61348],
      Ohio: [61349],
      Okawville: [62271],
      Olmsted: [62970],
      Olney: [62450],
      'Olympia Fields': [60461],
      Omaha: [62871],
      Onarga: [60955],
      Oneida: [61467],
      Opdyke: [62872],
      Oquawka: [61469],
      Orangeville: [61060],
      Oreana: [62554],
      Oregon: [61061],
      Orion: [61273],
      'Orland Park': [60462],
      Orleans: [62601],
      Osco: [61274],
      Oswego: [60543],
      Ottawa: [61350],
      Owaneco: [62555],
      Ozark: [62972],
      Palatine: [60067, 60074],
      Palestine: [62451],
      Paloma: [62359],
      'Palos Heights': [60463],
      'Palos Hills': [60465],
      'Palos Park': [60464],
      'Panther Creek': [62627],
      Paris: [61944],
      'Park Ridge': [60068],
      Parkersburg: [62452],
      Patoka: [62875],
      'Paw Paw': [61353],
      Paxton: [60957],
      Payson: [62360],
      Pearl: [62361],
      'Pearl City': [61062],
      Pecatonica: [61063],
      Pekin: [61554],
      Penfield: [61862],
      Peoria: [61602, 61604, 61605, 61606, 61615],
      'Peoria Heights': [61603, 61614],
      Peotone: [60468],
      Percy: [62272],
      Perry: [62362],
      Peru: [61354],
      Pesotum: [61863],
      Philo: [61864],
      Piasa: [62079],
      Pinckneyville: [62274],
      'Piper City': [60959],
      Pittsburg: [62974],
      Pittsfield: [62363],
      Plainfield: [60544],
      Plainview: [62676],
      Plainville: [62365],
      Plano: [60545],
      'Pleasant Hill': [62366],
      Pocahontas: [62275],
      Polo: [61064],
      Pomona: [62975],
      Pontiac: [61764],
      Pontoosuc: [62330],
      'Poplar Grove': [61065],
      'Port Byron': [61275],
      Posen: [60469],
      Potomac: [61865],
      'Prairie City': [61470],
      'Prairie Du Roche': [62277],
      'Prairie View': [60069],
      Princeton: [61356],
      Princeville: [61559],
      Prophetstown: [61277],
      'Prospect Heights': [60070],
      Pulaski: [62976],
      Putnam: [61560],
      Quincy: [62301],
      Radford: [62550],
      Raleigh: [62977],
      Ramsey: [62080],
      Rankin: [60960],
      Ransom: [60470],
      Rantoul: [61866, 61868],
      Raritan: [61471],
      Raymond: [62560],
      'Red Bud': [62278],
      Reddick: [60961],
      Renault: [62279],
      Reynolds: [61279],
      Richmond: [60071],
      'Richton Park': [60471],
      Richview: [62877],
      'Ridge Farm': [61870],
      Ridgway: [62979],
      Ridott: [61067],
      Rinard: [62878],
      Ringwood: [60072],
      Rio: [61472],
      'River Forest': [60305],
      'River Grove': [60171],
      Riverdale: [60627],
      Roanoke: [61561],
      Robbins: [60472],
      Robbs: [62985],
      Roberts: [60962],
      Robinson: [62454],
      Rochelle: [61068],
      'Rock City': [61070],
      'Rock Falls': [61071],
      'Rock Island': [61201],
      Rockbridge: [62081],
      Rockdale: [60436],
      Rockford: [61101, 61102, 61103, 61104, 61107, 61108, 61109, 61112],
      Rockport: [62370],
      Rockton: [61072],
      Rockwood: [62280],
      'Rolling Meadows': [60008],
      Romeoville: [60441],
      Roodhouse: [62082],
      Rosamond: [62083],
      Roscoe: [61073],
      Roselle: [60172],
      Rosemont: [60018],
      Roseville: [61473],
      Rosiclare: [62982],
      Rossville: [60963],
      'Round Lake': [60073],
      Roxana: [62084],
      'Royal Lakes': [62685],
      Royalton: [62983],
      Rutland: [61358],
      Sadorus: [61872],
      'Saint Anne': [60964],
      'Saint Augustine': [61474],
      'Saint Charles': [60174, 60175],
      'Saint David': [61563],
      'Saint Elmo': [62458],
      'Saint Francisvil': [62460],
      'Saint Jacob': [62281],
      'Saint Joseph': [61873],
      'Saint Mary': [63673],
      'Saint Peter': [62880],
      Salem: [62881],
      Sandoval: [62882],
      Sandwich: [60548],
      Sauget: [62201],
      'Sauk Village': [60411],
      Saunemin: [61769],
      Savanna: [61074],
      Savoy: [61874],
      Saybrook: [61770],
      'Scales Mound': [61075],
      Schaumburg: [60173, 60193],
      Scheller: [62883],
      'Schiller Park': [60176],
      Sciota: [61475],
      'Scott A F B': [62225],
      Scottville: [62683],
      Seaton: [61476],
      Secor: [61771],
      Seneca: [61360],
      Serena: [60549],
      Sesser: [62884],
      Seymour: [61875],
      Shabbona: [60550],
      Shannon: [61078],
      Shattuc: [62283],
      Shawneetown: [62984],
      Sheffield: [61361],
      Sheldon: [60966],
      Sheridan: [60551],
      Sherrard: [61281],
      Shiloh: [62269],
      Shirley: [61772],
      Shobonier: [62885],
      Shorewood: [60435],
      Shumway: [62461],
      Sibley: [61773],
      Sicily: [62558],
      Sidell: [61876],
      Sidney: [61877],
      Sigel: [62462],
      Silvis: [61282],
      Sims: [62886],
      Skokie: [60076, 60077],
      Smithboro: [62284],
      Smithfield: [61477],
      Smithshire: [61478],
      Smithton: [62285],
      Somonauk: [60552],
      Sorento: [62086],
      'South Beloit': [61080],
      'South Elgin': [60177],
      'South Holland': [60473],
      'Southern View': [62703],
      Sparland: [61565],
      Sparta: [62286],
      Spaulding: [62561],
      Speer: [61479],
      'Spring Grove': [60081],
      'Spring Valley': [61362],
      Springerton: [62887],
      Springfield: [62701],
      Stanford: [61774],
      Staunton: [62088],
      Steeleville: [62288],
      Steger: [60475],
      Sterling: [61081],
      Steward: [60553],
      Stewardson: [62463],
      Stickney: [60402],
      'Stillman Valley': [61084],
      Stockton: [61085],
      'Stone Park': [60165],
      Stonefort: [62987],
      Stonington: [62567],
      Strasburg: [62465],
      Strawn: [61775],
      Streamwood: [60107],
      Streator: [61364],
      Stronghurst: [61480],
      Sublette: [61367],
      'Sugar Grove': [60554],
      Sullivan: [61951],
      Sumner: [62466],
      Sunnyland: [61571],
      Sutter: [62373],
      Swanwick: [62237],
      Sycamore: [60178],
      'Table Grove': [61482],
      Tallula: [62688],
      Tamaroa: [62888],
      Tamms: [62988],
      Tampico: [61283],
      'Taylor Ridge': [61284],
      Techny: [60082],
      Tennessee: [62374],
      Teutopolis: [62467],
      Texico: [62889],
      Thawville: [60968],
      Thomasboro: [61878],
      Thomasville: [62533],
      Thompsonville: [62890],
      Thomson: [61285],
      Thornton: [60476],
      Tilton: [61833],
      Timewell: [62375],
      'Tinley Park': [60477],
      Tiskilwa: [61368],
      Toledo: [62468],
      Tolono: [61880],
      Toluca: [61369],
      Tonica: [61370],
      Topeka: [61567],
      Toulon: [61483],
      Towanda: [61776],
      Tremont: [61568],
      Trenton: [62293],
      Trilla: [62469],
      Trivoli: [61569],
      Troy: [62294],
      'Tunnel Hill': [62991],
      Tuscola: [61953],
      Ullin: [62992],
      Union: [60180],
      'University Park': [60466],
      Urbana: [61801],
      Ursa: [62376],
      Utica: [61373],
      Valmeyer: [62295],
      Vandalia: [62471],
      Varna: [61375],
      Venedy: [62214],
      Venice: [62090],
      Vergennes: [62994],
      Vermont: [61484],
      Vernon: [62892],
      'Vernon Hills': [60061],
      Verona: [60479],
      Versailles: [62378],
      Victoria: [61485],
      Vienna: [62995],
      'Villa Grove': [61956],
      'Villa Park': [60181],
      'Villa Ridge': [62996],
      Viola: [61486],
      Virden: [62690],
      Wadsworth: [60083],
      Waggoner: [62572],
      'Walnut Hill': [62893],
      Walsh: [62297],
      Walshville: [62091],
      Waltonville: [62894],
      Wapella: [61777],
      Warren: [61087],
      Warrenville: [60555],
      Warsaw: [62379],
      Washburn: [61570],
      'Washington Park': [62204],
      Wataga: [61488],
      Waterloo: [62298],
      Waterman: [60556],
      Watseka: [60970],
      Watson: [62473],
      Wauconda: [60084],
      Waukegan: [60087],
      Waverly: [62692],
      'Wayne City': [62895],
      Waynesville: [61778],
      Weldon: [61882],
      Wellington: [60973],
      Wenona: [61377],
      'West Brooklyn': [61378],
      'West Chicago': [60185],
      'West Frankfort': [62896],
      'West Liberty': [62475],
      'West Point': [62380],
      'West Salem': [62476],
      'West Union': [62477],
      'West York': [62478],
      Westchester: [60154],
      'Western Springs': [60558],
      Westfield: [62474],
      Westmont: [60559],
      Westville: [61883],
      Wheaton: [60187],
      Wheeler: [62479],
      Wheeling: [60090],
      'White Hall': [62092],
      'White Heath': [61884],
      Whittington: [62897],
      Williamsfield: [61489],
      Williamsville: [62693],
      Willisville: [62997],
      'Willow Hill': [62480],
      'Willow Springs': [60480],
      Wilmette: [60091],
      Windsor: [61957],
      Winfield: [60190],
      Winnebago: [61088],
      Winslow: [61089],
      'Winthrop Harbor': [60096],
      Witt: [62094],
      'Wolf Lake': [62998],
      'Wonder Lake': [60097],
      'Wood Dale': [60191],
      'Wood River': [62095],
      Woodhull: [61490],
      Woodlawn: [62898],
      Woodridge: [60517],
      Woodstock: [60098],
      Worden: [62097],
      Worth: [60482],
      Wyanet: [61379],
      Wyoming: [61491],
      Xenia: [62899],
      Yale: [62481],
      'Yates City': [61572],
      Yorkville: [60560],
      Zeigler: [62999],
      Zion: [60099],
    },
    name: 'Illinois',
  },
  IN: {
    cities: {
      47559: [47559],
      Acton: [46259],
      Adams: [47240],
      Akron: [46910],
      Albany: [47320],
      Albion: [46701],
      Alexandria: [46001],
      Ambia: [47917],
      Amboy: [46911],
      Anderson: [46011, 46012, 46013, 46016],
      Andrews: [46702],
      Angola: [46703],
      Arcadia: [46030],
      Argos: [46501],
      Arlington: [46104],
      Ashley: [46705],
      Atlanta: [46031],
      Attica: [47918],
      Auburn: [46706],
      Aurora: [47001],
      Austin: [47102],
      Avilla: [46710],
      Avon: [46168],
      Bainbridge: [46105],
      'Ball State Unive': [47306],
      Bargersville: [46106],
      Batesville: [47006],
      Bath: [47010],
      'Battle Ground': [47920],
      Bedford: [47421],
      'Beech Grove': [46107],
      Bennington: [47011],
      Bicknell: [47512],
      Birdseye: [47513],
      Bloomfield: [47424],
      Bloomingdale: [47832],
      Bloomington: [47401, 47403, 47404],
      Bluffton: [46714],
      Boggstown: [46110],
      Boonville: [47601],
      Borden: [47106],
      Boswell: [47921],
      Bourbon: [46504],
      'Bowling Green': [47833],
      Branchville: [47514],
      Brazil: [47834],
      Bremen: [46506],
      Bridgeport: [46231],
      Bridgeton: [47836],
      Bringhurst: [46913],
      Bristol: [46507],
      Brook: [47922],
      Brookston: [47923],
      Brookville: [47012],
      Brownsburg: [46112],
      Brownstown: [47220],
      Brownsville: [47325],
      Bruceville: [47516],
      Bryant: [47326],
      Buckskin: [47647],
      Buffaloville: [47550],
      'Bunker Hill': [46914],
      Burnettsville: [47926],
      Butler: [46721],
      Butlerville: [47223],
      'Cambridge City': [47327],
      Camby: [46113],
      Camden: [46917],
      Campbellsburg: [47108],
      Canaan: [47224],
      Cannelburg: [47519],
      Carbon: [47837],
      Carlisle: [47838],
      Carmel: [46032],
      Carthage: [46115],
      Castleton: [46250, 46256],
      Cates: [47952],
      Cayuga: [47928],
      'Cedar Grove': [47016],
      Celestine: [47521],
      Centerpoint: [47840],
      Centerton: [46151],
      Centerville: [47330],
      Central: [47110],
      Chalmers: [47929],
      Chandler: [47610],
      Charlestown: [47111],
      Charlottesville: [46117],
      Chesterfield: [46017],
      Chili: [46926],
      Chrisney: [47611],
      Churubusco: [46723],
      Cicero: [46034],
      'Clarks Hill': [47930],
      Clarksville: [47129],
      'Clay City': [47841],
      Claypool: [46510],
      Clayton: [46118],
      Clermont: [46234],
      Clinton: [47842],
      Cloverdale: [46120],
      'Coal City': [47427],
      Coatesville: [46121],
      Colfax: [46035],
      Collegeville: [47978],
      'Columbia City': [46725],
      Columbus: [47201, 47203],
      Commiskey: [47227],
      Connersville: [47331],
      Converse: [46919],
      Cortland: [47228],
      Corunna: [46730],
      Cory: [47846],
      Corydon: [47112],
      Covington: [47932],
      Craigville: [46731],
      Crandall: [47114],
      'Crane Naval Depo': [47522],
      Crawfordsville: [47933],
      Cromwell: [46732],
      'Cross Plains': [47017],
      Crothersville: [47229],
      'Crown Point': [46307],
      'Culver Military': [46511],
      Cumberland: [46229],
      Cutler: [46920],
      Cynthiana: [47612],
      Dale: [47523],
      Daleville: [47334],
      Dana: [47847],
      Danville: [46122],
      Darlington: [47940],
      Decatur: [46733],
      Decker: [47524],
      Delphi: [46923],
      Demotte: [46310],
      Depauw: [47115],
      Deputy: [47230],
      Derby: [47525],
      Dillsboro: [47018],
      Dubois: [47527],
      Dugger: [47848],
      Dunkirk: [47336],
      Dupont: [47231],
      Dyer: [46311],
      'Eagle Creek': [46214, 46254],
      'Earl Park': [47942],
      'East Cedar Lake': [46303],
      'East Chicago': [46312],
      Eaton: [47338],
      Eckerty: [47116],
      Economy: [47339],
      Edinburgh: [46124],
      Edwardsport: [47528],
      Elberfeld: [47613],
      Elizabeth: [47117],
      Elizabethtown: [47232],
      Elkhart: [46514, 46516, 46517],
      Ellettsville: [47429],
      Elnora: [47529],
      Elwood: [46036],
      English: [47118],
      'Etna Green': [46524],
      Evanston: [47531],
      Evansville: [47708, 47710, 47711, 47712, 47713, 47714, 47715, 47720],
      'Fair Oaks': [47943],
      Fairbanks: [47849],
      Fairland: [46126],
      Fairmount: [46928],
      Falmouth: [46127],
      Farmersburg: [47850],
      Farmland: [47340],
      Ferdinand: [47532],
      Fillmore: [46128],
      Fishers: [46038],
      'Flat Rock': [47234],
      Flora: [46929],
      Florence: [47020],
      'Floyds Knobs': [47119],
      Foraker: [46526],
      Forest: [46039],
      'Fort Benjamin Ha': [46216],
      'Fort Branch': [47648],
      'Fort Wayne': [
        46802, 46803, 46804, 46805, 46806, 46807, 46808, 46809, 46815, 46816,
        46818, 46819, 46825, 46835, 46845,
      ],
      Fortville: [46040],
      'Fountain City': [47341],
      Fountaintown: [46130],
      Fowler: [47944],
      Francesville: [47946],
      Francisco: [47649],
      Franklin: [46131],
      Frankton: [46044],
      Fredericksburg: [47120],
      Freedom: [47431],
      Freetown: [47235],
      Fremont: [46737],
      'French Lick': [47432],
      Friendship: [47021],
      Galveston: [46932],
      Garrett: [46738],
      Gary: [46402, 46403, 46404, 46406, 46407, 46408, 46409],
      'Gas City': [46933],
      Gaston: [47342],
      Geneva: [46740],
      Gentryville: [47537],
      Georgetown: [47122],
      Glenwood: [46133],
      Goodland: [47948],
      Gosport: [47433],
      Grabill: [46741],
      Grammer: [47236],
      Grandview: [47615],
      Granger: [46530],
      Grantsburg: [47123],
      Greencastle: [46135],
      Greenfield: [46140],
      'Greens Fork': [47345],
      Greentown: [46936],
      Greenville: [47124],
      Greenwood: [46142, 46143],
      Griffin: [47616],
      Griffith: [46319],
      'Grissom Air Forc': [46971],
      Grovertown: [46531],
      Guilford: [47022],
      Hagerstown: [47346],
      Hamilton: [46742],
      Hamlet: [46532],
      Hammond: [46320, 46323, 46324, 46327],
      Hanna: [46340],
      Hanover: [47243],
      Hardinsburg: [47125],
      Harlan: [46743],
      'Hartford City': [47348],
      Hartsville: [47244],
      Haubstadt: [47639],
      Haysville: [47546],
      Hazleton: [47640],
      Hebron: [46341],
      Helmer: [46747],
      Heltonville: [47436],
      Henryville: [47126],
      Highland: [46322],
      Hillisburg: [46041],
      Hillsboro: [47949],
      Hillsdale: [47854],
      Hoagland: [46745],
      Hobart: [46342],
      Holland: [47541],
      Holton: [47023],
      Hope: [47246],
      Howe: [46746],
      Huntertown: [46748],
      Huntingburg: [47542],
      Huntington: [46750],
      Idaville: [47950],
      Indianapolis: [
        46201, 46202, 46203, 46204, 46205, 46208, 46218, 46219, 46220, 46221,
        46222, 46225,
      ],
      Ingalls: [46048],
      Inwood: [46563],
      Jamestown: [46147],
      Jasonville: [47438],
      Jeffersonville: [47130],
      Jonesboro: [46938],
      Kempton: [46049],
      Kendallville: [46755],
      Kentland: [47951],
      Kewanna: [46939],
      Keystone: [46759],
      Kimmell: [46760],
      Kirklin: [46050],
      Knightstown: [46148],
      Kokomo: [46901, 46902],
      Kouts: [46347],
      Kyana: [47575],
      'La Crosse': [46348],
      'La Fontaine': [46940],
      'La Porte': [46350],
      Laconia: [47135],
      Ladoga: [47954],
      Lafayette: [47901, 47904, 47905],
      Lagrange: [46761],
      Lagro: [46941],
      'Lake Station': [46405],
      'Lake Village': [46349],
      Lakeville: [46536],
      Landess: [46991],
      Lanesville: [47136],
      Laotto: [46763],
      Lapel: [46051],
      Larwill: [46764],
      Laurel: [47024],
      Lawrence: [46226],
      Lawrenceburg: [47025],
      Leavenworth: [47137],
      Lebanon: [46052],
      Leesburg: [46538],
      Leo: [46765],
      Leopold: [47551],
      Lewis: [47858],
      Lewisville: [47352],
      Lexington: [47138],
      Liberty: [47353],
      'Liberty Center': [46766],
      Ligonier: [46767],
      'Lincoln City': [47552],
      Linden: [47955],
      'Linn Grove': [46711],
      Linton: [47441],
      Lizton: [46149],
      Logansport: [46947],
      Loogootee: [47553],
      Losantville: [47354],
      Lowell: [46356],
      Lucerne: [46950],
      Lynn: [47355],
      Lynnville: [47619],
      Lyons: [47443],
      Macy: [46951],
      Madison: [47250],
      Magnet: [47555],
      Manilla: [46150],
      Marengo: [47140],
      'Mariah Hill': [47556],
      Marion: [46952, 46953],
      Markle: [46770],
      Markleville: [46056],
      Marshall: [47859],
      Marshfield: [47993],
      Marysville: [47141],
      Mauckport: [47142],
      'Mc Cordsville': [46055],
      Medaryville: [47957],
      Medora: [47260],
      Memphis: [47143],
      Mentone: [46539],
      Merom: [47861],
      Merrillville: [46410],
      Metamora: [47030],
      'Michigan City': [46360],
      Michigantown: [46057],
      Middlebury: [46540],
      Middletown: [47356],
      Milan: [47031],
      Milford: [46542],
      'Mill Creek': [46365],
      Millersburg: [46543],
      Milltown: [47145],
      Milroy: [46156],
      Milton: [47357],
      Mishawaka: [46544, 46545],
      Mitchell: [47446],
      Modoc: [47358],
      Monon: [47959],
      Monroe: [46772],
      'Monroe City': [47557],
      Monroeville: [46773],
      Monrovia: [46157],
      Monterey: [46960],
      Montezuma: [47862],
      Montgomery: [47558],
      Monticello: [47960],
      Montpelier: [47359],
      Mooreland: [47360],
      'Moores Hill': [47032],
      Mooresville: [46158],
      Morgantown: [46160],
      Morocco: [47963],
      Morristown: [46161],
      'Mount Pleasant': [47520],
      'Mount Vernon': [47620],
      Mulberry: [46058],
      Muncie: [47302, 47303, 47304, 47305],
      Munster: [46321],
      Nabb: [47147],
      Nappanee: [46550],
      Nashville: [47448],
      Needham: [46162],
      'New Albany': [47150],
      'New Augusta': [46268, 46278],
      'New Carlisle': [46552],
      'New Castle': [47362],
      'New Harmony': [47631],
      'New Haven': [46774],
      'New Middletown': [47160],
      'New Palestine': [46163],
      'New Paris': [46553],
      'New Richmond': [47967],
      'New Ross': [47968],
      'New Salisbury': [47161],
      'New Washington': [47162],
      'New Whiteland': [46184],
      Newberry: [47449],
      Newburgh: [47630],
      Nineveh: [46164],
      Noblesville: [46060],
      Nora: [46240, 46260, 46280, 46290],
      Norman: [47264],
      'North Judson': [46366],
      'North Liberty': [46554],
      'North Manchester': [46962],
      'North Salem': [46165],
      'North Terre Haut': [47805],
      'North Vernon': [47265],
      'North Webster': [46555],
      'Oakland City': [47660],
      Oaklandon: [46236],
      Oaktown: [47561],
      Ober: [46534],
      Odon: [47562],
      Oldenburg: [47036],
      Oolitic: [47451],
      Orland: [46776],
      Orleans: [47452],
      Osceola: [46561],
      Osgood: [47037],
      Ossian: [46777],
      Otisco: [47163],
      Otterbein: [47970],
      Otwell: [47564],
      Owensburg: [47453],
      Owensville: [47665],
      Oxford: [47971],
      Palmyra: [47164],
      Paoli: [47454],
      Paragon: [46166],
      'Paris Crossing': [47270],
      'Park Fletcher': [46241],
      'Parker City': [47368],
      Patoka: [47666],
      Patriot: [47038],
      Pekin: [47165],
      Pendleton: [46064],
      Pennville: [47369],
      Perrysville: [47974],
      Peru: [46970],
      Petersburg: [47567],
      Pierceton: [46562],
      Pimento: [47866],
      'Pine Village': [47975],
      Pittsboro: [46167],
      Plainville: [47568],
      'Pleasant Lake': [46779],
      Poland: [47868],
      Poneto: [46781],
      Portage: [46368],
      Porter: [46304],
      Portland: [47371],
      Poseyville: [47633],
      Princeton: [47670],
      Quincy: [47456],
      Ramsey: [47166],
      Redkey: [47373],
      Reelsville: [46171],
      Remington: [47977],
      Reynolds: [47980],
      Richland: [47634],
      Richmond: [47374],
      Ridgeville: [47380],
      'Rising Sun': [47040],
      Roachdale: [46172],
      Roann: [46974],
      Roanoke: [46783],
      Rochester: [46975],
      Rockport: [47635],
      Rockville: [47872],
      'Rolling Prairie': [46371],
      Rome: [47574],
      'Rome City': [46784],
      Romney: [47981],
      Rosedale: [47874],
      Rossville: [46065],
      'Royal Center': [46978],
      Rushville: [46173],
      Russellville: [46175],
      Russiaville: [46979],
      'Saint Croix': [47576],
      'Saint Joe': [46785],
      'Saint John': [46373],
      'Saint Marys': [46556],
      'Saint Meinrad': [47577],
      'Saint Paul': [47272],
      Salamonia: [47381],
      Salem: [47167],
      'San Pierre': [46374],
      Sandborn: [47578],
      Sandford: [47885],
      'Santa Claus': [47579],
      Saratoga: [47382],
      Schererville: [46375],
      Schnellville: [47580],
      Scipio: [47273],
      Scottsburg: [47170],
      Selma: [47383],
      Seymour: [47274],
      Sharpsville: [46068],
      Shelburn: [47879],
      Shelbyville: [46176],
      Sheridan: [46069],
      Shipshewana: [46565],
      Shirley: [47384],
      Shoals: [47581],
      Siberia: [47515],
      'Silver Lake': [46982],
      Solsberry: [47459],
      'South Bend': [
        46601, 46613, 46614, 46615, 46616, 46617, 46619, 46628, 46635, 46637,
      ],
      'South Whitley': [46787],
      Southport: [46217, 46227, 46237],
      Speed: [47172],
      Speedway: [46224],
      Spencer: [47460],
      Spencerville: [46788],
      Spiceland: [47385],
      Springport: [47386],
      Springville: [47462],
      'Star City': [46985],
      Stendal: [47585],
      Stilesville: [46180],
      Straughn: [47387],
      Sullivan: [47882],
      Sulphur: [47174],
      'Sulphur Springs': [47388],
      Summitville: [46070],
      Sunman: [47041],
      Swayzee: [46986],
      'Switz City': [47465],
      Syracuse: [46567],
      Tangier: [47985],
      Taswell: [47175],
      'Tell City': [47586],
      Tennyson: [47637],
      'Terre Haute': [47802, 47803, 47804, 47807],
      Thorntown: [46071],
      Tippecanoe: [46570],
      Tipton: [46072],
      Tobinsport: [47587],
      Topeka: [46571],
      Trafalgar: [46181],
      Troy: [47588],
      'Twelve Mile': [46988],
      Underwood: [47177],
      'Union City': [47390],
      'Union Mills': [46382],
      Uniondale: [46791],
      Unionville: [47468],
      Upland: [46989],
      Urbana: [46990],
      Vallonia: [47281],
      Valparaiso: [46383],
      Veedersburg: [47987],
      Velpen: [47590],
      Vernon: [47282],
      Versailles: [47042],
      Vevay: [47043],
      Vincennes: [47591],
      'W Harrison': [47060],
      Wabash: [46992],
      Wadesville: [47638],
      Wakarusa: [46573],
      Waldron: [46182],
      Walkerton: [46574],
      Walton: [46994],
      Wanamaker: [46239],
      Wanatah: [46390],
      Warren: [46792],
      Warsaw: [46580],
      Washington: [47501],
      Waterloo: [46793],
      Waveland: [47989],
      Wawaka: [46794],
      Waynetown: [47990],
      Webster: [47392],
      'West Baden Sprin': [47469],
      'West Lafayette': [47906],
      'West Lebanon': [47991],
      Westfield: [46074],
      Westpoint: [47992],
      Westport: [47283],
      Westville: [46391],
      Wheatfield: [46392],
      Wheatland: [47597],
      Whitestown: [46075],
      Whiting: [46394],
      Wilkinson: [46186],
      Williams: [47470],
      Williamsburg: [47393],
      Winamac: [46996],
      Winchester: [47394],
      Windfall: [46076],
      Wingate: [47994],
      'Winona Lake': [46590],
      Winslow: [47598],
      Wolcott: [47995],
      Wolcottville: [46795],
      Woodbridge: [47408],
      Woodburn: [46797],
      Worthington: [47471],
      Yoder: [46798],
      Yorktown: [47396],
      Zionsville: [46077],
    },
    name: 'Indiana',
  },
  KS: {
    cities: {
      66081: [66081],
      66545: [66545],
      66847: [66847],
      67014: [67014],
      67549: [67549],
      67580: [67580],
      67633: [67633],
      67746: [67746],
      67830: [67830],
      67833: [67833],
      67866: [67866],
      Abbyville: [67510],
      Abilene: [67410],
      Ada: [67414],
      Admire: [66830],
      Agenda: [66930],
      Agra: [67621],
      Alamota: [67839],
      Albert: [67511],
      Alden: [67512],
      Alexander: [67513],
      Alma: [66401],
      Almena: [67622],
      'Alta Vista': [66834],
      Altamont: [67330],
      Alton: [67623],
      Altoona: [66710],
      Americus: [66835],
      Ames: [66931],
      Andale: [67001],
      Andover: [67002],
      Antelope: [66858],
      Anthony: [67003],
      Antonino: [67601],
      Arcadia: [66711],
      Argonia: [67004],
      'Arkansas City': [67005],
      Arlington: [67514],
      Arnold: [67515],
      Ashland: [67831],
      Assaria: [67416],
      Atchison: [66002],
      Athol: [66932],
      Atlanta: [67008],
      Attica: [67009],
      Atwood: [67730],
      Auburn: [66402],
      Augusta: [67010],
      Aurora: [67417],
      Axtell: [66403],
      Baileyville: [66404],
      'Baldwin City': [66006],
      Barnard: [67418],
      Barnes: [66933],
      Bartlett: [67332],
      Basehor: [66007],
      Bavaria: [67401],
      'Baxter Springs': [66713],
      Bazine: [67516],
      Beattie: [66406],
      Beaumont: [67012],
      Beaver: [67517],
      Beeler: [67518],
      'Bel Aire': [67220],
      Bellaire: [66952],
      'Belle Plaine': [67013],
      Belleville: [66935],
      Belmont: [67068],
      Belpre: [67519],
      Belvue: [66407],
      Bendena: [66008],
      Benedict: [66714],
      Bennington: [67422],
      Bentley: [67016],
      Benton: [67017],
      Bern: [66408],
      Berryton: [66409],
      Beverly: [67423],
      'Bird City': [67731],
      Bison: [67520],
      Blaine: [66549],
      Bloom: [67865],
      'Blue Mound': [66010],
      'Blue Rapids': [66411],
      'Bluff City': [67018],
      Bogue: [67625],
      Bremen: [66412],
      Brewster: [67732],
      Bronson: [66716],
      Brookville: [67425],
      Brownell: [67521],
      Bucklin: [67834],
      Bucyrus: [66013],
      Buffalo: [66717],
      Buhler: [67522],
      'Bunker Hill': [67626],
      Burden: [67019],
      Burdett: [67523],
      Burdick: [66838],
      Burlingame: [66413],
      Burns: [66840],
      'Burr Oak': [66936],
      Burrton: [67020],
      Bushong: [66833],
      Bushton: [67427],
      Byers: [67021],
      Caldwell: [67022],
      Cambridge: [67023],
      Caney: [67333],
      Canton: [67428],
      Carbondale: [66414],
      Carlton: [67429],
      Carlyle: [66749],
      Carona: [66773],
      Cassoday: [66842],
      Catharine: [67627],
      'Cawker City': [67430],
      Cedar: [67628],
      'Cedar Vale': [67024],
      Centerville: [66014],
      Centralia: [66415],
      Chanute: [66720],
      Chapman: [67431],
      Chase: [67524],
      Cheney: [67025],
      Cherokee: [66724],
      Cherryvale: [67335],
      Chetopa: [67336],
      Cimarron: [67835],
      Circleville: [66416],
      Claflin: [67525],
      'Clay Center': [67432],
      Clayton: [67629],
      Clearwater: [67026],
      Clements: [66843],
      Clifton: [66937],
      Climax: [67137],
      Clyde: [66938],
      Coats: [67028],
      Codell: [67630],
      Coffeyville: [67337],
      Colby: [67701],
      Coldwater: [67029],
      Collyer: [67631],
      Colony: [66015],
      Colwich: [67030],
      Conway: [67460],
      'Conway Springs': [67031],
      Copeland: [67837],
      Corbin: [67032],
      Corning: [66417],
      'Cottonwood Falls': [66845],
      Countryside: [66202],
      Courtland: [66939],
      Coyville: [66727],
      Crestline: [66728],
      Cuba: [66940],
      Culver: [67484],
      Cummings: [66016],
      Damar: [67632],
      Danville: [67036],
      'De Soto': [66018],
      Deerfield: [67838],
      Delavan: [67449],
      Delia: [66418],
      Delphos: [67436],
      Denison: [66419],
      Dennis: [67341],
      Densmore: [67645],
      Denton: [66017],
      Derby: [67037],
      Dexter: [67038],
      'Dodge City': [67801],
      Dorrance: [67634],
      Douglass: [67039],
      Dover: [66420],
      Downs: [67437],
      Dresden: [67635],
      Duluth: [66521],
      Dunlap: [66846],
      Durham: [67438],
      Dwight: [66849],
      Eastborough: [67206, 67207],
      Easton: [66020],
      Edgerton: [66021],
      Edmond: [67636],
      Edna: [67342],
      Edson: [67733],
      Effingham: [66023],
      'El Dorado': [67042],
      Elbing: [67041],
      'Elk City': [67344],
      'Elk Falls': [67345],
      Elkhart: [67950],
      Ellinwood: [67526],
      Ellis: [67637],
      Ellsworth: [67439],
      Elmdale: [66850],
      Elsmore: [66732],
      Emmett: [66422],
      Emporia: [66801],
      Englewood: [67840],
      Ensign: [67841],
      Enterprise: [67441],
      Erie: [66733],
      Esbon: [66941],
      Eskridge: [66423],
      Eudora: [66025],
      Eureka: [67045],
      Everest: [66424],
      Fairview: [66425],
      'Fall River': [67047],
      Falun: [67442],
      Farlington: [66734],
      Florence: [66851],
      Fontana: [66026],
      Ford: [67842],
      Formoso: [66942],
      'Fort Dodge': [67843],
      'Fort Leavenworth': [66027],
      'Fort Riley': [66442],
      Fowler: [67844],
      Freeport: [67049],
      Friend: [67871],
      Fulton: [66738],
      Galatia: [67564, 67565],
      Galena: [66739],
      Galesburg: [66740],
      Galva: [67443],
      'Garden City': [67846],
      'Garden Plain': [67050],
      Gardner: [66030],
      Garfield: [67529],
      Garland: [66741],
      Garnett: [66032],
      Gaylord: [67638],
      Gem: [67734],
      Geneseo: [67444],
      'Geuda Springs': [67051],
      Girard: [66743],
      Glade: [67639],
      Glasco: [67445],
      'Glen Elder': [67446],
      Goddard: [67052],
      Goessel: [67053],
      Goff: [66428],
      Goodland: [67735],
      Gorham: [67640],
      Gove: [67736],
      Grainfield: [67737],
      Grantville: [66429],
      Greeley: [66033],
      Green: [67447],
      Greenleaf: [66943],
      Greensburg: [67054],
      Grenola: [67346],
      Gridley: [66852],
      Grinnell: [67738],
      Gypsum: [67448],
      Haddam: [66944],
      Hallowell: [66725],
      Halstead: [67056],
      Hamilton: [66853],
      Hanover: [66945],
      Hanston: [67849],
      Hardtner: [67057],
      Harlan: [67641],
      Harper: [67058],
      Hartford: [66854],
      Harveyville: [66431],
      Havana: [67347],
      Haven: [67543],
      Havensville: [66432],
      Haviland: [67059],
      Haysville: [67060],
      Hazelton: [67061],
      Healy: [67850],
      Heizer: [67530],
      Hepler: [66746],
      Herkimer: [66433],
      Herndon: [67739],
      Hesston: [67062],
      Hiattville: [66701],
      Highland: [66035],
      'Hill City': [67642],
      Hillsboro: [67063],
      Hillsdale: [66036],
      Holcomb: [67851],
      Hollenberg: [66946],
      Holton: [66436],
      Holyrood: [67450],
      Home: [66438],
      Hope: [67451],
      Horton: [66439],
      Howard: [67349],
      Hoxie: [67740],
      Hoyt: [66440],
      Hudson: [67545],
      Hugoton: [67951],
      Humboldt: [66748],
      Hunter: [67452],
      Huron: [66041],
      Hutchinson: [67501],
      Independence: [67301],
      'Industrial Airpo': [66031],
      Ingalls: [67853],
      Inman: [67546],
      Ionia: [66949],
      Isabel: [67065],
      Iuka: [67066],
      Jamestown: [66948],
      Jennings: [67643],
      Jetmore: [67854],
      Johnson: [67855],
      'Junction City': [66441],
      Kalvesta: [67856],
      Kanopolis: [67454],
      Kanorado: [67741],
      'Kansas City': [
        66101, 66102, 66104, 66105, 66109, 66111, 66112, 66115, 66118,
      ],
      Kelly: [66538],
      Kendall: [67857],
      Kensington: [66951],
      Kingsdown: [67858],
      Kinsley: [67547],
      Kiowa: [67070],
      Kirwin: [67644],
      Kismet: [67859],
      'La Crosse': [67548],
      'La Cygne': [66040],
      'La Harpe': [66751],
      Lafontaine: [66736],
      'Lake City': [67071],
      'Lake Of The Fore': [66012],
      'Lake Quivira': [66106],
      Lakin: [67860],
      Lane: [66042],
      Langdon: [67583],
      Lansing: [66043],
      Latham: [67072],
      Lawrence: [66044, 66046, 66047, 66049],
      Lawton: [66781],
      'Le Roy': [66857],
      Leavenworth: [66048],
      Leawood: [66206, 66209, 66211],
      Lebo: [66856],
      Lecompton: [66050],
      Lehigh: [67073],
      Lenexa: [66210, 66214, 66215, 66219, 66220, 66227],
      Leon: [67074],
      Leona: [66532],
      Leonardville: [66449],
      Leoti: [67861],
      Levant: [67743],
      Lewis: [67552],
      Liberal: [67901],
      Liberty: [67351],
      Liebenthal: [67553],
      Lindsborg: [67456],
      Linn: [66953],
      Linwood: [66052],
      'Little River': [67457],
      Logan: [67646],
      'Long Island': [67647],
      Longford: [67458],
      Longton: [67352],
      Lorraine: [67459],
      'Lost Springs': [66859],
      Louisburg: [66053],
      Louisville: [66450],
      Lucas: [67648],
      Ludell: [67744],
      Luray: [67649],
      Lyndon: [66451],
      Lyons: [67554],
      Macksville: [67557],
      Madison: [66860],
      Mahaska: [66955],
      Maize: [67101],
      Manchester: [67463],
      Manhattan: [66502],
      Mankato: [66956],
      Manter: [67862],
      'Maple City': [67102],
      'Maple Hill': [66507],
      Mapleton: [66754],
      Marion: [66861],
      Marquette: [67464],
      Marysville: [66508],
      'Matfield Green': [66862],
      Mayetta: [66509],
      Mayfield: [67103],
      'Mc Connell A F B': [67221],
      'Mc Cracken': [67556],
      'Mc Cune': [66753],
      'Mc Donald': [67745],
      'Mc Louth': [66054],
      Meade: [67864],
      'Medicine Lodge': [67104],
      Medora: [67502],
      Melvern: [66510],
      Menlo: [67753],
      Mentor: [67465],
      Meriden: [66512],
      Milan: [67105],
      Mildred: [66039],
      Milford: [66514],
      Milton: [67106],
      Miltonvale: [67466],
      Minneapolis: [67467],
      Mission: [66205],
      Modoc: [67863],
      Moline: [67353],
      Montezuma: [67867],
      Monument: [67747],
      Moran: [66755],
      Morganville: [67468],
      Morland: [67650],
      Morrill: [66515],
      Morrowville: [66958],
      Moscow: [67952],
      'Mound City': [66056],
      'Mound Valley': [67354],
      Moundridge: [67107],
      'Mount Hope': [67108],
      Mulberry: [66756],
      Mullinville: [67109],
      Mulvane: [67110],
      Munden: [66959],
      Murdock: [67111],
      Muscotah: [66058],
      Narka: [66960],
      Nashville: [67112],
      Natoma: [67651],
      Navarre: [67469],
      Nekoma: [67559],
      Neodesha: [66757],
      'Neosho Falls': [66758],
      'Neosho Rapids': [66864],
      'Ness City': [67560],
      Netawaka: [66516],
      'New Albany': [66759],
      'New Almelo': [67652],
      'New Cambria': [67470],
      Newton: [67114],
      Nickerson: [67561],
      Niotaze: [67355],
      Norcatur: [67653],
      'North Newton': [67117],
      Norton: [67654],
      Nortonville: [66060],
      Norway: [66961],
      Norwich: [67118],
      Oakhill: [67472],
      Oakley: [67748],
      Oberlin: [67749],
      Odin: [67562],
      Offerle: [67563],
      Ogallah: [67656],
      Ogden: [66517],
      Oketo: [66518],
      Olathe: [66061, 66062],
      Olpe: [66865],
      Olsburg: [66520],
      Onaga: [66551],
      Oneida: [66522],
      'Osage City': [66523],
      Osawatomie: [66064],
      Osborne: [67473],
      Oskaloosa: [66066],
      Oswego: [67356],
      Ottawa: [66067],
      Overbrook: [66524],
      'Overland Park': [66204, 66212, 66213],
      Oxford: [67119],
      Ozawkie: [66070],
      Palco: [67657],
      Palmer: [66962],
      Paola: [66071],
      Paradise: [67658],
      Park: [67751],
      'Park City': [67219],
      Parker: [66072],
      Parsons: [67357],
      Partridge: [67566],
      Pauline: [66619],
      'Pawnee Rock': [67567],
      Paxico: [66526],
      Peabody: [66866],
      Peck: [67120],
      Penalosa: [67035],
      Penokee: [67659],
      Perry: [66073],
      Peru: [67360],
      Pfeifer: [67660],
      Phillipsburg: [67661],
      Piedmont: [67122],
      Pierceville: [67868],
      Piqua: [66761],
      Plains: [67869],
      Plainville: [67663],
      Pleasanton: [66075],
      Plevna: [67568],
      Pomona: [66076],
      Portis: [67474],
      Potwin: [67123],
      Powhattan: [66527],
      'Prairie View': [67664],
      'Prairie Village': [66208],
      Pratt: [67124],
      Prescott: [66767],
      'Pretty Prairie': [67570],
      Princeton: [66078],
      Protection: [67127],
      Quenemo: [66528],
      Quinter: [67752],
      Radium: [67550],
      Radley: [66762],
      Rago: [67128],
      Ramona: [67475],
      Randall: [66963],
      Randolph: [66554],
      Ransom: [67572],
      Rantoul: [66079],
      Raymond: [67573],
      Reading: [66868],
      Redfield: [66769],
      Republic: [66964],
      Reserve: [66434],
      Rice: [66901],
      Richfield: [67953],
      Richmond: [66080],
      Riley: [66531],
      Riverton: [66770],
      Rock: [67131],
      Rolla: [67954],
      Rosalia: [67132],
      'Rose Hill': [67133],
      Rosedale: [66103],
      Rossville: [66533],
      Roxbury: [67476],
      Rozel: [67574],
      'Rush Center': [67575],
      Russell: [67665],
      'Russell Springs': [67755],
      Sabetha: [66534],
      'Saint George': [66535],
      'Saint John': [67576],
      'Saint Marys': [66536],
      'Saint Paul': [66771],
      Satanta: [67870],
      Savonburg: [66772],
      Sawyer: [67134],
      Scandia: [66966],
      Schoenchen: [67667],
      Scottsville: [67420],
      Scranton: [66537],
      Sedan: [67361],
      Sedgwick: [67135],
      Selden: [67757],
      Severance: [66087],
      Seward: [67577],
      Sharon: [67138],
      'Sharon Springs': [67758],
      Shawnee: [66203, 66216, 66217, 66218, 66226],
      'Shawnee Mission': [66207],
      Shields: [67874],
      'Silver Lake': [66539],
      Simpson: [67478],
      'Smith Center': [66967],
      Smolan: [67479],
      Soldier: [66540],
      Solomon: [67480],
      'South Haven': [67140],
      'South Hutchinson': [67505],
      Spearville: [67876],
      Spivey: [67142],
      'Spring Hill': [66083],
      Stafford: [67578],
      Stanley: [66221, 66223, 66224],
      Stark: [66775],
      Sterling: [67579],
      Stilwell: [66085],
      Stockton: [67669],
      Strawn: [66839],
      'Strong City': [66869],
      Studley: [67759],
      Sublette: [67877],
      Summerfield: [66541],
      'Sun City': [67143],
      Susank: [67544],
      'Sylvan Grove': [67481],
      Sylvia: [67581],
      Syracuse: [67878],
      Talmage: [67482],
      Tampa: [67483],
      Tecumseh: [66542],
      Thayer: [66776],
      Timken: [67582],
      Tipton: [67485],
      Tonganoxie: [66086],
      Topeka: [
        66603, 66604, 66605, 66606, 66607, 66608, 66609, 66610, 66611, 66612,
        66614, 66615, 66616, 66617, 66618,
      ],
      Toronto: [66777],
      Towanda: [67144],
      Treece: [66778],
      Tribune: [67879],
      Udall: [67146],
      Ulysses: [67880],
      Uniontown: [66779],
      Utica: [67584],
      'Valley Center': [67147],
      'Valley Falls': [66088],
      Vassar: [66543],
      Victoria: [67671],
      Viola: [67149],
      Virgil: [66870],
      Vliets: [66544],
      'Wa Keeney': [67672],
      Wakarusa: [66546],
      Wakefield: [67487],
      Waldo: [67673],
      Waldron: [67150],
      Wallace: [67761],
      Walnut: [66780],
      Walton: [67151],
      Wamego: [66547],
      Washington: [66968],
      Waterville: [66548],
      Wathena: [66090],
      Waverly: [66871],
      Webber: [66970],
      Welda: [66091],
      Wellington: [67152],
      Wells: [67488],
      Wellsville: [66092],
      Weskan: [67762],
      Westfall: [67455],
      Westphalia: [66093],
      Wetmore: [66550],
      Wheeler: [67756],
      'White City': [66872],
      'White Cloud': [66094],
      Whitewater: [67154],
      Whiting: [66552],
      Wichita: [
        67202, 67203, 67204, 67205, 67208, 67209, 67210, 67211, 67212, 67213,
        67214, 67215, 67216, 67217, 67218, 67223, 67226, 67227, 67228, 67230,
        67231, 67232, 67233, 67235, 67236,
      ],
      Williamsburg: [66095],
      Wilmore: [67155],
      Wilsey: [66873],
      Wilson: [67490],
      Winchester: [66097],
      Windom: [67491],
      Winfield: [67156],
      Winifred: [66427],
      Winona: [67764],
      Woodbine: [67492],
      Woodston: [67675],
      Wright: [67882],
      'Yates Center': [66783],
      Zenda: [67159],
      Zurich: [67676],
    },
    name: 'Kansas',
  },
  KY: {
    cities: {
      40103: [40103],
      40141: [40141],
      40163: [40163],
      40817: [40817],
      40905: [40905],
      40980: [40980],
      41178: [41178],
      41225: [41225],
      41316: [41316],
      41359: [41359],
      41370: [41370],
      41393: [41393],
      41401: [41401],
      41429: [41429],
      41431: [41431],
      41648: [41648],
      42340: [42340],
      Aaron: [42601],
      Adairville: [42202],
      Adams: [41201],
      Adolphus: [42120],
      Aflex: [41529],
      'Ages Brookside': [40801],
      Albany: [42602],
      Alcalde: [42501],
      Alexandria: [41001],
      Allen: [41601],
      Allensville: [42204],
      Almo: [42020],
      Alpha: [42603],
      Altro: [41306],
      Alvaton: [42122],
      Amburgey: [41801],
      Anchorage: [40223],
      Anco: [41759],
      Argillite: [41121],
      Argo: [41568],
      Arjay: [40902],
      Arlington: [42021],
      Artemus: [40903],
      Ary: [41712],
      Ashcamp: [41512],
      Ashland: [41102],
      Auburn: [42206],
      Augusta: [41002],
      Austin: [42123],
      Auxier: [41602],
      Bagdad: [40003],
      'Bailey Switch': [40906],
      Bakerton: [42711],
      Banner: [41603],
      Bardstown: [40004],
      Bardwell: [42023],
      Barlow: [42024],
      'Barnetts Creek': [41256],
      Battletown: [40104],
      Baxter: [40806],
      'Bear Branch': [41714],
      Bearville: [41740],
      Beaumont: [42124],
      'Beaver Dam': [42320],
      Bedford: [40006],
      'Bee Spring': [42207],
      'Beech Creek': [42321],
      Beechmont: [42323],
      Belcher: [41513],
      Belfry: [41514],
      Bellevue: [41073],
      Belton: [42324],
      Benham: [40807],
      Benton: [42025],
      Berea: [40403],
      Berry: [41003],
      Bethanna: [41465],
      Bethelridge: [42516],
      Bethlehem: [40007],
      'Betsy Layne': [41605],
      Beverly: [40913],
      Bevinsville: [41606],
      'Big Clifty': [42712],
      'Big Creek': [40914],
      'Big Laurel': [40808],
      'Big Rock': [41777],
      'Big Spring': [40106],
      Biggs: [41524],
      Bimble: [40915],
      Blaine: [41124],
      'Blairs Mill': [41472],
      Bloomfield: [40008],
      'Blue Diamond': [41719],
      'Blue River': [41607],
      Boaz: [42027],
      Bondville: [40372],
      Bonnieville: [42713],
      'Boons Camp': [41204],
      Boston: [40107],
      Bow: [42714],
      'Bowling Green': [42103, 42104],
      Bradfordsville: [40009],
      Brandenburg: [40108],
      Breeding: [42715],
      Bremen: [42325],
      'Bright Shade': [40962],
      Brinkley: [41805],
      'Broad Bottom': [41501],
      Brodhead: [40409],
      Bronston: [42518],
      Brooks: [40109],
      Brooksville: [41004],
      Browder: [42326],
      Browning: [42274],
      'Bryants Store': [40921],
      Buckhorn: [41721],
      Buckingham: [41636],
      Buckner: [40010],
      Buechel: [40218, 40228],
      Buffalo: [42716],
      Burke: [41171],
      Burkesville: [42717],
      Burkhart: [41315],
      Burna: [42028],
      Bush: [40724],
      Busy: [41723],
      Butler: [41006],
      Bybee: [40385],
      Calhoun: [42327],
      California: [41007],
      Callaway: [40977],
      'Calvert City': [42029],
      Calvin: [40813],
      'Camp Dix': [41127],
      Campbellsburg: [40011],
      Campbellsville: [42718],
      Canada: [41519],
      Caney: [41407],
      Caneyville: [42721],
      Canmer: [42722],
      Cannon: [40923],
      Canoe: [41339],
      Carcassonne: [41804],
      Carlisle: [40311],
      Carrie: [41725],
      Carrollton: [41008],
      Carrsville: [42081],
      Carver: [41409],
      'Casey Creek': [42723],
      Catlettsburg: [41129],
      'Cave City': [42127],
      Center: [42214],
      Centertown: [42328],
      'Central City': [42330],
      Cerulean: [42215],
      Chaplin: [40012],
      Chavies: [41727],
      Chevrolet: [40831],
      Cinda: [41728],
      Clay: [42404],
      Clayhole: [41317],
      Clearfield: [40313],
      Clifford: [41230],
      Climax: [40456],
      Clinton: [42031],
      Closplint: [40927],
      'Clover Bottom': [40447],
      Cloverport: [40111],
      Coalgood: [40818],
      Cobhill: [40415],
      Coldiron: [40819],
      Columbus: [42032],
      Combs: [41729],
      Confluence: [41730],
      Constantine: [40114],
      Conway: [40417],
      Coopersville: [42611],
      Corbin: [40701],
      Corinth: [41010],
      Cornishville: [40330],
      Corydon: [42406],
      Cottle: [41412],
      Covington: [41011],
      'Crab Orchard': [40419],
      Cranks: [40820],
      Craynor: [41614],
      Crestwood: [40014],
      Crittenden: [41030],
      Crofton: [42217],
      Cromwell: [42333],
      Cropper: [40057],
      Crown: [41811],
      Crummies: [40815],
      Crutchfield: [42041],
      'Cub Run': [42729],
      Cumberland: [40823],
      Cundiff: [42730],
      Cunningham: [42035],
      Custer: [40115],
      Cutshin: [41732],
      Cynthiana: [41031],
      Daisy: [41733],
      Dana: [41615],
      Danville: [40422],
      Darfork: [41701],
      Davella: [41214],
      David: [41616],
      Davisport: [41262],
      'Dawson Springs': [42408],
      'Day Rural': [41858],
      Dayhoit: [40824],
      Daysville: [42276],
      Dayton: [41074],
      Deane: [41812],
      Deatsville: [40013],
      Decoy: [41321],
      Delphia: [41735],
      Delta: [42613],
      Dema: [41859],
      Demossville: [41033],
      Denniston: [40316],
      Denton: [41132],
      Denver: [41215],
      Dewitt: [40930],
      Dexter: [42036],
      Dice: [41736],
      Dixie: [41017],
      Dixon: [42409],
      Dizney: [40825],
      Dover: [41034],
      Drakesboro: [42337],
      Dreyfus: [40426],
      'Dry Creek': [41862],
      'Dry Ridge': [41035],
      Dryhill: [41749],
      Dubre: [42731],
      Dundee: [42338],
      Dunmor: [42339],
      Dunnville: [42528],
      'E Town': [42701],
      'E View': [42732],
      Earlington: [42410],
      'East Mc Dowell': [41647],
      'East Point': [41216],
      Eastern: [41622],
      Eddyville: [42038],
      Edna: [41419],
      'Eighty Eight': [42130],
      Ekron: [40117],
      Elias: [40486],
      'Elk Horn': [42733],
      Elkfork: [41421],
      Elkton: [42220],
      Elmrock: [41640],
      Elna: [41219],
      Elsie: [41422],
      Eminence: [40019],
      Emma: [41653],
      Endicott: [41626],
      Eolia: [40826],
      Erlanger: [41018],
      Ermine: [41815],
      Estill: [41627],
      Etoile: [42131],
      Etty: [41572],
      Ewing: [41039],
      Ezel: [41425],
      Fairdale: [40118],
      Fairplay: [42735],
      Falmouth: [41040],
      'Fancy Farm': [42039],
      Farler: [41774],
      Farmington: [42040],
      'Fern Creek': [40291],
      Finchville: [40022],
      Finley: [42736],
      Firebrick: [41137],
      Fisherville: [40023],
      Fishtrap: [41557],
      Fisty: [41743],
      Flat: [41301],
      Flatwoods: [41139],
      'Fleming Neon': [41840],
      Flemingsburg: [41041],
      Florence: [41042],
      Fonde: [40940],
      Fordsville: [42343],
      'Forest Hills': [41527],
      'Fort Campbell': [42223],
      'Fort Knox': [40121],
      'Fort Thomas': [41075],
      Foster: [41043],
      'Fountain Run': [42133],
      Franklin: [42134],
      Fredonia: [42411],
      Freeburn: [41528],
      Frew: [41776],
      Fuget: [41220, 41266],
      Fultz: [41143],
      Galveston: [41629],
      Gamaliel: [42140],
      Garfield: [40140],
      Garrett: [41630],
      Garrison: [41141],
      'Gays Creek': [41745],
      Georgetown: [40324],
      Germantown: [41044],
      Ghent: [41045],
      Gilbertsville: [42044],
      Gillmore: [41327],
      Gilly: [41819],
      Girdler: [40943],
      Glasgow: [42141],
      'Glen Dean': [40119],
      Glencoe: [41046],
      Glendale: [42740],
      'Glens Fork': [42741],
      'Golden Pond': [42211],
      Goshen: [40026],
      Gracey: [42232],
      Gradyville: [42742],
      Graham: [42344],
      'Grassy Creek': [41332],
      Gratz: [40327],
      'Gravel Switch': [40328],
      Gray: [40734],
      'Grays Knob': [40829],
      'Green Hall': [41328],
      'Green Road': [40946],
      Greensburg: [42743],
      Greenville: [42345],
      Grethel: [41631],
      Gulston: [40830],
      Guston: [40142],
      Haddix: [41331],
      Hagerhill: [41222],
      Halo: [41633],
      Hampton: [42047],
      Hanson: [42413],
      Happy: [41746],
      Hardin: [42048],
      Hardshell: [41348],
      Hardy: [41531],
      Hardyville: [42746],
      Harold: [41635],
      Hartford: [42347],
      Hatton: [40601],
      Hawesville: [42348],
      Hazel: [42049],
      'Head Of Grassy': [41135],
      Hebron: [41048],
      Heidrick: [40949],
      Henderson: [42420],
      Hendricks: [41441],
      Henshaw: [42437],
      Herndon: [42236],
      Hestand: [42151],
      Hickman: [42050],
      Hickory: [42051],
      'High Bridge': [40390],
      Hillsboro: [41049],
      Hindman: [41822],
      Hinkle: [40953],
      Hitchins: [41146],
      Hite: [41649],
      Hode: [41267],
      Hodgenville: [42748],
      Holland: [42153],
      Hollybush: [41823],
      Hollyhill: [42635],
      'Holmes Mill': [40843],
      Honaker: [41639],
      Hopkinsville: [42240],
      'Horse Branch': [42349],
      'Horse Cave': [42749],
      Howardstown: [40028],
      Huddy: [41535],
      Hudson: [40145],
      Huff: [42250],
      Hulen: [40845],
      Hustonville: [40437],
      Independence: [41051],
      Irvington: [40146],
      Island: [42350],
      'Island City': [41338],
      Isom: [41824],
      Isonville: [41149],
      Iuka: [42045],
      Ivel: [41642],
      Jabez: [42532],
      Jackhorn: [41825],
      Jamboree: [41536],
      Jamestown: [42629],
      Jeffersontown: [40299],
      Jeffersonville: [40337],
      Jeremiah: [41826],
      Jetson: [42252],
      Jinks: [40336],
      Job: [41224],
      Jonesville: [41052],
      'Junction City': [40440],
      Keaton: [41226],
      Keavy: [40737],
      Keene: [40339],
      Keith: [40846],
      Kenvir: [40847],
      Kettle: [42752],
      'Kettle Island': [40958],
      Kevil: [42053],
      Kimper: [41539],
      'Kings Mountain': [40442],
      Kirksey: [42054],
      Knifley: [42753],
      'Knob Lick': [42154],
      Kona: [41829],
      Korea: [40387],
      Kuttawa: [42055],
      Kyrock: [42285],
      'La Center': [42056],
      'La Fayette': [42254],
      'La Grange': [40031],
      Lackey: [41643],
      Lamb: [42155],
      Lambric: [41340],
      Lamero: [40341],
      Lancaster: [40444],
      Langley: [41645],
      Larkslane: [41817],
      Latonia: [41015],
      Laura: [41250],
      Lawrenceburg: [40342],
      Lawton: [41164],
      Leander: [41228],
      Leatherwood: [41756],
      Lebanon: [40033],
      'Lebanon Junction': [40150],
      Ledbetter: [42058],
      'Lee City': [41342],
      Leeco: [41343],
      Lejunior: [40849],
      Lenox: [41447],
      Letcher: [41832],
      'Lewis Creek': [40810],
      Lewisburg: [42256],
      Lewisport: [42351],
      Lexington: [
        40502, 40503, 40504, 40505, 40507, 40508, 40509, 40510, 40511, 40513,
        40514, 40515, 40516, 40517,
      ],
      Liberty: [42539],
      'Lick Creek': [41540],
      Ligon: [41604],
      Lily: [40740],
      'Limestone Sq': [41056],
      Lindseyville: [42257],
      Linefork: [41833],
      Littcarr: [41834],
      Little: [41346],
      Livermore: [42352],
      Livingston: [40445],
      Lockport: [40036],
      'Locust Hill': [40144],
      Logansport: [42261],
      Loretto: [40037],
      Louellen: [40828],
      Louisville: [
        40202, 40203, 40204, 40205, 40208, 40209, 40210, 40211, 40212, 40213,
        40214, 40215, 40217, 40220, 40245,
      ],
      Lovely: [41231],
      Lucas: [42156],
      Ludlow: [41016],
      Lynch: [40855],
      Lyndon: [40222, 40241, 40242],
      Lynn: [41144],
      Maceo: [42355],
      Mackville: [40040],
      Madisonville: [42431],
      Magnolia: [42757],
      Mallie: [41836],
      Maloneton: [41175],
      'Mammoth Cave Nat': [42259],
      Manila: [41238],
      Manitou: [42436],
      Mariba: [40345],
      Marion: [42064],
      Martha: [41159],
      'Mary Alice': [40964],
      Maud: [40069],
      Mayfield: [42066],
      'Mays Lick': [41055],
      'Mc Andrews': [41543],
      'Mc Carr': [41544],
      'Mc Combs': [41545],
      'Mc Daniels': [40152],
      'Mc Veigh': [41546],
      Meally: [41234],
      Means: [40346],
      Melber: [42069],
      Melbourne: [41059],
      Middleburg: [42541],
      Middlesboro: [40965],
      Middletown: [40243],
      Midway: [40347],
      Mills: [40970],
      Millstone: [41838],
      Milltown: [42761],
      Millwood: [42762],
      Milton: [40045],
      Mistletoe: [41351],
      Montpelier: [42728],
      Mooleyville: [40143],
      Moorefield: [40350],
      'Moores Creek': [40402],
      Morehead: [40351],
      'Morning View': [41063],
      'Morris Fork': [41314],
      'Mount Eden': [40046],
      'Mount Herman': [42157],
      'Mount Olivet': [41064],
      'Mount Sherman': [42764],
      'Mount Sterling': [40353],
      'Mount Washington': [40047],
      Mousie: [41839],
      Mouthcard: [41548],
      Mozelle: [40858],
      Munfordville: [42765],
      Murray: [42071],
      Napfor: [41754],
      Narrows: [42358],
      Nebo: [42441],
      Nevisdale: [40754],
      'New Castle': [40050],
      'New Concord': [42076],
      'New Liberty': [40355],
      Newport: [41076],
      Nicholasville: [40356],
      Nippa: [41240],
      Noctor: [41357],
      Nortonville: [42442],
      'Oak Grove': [42262],
      Oakland: [42159],
      Offutt: [41237],
      Okolona: [40219, 40229],
      Olaton: [42361],
      'Old Landing': [41358],
      Oldtown: [41163],
      Olmstead: [42265],
      Olympia: [40358],
      Omaha: [41843],
      Oneida: [40972],
      Orlando: [40460],
      'Oven Fork': [40861],
      Owensboro: [42301, 42303],
      Owenton: [40359],
      Owingsville: [40360],
      Paducah: [42001, 42003],
      'Paint Lick': [40461],
      Paris: [40361],
      'Park City': [42160],
      'Parkers Lake': [42634],
      Parksville: [40464],
      Partridge: [40862],
      Pathfork: [40863],
      Patsey: [40380],
      'Paw Paw': [41551],
      'Payne Gap': [41537],
      Payneville: [40157],
      Pembroke: [42266],
      Pendleton: [40055],
      Penrod: [42365],
      Perryville: [40468],
      Petersburg: [41080],
      'Pewee Valley': [40056],
      Peytonsburg: [42768],
      Phelps: [41553],
      Philpot: [42366],
      Phyllis: [41554],
      'Pine Ridge': [41360],
      Pinsonfork: [41555],
      'Pleasant View': [40769],
      'Pleasure Ridge P': [40258],
      'Plum Springs': [42101],
      Pointer: [42544],
      Pomeroyton: [40365],
      Premium: [41845],
      Princeton: [42445],
      Printer: [41655],
      Prospect: [40059],
      Providence: [42450],
      Pryse: [40471],
      Pueblo: [42633],
      Pulaski: [42567],
      Puncheon: [41828],
      Putney: [40865],
      Pyrmid: [41637],
      Quality: [42268],
      Quicksand: [41363],
      Quincy: [41166],
      'Rabbit Hash': [41005],
      Raceland: [41169],
      Radcliff: [40160],
      Raven: [41844, 41861],
      Ravenna: [40472],
      Raywick: [40060],
      Redfox: [41847],
      Reed: [42451],
      Reedyville: [42210],
      Regina: [41559],
      Revelo: [42638],
      'Reynolds Station': [42368],
      Rhodelia: [40161],
      Ricetown: [41364],
      Riceville: [41258],
      Richmond: [40475],
      Rineyville: [40162],
      River: [41254],
      Roark: [40979],
      Robards: [42452],
      'Robinson Creek': [41560],
      Rochester: [42273],
      Rockholds: [40759],
      Rockport: [42369],
      'Rocky Hill': [42163],
      Rockybranch: [42640],
      Rogers: [41365],
      Roundhill: [42275],
      Rouse: [41014],
      Rousseau: [41366],
      Rowdy: [41367],
      Roxana: [41848],
      Royalton: [41464],
      Rumsey: [42371],
      Rush: [41168],
      Sacramento: [42372],
      Sadieville: [40370],
      Sadler: [42754],
      'Saint Catharine': [40061],
      'Saint Charles': [42453],
      'Saint Francis': [40062],
      'Saint Matthews': [40206, 40207],
      'Saint Paul': [41170],
      Saldee: [41369],
      Salem: [42078],
      'Salt Gum': [40935],
      'Salt Lick': [40371],
      Sanders: [41083],
      Sandgap: [40481],
      Sasser: [40741],
      Sawyer: [42643],
      Scalf: [40982],
      'Science Hill': [42553],
      Scottsville: [42164],
      Scranton: [40322],
      Scuddy: [41760],
      'Se Ree': [40164],
      Sebree: [42455],
      Seco: [41849],
      Sedalia: [42079],
      Seitz: [41466],
      Senterville: [41522],
      'Sextons Creek': [40983],
      'Sharon Grove': [42280],
      Sharpsburg: [40374],
      Shelbiana: [41562],
      'Shelby Gap': [41563],
      Shelbyville: [40065],
      Shepherdsville: [40165],
      Shively: [40216],
      Shopville: [42554],
      Sidney: [41564],
      Siler: [40763],
      'Silver Grove': [41085],
      Simpsonville: [40067],
      Sitka: [41255],
      Skyline: [41821],
      Slade: [40376],
      Slaughters: [42456],
      Slemp: [41763],
      'Sloans Valley': [42519, 42555],
      Smilax: [41764],
      Smith: [40867],
      Smithfield: [40068],
      'Smiths Grove': [42171],
      'Soft Shell': [41831],
      Sonora: [42776],
      'South Portsmouth': [41174],
      'South Williamson': [41503],
      Southgate: [41071],
      Sparta: [41086],
      Speight: [41565],
      Spottsville: [42458],
      Stambaugh: [41257],
      'Stamping Ground': [40379],
      Stanford: [40484],
      Stanville: [41659],
      Stearns: [42647],
      Steele: [41566],
      Stephens: [41177],
      Stephensburg: [42724],
      Stephensport: [40170],
      Stinnett: [40868],
      Stone: [41567],
      'Stoney Fork': [40988],
      Strunk: [42649],
      Sturgis: [42459],
      Subtle: [42129],
      Sulphur: [40070],
      'Summer Shade': [42166],
      Summersville: [42782],
      Sunfish: [42284],
      Symbol: [40729],
      Symsonia: [42082],
      'T Ville': [42167],
      Talbert: [41377],
      Talcum: [41765],
      Tateville: [42558],
      Taylorsville: [40071],
      Teaberry: [41660],
      Thelma: [41260],
      Thornton: [41855],
      Tiline: [42083],
      'Tiny Town': [42234],
      Tollesboro: [41189],
      Totz: [40870],
      Trappist: [40051],
      Trenton: [42286],
      Tribbey: [41722],
      Trinity: [41179],
      Trosper: [40995],
      'Turkey Creek': [41570],
      'Turners Station': [40075],
      'Tutor Key': [41263],
      Ulvah: [41731],
      Union: [41091],
      'Union Star': [40171],
      Uniontown: [42461],
      Upton: [42784],
      Utica: [42376],
      Vada: [41311],
      'Valley Station': [40272],
      'Van Lear': [41265],
      Vancleve: [41385],
      Varney: [41571],
      Verona: [41092],
      Versailles: [40383],
      Vest: [41772],
      Vicco: [41773],
      Vincent: [41386],
      'Vine Grove': [40175],
      Waddy: [40076],
      Waldo: [41632],
      Walker: [40997],
      Wallingford: [41093],
      'Wallins Creek': [40873],
      Walton: [41094],
      Warsaw: [41095],
      'Water Valley': [42085],
      Waverly: [42462],
      Wax: [42726],
      Wayland: [41666],
      Waynesburg: [40489],
      'Webbs Cross Road': [42642],
      Webbville: [41180],
      Webster: [40176],
      'Welchs Creek': [42287],
      Wendover: [41775],
      'West Paducah': [42086],
      'West Point': [40177],
      Westbend: [40312],
      Westport: [40077],
      Westview: [40178],
      Westwood: [41101],
      Whick: [41390],
      'White Mills': [42788],
      'White Oak': [41474],
      'White Plains': [42464],
      Whitehouse: [41269],
      Whitesville: [42378],
      Wiborg: [42653],
      Wickliffe: [42087],
      Williamsport: [41271],
      Williamstown: [41097],
      Willisburg: [40078],
      'Willow Shade': [42169],
      Winchester: [40391],
      Windy: [42655],
      Wingo: [42088],
      Wittensville: [41274],
      Woodbine: [40771],
      Woodburn: [42170],
      Woollum: [40999],
      Worthington: [41183],
      Worthville: [41098],
      Yosemite: [42566],
      Zachariah: [41396],
      Zoe: [41397],
    },
    name: 'Kentucky',
  },
  LA: {
    cities: {
      71344: [71344],
      71372: [71372],
      71421: [71421],
      71436: [71436],
      71445: [71445],
      'Abita Springs': [70420],
      Acme: [71316],
      Addis: [70710],
      Aimwell: [71401],
      Albany: [70711],
      Alexandria: [71301, 71302, 71303],
      Alto: [71269],
      Ama: [70031],
      Amelia: [70340],
      Amite: [70422],
      Anacoco: [71403],
      Angie: [70426],
      Angola: [70712],
      Arabi: [70032],
      Arcadia: [71001],
      Arnaudville: [70512],
      Athens: [71003],
      Atlanta: [71404],
      Bains: [70775],
      Baker: [70714],
      Baldwin: [70514],
      Barataria: [70036],
      'Barksdale A F B': [71110],
      Basile: [70515],
      Baskin: [71219],
      Bastrop: [71220],
      Batchelor: [70715],
      'Baton Rouge': [
        70801, 70802, 70805, 70806, 70808, 70809, 70810, 70812, 70814, 70815,
        70816, 70817, 70818, 70819, 70820,
      ],
      Belcher: [71004],
      'Bell City': [70630],
      'Belle Chasse': [70037],
      'Belle Rose': [70341],
      Belmont: [71406],
      Bentley: [71407],
      Benton: [71006],
      Bernice: [71222],
      Berwick: [70342],
      Bethany: [71007],
      Bienville: [71008],
      'Big Bend': [71318],
      Blanks: [70717],
      Bogalusa: [70427],
      Bonita: [71223],
      'Bossier City': [71111, 71112],
      Bourg: [70343],
      Boutte: [70039],
      Boyce: [71409],
      Braithwaite: [70040],
      Branch: [70516],
      'Bridge City': [70094],
      Broussard: [70518],
      Brusly: [70719],
      Buckeye: [71328],
      Bueche: [70720],
      Buras: [70041],
      Bush: [70431],
      Calcasieu: [71433],
      Calhoun: [71225],
      Cameron: [70631],
      Campti: [71411],
      Cankton: [70584],
      Carencro: [70520],
      Caspiana: [71115],
      Castor: [71016],
      'Center Point': [71323],
      Chalmette: [70043],
      Chatham: [71226],
      Chauvin: [70344],
      Cheneyville: [71325],
      Chestnut: [71070],
      Chopin: [71412, 71447],
      Choudrant: [71227],
      'Church Point': [70525],
      Clayton: [71326],
      Clifton: [71455],
      Clinton: [70722],
      Colfax: [71417],
      Collinston: [71229],
      Convent: [70723],
      'Cotton Valley': [71018],
      Cottonport: [71327],
      Covington: [70433],
      Creole: [70632],
      Crowley: [70526],
      'Cut Off': [70345],
      Darrow: [70725],
      Delcambre: [70528],
      Dequincy: [70633],
      Deridder: [70634],
      Derry: [71416],
      'Des Allemands': [70030],
      Dixie: [71107],
      Dodson: [71422],
      Donaldsonville: [70346],
      Downsville: [71234],
      Doyline: [71023],
      'Dry Creek': [70637],
      'Dry Prong': [71423],
      Dubach: [71235],
      Dubberly: [71024],
      Dulac: [70353],
      Duson: [70529],
      Edgard: [70049],
      Egan: [70531],
      'Elm Grove': [71051],
      Elmer: [71424],
      Elton: [70532],
      Enterprise: [71425],
      Eola: [71322],
      Epps: [71237],
      Erath: [70533],
      Eros: [71238],
      Erwinville: [70729],
      Ethel: [70730],
      Eunice: [70535],
      Evangeline: [70537],
      Evans: [70639],
      Extension: [71239],
      Farmerville: [71241],
      Fields: [70653],
      Fisher: [71426],
      Flatwoods: [71427],
      Florien: [71429],
      Fluker: [70436],
      Folsom: [70437],
      Forbing: [71106],
      Fordoche: [70732],
      'Forest Hill': [71430],
      'Forked Island': [70510],
      'Fort Necessity': [71243],
      'Fort Polk': [71459],
      Franklin: [70538],
      Franklinton: [70438],
      'French Settlemen': [70733],
      Frierson: [71027],
      Frogmore: [71334],
      Galliano: [70354],
      Galvez: [70769],
      Garyville: [70051],
      Geismar: [70734],
      Georgetown: [71432],
      Gheens: [70355],
      Gibsland: [71028],
      Gibson: [70356],
      Gilbert: [71336],
      Gilliam: [71029],
      Gloster: [71030],
      Glynn: [70736],
      'Golden Meadow': [70357],
      Goldonna: [71031],
      Gonzales: [70737],
      Goudeau: [71333],
      Grambling: [71245],
      Gramercy: [70052],
      'Grand Cane': [71032],
      'Grand Chenier': [70643],
      'Grand Isle': [70358],
      Gray: [70359],
      Grayson: [71435],
      Greensburg: [70441],
      'Greenwell Spring': [70739],
      Greenwood: [70811, 71033],
      Gretna: [70053],
      'Grosse Tete': [70740],
      Gueydan: [70542],
      Hackberry: [70645],
      Hahnville: [70057],
      'Hall Summit': [71034],
      Hamburg: [71339],
      Hammond: [70401, 70403],
      Hanna: [71019],
      Harahan: [70123],
      Harrisonburg: [71340],
      Harvey: [70058],
      Haughton: [71037],
      Haynesville: [71038],
      Hebert: [71418],
      Heflin: [71039],
      Henderson: [70517],
      Hessmer: [71341],
      Hicks: [71446],
      Holden: [70744],
      Homer: [71040],
      Hornbeck: [71439],
      Hosston: [71043],
      Houma: [70360, 70363, 70364],
      Iberville: [70776],
      Ida: [71044],
      Independence: [70443],
      Iota: [70543],
      Iowa: [70647],
      Jamestown: [71045],
      Jarreau: [70749],
      Jeanerette: [70544],
      Jefferson: [70121],
      Jena: [71342],
      Jennings: [70546],
      Jones: [71250],
      Jonesboro: [71251],
      Kaplan: [70548],
      Keatchie: [71046],
      Keithville: [71047],
      Kelly: [71441],
      Kenner: [70062, 70065],
      Kentwood: [70444],
      Kinder: [70648],
      Kolin: [71360],
      'Krotz Springs': [70750],
      'La Place': [70068],
      Labadieville: [70372],
      Lacamp: [71444],
      Lacassine: [70650],
      Lacombe: [70445],
      Lafayette: [70501, 70503, 70506, 70507, 70508],
      Lafitte: [70067],
      'Lake Arthur': [70549],
      'Lake Charles': [70601, 70605, 70611],
      'Lake Providence': [71254],
      Lakeland: [70752],
      Larto: [71343],
      'Le Moyen': [71356],
      Leander: [71438],
      Lecompte: [71346],
      Lettsworth: [70753],
      Lillie: [71256],
      Linville: [71260],
      Lisbon: [71048],
      Livingston: [70754],
      Livonia: [70755],
      Lockport: [70374],
      Logansport: [71049],
      Longville: [70652],
      Loranger: [70446],
      Loreauville: [70552],
      Lottie: [70756],
      Luling: [70070],
      Lutcher: [70071],
      Madisonville: [70447],
      Mamou: [70554],
      Mandeville: [70448],
      Mangham: [71259],
      Mansfield: [71052],
      Mansura: [71350],
      Many: [71449],
      Marksville: [71351],
      Marrero: [70072],
      Marthaville: [71450],
      Mathews: [70375],
      Maurepas: [70449],
      Maurice: [70555],
      Melder: [71451],
      Melville: [71353],
      'Mer Rouge': [71261],
      Meraux: [70075],
      Metairie: [70001, 70002, 70003, 70005, 70006],
      Midland: [70559],
      Minden: [71055],
      Mira: [71059],
      Mitchell: [71419],
      Mittie: [70654],
      Monroe: [71201, 71203],
      Montegut: [70377],
      Monterey: [71354],
      Montgomery: [71454],
      Mooringsport: [71060],
      Moreauville: [71355],
      'Morgan City': [70380],
      Morganza: [70759],
      Mound: [71282],
      'Mount Hermon': [70450],
      Napoleonville: [70390],
      Natchez: [71456],
      Natchitoches: [71457],
      'New Iberia': [70560],
      'New Orleans': [
        70112, 70113, 70114, 70115, 70116, 70117, 70118, 70119, 70122, 70124,
        70125, 70126, 70127, 70128, 70129, 70130, 70131,
      ],
      'New Roads': [70760],
      'New Sarpy': [70047],
      Newellton: [71357],
      Newllano: [71461],
      Noble: [71462],
      Norco: [70079],
      Norwood: [70761],
      'Oak Ridge': [71264],
      Oakdale: [71463],
      Oberlin: [70655],
      'Oil City': [71061],
      Olla: [71465],
      Opelousas: [70570],
      Oscar: [70762],
      Otis: [71466],
      Palmetto: [71358],
      Paradis: [70080],
      Patterson: [70392],
      Paulina: [70763],
      'Pearl River': [70452],
      Pelican: [71063],
      'Pierre Part': [70339],
      'Pine Grove': [70453],
      Pioneer: [71266],
      Pitkin: [70656],
      'Plain Dealing': [71064],
      Plaquemine: [70764],
      Plaucheville: [71362],
      'Pleasant Hill': [71065],
      'Point Clair': [70721],
      Pollock: [71467],
      Ponchatoula: [70454],
      'Port Allen': [70767],
      'Port Barre': [70577],
      'Port Sulphur': [70083],
      'Port Vincent': [70726],
      Pride: [70770],
      Princeton: [71067],
      Provencal: [71468],
      Quitman: [71268],
      Raceland: [70394],
      Ragley: [70657],
      Ramah: [70757],
      Rayne: [70578],
      Reeves: [70658],
      Reserve: [70084],
      Richwood: [71202],
      Ringgold: [71068],
      Roanoke: [70581],
      Robeline: [71469],
      Robert: [70455],
      Rodessa: [71069],
      Rosedale: [70772],
      Roseland: [70456],
      Rougon: [70773],
      Ruston: [71270],
      'Saint Amant': [70774],
      'Saint Bernard': [70085],
      'Saint James': [70086],
      'Saint Joseph': [71366],
      'Saint Landry': [71367],
      'Saint Martinvill': [70582],
      'Saint Rose': [70087],
      Sarepta: [71071],
      Schriever: [70395],
      Scotlandville: [70807],
      Scott: [70583],
      Shongaloo: [71072],
      Shreveport: [
        71101, 71103, 71104, 71105, 71108, 71109, 71118, 71119, 71129,
      ],
      Sibley: [71073],
      'Sicily Island': [71368],
      Sieper: [71472],
      Sikes: [71473],
      Simmesport: [71369],
      Simsboro: [71275],
      Singer: [70660],
      Slaughter: [70777],
      Slidell: [70458, 70460, 70461],
      Sondheimer: [71276],
      Sorrento: [70778],
      Spearsville: [71277],
      Spencer: [71280],
      Springfield: [70462],
      Springhill: [71075],
      Starks: [70661],
      Stonewall: [71078],
      Sugartown: [70662],
      Sulphur: [70663],
      Summerfield: [71079],
      Sunshine: [70780],
      Terry: [71263],
      Terrytown: [70056],
      'The Bluffs': [70748],
      Theriot: [70397],
      Thibodaux: [70301],
      Tickfaw: [70466],
      Tioga: [71477],
      Torbert: [70781],
      Transylvania: [71286],
      Trees: [71082],
      Trout: [71371],
      Tullos: [71479],
      'Uncle Sam': [70792],
      Vacherie: [70090],
      Varnado: [70467],
      Venice: [70091],
      Ventress: [70783],
      Vick: [71331],
      Vidalia: [71373],
      'Ville Platte': [70586],
      Vinton: [70668],
      Violet: [70092],
      Walker: [70785],
      Warden: [71232],
      Washington: [70589],
      Waterproof: [71375],
      Welsh: [70591],
      'West Monroe': [71291, 71292],
      Westlake: [70669],
      'White Castle': [70788],
      Wilson: [70789],
      Winnfield: [71483],
      Winnsboro: [71295],
      Wisner: [71378],
      Woodworth: [71485],
      Youngsville: [70592],
      Zachary: [70791],
      Zwolle: [71486],
    },
    name: 'Louisiana',
  },
  MA: {
    cities: {
      Abington: ['02351'],
      Acton: ['01720'],
      Acushnet: ['02743'],
      Adams: ['01220'],
      Agawam: ['01001'],
      Allston: ['02134'],
      Amesbury: ['01913'],
      Andover: ['01810'],
      Arlington: ['02174'],
      Ashburnham: ['01430'],
      Ashby: ['01431'],
      Ashfield: ['01330'],
      Ashland: ['01721'],
      'Ashley Falls': ['01222'],
      Assonet: ['02702'],
      Attleboro: ['02703'],
      Auburn: ['01501'],
      Auburndale: ['02166'],
      Avon: ['02322'],
      Ayer: ['01432'],
      Baldwinville: ['01436'],
      Barnstable: ['02630'],
      Barre: ['01005'],
      'Bass River': ['02664'],
      Becket: ['01223'],
      Bedford: ['01730'],
      Belchertown: ['01007'],
      Bellingham: ['02019'],
      Belmont: ['02178'],
      Berkley: ['02779'],
      Berlin: ['01503'],
      Beverly: ['01915'],
      Billerica: ['01821'],
      Blackstone: ['01504'],
      Blandford: ['01008'],
      Bolton: ['01740'],
      Boston: [
        '02108',
        '02109',
        '02110',
        '02111',
        '02113',
        '02114',
        '02115',
        '02116',
        '02199',
        '02210',
        '02215',
      ],
      'Boston College': ['02167'],
      Boxboro: ['01719'],
      Boxford: ['01921'],
      Boylston: ['01505'],
      Bradford: ['01835'],
      Braintree: ['02184'],
      Brewster: ['02631'],
      Bridgewater: ['02324'],
      Brighton: ['02135'],
      Brimfield: ['01010'],
      Brockton: ['02401', '02402'],
      Brookfield: ['01506'],
      Brookline: ['02146'],
      Buckland: ['01338'],
      Burlington: ['01803'],
      Byfield: ['01922'],
      Cambridge: ['02138', '02139', '02142', '02163'],
      Canton: ['02021'],
      Carlisle: ['01741'],
      Carver: ['02330'],
      Centerville: ['02632'],
      Charlestown: ['02129'],
      Charlton: ['01507'],
      Chelsea: ['02150'],
      'Cherry Valley': ['01611'],
      Cheshire: ['01225'],
      Chester: ['01011'],
      Chesterfield: ['01012'],
      Chicopee: ['01013', '01020'],
      Chilmark: ['02535'],
      Clarksburg: ['01247'],
      Clinton: ['01510'],
      Cohasset: ['02025'],
      Colrain: ['01340'],
      Concord: ['01742'],
      Conway: ['01341'],
      Cotuit: ['02635'],
      Cummington: ['01026'],
      Cushman: ['01002'],
      Cuttyhunk: ['02713'],
      Dalton: ['01226'],
      Danvers: ['01923'],
      Dedham: ['02026'],
      Deerfield: ['01342'],
      Dennis: ['02638'],
      'Dennis Port': ['02639'],
      Dighton: ['02715'],
      Dorchester: ['02121', '02122', '02124', '02125'],
      Dover: ['02030'],
      Dracut: ['01826'],
      Dudley: ['01571'],
      'Dudley Hill': ['01570'],
      Dunstable: ['01827'],
      Duxbury: ['02332'],
      'East Boston': ['02128'],
      'East Bridgewater': ['02333'],
      'East Brookfield': ['01515'],
      'East Cambridge': ['02141'],
      'East Douglas': ['01516'],
      'East Freetown': ['02717'],
      'East Longmeadow': ['01028'],
      'East Lynn': ['01904'],
      'East Sandwich': ['02537'],
      'East Taunton': ['02718'],
      'East Walpole': ['02032'],
      'East Wareham': ['02538'],
      'East Watertown': ['02172'],
      Eastham: ['02642'],
      Edgartown: ['02539'],
      Erving: ['01344'],
      Essex: ['01929'],
      Everett: ['02149'],
      Fairhaven: ['02719'],
      'Fall River': ['02720', '02721', '02723', '02724'],
      Falmouth: ['02540'],
      'Feeding Hills': ['01030'],
      Fiskdale: ['01518'],
      Fitchburg: ['01420'],
      Florence: ['01060'],
      Forestdale: ['02644'],
      Foxboro: ['02035'],
      Framingham: ['01701'],
      Franklin: ['02038'],
      'Ft Devens': ['01433'],
      Gardner: ['01440'],
      Georgetown: ['01833'],
      Gilbertville: ['01031'],
      Gloucester: ['01930'],
      Goshen: ['01032'],
      Grafton: ['01519'],
      Granby: ['01033'],
      Graniteville: ['01886'],
      'Great Barrington': ['01230'],
      Groton: ['01450'],
      Groveland: ['01834'],
      Hadley: ['01035'],
      Halifax: ['02338'],
      Hampden: ['01036'],
      Hancock: ['01237'],
      Hanover: ['02339'],
      Hanson: ['02341'],
      Harvard: ['01451'],
      Harwich: ['02645'],
      'Harwich Port': ['02646'],
      Hatfield: ['01038'],
      Haverhill: ['01830', '01832'],
      Hawley: ['01339'],
      Haydenville: ['01039'],
      Heath: ['01346'],
      Hingham: ['02043'],
      Holbrook: ['02343'],
      Holden: ['01520'],
      Holland: ['01521'],
      Holliston: ['01746'],
      Holyoke: ['01040'],
      Hopedale: ['01747'],
      Hopkinton: ['01748'],
      Housatonic: ['01236'],
      Hubbardston: ['01452'],
      Hudson: ['01749'],
      Hull: ['02045'],
      Huntington: ['01050'],
      'Hyde Park': ['02136'],
      'Indian Orchard': ['01151'],
      Ipswich: ['01938'],
      'Jamaica Plain': ['02130'],
      Jefferson: ['01522'],
      Kingston: ['02364'],
      Lakeville: ['02347'],
      Lancaster: ['01523'],
      Lawrence: ['01840', '01841', '01843'],
      Lee: ['01238'],
      Leeds: ['01053'],
      Leicester: ['01524'],
      Lenox: ['01240'],
      Leominster: ['01453'],
      Leverett: ['01054'],
      Lexington: ['02173'],
      Leyden: ['01301', '01337'],
      Lincoln: ['01773'],
      Littleton: ['01460'],
      Longmeadow: ['01106'],
      Lowell: ['01850', '01851', '01852', '01854'],
      Ludlow: ['01056'],
      Lunenburg: ['01462'],
      Lynn: ['01901', '01902'],
      Lynnfield: ['01940'],
      Malden: ['02148'],
      Manchester: ['01944'],
      Mansfield: ['02048'],
      Marblehead: ['01945'],
      Marion: ['02738'],
      Marlborough: ['01752'],
      Marshfield: ['02050'],
      'Marstons Mills': ['02648'],
      Mashpee: ['02649'],
      Mattapan: ['02126'],
      Mattapoisett: ['02739'],
      Maynard: ['01754'],
      Medfield: ['02052'],
      Medford: ['02155'],
      Medway: ['02053'],
      Melrose: ['02176'],
      Mendon: ['01756'],
      Merrimac: ['01860'],
      Methuen: ['01844'],
      Middleboro: ['02346'],
      Middlefield: ['01243'],
      Middleton: ['01949'],
      Milford: ['01757'],
      Millbury: ['01527'],
      'Millers Falls': ['01349'],
      Millis: ['02054'],
      Millville: ['01529'],
      Milton: ['02186'],
      Monroe: ['01350'],
      Monson: ['01057'],
      Montague: ['01351'],
      Montgomery: ['01085'],
      'Mount Tom': ['01027'],
      Nahant: ['01908'],
      Nantucket: ['02554'],
      Natick: ['01760'],
      Needham: ['02192', '02194'],
      'New Bedford': ['02740', '02744', '02745', '02746'],
      'New Braintree': ['01531'],
      'New Salem': ['01331', '01355', '01364'],
      Newbury: ['01951'],
      Newburyport: ['01950'],
      'Newton Center': ['02159'],
      'Newton Highlands': ['02161'],
      'Newton Upper Fal': ['02164'],
      Newtonville: ['02158', '02160', '02162', '02165'],
      Norfolk: ['02056'],
      'North Andover': ['01845'],
      'North Attleboro': ['02760', '02763'],
      'North Billerica': ['01862'],
      'North Brookfield': ['01535'],
      'North Cambridge': ['02140'],
      'North Chatham': ['02650'],
      'North Chelmsford': ['01863'],
      'North Dartmouth': ['02747'],
      'North Dighton': ['02764'],
      'North Easton': ['02356'],
      'North Falmouth': ['02556'],
      'North Grafton': ['01536'],
      'North Oxford': ['01537'],
      'North Reading': ['01864'],
      'North Truro': ['02652'],
      'North Waltham': ['02154'],
      Northborough: ['01532'],
      Northbridge: ['01534'],
      Northfield: ['01360'],
      Norton: ['02766'],
      Norwell: ['02061'],
      Norwood: ['02062'],
      Oakham: ['01068'],
      Onset: ['02532'],
      Orleans: ['02653'],
      Osterville: ['02655'],
      Otis: ['01253'],
      'Otis A F B': ['02542'],
      Oxford: ['01540'],
      'Padanaram Villag': ['02748'],
      Palmer: ['01069'],
      Paxton: ['01612'],
      Peabody: ['01960'],
      Pembroke: ['02359'],
      Pepperell: ['01463'],
      Peru: ['01235'],
      Petersham: ['01366'],
      Pittsfield: ['01201'],
      Plainfield: ['01070'],
      Plainville: ['02762'],
      Plymouth: ['02360'],
      Plympton: ['02367'],
      Pocasset: ['02559'],
      Princeton: ['01541'],
      Provincetown: ['02657'],
      Quincy: ['02169', '02170', '02171'],
      Randolph: ['02368'],
      Raynham: ['02767'],
      Reading: ['01867'],
      Rehoboth: ['02769'],
      Revere: ['02151'],
      Richmond: ['01254'],
      Rochdale: ['01542'],
      Rochester: ['02770'],
      Rockland: ['02370'],
      Rockport: ['01966'],
      Roslindale: ['02131'],
      Rowe: ['01367'],
      Rowley: ['01969'],
      Roxbury: ['02118', '02119', '02120'],
      Russell: ['01071'],
      Rutland: ['01543'],
      Salem: ['01970'],
      Salisbury: ['01952'],
      Sandisfield: ['01255'],
      Sandwich: ['02563'],
      Saugus: ['01906'],
      Savoy: ['01256'],
      Scituate: ['02066'],
      Seekonk: ['02771'],
      Sharon: ['02067'],
      Sheffield: ['01257'],
      'Shelburne Falls': ['01370'],
      Sherborn: ['01770'],
      'Shirley Center': ['01464'],
      Shrewsbury: ['01545'],
      Shutesbury: ['01072'],
      Somerset: ['02725', '02726'],
      Somerville: ['02143', '02144', '02145'],
      'South Boston': ['02127'],
      'South Chatham': ['02633', '02659'],
      'South Chelmsford': ['01824'],
      'South Deerfield': ['01373'],
      'South Dennis': ['02660'],
      'South Easton': ['02375'],
      'South Egremont': ['01258'],
      'South Grafton': ['01560'],
      'South Hadley': ['01075'],
      'South Hamilton': ['01982'],
      'South Walpole': ['02071'],
      Southampton: ['01073'],
      Southborough: ['01745', '01772'],
      Southbridge: ['01550'],
      Southfield: ['01259'],
      Southwick: ['01077'],
      Spencer: ['01562'],
      Springfield: [
        '01103',
        '01104',
        '01105',
        '01107',
        '01108',
        '01109',
        '01118',
        '01119',
        '01128',
        '01129',
      ],
      Sterling: ['01564'],
      Stockbridge: ['01262'],
      Stoneham: ['02180'],
      Stoughton: ['02072'],
      Stow: ['01775'],
      Sturbridge: ['01566'],
      Sudbury: ['01776'],
      Sunderland: ['01375'],
      Swampscott: ['01907'],
      Swansea: ['02777'],
      Taunton: ['02780'],
      Teaticket: ['02536'],
      Templeton: ['01468'],
      Tewksbury: ['01876'],
      'Three Rivers': ['01080'],
      Tolland: ['01034'],
      Topsfield: ['01983'],
      Townsend: ['01469'],
      Truro: ['02666'],
      'Turners Falls': ['01376'],
      Tyngsboro: ['01879'],
      Uxbridge: ['01569'],
      'Village Of Nagog': ['01718'],
      'Vineyard Haven': ['02568'],
      'W Townsend': ['01474'],
      Waban: ['02168'],
      Wakefield: ['01880'],
      Wales: ['01081'],
      Walpole: ['02081'],
      Ware: ['01082'],
      Wareham: ['02571'],
      Wayland: ['01778'],
      Wellesley: ['02181'],
      Wellfleet: ['02667'],
      Wendell: ['01379'],
      Wenham: ['01984'],
      'West Barnstable': ['02668'],
      'West Boylston': ['01583'],
      'West Bridgewater': ['02379'],
      'West Brookfield': ['01585'],
      'West Dennis': ['02670'],
      'West Harwich': ['02671'],
      'West Lynn': ['01905'],
      'West Newbury': ['01985'],
      'West Otis': ['01245'],
      'West Roxbury': ['02132'],
      'West Springfield': ['01089'],
      'West Stockbridge': ['01266'],
      'West Tisbury': ['02575'],
      'West Upton': ['01568'],
      'West Wareham': ['02576'],
      'West Warren': ['01092'],
      'West Yarmouth': ['02601', '02673'],
      Westborough: ['01581'],
      Westminster: ['01473'],
      Weston: ['02193'],
      'Westover Afb': ['01022'],
      Westport: ['02790'],
      Westwood: [2090],
      Weymouth: ['02188', '02189', '02190', '02191'],
      Whitinsville: ['01588'],
      Whitman: ['02382'],
      Wilbraham: ['01095'],
      Wilkinsonville: ['01590'],
      Williamsburg: ['01096'],
      Williamstown: ['01267'],
      Wilmington: ['01887'],
      Winchendon: ['01475'],
      Winchester: ['01890'],
      Windsor: ['01270'],
      Winthrop: ['02152'],
      Woburn: ['01801'],
      'Woods Hole': ['02543'],
      Worcester: [
        '01602',
        '01603',
        '01604',
        '01605',
        '01606',
        '01607',
        '01608',
        '01609',
        '01610',
      ],
      Worthington: ['01098'],
      Wrentham: ['02093'],
      'Yarmouth Port': ['02675'],
    },
    name: 'Massachusetts',
  },
  MD: {
    cities: {
      21858: [21858],
      Abell: [20606],
      Aberdeen: [21001],
      'Aberdeen Proving': [21005],
      Abingdon: [21009],
      Accident: [21520],
      Accokeek: [20607],
      Adelphi: [20783],
      'Andrews Afb': [20331],
      Annapolis: [21403],
      'Annapolis Juncti': [20701],
      Aquasco: [20608],
      Arnold: [21012],
      Ashton: [20861],
      'Aspen Hill': [20906],
      Avenue: [20609],
      Bainbridge: [21904],
      Baldwin: [21013],
      Baltimore: [
        21201, 21202, 21205, 21206, 21209, 21210, 21211, 21212, 21213, 21214,
        21215, 21216, 21217, 21218, 21223, 21224, 21229, 21230, 21231, 21239,
        21240,
      ],
      Barclay: [21607],
      Barnesville: [20838],
      Barton: [21521],
      Beallsville: [20839],
      'Bel Air': [21014, 21015],
      'Bel Alton': [20611],
      Belcamp: [21017],
      Beltsville: [20705],
      'Bentley Springs': [21120],
      Berlin: [21811],
      Bethesda: [20814, 20816],
      Betterton: [21610],
      'Big Pool': [21711],
      'Big Spring': [21722],
      Bishopville: [21813],
      Bittinger: [21522],
      Bivalve: [21814],
      Bladensburg: [20710],
      Bloomington: [21523],
      Bowie: [20715, 20720],
      Boyds: [20841],
      Bozman: [21612],
      Bradshaw: [21021],
      Brandywine: [20613],
      Brentwood: [20722],
      Brinklow: [20862],
      Brookeville: [20833],
      'Brooklyn Curtis': [21225, 21226],
      'Broomes Island': [20615],
      Brunswick: [21716],
      'Bryans Road': [20616],
      Bryantown: [20617],
      Burkittsville: [21718],
      Burtonsville: [20866],
      Bushwood: [20618],
      'Cabin John': [20818],
      California: [20619],
      Callaway: [20620],
      Cambridge: [21613],
      'Cape Saint Clair': [21401],
      'Capital Heights': [20743],
      Carrollton: [21157],
      Carrolltowne: [21784],
      Catonsville: [21228],
      Cecilton: [21913],
      Centreville: [21617],
      Chance: [21816],
      Charlestown: [21914],
      'Charlotte Hall': [20622],
      Cheltenham: [20623],
      'Chesapeake Beach': [20732],
      'Chesapeake City': [21915],
      Chester: [21619],
      Chestertown: [21620],
      'Chevy Chase': [20815],
      'Church Creek': [21622],
      'Church Hill': [21623],
      Churchton: [20733],
      Churchville: [21028],
      Clarksburg: [20871],
      Clarksville: [21029],
      Clements: [20624],
      Clinton: [20735],
      'Cockeysville Hun': [21030, 21031],
      Colesville: [20904, 20905],
      'College Park': [20740],
      Colora: [21917],
      'Coltons Point': [20626],
      Columbia: [21044, 21045, 21046],
      Conowingo: [21918],
      Cooksville: [21723],
      Cordova: [21625],
      Crapo: [21626],
      Cresaptown: [21502],
      Crisfield: [21817],
      Crofton: [21114],
      Crownsville: [21032],
      Crumpton: [21628],
      Damascus: [20872],
      Dameron: [20628],
      'Dames Quarter': [21820],
      Daniels: [21043],
      Darlington: [21034],
      Darnestown: [20874, 20878],
      Davidsonville: [21035],
      Dayton: [21036],
      'Deal Island': [21821],
      Deale: [20751],
      'Deer Park': [21550],
      Delmar: [21875],
      Denton: [21629],
      Derwood: [20855],
      Detour: [21725],
      Dickerson: [20842],
      'District Heights': [20747],
      Doubs: [21710],
      Drayden: [20630],
      'Dundalk Sparrows': [21219, 21222],
      Dunkirk: [20754],
      Earleville: [21919],
      'East New Market': [21631],
      Easton: [21601],
      Eden: [21822],
      'Edgewater Beach': [21037],
      Edgewood: [21040],
      Elkton: [21921],
      'Ellicott City': [21042],
      Emmitsburg: [21727],
      Essex: [21221],
      Eudowood: [21204],
      Ewell: [21824],
      'Fahrney Keedy Me': [21713],
      'Fair Play': [21733],
      Fallston: [21047],
      Faulkner: [20632],
      Federalsburg: [21632],
      'Fishing Creek': [21634],
      Flintstone: [21530],
      'Forest Hill': [21050],
      Fork: [21051],
      'Fort Detrick': [21702],
      'Fort George G Me': [20755],
      'Fort Ritchie': [21719],
      'Fort Washington': [20744],
      Fowbelsburg: [21155],
      Freeland: [21053],
      Friendship: [20758],
      Friendsville: [21531],
      Frostburg: [21532],
      Fruitland: [21826],
      Fulton: [20759],
      Gaithersburg: [20877],
      Galena: [21635],
      Gambrills: [21054],
      Germantown: [20876],
      'Gibson Island': [21056],
      Girdletree: [21829],
      'Glen Arm': [21057],
      'Glen Burnie': [21061],
      'Glen Echo': [20812],
      Glencoe: [21152],
      Glenelg: [21737],
      'Glenn Dale': [20769],
      Glenwood: [21738],
      Glyndon: [21071],
      Goldsboro: [21636],
      Golts: [21637],
      Graceham: [21788],
      Granite: [21163],
      Grasonville: [21638],
      'Great Mills': [20634],
      Greenbelt: [20770],
      Greenmount: [21074],
      Greensboro: [21639],
      Gunpowder: [21010],
      'Gwynn Oak': [21207],
      Hagerstown: [21740, 21742],
      Halethorpe: [21227],
      Hancock: [21750],
      Hanover: [21076],
      Harwood: [20776],
      'Havre De Grace': [21078],
      Hebron: [21830],
      Henderson: [21640],
      Hereford: [21111],
      Highland: [20777],
      Hollywood: [20636],
      Hughesville: [20637],
      Huntingtown: [20639],
      Hyattsville: [20781],
      Hydes: [21082],
      Ijamsville: [21754],
      Ingleside: [21644],
      Issue: [20645],
      Jacksonville: [21131],
      Jarrettsville: [21084],
      Jefferson: [21755],
      Jennings: [21536],
      Jessup: [20794],
      Joppa: [21085],
      Keedysville: [21756],
      Kennedyville: [21645],
      Kensington: [20895],
      Keymar: [21757],
      Kingsville: [21087],
      Knoxville: [21758],
      'La Plata': [20646],
      Landover: [20785],
      'Landover Hills': [20784],
      Lanham: [20706],
      Laurel: [20707, 20723, 20724],
      Laytonsville: [20879, 20882],
      Leonardtown: [20650],
      Lewistown: [21701],
      'Lexington Park': [20653],
      Lineboro: [21088],
      Linkwood: [21835],
      'Linthicum Height': [21090],
      Linwood: [21764],
      'Little Orleans': [21766],
      Lonaconing: [21539],
      Lothian: [20711],
      Loveville: [20656],
      Luke: [21540],
      Lusby: [20657],
      Lutherville: [21093],
      Maddox: [20621],
      Manchester: [21102],
      'Mardela Springs': [21837],
      'Marion Station': [21838],
      Marriottsville: [21104],
      Marydel: [21649],
      Massey: [21650],
      Maugansville: [21767],
      Mccoole: [21562],
      Mcdaniel: [21647],
      Mechanicsville: [20659],
      'Middle River': [21220],
      Middletown: [21769],
      Millers: [21107],
      Millersville: [21108],
      Millington: [21651],
      Mitchellville: [20716, 20721],
      Monrovia: [21770],
      Montpelier: [20708],
      'Mount Airy': [21771],
      'Mount Rainier': [20712],
      'Mount Savage': [21545],
      Myersville: [21773],
      Nanjemoy: [20662],
      Nanticoke: [21840],
      'Naval Academy': [21402],
      'New Windsor': [21776],
      Newark: [21841],
      Newburg: [20664],
      'North Beach': [20714],
      'North East': [21901],
      Nottingham: [21236],
      'Ocean City': [21842],
      Odenton: [21113],
      Oldtown: [21555],
      Olney: [20832],
      Owings: [20736],
      'Owings Mills': [21117],
      Oxford: [21654],
      'Oxon Hill': [20745],
      'Park Hall': [20667],
      Parkville: [21234],
      Parsonsburg: [21849],
      Patapsco: [21048],
      'Patuxent River': [20670],
      'Perry Hall': [21128],
      Perryville: [21903],
      Pikesville: [21208],
      'Piney Point': [20674],
      Pisgah: [20640],
      Pittsville: [21850],
      'Pocomoke City': [21851],
      'Point Of Rocks': [21777],
      Pomfret: [20675],
      Poolesville: [20837],
      'Port Republic': [20676],
      'Port Tobacco': [20677],
      Potomac: [20854],
      Preston: [21655],
      'Prince Frederick': [20678],
      'Princess Anne': [21853],
      Pylesville: [21132],
      Quantico: [21856],
      'Queen Anne': [21657],
      Queenstown: [21658],
      Randallstown: [21133],
      Rawlings: [21557],
      Reisterstown: [21136],
      Rhodesdale: [21659],
      Ridge: [20680],
      Ridgely: [21660],
      'Rising Sun': [21911],
      Rison: [20658],
      Riva: [21140],
      Riverdale: [20737],
      'Riviera Beach': [21122],
      'Rock Hall': [21661],
      Rocks: [21154],
      Rockville: [20850, 20851, 20852, 20853],
      'Rocky Ridge': [21778],
      Rohrersville: [21779],
      Rosedale: [21237],
      'Royal Oak': [21662],
      Sabillasville: [21780],
      'Saint Charles': [20602, 20603],
      'Saint Inigoes': [20684],
      'Saint Leonard': [20685],
      'Saint Michaels': [21663],
      Salisbury: [21801],
      'Sandy Spring': [20860],
      'Sang Run': [21541],
      Savage: [20763],
      Scotland: [20687],
      Severn: [21144],
      'Severna Park': [21146],
      'Shady Side': [20764],
      Shallmar: [21538],
      Sharpsburg: [21782],
      Sherwood: [21665],
      'Silver Spring': [20901, 20903, 20910],
      Smithsburg: [21783],
      'Snow Hill': [21863],
      Solomons: [20688],
      Spencerville: [20868],
      Stevensville: [21666],
      'Still Pond': [21667],
      Stockton: [21864],
      Sudlersville: [21668],
      Suitland: [20746],
      Sunderland: [20689],
      Swanton: [21561],
      'Takoma Park': [20912],
      'Tall Timbers': [20690],
      Taneytown: [21787],
      'Taylors Island': [21669],
      'Temple Hills': [20748],
      Tilghman: [21671],
      Toddville: [21672],
      'Tracys Landing': [20779],
      Trappe: [21673],
      Tuscarora: [21790],
      Tyaskin: [21865],
      Tylerton: [21866],
      Uniontown: [21158],
      Unionville: [21791],
      'Upper Falls': [21156],
      'Upper Marlboro': [20772],
      'Valley Lee': [20692],
      Vienna: [21869],
      Waldorf: [20601],
      Walkersville: [21793],
      Warwick: [21912],
      Welcome: [20693],
      Wenona: [21870],
      'West Bethesda': [20817],
      'West Friendship': [21794],
      'West Hyattsville': [20782],
      'West River': [20778],
      Westover: [21871],
      Whaleysville: [21872],
      Wheaton: [20902],
      'White Hall': [21161],
      'White Marsh': [21162],
      'White Plains': [20695],
      Whiteford: [21160],
      Willards: [21874],
      Williamsburg: [21643],
      Williamsport: [21795],
      Wingate: [21675],
      Wittman: [21676],
      Woodbine: [21797],
      Woodsboro: [21798],
      Woolford: [21677],
      Worton: [21678],
      'Wye Mills': [21679],
    },
    name: 'Maryland',
  },
  ME: {
    cities: {
      4465: ['04465'],
      4689: ['04689'],
      'Abbot Village': ['04406'],
      Acton: ['04001'],
      Addison: ['04606'],
      Albion: ['04910'],
      Alfred: ['04002'],
      Andover: ['04216'],
      Anson: ['04911'],
      Arundel: ['04005'],
      Ashland: ['04732'],
      Athens: ['04912'],
      Auburn: ['04210'],
      Augusta: ['04330'],
      Aurora: ['04408'],
      'Bailey Island': ['04003'],
      Bangor: ['04401'],
      'Bar Harbor': ['04609'],
      'Bass Harbor': ['04653'],
      Bath: ['04530'],
      Beals: ['04611'],
      Belfast: ['04915'],
      Belgrade: ['04917'],
      'Belgrade Lakes': ['04918'],
      Benedicta: ['04733'],
      'Benton Station': ['04937'],
      Bernard: ['04612'],
      Berwick: ['03901'],
      Bethel: ['04217'],
      'Biddeford Pool': ['04006'],
      Bingham: ['04920'],
      'Birch Harbor': ['04613'],
      'Birch Island': ['04011'],
      'Blue Hill': ['04614'],
      'Blue Hill Falls': ['04615'],
      Boothbay: ['04537'],
      Bowdoinham: ['04008'],
      Bradford: ['04410'],
      Bradley: ['04411'],
      Brewer: ['04412'],
      Bridgewater: ['04735'],
      Bridgton: ['04009'],
      Bristol: ['04539'],
      Brooklin: ['04616'],
      Brooks: ['04921'],
      Brooksville: ['04617'],
      Brookton: ['04413'],
      Brownfield: ['04010'],
      Brownville: ['04414'],
      'Bryant Pond': ['04219'],
      Buckfield: ['04220'],
      'Bucks Harbor': ['04618'],
      Bucksport: ['04416'],
      Burlington: ['04417'],
      Burnham: ['04922'],
      'Bustins Island': ['04013'],
      Calais: ['04619'],
      Cambridge: ['04923'],
      Camden: ['04843'],
      Canaan: ['04924'],
      Canton: ['04221'],
      'Cape Elizabeth': ['04107'],
      'Cape Neddick': ['03902'],
      'Capitol Island': ['04538'],
      Caratunk: ['04925'],
      Cardville: ['04418'],
      Caribou: ['04736'],
      Carmel: ['04419'],
      Casco: ['04015'],
      'Center Lovell': ['04016'],
      Chamberlain: ['04541'],
      Charleston: ['04422'],
      'Chebeague Island': ['04017'],
      Cherryfield: ['04622'],
      'Clayton Lake': ['04737'],
      'Cliff Island': ['04019'],
      Clinton: ['04927'],
      'Columbia Falls': ['04623'],
      'Coopers Mills': ['04341'],
      Corea: ['04624'],
      Corinna: ['04928'],
      Cornish: ['04020'],
      Costigan: ['04423'],
      'Cumberland Cente': ['04021'],
      'Cumberland Fores': ['04110'],
      Cushing: ['04563'],
      'Cushing Island': ['04109'],
      Cutler: ['04626'],
      Damariscotta: ['04543'],
      Danforth: ['04424'],
      Danville: ['04223'],
      'Deer Isle': ['04627'],
      Denmark: ['04022'],
      Dennysville: ['04628'],
      Derby: ['04463'],
      Detroit: ['04929'],
      Dexter: ['04930'],
      Dixfield: ['04224'],
      Dixmont: ['04932'],
      'Dover Foxcroft': ['04426'],
      Dresden: ['04342'],
      Dryden: ['04225'],
      'East Andover': ['04226'],
      'East Baldwin': ['04024'],
      'East Boothbay': ['04544'],
      'East Corinth': ['04427'],
      'East Eddington': ['04428'],
      'East Holden': ['04429'],
      'East Livermore': ['04228'],
      'East Machias': ['04630'],
      'East Millinocket': ['04430'],
      'East Orland': ['04431'],
      'East Stoneham': ['04231'],
      'East Waterboro': ['04030'],
      Easton: ['04740'],
      Eastport: ['04631'],
      Edgecomb: ['04556'],
      Eliot: ['03903'],
      Ellsworth: ['04605'],
      Enfield: ['04433'],
      Etna: ['04434'],
      Eustis: ['04936'],
      Exeter: ['04435'],
      Falmouth: ['04105'],
      Farmingdale: ['04344'],
      Farmington: ['04938'],
      'Fort Fairfield': ['04742'],
      'Fort Kent': ['04743'],
      Frankfort: ['04438'],
      Franklin: ['04634'],
      Freedom: ['04941'],
      Freeport: ['04032'],
      Friendship: ['04547'],
      Frye: ['04235'],
      Fryeburg: ['04037'],
      Gardiner: ['04345'],
      Gorham: ['04038'],
      Gouldsboro: ['04607'],
      'Grand Isle': ['04746'],
      Gray: ['04039'],
      Greene: ['04236'],
      Greenville: ['04441'],
      'Greenville Junct': ['04442'],
      Guilford: ['04443'],
      Hallowell: ['04347'],
      Hampden: ['04444'],
      Hancock: ['04640'],
      Hanover: ['04237'],
      Harborside: ['04642'],
      Harrington: ['04643'],
      Harrison: ['04040'],
      Hartland: ['04943'],
      Haynesville: ['04446'],
      Hebron: ['04238'],
      Hiram: ['04041'],
      'Hollis Center': ['04042'],
      Hope: ['04847'],
      Houlton: ['04730'],
      Hudson: ['04449'],
      'Island Falls': ['04747'],
      'Isle Au Haut': ['04645'],
      Islesboro: ['04848'],
      Jackman: ['04945'],
      Jay: ['04239'],
      Jefferson: ['04348'],
      Jonesboro: ['04648'],
      Jonesport: ['04649'],
      Kenduskeag: ['04450'],
      Kennebunk: ['04043'],
      Kennebunkport: ['04046'],
      'Kents Hill': ['04349'],
      'Kezar Falls': ['04047'],
      Kingfield: ['04947'],
      Kingman: ['04451'],
      Kittery: ['03904'],
      'Kittery Point': ['03905'],
      Lagrange: ['04453'],
      Lee: ['04455'],
      Leeds: ['04263'],
      Levant: ['04456'],
      Lewiston: ['04240'],
      Liberty: ['04949'],
      Lille: ['04749'],
      Limerick: ['04048'],
      Limestone: ['04750'],
      Limington: ['04049'],
      Lincoln: ['04457'],
      'Lincoln Center': ['04458'],
      Lincolnville: ['04849'],
      Lisbon: ['04250'],
      'Lisbon Falls': ['04252'],
      Litchfield: ['04350'],
      'Little Deer Isle': ['04650'],
      'Livermore Falls': ['04254'],
      'Long Island': ['04050'],
      'Loring Afb': ['04751'],
      Lovell: ['04051'],
      Lubec: ['04652'],
      'Mac Mahan': ['04548'],
      Machias: ['04654'],
      Machiasport: ['04655'],
      Madawaska: ['04756'],
      Madison: ['04950'],
      Manchester: ['04351'],
      Manset: ['04656'],
      Mapleton: ['04757'],
      Maplewood: ['04095'],
      'Mars Hill': ['04758'],
      Mattawamkeag: ['04459'],
      'Mechanic Falls': ['04256'],
      Meddybemps: ['04657'],
      Medomak: ['04551'],
      Medway: ['04460'],
      Merepoint: ['04053'],
      Mexico: ['04257'],
      Milbridge: ['04658'],
      Milford: ['04461'],
      Millinocket: ['04462'],
      Monhegan: ['04852'],
      Monmouth: ['04259'],
      Monroe: ['04951'],
      Monson: ['04464'],
      Monticello: ['04760'],
      Morrill: ['04952'],
      'Mount Desert': ['04660'],
      'Mount Vernon': ['04352'],
      Naples: ['04055'],
      'New Gloucester': ['04260'],
      'New Harbor': ['04554'],
      'New Portland': ['04954'],
      'New Sharon': ['04955'],
      'New Sweden': ['04762'],
      'New Vineyard': ['04956'],
      Newcastle: ['04553'],
      Newport: ['04953'],
      Newry: ['04261'],
      Nobleboro: ['04555'],
      Norridgewock: ['04957'],
      'North Amity': ['04471'],
      'North Anson': ['04958'],
      'North Berwick': ['03906'],
      'North Brooklin': ['04661'],
      'North Fryeburg': ['04058'],
      'North Haven': ['04853'],
      'North Monmouth': ['04265'],
      'North New Portla': ['04961'],
      'North Sebago': ['04029'],
      'North Shapleigh': ['04060'],
      'North Turner': ['04266'],
      'North Vassalboro': ['04962'],
      'North Waterboro': ['04061'],
      'North Waterford': ['04267'],
      'North Whitefield': ['04353'],
      Norway: ['04268'],
      Oakfield: ['04763'],
      Oakland: ['04963'],
      Ogunquit: ['03907'],
      'Old Orchard Beac': ['04064'],
      'Old Town': ['04468'],
      Orland: ['04472'],
      Orono: ['04473'],
      Orrington: ['04474'],
      'Orrs Island': ['04066'],
      'Owls Head': ['04854'],
      Oxbow: ['04764'],
      Oxford: ['04270'],
      Palermo: ['04354'],
      Palmyra: ['04965'],
      Passadumkeag: ['04475'],
      Patten: ['04765'],
      'Peaks Island': ['04108'],
      Pejepscot: ['04086'],
      Pemaquid: ['04558'],
      Pembroke: ['04666'],
      Penobscot: ['04476'],
      Perry: ['04667'],
      Peru: ['04290'],
      Phillips: ['04966'],
      Phippsburg: ['04562'],
      Pittsfield: ['04967'],
      Plymouth: ['04969'],
      Poland: ['04273'],
      'Poland Spring': ['04274'],
      Portage: ['04768'],
      Porter: ['04068'],
      Portland: ['04101', '04102', '04103'],
      Pownal: ['04069'],
      'Presque Isle': ['04769'],
      Princeton: ['04668'],
      'Prospect Harbor': ['04669'],
      Randolph: ['04346'],
      Rangeley: ['04970'],
      Raymond: ['04071'],
      Readfield: ['04355'],
      Richmond: ['04357'],
      Robbinston: ['04671'],
      Rockland: ['04841'],
      Rockport: ['04856'],
      Rockwood: ['04478'],
      'Round Pond': ['04564'],
      Roxbury: ['04275'],
      Rumford: ['04276'],
      'Rumford Center': ['04278'],
      'Rumford Point': ['04279'],
      Sabattus: ['04280'],
      Saco: ['04072'],
      'Saint Agatha': ['04772'],
      'Saint Albans': ['04971'],
      'Saint David': ['04773'],
      'Saint Francis': ['04774'],
      'Saint George': ['04857'],
      Sanford: ['04073'],
      Sangerville: ['04479'],
      Sargentville: ['04673'],
      Scarborough: ['04074'],
      Searsmont: ['04973'],
      Searsport: ['04974'],
      'Sebago Lake': ['04075'],
      'Sebasco Estates': ['04565'],
      Seboeis: ['04448'],
      Sedgwick: ['04676'],
      Shapleigh: ['04076'],
      'Sherman Mills': ['04776'],
      'Sherman Station': ['04777'],
      Sinclair: ['04779'],
      Skowhegan: ['04976'],
      'Small Point': ['04567'],
      Smithfield: ['04978'],
      'Smyrna Mills': ['04780'],
      'Soldier Pond': ['04781'],
      Solon: ['04979'],
      Sorrento: ['04677'],
      'South Berwick': ['03908'],
      'South Bristol': ['04568'],
      'South Casco': ['04077'],
      'South China': ['04358'],
      'South Gouldsboro': ['04678'],
      'South Harpswell': ['04079'],
      'South Paris': ['04281'],
      'South Portland': ['04106'],
      'South Thomaston': ['04858'],
      'South Waterford': ['04081'],
      'Southwest Harbor': ['04679'],
      Springfield: ['04487'],
      Springvale: ['04083'],
      'Spruce Head': ['04859'],
      'Squirrel Island': ['04570'],
      Standish: ['04084'],
      'Steep Falls': ['04085'],
      Stetson: ['04488'],
      Steuben: ['04680'],
      Stockholm: ['04783'],
      'Stockton Springs': ['04981'],
      Stonington: ['04681'],
      Stratton: ['04982'],
      Strong: ['04983'],
      Sunset: ['04683'],
      Surry: ['04684'],
      Temple: ['04984'],
      'Tenants Harbor': ['04860'],
      Thomaston: ['04861'],
      Thorndike: ['04986'],
      Topsfield: ['04490'],
      Trevett: ['04571'],
      Troy: ['04987'],
      Turner: ['04282'],
      Union: ['04862'],
      Unity: ['04988'],
      'Van Buren': ['04785'],
      Vanceboro: ['04491'],
      Vassalboro: ['04989'],
      Vinalhaven: ['04863'],
      Waite: ['04492'],
      Waldoboro: ['04572'],
      Walpole: ['04573'],
      Warren: ['04864'],
      Washburn: ['04786'],
      Washington: ['04574'],
      Waterboro: ['04087'],
      Wayne: ['04284'],
      'Weeks Mills': ['04361'],
      Weld: ['04285'],
      Wellington: ['04942'],
      Wells: ['04090'],
      'West Baldwin': ['04091'],
      'West Buxton': ['04093'],
      'West Forks': ['04985'],
      'West Lebanon': ['04027'],
      'West Paris': ['04289'],
      'West Poland': ['04291'],
      'West Rockport': ['04865'],
      'West Southport': ['04576'],
      'West Sumner': ['04292'],
      'West Tremont': ['04690'],
      Westbrook: ['04092'],
      Westfield: ['04787'],
      Wilton: ['04294'],
      Windham: ['04062'],
      Windsor: ['04363'],
      Winn: ['04495'],
      Winslow: ['04901'],
      'Winter Harbor': ['04693'],
      Winterport: ['04496'],
      Winthrop: ['04364'],
      Wiscasset: ['04578'],
      Woodland: ['04694'],
      Woolwich: ['04579'],
      Wytopitlock: ['04497'],
      Yarmouth: ['04096'],
      York: ['03909'],
    },
    name: 'Maine',
  },
  MI: {
    cities: {
      Ada: [49301],
      Addison: [49220],
      'Addison Township': [48367],
      Adrian: [49221],
      Afton: [49705],
      Akron: [48701],
      Alanson: [49706],
      Albion: [49224],
      Alden: [49612],
      Alger: [48610],
      Allegan: [49010],
      Allen: [49227],
      'Allen Park': [48101],
      Allendale: [49401],
      Alma: [48801],
      Almont: [48003],
      Alpena: [49707],
      Alto: [49302],
      Anchorville: [48004],
      'Ann Arbor': [48103, 48104, 48105, 48108, 48109],
      Applegate: [48401],
      Arcadia: [49613],
      Armada: [48005],
      Ashley: [48806],
      Athens: [49011],
      Atlanta: [49709],
      'Atlantic Mine': [49905],
      Attica: [48412],
      'Au Gres': [48703],
      'Au Train': [49806],
      Auburn: [48611],
      'Auburn Hills': [48326],
      Augusta: [49012],
      'Bad Axe': [48413],
      Bailey: [49303],
      Baldwin: [49304],
      Bancroft: [48414],
      Bangor: [49013],
      Bannister: [48807],
      Barbeau: [49710],
      Baroda: [49101],
      Barryton: [49305],
      'Barton City': [48705],
      Bath: [48808],
      'Battle Creek': [49015, 49017],
      'Bay City': [48708],
      'Bay Port': [48720],
      'Bay View': [49770],
      'Bear Lake': [49614],
      'Beaver Grove': [49855],
      Beaverton: [48612],
      Belding: [48809],
      Bellaire: [49615],
      Belleville: [48111],
      Bellevue: [49021],
      Belmont: [49306],
      Bentley: [48613],
      'Benton Harbor': [49022],
      Benzonia: [49616],
      Bergland: [49910],
      Berkley: [48072],
      Berlin: [48002],
      'Berrien Center': [49102],
      'Berrien Springs': [49103],
      Bessemer: [49911],
      Beulah: [49617],
      'Big Rapids': [49307],
      'Birch Run': [48415],
      Birmingham: [48009],
      Bitely: [49309],
      'Black River': [48721],
      Blanchard: [49310],
      Blissfield: [49228],
      'Bloomfield Towns': [48301, 48302, 48304],
      Bloomingdale: [49026],
      Boon: [49618],
      'Boyne City': [49712],
      'Boyne Falls': [49713],
      Brampton: [49837],
      Branch: [49402],
      Brant: [48614],
      Breckenridge: [48615],
      Brethren: [49619],
      Bridgeport: [48722],
      Bridgman: [49106],
      Brighton: [48116],
      Britton: [49229],
      Brockway: [48097],
      Bronson: [49028],
      Brooklyn: [49230],
      'Brown City': [48416],
      Bruce: [48065],
      'Bruce Crossing': [49912],
      Brutus: [49716],
      Buchanan: [49107],
      Buckley: [49620],
      Burlington: [49029],
      'Burr Oak': [49030],
      Burt: [48417],
      Byron: [48418],
      'Byron Center': [49315],
      Cadillac: [49601],
      Camden: [49232],
      Canton: [48187, 48188],
      Carland: [48831],
      Carleton: [48117],
      Carney: [49812],
      Caro: [48723],
      'Carp Lake': [49718],
      'Carson City': [48811],
      Carsonville: [48419],
      Caseville: [48725],
      Casnovia: [49318],
      'Cass City': [48726],
      Cassopolis: [49031],
      Cedar: [49621],
      'Cedar River': [49813],
      'Cedar Springs': [49319],
      Cedarville: [49719],
      'Cement City': [49233],
      'Center Line': [48015],
      'Central Lake': [49622],
      Centreville: [49032],
      Ceresco: [49033],
      Champion: [49814],
      Channing: [49815],
      Charlevoix: [49720],
      Charlotte: [48813],
      Chase: [49623],
      Chassell: [49916],
      Cheboygan: [49721],
      Chelsea: [48118],
      Chesaning: [48616],
      Chesterfield: [48047],
      Christmas: [49862],
      Clare: [48617],
      Clarklake: [49234],
      Clarksville: [48815],
      Clawson: [48017],
      Clayton: [49235],
      Clifford: [48727],
      Climax: [49034],
      Clinton: [49236],
      Clio: [48420],
      Coldwater: [49036],
      Coleman: [48618],
      Coloma: [49038],
      Colon: [49040],
      Columbiaville: [48421],
      Comins: [48619],
      'Commerce Townshi': [48382],
      'Comstock Park': [49321],
      Concord: [49237],
      Conklin: [49403],
      Constantine: [49042],
      Cooks: [49817],
      Coopersville: [49404],
      Copemish: [49625],
      Coral: [49322],
      Cornell: [49818],
      Corunna: [48817],
      Cottrellville: [48039],
      Covert: [49043],
      Covington: [49919],
      Croswell: [48422],
      Crystal: [48818],
      'Crystal Falls': [49920],
      Curran: [48728],
      Curtis: [49820],
      Custer: [49405],
      Dafter: [49724],
      Daggett: [49821],
      Dansville: [48819],
      Davison: [48423],
      'De Tour Village': [49725],
      Dearborn: [48120, 48124, 48126, 48128],
      'Dearborn Heights': [48125, 48127],
      Decatur: [49045],
      Decker: [48426],
      Deckerville: [48427],
      Deerfield: [49238],
      Deerton: [49822],
      Deford: [48729],
      Delton: [49046],
      Detroit: [
        48201, 48202, 48204, 48205, 48206, 48207, 48208, 48209, 48210, 48211,
        48213, 48214, 48215, 48216, 48217, 48219, 48221, 48223, 48224, 48226,
        48227, 48228, 48234, 48235, 48238, 48242,
      ],
      'Detroit Beach': [48161],
      Dewitt: [48820],
      Dexter: [48130],
      Dimondale: [48821],
      Dodgeville: [49921],
      Dorr: [49323],
      Dowagiac: [49047],
      Dowling: [49050],
      'Drummond Island': [49726],
      Dryden: [48428],
      Dundee: [48131],
      Durand: [48429],
      Dutton: [49316],
      Eagle: [48822],
      'Eagle Harbor': [49950],
      'East Jordan': [49727],
      'East Lansing': [48823],
      'East Leroy': [49051],
      'East Tawas': [48730],
      Eastpointe: [48021],
      'Eaton Rapids': [48827],
      'Eau Claire': [49111],
      'Eben Junction': [49825],
      Eckerman: [49728],
      Ecorse: [48229],
      Edenville: [48620],
      Edmore: [48829],
      Edwardsburg: [49112],
      'Elk Rapids': [49629],
      Elkton: [48731],
      Ellsworth: [49729],
      Elmira: [49730],
      Elwell: [48832],
      Emmett: [48022],
      Empire: [49630],
      Engadine: [49827],
      Erie: [48133],
      Escanaba: [49829],
      Essexville: [48732],
      Evart: [49631],
      Ewen: [49925],
      Fairgrove: [48733],
      Fairview: [48621],
      Falmouth: [49632],
      'Farmington Hills': [48331, 48334, 48335, 48336],
      Farwell: [48622],
      Fennville: [49408],
      Fenton: [48430],
      Fenwick: [48834],
      Ferndale: [48220],
      Fibre: [49780],
      'Fife Lake': [49633],
      Filion: [48432],
      'Flat Rock': [48134],
      Flint: [48502, 48503, 48505, 48507],
      Flushing: [48433],
      'Foster City': [49834],
      Fostoria: [48435],
      Fountain: [49410],
      Fowler: [48835],
      Fowlerville: [48836],
      Frankenmuth: [48734],
      Frankfort: [49635],
      Franklin: [48025],
      Fraser: [48026],
      Frederic: [49733],
      'Free Soil': [49411],
      Freeland: [48623],
      Freeport: [49325],
      Fremont: [49412],
      Fruitport: [49415],
      Fulton: [49052],
      Gaastra: [49927],
      Gagetown: [48735],
      Gaines: [48436],
      Galesburg: [49053],
      Galien: [49113],
      Garden: [49835],
      'Garden City': [48135],
      Gay: [49945],
      Gaylord: [49735],
      Germfask: [49836],
      Gibraltar: [48173],
      Gladwin: [48624],
      'Glen Arbor': [49636],
      Glennie: [48737],
      Gobles: [49055],
      Goetzville: [49736],
      Goodrich: [48438],
      'Gould City': [49838],
      Gowen: [49326],
      'Grand Beach': [49117],
      'Grand Blanc': [48439],
      'Grand Haven': [49417],
      'Grand Junction': [49056],
      'Grand Ledge': [48837],
      'Grand Marais': [49839],
      'Grand Rapids': [49503, 49505, 49506, 49507, 49546],
      Grandville: [49418],
      Grant: [49327],
      'Grant Township': [48032],
      'Grass Lake': [49240],
      Grawn: [49637],
      Grayling: [49738],
      Greenbush: [48738],
      Greenville: [48838],
      Greenwood: [48006],
      Gregory: [48137],
      'Grosse Ile': [48138],
      'Grosse Pointe': [48230, 48236],
      Gulliver: [49840],
      Hale: [48739],
      Hamilton: [49419],
      Hamtramck: [48212],
      Hancock: [49930],
      Hanover: [49241],
      'Harbor Beach': [48441],
      'Harbor Point': [49740],
      Hardwood: [49807],
      'Harper Woods': [48225],
      Harrietta: [49638],
      Harrison: [48625],
      Harrisville: [48740],
      'Harsens Island': [48028],
      Hart: [49420],
      Hartford: [49057],
      Hartland: [48353],
      Haslett: [48840],
      Hastings: [49058],
      Hawks: [49743],
      'Hazel Park': [48030],
      Hemlock: [48626],
      Henderson: [48841],
      Hermansville: [49847],
      Herron: [49744],
      Hersey: [49639],
      Hesperia: [49421],
      'Hickory Corners': [49060],
      Highland: [48356, 48357],
      'Highland Park': [48203],
      Hillman: [49746],
      Hillsdale: [49242],
      Holland: [49423, 49424],
      Holly: [48442],
      Holt: [48842],
      Holton: [49425],
      Homer: [49245],
      Honor: [49640],
      Hope: [48628],
      Hopkins: [49328],
      Horton: [49246],
      Houghton: [49931],
      'Houghton Lake': [48629],
      'Howard City': [49329],
      Howell: [48843],
      'Hubbard Lake': [49747],
      Hubbardston: [48845],
      Hudson: [49247],
      Hudsonville: [49426],
      'Huntington Woods': [48070],
      Ida: [48140],
      Idlewild: [49642],
      'Imlay City': [48444],
      Independence: [48346, 48348],
      'Indian River': [49749],
      Ingalls: [49848],
      Inkster: [48141],
      Interlochen: [49643],
      Ionia: [48846],
      Ira: [48023],
      'Iron Mountain': [49801],
      'Iron River': [49935],
      Irons: [49644],
      Ironwood: [49938],
      Ithaca: [48847],
      Jackson: [49201, 49202, 49203],
      Jasper: [49248],
      Jenison: [49428],
      Jerome: [49249],
      Johannesburg: [49751],
      Jones: [49061],
      Jonesville: [49250],
      'K I Sawyer A F B': [49843],
      Kalamazoo: [49001, 49002, 49007, 49008, 49009],
      Kaleva: [49645],
      Kalkaska: [49646],
      Karlin: [49647],
      Kawkawlin: [48631],
      'Kent City': [49330],
      Kenton: [49943],
      Kentwood: [49508, 49512, 49548],
      Kewadin: [49648],
      'Keweenaw Bay': [49908],
      Kimball: [48074],
      Kincheloe: [49788],
      Kinde: [48445],
      Kingsley: [49649],
      Kingston: [48741],
      Kinross: [49752],
      'La Salle': [48145],
      Lachine: [49753],
      Laingsburg: [48848],
      Lake: [48632],
      'Lake Ann': [49650],
      'Lake Leelanau': [49653],
      'Lake Odessa': [48849],
      Lakeside: [49116],
      Lakeview: [48850],
      Lambertville: [48144],
      Lanse: [49946],
      Lansing: [48906, 48910, 48911, 48912, 48915, 48917, 48933],
      Lapeer: [48446],
      'Lathrup Village': [48076],
      Laurium: [49913],
      Lawrence: [49064],
      Lawton: [49065],
      Leland: [49654],
      Lennon: [48449],
      Lenox: [48048],
      Leonidas: [49066],
      Leroy: [49655],
      Leslie: [49251],
      Levering: [49755],
      Lewiston: [49756],
      Lexington: [48450],
      Limestone: [49816],
      Lincoln: [48742],
      'Lincoln Park': [48146],
      Linden: [48451],
      Linwood: [48634],
      Litchfield: [49252],
      'Little Lake': [49833],
      Livonia: [48150, 48152, 48154],
      'Long Lake': [48743],
      Lowell: [49331],
      Ludington: [49431],
      'Luna Pier': [48157],
      Lupton: [48635],
      Luther: [49656],
      Luzerne: [48636],
      Lyons: [48851],
      'Mackinac Island': [49757],
      Macomb: [48044],
      'Madison Heights': [48071],
      Mancelona: [49659],
      Manchester: [48158],
      'Manitou Beach': [49253],
      Manton: [49663],
      'Maple City': [49664],
      Marcellus: [49067],
      Marenisco: [49947],
      Marion: [49665],
      Marlette: [48453],
      Marne: [49435],
      Marshall: [49068],
      Martin: [49070],
      Marysville: [48040],
      Mason: [48854],
      'Mass City': [49948],
      Mattawan: [49071],
      Maybee: [48159],
      Mayville: [48744],
      'Mc Bain': [49657],
      'Mc Millan': [49853],
      Mears: [49436],
      Mecosta: [49332],
      Melvin: [48454],
      Melvindale: [48122],
      Mendon: [49072],
      Menominee: [49858],
      Merrill: [48637],
      Merritt: [49667],
      Mesick: [49668],
      Metamora: [48455],
      Michigamme: [49861],
      'Michigan Center': [49254],
      Middleton: [48856],
      Middleville: [49333],
      Midland: [48640, 48642],
      Mikado: [48745],
      Milan: [48160],
      Milford: [48380, 48381],
      Millersburg: [49759],
      Millington: [48746],
      'Minden City': [48456],
      Mio: [48647],
      Montague: [49437],
      Montgomery: [49255],
      Montrose: [48457],
      Moorestown: [49651],
      Moran: [49760],
      Morenci: [49256],
      Morley: [49336],
      Morrice: [48857],
      'Mount Clemens': [48043],
      'Mount Morris': [48458],
      'Mount Pleasant': [48858],
      Muir: [48860],
      Mulliken: [48861],
      Munger: [48747],
      Munith: [49259],
      Muskegon: [49440, 49441, 49442],
      'Muskegon Heights': [49444],
      Mussey: [48014],
      Nashville: [49073],
      'National City': [48748],
      Naubinway: [49762],
      Negaunee: [49866],
      'New Boston': [48164],
      'New Era': [49446],
      'New Hudson': [48165],
      'New Lothrop': [48460],
      'New Richmond': [49447],
      Newaygo: [49337],
      Newberry: [49868],
      Newport: [48166],
      Niles: [49120],
      Nisula: [49952],
      'North Adams': [49262],
      'North Branch': [48461],
      'North Lake': [49849],
      'North Muskegon': [49445],
      Northeast: [48506, 48509],
      Northport: [49670],
      Northville: [48167],
      Northwest: [48504, 48532],
      Norway: [49870],
      Novi: [48374, 48375, 48377],
      Nunica: [49448],
      'Oak Park': [48237],
      Oakland: [48363],
      Oakley: [48649],
      Okemos: [48864],
      Olivet: [49076],
      Omer: [48749],
      Onaway: [49765],
      Onekama: [49675],
      Onondaga: [49264],
      Onsted: [49265],
      Ontonagon: [49953],
      'Orchard Lake': [48323, 48324],
      Orion: [48359, 48360, 48362],
      Orleans: [48865],
      Ortonville: [48462],
      Oscoda: [48750],
      Osseo: [49266],
      Ossineke: [49766],
      Otisville: [48463],
      Otsego: [49078],
      'Ottawa Lake': [49267],
      'Otter Lake': [48464],
      Ovid: [48866],
      Owendale: [48754],
      Owosso: [48867],
      Oxford: [48370, 48371],
      Palms: [48465],
      Palmyra: [49268],
      Paradise: [49768],
      Parchment: [49004],
      Paris: [49338],
      Parma: [49269],
      'Paw Paw': [49079],
      'Pearl Beach': [48001],
      Peck: [48466],
      Pelkie: [49958],
      Pellston: [49769],
      Pentwater: [49449],
      Perrinton: [48871],
      Perronville: [49873],
      Perry: [48872],
      Petersburg: [49270],
      Pewamo: [48873],
      Pickford: [49774],
      Pierson: [49339],
      Pigeon: [48755],
      Pinckney: [48169],
      Pinconning: [48650],
      Pittsford: [49271],
      Plainwell: [49080],
      'Pleasant Lake': [49272],
      'Pleasant Ridge': [48069],
      Plymouth: [48170],
      'Pointe Aux Pins': [49775],
      Pontiac: [48340, 48341, 48342],
      'Port Austin': [48467],
      'Port Hope': [48468],
      'Port Huron': [48060],
      'Port Sanilac': [48469],
      Portland: [48875],
      Posen: [49776],
      Potterville: [48876],
      Powers: [49874],
      Prescott: [48756],
      Princeton: [49841],
      Prudenville: [48651],
      Pullman: [49450],
      Quincy: [49082],
      Quinnesec: [49876],
      Raco: [49715],
      'Rapid City': [49676],
      'Rapid River': [49878],
      Ravenna: [49451],
      Reading: [49274],
      Redford: [48239, 48240],
      'Reed City': [49677],
      Reese: [48757],
      Remus: [49340],
      Republic: [49879],
      Rhodes: [48652],
      Richland: [49083],
      Richmond: [48062],
      Ridgeway: [49275],
      Riga: [49276],
      Riley: [48041],
      'River Rouge': [48218],
      Riverdale: [48877],
      Riverview: [48192],
      'Rives Junction': [49277],
      'Rochester Hills': [48306, 48307, 48309],
      Rock: [49880],
      Rockford: [49341],
      Rodney: [49342],
      'Rogers City': [49779],
      Romulus: [48174],
      Roscommon: [48653],
      'Rose City': [48654],
      Rosebush: [48878],
      Roseville: [48066],
      Rothbury: [49452],
      'Royal Oak': [48067, 48073],
      Ruby: [48049],
      Rumely: [49826],
      Ruth: [48470],
      Saginaw: [48601, 48602, 48603, 48604, 48607],
      Sagola: [49881],
      'Saint Charles': [48655],
      'Saint Clair': [48079],
      'Saint Clair Shor': [48080, 48081, 48082],
      'Saint Helen': [48656],
      'Saint Ignace': [49781],
      'Saint James': [49782],
      'Saint Johns': [48879],
      'Saint Joseph': [49085],
      'Saint Louis': [48880],
      Saline: [48176],
      'Sand Creek': [49279],
      'Sand Lake': [49343],
      Sandusky: [48471],
      Sanford: [48657],
      Saranac: [48881],
      Saugatuck: [49453],
      'Sault Sainte Mar': [49783],
      Sawyer: [49125],
      Schoolcraft: [49087],
      Scotts: [49088],
      Scottville: [49454],
      Sears: [49679],
      Sebewaing: [48759],
      'Selfridge A N G': [48045],
      Seney: [49883],
      Shelby: [49455],
      'Shelby Township': [48315, 48316, 48317],
      Shelbyville: [49344],
      Shepherd: [48883],
      Sheridan: [48884],
      Sherwood: [49089],
      Shingleton: [49884],
      Sidney: [48885],
      Silverwood: [48760],
      'Six Lakes': [48886],
      Skandia: [49885],
      Skanee: [49962],
      Snover: [48472],
      Sodus: [49126],
      Somerset: [49281],
      'South Boardman': [49680],
      'South Branch': [48761],
      'South Haven': [49090],
      'South Lyon': [48178],
      'South Rockwood': [48179],
      Southeast: [48519, 48529],
      Southfield: [48034, 48075],
      Southgate: [48195],
      Spalding: [49886],
      Sparta: [49345],
      'Spring Arbor': [49283],
      'Spring Lake': [49456],
      Springfield: [48350],
      Springport: [49284],
      Spruce: [48762],
      Stalwart: [49789],
      Standish: [48658],
      Stanton: [48888],
      Stanwood: [49346],
      Stephenson: [49887],
      Sterling: [48659],
      'Sterling Heights': [48310, 48312, 48313, 48314],
      Stevensville: [49127],
      Stockbridge: [49285],
      Stronach: [49660],
      Sturgis: [49091],
      Sumner: [48889],
      Sunfield: [48890],
      'Suttons Bay': [49682],
      'Swartz Creek': [48473],
      'Sylvan Lake': [48320],
      'Tawas City': [48763],
      Taylor: [48180],
      Tecumseh: [49286],
      Tekonsha: [49092],
      Temperance: [48182],
      Thompson: [49854],
      Thompsonville: [49683],
      'Three Oaks': [49128],
      'Three Rivers': [49093],
      Tipton: [49287],
      Toivola: [49965],
      Tower: [49792],
      Traunik: [49890],
      'Traverse City': [49684],
      Trenary: [49891],
      'Trout Creek': [49967],
      Troy: [48083, 48084, 48098],
      Trufant: [49347],
      Turner: [48765],
      Tustin: [49688],
      'Twin Lake': [49457],
      Twining: [48766],
      Ubly: [48475],
      Union: [49130],
      'Union City': [49094],
      'Union Pier': [49129],
      Unionville: [48767],
      'University Cente': [48706],
      Vandalia: [49095],
      Vanderbilt: [49795],
      Vassar: [48768],
      Vermontville: [49096],
      Vestaburg: [48891],
      Vicksburg: [49097],
      Vulcan: [49892],
      Wakefield: [49968],
      Waldron: [49288],
      Wales: [48027],
      Walker: [49504],
      Walkerville: [49459],
      Wallace: [49893],
      Warren: [48089, 48091, 48092, 48093],
      Washington: [48094],
      Waterford: [48327, 48328, 48329],
      Watersmeet: [49969],
      Watervliet: [49098],
      Watton: [49970],
      Wayland: [49348],
      Wayne: [48184],
      Webberville: [48892],
      Weidman: [48893],
      Wells: [49894],
      Wellston: [49689],
      'West Bloomfield': [48322],
      'West Branch': [48661],
      'West Olive': [49460],
      Westland: [48185],
      Westphalia: [48894],
      Wetmore: [49895],
      Wheeler: [48662],
      'White Cloud': [49349],
      'White Lake': [48383, 48386],
      'White Pigeon': [49099],
      Whitehall: [49461],
      'Whitmore Lake': [48189],
      Whittemore: [48770],
      Williamsburg: [49690],
      Williamston: [48895],
      Willis: [48191],
      Wilson: [49896],
      Wixom: [48393],
      Wolverine: [49799],
      'Wolverine Lake': [48390],
      Woodhaven: [48183],
      Woodland: [48897],
      Wyoming: [49509],
      Ypsilanti: [48197, 48198],
      Zeeland: [49464],
    },
    name: 'Michigan',
  },
  MN: {
    cities: {
      55048: [55048],
      55755: [55755],
      56130: [56130],
      56135: [56135],
      56290: [56290],
      56625: [56625],
      Adams: [55909],
      Adrian: [56110],
      Afton: [55001],
      Aitkin: [56431],
      Akeley: [56433],
      Albany: [56307],
      'Albert Lea': [56007],
      Alberta: [56207],
      Albertville: [55301],
      Alborn: [55702],
      Alden: [56009],
      Aldrich: [56434],
      Alexandria: [56308],
      Alpha: [56111],
      Altura: [55910],
      Alvarado: [56710],
      Amboy: [56010],
      Amiret: [56112],
      'Angle Inlet': [56711],
      Angora: [55703],
      Angus: [56712],
      Annandale: [55302],
      'Apple Valley': [55124],
      Appleton: [56208],
      Arco: [56113],
      Argyle: [56713],
      Arlington: [55307],
      Ashby: [56309],
      Askov: [55704],
      Atwater: [56209],
      Audubon: [56511],
      Aurora: [55705],
      Austin: [55912],
      Avoca: [56114],
      Avon: [56310],
      Babbitt: [55706],
      Backus: [56435],
      Badger: [56714],
      Bagley: [56621],
      Baker: [56513],
      Balaton: [56115],
      Barnum: [55707],
      Barrett: [56311],
      Barry: [56210],
      'Battle Lake': [56515],
      Baudette: [56623],
      Bayport: [55003],
      Beardsley: [56211],
      'Beaver Creek': [56116],
      Becker: [55308],
      Bejou: [56516],
      Belgrade: [56312],
      'Belle Plaine': [56011],
      Bellingham: [56212],
      Beltrami: [56517],
      Belview: [56214],
      Bemidji: [56601],
      Bena: [56626],
      Benson: [56215],
      Beroun: [55063],
      Bertha: [56437],
      'Big Falls': [56627],
      'Big Lake': [55309],
      Bigelow: [56117],
      Bigfork: [56628],
      'Bingham Lake': [56118],
      Birchdale: [56629],
      'Bird Island': [55310],
      Blackduck: [56630],
      Blaine: [55434],
      'Blooming Prairie': [55917],
      Bloomington: [55420, 55425, 55431, 55437, 55438],
      'Blue Earth': [56013],
      Bluffton: [56518],
      Bock: [56313],
      Borup: [56519],
      Bovey: [55709],
      Bowlus: [56314],
      'Boy River': [56632],
      Boyd: [56218],
      Braham: [55006],
      Brandon: [56315],
      Breckenridge: [56520],
      Brewster: [56119],
      Bricelyn: [56014],
      Brimson: [55602],
      Britt: [55710],
      'Brooklyn Center': [55429, 55430, 55443, 55444],
      'Brooklyn Park': [55445],
      Brooks: [56715],
      Brookston: [55711],
      Brooten: [56316],
      Browerville: [56438],
      'Browns Valley': [56219],
      Brownsdale: [55918],
      Brownsville: [55919],
      Brownton: [55312],
      Bruno: [55712],
      Buffalo: [55313],
      'Buffalo Lake': [55314],
      Burnsville: [55337],
      Burtrum: [56318],
      Butterfield: [56120],
      Buyck: [55771],
      Byron: [55920],
      Caledonia: [55921],
      Callaway: [56521],
      Cambridge: [55008],
      Canby: [56220],
      'Cannon Falls': [55009],
      Canton: [55922],
      Canyon: [55717],
      Carlisle: [56537],
      Carlos: [56319],
      Carlton: [55718],
      Carver: [55315],
      'Cass Lake': [56633],
      'Castle Rock': [55010],
      'Cedar East Bethe': [55011],
      Centerville: [55038],
      Ceylon: [56121],
      Champlin: [55316],
      Chandler: [56122],
      Chanhassen: [55317],
      Chaska: [55318],
      Chatfield: [55923],
      'Chisago City': [55013],
      Chisholm: [55719],
      Chokio: [56221],
      'Circle Pines': [55014],
      'Clara City': [56222],
      Claremont: [55924],
      Clarissa: [56440],
      Clarkfield: [56223],
      'Clarks Grove': [56016],
      'Clear Lake': [55319],
      Clearbrook: [56634],
      Clearwater: [55320],
      Clements: [56224],
      Cleveland: [56017],
      Clinton: [56225],
      Clitherall: [56524],
      Clontarf: [56226],
      Cloquet: [55720],
      Cohasset: [55721],
      Cokato: [55321],
      'Cold Spring': [56320],
      Cologne: [55322],
      'Columbia Heights': [55421],
      Comfrey: [56019],
      Comstock: [56525],
      Conger: [56020],
      Cook: [55723],
      'Coon Rapids': [55433, 55448],
      Correll: [56227],
      Cosmos: [56228],
      'Cottage Grove': [55016],
      Cottonwood: [56229],
      Courtland: [56021],
      'Crane Lake': [55725],
      Cromwell: [55726],
      Crookston: [56716],
      Crosby: [56441],
      Crosslake: [56442],
      Crystal: [55428],
      Culver: [55727],
      Currie: [56123],
      Cushing: [56443],
      Cyrus: [56323],
      Dakota: [55925],
      Dalbo: [55017],
      Dalton: [56324],
      Danube: [56230],
      Danvers: [56231],
      Darfur: [56022],
      Darwin: [55324],
      Dassel: [55325],
      Dawson: [56232],
      Dayton: [55327],
      'De Graff': [56233],
      'Deer Creek': [56527],
      'Deer River': [56636],
      Deerwood: [56444],
      Delano: [55328],
      Delavan: [56023],
      Delft: [56124],
      Delhi: [56283],
      Dent: [56528],
      'Detroit Lakes': [56501],
      Dexter: [55926],
      Dilworth: [56529],
      'Dodge Center': [55927],
      Donaldson: [56720],
      Donnelly: [56235],
      Doran: [56522],
      Dover: [55929],
      Dovray: [56125],
      Downer: [56514],
      Duluth: [55801, 55802, 55803, 55804, 55805, 55806, 55807, 55808, 55812],
      Dumont: [56236],
      Dundas: [55019],
      Dundee: [56126],
      Dunnell: [56127],
      Eagan: [55120, 55121, 55122, 55123],
      'Eagle Bend': [56446],
      'Eagle Lake': [56024],
      'East Bethel': [55005, 55092],
      'East Grand Forks': [56721],
      'East Gull Lake': [56401],
      Easton: [56025],
      Echo: [56237],
      'Eden Prairie': [55343, 55344, 55346, 55347],
      'Eden Valley': [55329],
      Edgerton: [56128],
      Edina: [55410, 55424, 55435, 55436, 55439],
      Effie: [56639],
      'Elbow Lake': [56531],
      Eldred: [56523],
      Elgin: [55932],
      Elizabeth: [56533],
      'Elk River': [55330],
      Elko: [55020],
      Elkton: [55933],
      Ellendale: [56026],
      Ellsworth: [56129],
      Elmore: [56027],
      Ely: [55731],
      Elysian: [56028],
      Embarrass: [55732],
      Emily: [56447],
      Emmons: [56029],
      Erhard: [56534],
      Erskine: [56535],
      Esko: [55733],
      Essig: [56030],
      Euclid: [56722],
      Evan: [56238],
      Evansville: [56326],
      Eveleth: [55734],
      Excelsior: [55331],
      Fairfax: [55332],
      Fairmont: [56031],
      Faribault: [55021],
      Farmington: [55024],
      Farwell: [56327],
      'Federal Dam': [56641],
      Felton: [56536],
      Fertile: [56540],
      'Fifty Lakes': [56448],
      Finland: [55603],
      Finlayson: [55735],
      Fisher: [56723],
      Flensburg: [56328],
      Floodwood: [55736],
      Florence: [56170],
      Foley: [56329],
      'Forest Lake': [55025],
      Foreston: [56330],
      'Fort Ripley': [56449],
      'Fort Snelling': [55111],
      Fosston: [56542],
      Fountain: [55935],
      Foxhome: [56543],
      Franklin: [55333],
      Frazee: [56544],
      Freeborn: [56032],
      Freeport: [56331],
      Fridley: [55432],
      Frontenac: [55026],
      Frost: [56033],
      Fulda: [56131],
      'Garden City': [56034],
      Garfield: [56332],
      Garrison: [56450],
      Garvin: [56132],
      Gary: [56545],
      Gatzke: [56724],
      Gaylord: [55334],
      Geneva: [56035],
      Georgetown: [56546],
      Gheen: [55740],
      Ghent: [56239],
      Gibbon: [55335],
      Gilbert: [55741],
      Gilman: [56333],
      Glencoe: [55336],
      Glenville: [56036],
      Glenwood: [56334],
      Glyndon: [56547],
      'Golden Valley': [55427],
      Gonvick: [56644],
      'Good Thunder': [56037],
      Goodhue: [55027],
      Goodland: [55742],
      Goodridge: [56725],
      Goodview: [55987],
      Graceville: [56240],
      Granada: [56039],
      'Grand Marais': [55604],
      'Grand Meadow': [55936],
      'Grand Portage': [55605],
      Granger: [55937],
      'Granite Falls': [56241],
      Grasston: [55030],
      'Green Isle': [55338],
      Greenbush: [56726],
      'Grey Eagle': [56336],
      'Grove City': [56243],
      Grygla: [56727],
      Gully: [56646],
      Hackensack: [56452],
      Hadley: [56133],
      Hallock: [56728],
      Halma: [56729],
      Halstad: [56548],
      'Ham Lake': [55304],
      Hamburg: [55339],
      Hamel: [55340],
      Hammond: [55991],
      Hampton: [55031],
      Hancock: [56244],
      'Hanley Falls': [56245],
      Hanska: [56041],
      Hardwick: [56134],
      Harmony: [55939],
      Harris: [55032],
      Hartland: [56042],
      Hatfield: [56164],
      Hawick: [56246],
      Hayfield: [55940],
      Hayward: [56043],
      'Hazel Run': [56247],
      Hector: [55342],
      Henderson: [56044],
      Hendricks: [56136],
      Hendrum: [56550],
      Henning: [56551],
      Herman: [56248],
      Hermantown: [55811],
      'Heron Lake': [56137],
      Hewitt: [56453],
      Hibbing: [55746],
      'Hill City': [55748],
      Hillman: [56338],
      Hills: [56138],
      Hinckley: [55037],
      Hines: [56647],
      Hitterdal: [56552],
      Hoffman: [56339],
      Hokah: [55941],
      Holdingford: [56340],
      Holland: [56139],
      Hollandale: [56045],
      Holloway: [56249],
      'Holmes City': [56341],
      Holyoke: [55749],
      Hope: [56046],
      Houston: [55943],
      Hovland: [55606],
      'Howard Lake': [55349],
      'Hoyt Lakes': [55750],
      Huntley: [56047],
      Hutchinson: [55350],
      'International Fa': [56649],
      'Inver Grove Heig': [55076, 55077],
      Iona: [56141],
      Iron: [55751],
      Ironton: [56455],
      Isabella: [55607],
      Isanti: [55040],
      Isle: [56342],
      Ivanhoe: [56142],
      Jackson: [56143],
      Jacobson: [55752],
      Janesville: [56048],
      Jasper: [56144],
      Jeffers: [56145],
      Jenkins: [56456],
      Johnson: [56250],
      Jordan: [55352],
      Kanaranzi: [56146],
      Kandiyohi: [56251],
      Karlstad: [56732],
      Kasota: [56050],
      Kasson: [55944],
      Kelliher: [56650],
      Kelsey: [55724],
      Kennedy: [56733],
      Kenneth: [56147],
      Kensington: [56343],
      Kent: [56553],
      Kenyon: [55946],
      Kerkhoven: [56252],
      Kerrick: [55756],
      'Kettle River': [55757],
      Kiester: [56051],
      Kilkenny: [56052],
      Kimball: [55353],
      'La Crescent': [55947],
      'La Prairie': [55744],
      Lafayette: [56054],
      'Lake Benton': [56149],
      'Lake Bronson': [56734],
      'Lake City': [55041],
      'Lake Crystal': [56055],
      'Lake Elmo': [55042],
      'Lake George': [56458],
      'Lake Itasca': [56460],
      'Lake Lillian': [56253],
      'Lake Park': [56554],
      'Lake Shore': [56468],
      'Lake Wilson': [56151],
      Lakefield: [56150],
      Lakeland: [55043],
      Lakeville: [55044],
      Lamberton: [56152],
      Lanesboro: [55949],
      Laporte: [56461],
      Lauderdale: [55108],
      'Le Center': [56057],
      'Le Roy': [55951],
      'Le Sueur': [56058],
      Leader: [56466],
      Lengby: [56651],
      Leonard: [56652],
      Leota: [56153],
      'Lester Prairie': [55354],
      Lewiston: [55952],
      Lewisville: [56060],
      Lindstrom: [55045],
      Lismore: [56155],
      Litchfield: [55355],
      'Little Canada': [55117],
      'Little Falls': [56345],
      'Little Marais': [55614],
      'Little Sauk': [56347],
      Littlefork: [56653],
      Lockhart: [56510],
      Loman: [56654],
      London: [56061],
      'Long Lake': [55356],
      Longville: [56655],
      Loretto: [55357, 55599],
      Louisburg: [56254],
      Lowry: [56349],
      Lucan: [56255],
      Lutsen: [55612],
      Luverne: [56156],
      Lyle: [55953],
      Lynd: [56157],
      Mabel: [55954],
      Madelia: [56062],
      Madison: [56256],
      'Madison Lake': [56063],
      Magnolia: [56158],
      Mahnomen: [56557],
      Mahtowa: [55762],
      Makinen: [55763],
      Manchester: [56064],
      'Manhattan Beach': [56463],
      Mankato: [56001],
      Mantorville: [55955],
      'Maple Grove': [55369],
      'Maple Lake': [55358],
      'Maple Plain': [55359],
      Mapleton: [56065],
      Maplewood: [55119],
      Marcell: [56657],
      Marietta: [56257],
      'Marine On Saint': [55047],
      Markville: [55072],
      Marshall: [56258],
      Max: [56659],
      Mayer: [55360],
      Maynard: [56260],
      Mazeppa: [55956],
      'Mc Grath': [56350],
      'Mc Gregor': [55760],
      Mcintosh: [56556],
      Meadowlands: [55765],
      Medford: [55049],
      Melrose: [56352],
      Melrude: [55766],
      Menahga: [56464],
      Mendota: [55150],
      Mentor: [56736],
      Meriden: [56067],
      Merrifield: [56465],
      'Middle River': [56737],
      Milaca: [56353],
      Milan: [56262],
      Millville: [55957],
      Milroy: [56263],
      Miltona: [56354],
      Minneapolis: [
        55401, 55402, 55403, 55404, 55405, 55406, 55407, 55408, 55409, 55411,
        55412, 55413, 55414, 55415, 55417, 55418, 55419, 55450, 55454, 55455,
      ],
      Minneota: [56264],
      'Minnesota City': [55959],
      'Minnesota Lake': [56068],
      Minnetonka: [55345],
      Mizpah: [56660],
      Montevideo: [56265],
      Montgomery: [56069],
      Monticello: [55362],
      Montrose: [55363],
      Moorhead: [56560],
      'Moose Lake': [55767],
      Mora: [55051],
      Morgan: [56266],
      Morris: [56267],
      Morristown: [55052],
      Morton: [56270],
      Mound: [55364],
      'Mountain Iron': [55768],
      'Mountain Lake': [56159],
      Murdock: [56271],
      Nashua: [56565],
      Nashwauk: [55769],
      Nassau: [56272],
      Naytahwaush: [56566],
      Nelson: [56355],
      Nerstrand: [55053],
      Nevis: [56467],
      'New Auburn': [55366],
      'New Brighton': [55112],
      'New Germany': [55367],
      'New London': [56273],
      'New Prague': [56071],
      'New Richland': [56072],
      'New Ulm': [56073],
      'New York Mills': [56567],
      Newfolden: [56738],
      Newport: [55055],
      Nicollet: [56074],
      Nielsville: [56568],
      Norcross: [56274],
      'North Branch': [55056],
      'North Mankato': [56003],
      'North Saint Paul': [55109],
      Northfield: [55057],
      Northome: [56661],
      Northrop: [56075],
      Norwood: [55368],
      Noyes: [56740],
      'Oak Island': [56741],
      'Oak Park': [56357],
      'Oak Park Heights': [55082],
      Oakdale: [55128],
      Oakland: [56076],
      Odessa: [56276],
      Odin: [56160],
      Ogema: [56569],
      Ogilvie: [56358],
      Okabena: [56161],
      Oklee: [56742],
      Olivia: [56277],
      Onamia: [56359],
      Orleans: [56735],
      Ormsby: [56162],
      Oronoco: [55960],
      Ortonville: [56278],
      Osage: [56570],
      Osakis: [56360],
      Oslo: [56744],
      Ostrander: [55961],
      Otisco: [56077],
      Ottertail: [56571],
      Outing: [56662],
      Owatonna: [55060],
      Palisade: [56469],
      'Park Rapids': [56470],
      'Parkers Prairie': [56361],
      Parkville: [55773],
      Paynesville: [56362],
      Pease: [56363],
      'Pelican Rapids': [56572],
      Pemberton: [56078],
      Pencer: [56751],
      Pengilly: [55775],
      Pennington: [56663],
      Pennock: [56279],
      'Pequot Lakes': [56472],
      Perham: [56573],
      Perley: [56574],
      Peterson: [55962],
      Pierz: [56364],
      Pillager: [56473],
      'Pine Island': [55963],
      'Pine River': [56474],
      Pitt: [56665],
      Plainview: [55964],
      Plato: [55370],
      Plummer: [56748],
      Plymouth: [55441, 55442, 55446, 55447],
      Ponemah: [56666],
      Ponsford: [56575],
      Porter: [56280],
      Preston: [55965],
      Princeton: [55371],
      Prinsburg: [56281],
      'Prior Lake': [55372],
      Proctor: [55810],
      Puposky: [56667],
      Quamba: [55007],
      Racine: [55967],
      Radium: [56762],
      Ramsey: [55303],
      Randall: [56475],
      Randolph: [55065],
      Ranier: [56668],
      Ray: [56669],
      Raymond: [56282],
      Reading: [56165],
      'Red Lake Falls': [56750],
      'Red Wing': [55066],
      Redby: [56670],
      Redlake: [56671],
      Remer: [56672],
      Renville: [56284],
      Revere: [56166],
      Rice: [56367],
      Richfield: [55423],
      Richmond: [56368],
      Richville: [56576],
      Richwood: [56577],
      Robbinsdale: [55422],
      Rochert: [56578],
      Rochester: [55901, 55902, 55904, 55906],
      'Rock Creek': [55067],
      Rockford: [55373],
      Rogers: [55374],
      Rollag: [56549],
      Rollingstone: [55969],
      Roosevelt: [56673],
      'Rose Creek': [55970],
      Rosemount: [55068],
      Roseville: [55113],
      Rothsay: [56579],
      'Round Lake': [56167],
      Royalton: [56373],
      'Rush City': [55069],
      Rushford: [55971],
      Rushmore: [56168],
      Russell: [56169],
      Sabin: [56580],
      'Sacred Heart': [56285],
      Saginaw: [55779],
      'Saint Charles': [55972],
      'Saint Clair': [56080],
      'Saint Cloud': [56301, 56303, 56304],
      'Saint Francis': [55070],
      'Saint Hilaire': [56754],
      'Saint James': [56081],
      'Saint Joseph': [56374],
      'Saint Leo': [56286],
      'Saint Louis Park': [55416, 55426],
      'Saint Michael': [55376],
      'Saint Paul': [55101, 55102, 55103, 55104, 55105, 55106, 55114, 55116],
      'Saint Paul Park': [55071],
      'Saint Peter': [56082],
      'Saint Stephen': [56375],
      'Saint Vincent': [56755],
      Salol: [56756],
      Sanborn: [56083],
      Sargeant: [55973],
      Sartell: [56377],
      'Sauk Centre': [56378],
      'Sauk Rapids': [56379],
      Saum: [56674],
      Savage: [55378],
      Sawyer: [55780],
      Scandia: [55073],
      Schroeder: [55613],
      Seaforth: [56287],
      Sebeka: [56477],
      Sedan: [56380],
      Shafer: [55074],
      Shakopee: [55379],
      Shelly: [56581],
      Sherburn: [56171],
      Shevlin: [56676],
      Shoreview: [55126],
      'Silver Creek': [55380],
      'Silver Lake': [55381],
      Slayton: [56172],
      'Sleepy Eye': [56085],
      Solway: [56678],
      'South Haven': [55382],
      'South Saint Paul': [55075],
      Spicer: [56288],
      'Spring Grove': [55974],
      'Spring Lake': [56680],
      'Spring Park': [55384],
      'Spring Valley': [55975],
      Springfield: [56087],
      'Squaw Lake': [56681],
      Stacy: [55079],
      Stanchfield: [55080],
      Stanton: [55018],
      Staples: [56479],
      Starbuck: [56381],
      Steen: [56173],
      Stephen: [56757],
      Stewart: [55385],
      Stewartville: [55976],
      Storden: [56174],
      Strandquist: [56758],
      Strathcona: [56759],
      'Sturgeon Lake': [55783],
      Sunburg: [56289],
      Svea: [56216],
      'Swan River': [55784],
      Swanville: [56382],
      Swatara: [55785],
      Swift: [56682],
      Talmoon: [56637],
      Tamarack: [55787],
      Taopi: [55977],
      Taunton: [56291],
      'Taylors Falls': [55084],
      Tenney: [56583],
      Tenstrike: [56683],
      Theilman: [55945, 55978],
      'Thief River Fall': [56701],
      Tofte: [55615],
      Togo: [55788],
      Tower: [55790],
      Tracy: [56175],
      Trail: [56684],
      Trimont: [56176],
      Truman: [56088],
      'Twin Lakes': [56089],
      'Twin Valley': [56584],
      'Two Harbors': [55616],
      Tyler: [56178],
      Ulen: [56585],
      Underwood: [56586],
      Upsala: [56384],
      Utica: [55979],
      'Vadnais Heights': [55127],
      Verdi: [56179],
      Vergas: [56587],
      Verndale: [56481],
      'Vernon Center': [56090],
      Veseli: [55046],
      Vesta: [56292],
      Victoria: [55386],
      Viking: [56760],
      Villard: [56385],
      Vining: [56588],
      Viola: [55934],
      Virginia: [55792],
      Wabasha: [55981],
      Wabasso: [56293],
      Waconia: [55387],
      Wadena: [56482],
      Wahkon: [56386],
      'Waite Park': [56387],
      Waldorf: [56091],
      Walker: [56484],
      'Walnut Grove': [56180],
      Walters: [56092],
      Waltham: [55982],
      Wanamingo: [55983],
      Wanda: [56294],
      Wannaska: [56761],
      Warba: [55793],
      Warroad: [56763],
      Warsaw: [55087],
      Waseca: [56093],
      Waskish: [56685],
      Watertown: [55388],
      Waterville: [56096],
      Watkins: [55389],
      Watson: [56295],
      Waubun: [56589],
      Waverly: [55390],
      Wayzata: [55391],
      Webster: [55088],
      Welch: [55033, 55089],
      Welcome: [56181],
      Wells: [56097],
      Wendell: [56590],
      'West Concord': [55985],
      'West Saint Paul': [55107, 55118],
      'West Union': [56389],
      Westbrook: [56183],
      Whalan: [55986],
      Wheaton: [56296],
      Whipholt: [56485],
      'White Bear Lake': [55110, 55115],
      Wilder: [56101],
      Williams: [56686],
      Willmar: [56201],
      'Willow River': [55795],
      Wilmont: [56185],
      Wilton: [56687],
      Winger: [56592],
      Winnebago: [56098],
      Winsted: [55395],
      Winthrop: [55396],
      Wirt: [56688],
      'Wolf Lake': [56593],
      Wolverton: [56594],
      'Wood Lake': [56297],
      Woodbury: [55125],
      Woodstock: [56186],
      Worthington: [56187],
      Wrenshall: [55797],
      Wright: [55798],
      Wykoff: [55990],
      'Young America': [55397],
      Zim: [55799],
      Zimmerman: [55398],
      Zumbrota: [55992],
    },
    name: 'Minnesota',
  },
  MO: {
    cities: {
      63768: [63768],
      63959: [63959],
      64425: [64425],
      65451: [65451],
      65751: [65751],
      Adrian: [64720],
      Advance: [63730],
      Affton: [63123],
      Agency: [64401],
      Albany: [64402],
      Aldrich: [65601],
      Alexandria: [63430],
      Alma: [64001],
      Altamont: [64620],
      Amazonia: [64421],
      Amity: [64422],
      Amoret: [64722],
      Amsterdam: [64723],
      Anabel: [63431],
      Anderson: [64831],
      Annada: [63330],
      Annapolis: [63620],
      Antonia: [63052],
      Anutt: [65540],
      'Appleton City': [64724],
      Arab: [63733],
      Arbela: [63432],
      Arbyrd: [63821],
      Arcadia: [63621],
      Archie: [64725],
      Arcola: [65603],
      Argyle: [65001],
      Armstrong: [65230],
      Arnold: [63010],
      Asbury: [64832],
      'Ash Grove': [65604],
      Ashburn: [63433],
      Ashland: [65010],
      Atlanta: [63530],
      Augusta: [63332],
      Auxvasse: [65231],
      Ava: [65608],
      Avalon: [64621],
      Avilla: [64833],
      Bakersfield: [65609],
      Ballwin: [63021],
      Baring: [63531],
      Barnard: [64423],
      Barnett: [65011],
      Barnhart: [63012],
      'Bates City': [64011],
      Bay: [65041],
      Beaufort: [63013],
      Belgrade: [63622],
      'Bell City': [63735],
      Belle: [65013],
      Belleview: [63623],
      Bellflower: [63333],
      Belton: [64012],
      Bendavis: [65433],
      Benton: [63736],
      'Benton City': [65232],
      Berger: [63014],
      Berkeley: [63134, 63140],
      Bernie: [63822],
      Berryman: [65565],
      Bertrand: [63823],
      Bethany: [64424],
      Bethel: [63434],
      Beulah: [65436],
      Bevier: [63532],
      Bigelow: [64437],
      Billings: [65610],
      'Birch Tree': [65438],
      Bixby: [65439],
      Black: [63625],
      Blackburn: [65321],
      Blackwater: [65322],
      Blackwell: [63626],
      Blairstown: [64726],
      Bland: [65014],
      Bloomfield: [63825],
      Bloomsdale: [63627],
      'Blue Eye': [65611],
      'Blue Springs': [64014],
      Blythedale: [64426],
      Bogard: [64622],
      'Bois D Arc': [65612],
      Bolckow: [64427],
      Bolivar: [65613],
      'Bonne Terre': [63628],
      'Bonnots Mill': [65016],
      Boonville: [65233],
      Boss: [65440],
      Bosworth: [64623],
      Bourbon: [65441],
      'Bowling Green': [63334],
      Bradleyville: [65614],
      'Bragg City': [63827],
      Brandsville: [65688],
      'Branson West': [65737],
      Brashear: [63533],
      Braymer: [64624],
      Breckenridge: [64625],
      Brentwood: [63144],
      Briar: [63931],
      Bridgeton: [63044, 63045],
      Brighton: [65617],
      Brinktown: [65443],
      Brixey: [65618],
      Bronaugh: [64728],
      Brookfield: [64628],
      'Brookline Statio': [65619],
      Broseley: [63932],
      Browning: [64630],
      Brumley: [65017],
      Bruner: [65620],
      Brunswick: [65236],
      Bucklin: [64631],
      Buckner: [64016],
      Bucyrus: [65444],
      Buffalo: [65622],
      Bunceton: [65237],
      Bunker: [63629],
      Burfordville: [63739],
      'Burlington Junct': [64428],
      Butler: [64730],
      Butterfield: [65623],
      Cabool: [65689],
      Cadet: [63630],
      Cainsville: [64632],
      Cairo: [65239],
      Caledonia: [63631],
      Calhoun: [65323],
      California: [65018],
      Callao: [63534],
      Camden: [64017],
      'Camden Point': [64018],
      Camdenton: [65020],
      Cameron: [64429],
      Campbell: [63933],
      Canton: [63435],
      'Cape Fair': [65624],
      'Cape Girardeau': [63701],
      Cardwell: [63829],
      'Carl Junction': [64834],
      Carrollton: [64633],
      Carterville: [64835],
      Carthage: [64836],
      Caruthersville: [63830],
      Cassville: [65625],
      Catawissa: [63015],
      Catron: [63833],
      Caulfield: [65626],
      'Cedar Hill': [63016],
      Cedarcreek: [65627],
      Center: [63436],
      Centertown: [65023],
      Centerview: [64019],
      Centerville: [63633],
      Centralia: [65240],
      Chadwick: [65629],
      Chaffee: [63740],
      Chamois: [65024],
      Charleston: [63834],
      Cherryville: [65446],
      Chesterfield: [63005],
      Chestnutridge: [65630],
      Chilhowee: [64733],
      Chillicothe: [64601],
      Chula: [64635],
      Clarence: [63437],
      Clark: [65243],
      Clarksburg: [65025],
      Clarksdale: [64430],
      Clarksville: [63336],
      Clarkton: [63837],
      Clayton: [63105],
      Clearmont: [64431],
      Cleveland: [64734],
      Clever: [65631],
      'Clifton Hill': [65244],
      'Climax Springs': [65324],
      Clubb: [63934],
      Clyde: [64432],
      Coatsville: [63535],
      Coffey: [64636],
      'Cole Camp': [65325],
      Collins: [64738],
      Columbia: [65201, 65202, 65203],
      Conception: [64433],
      'Conception Junct': [64434],
      Concordia: [64020],
      Conway: [65632],
      'Cook Station': [65449],
      Corder: [64021],
      Corning: [64435],
      Cosby: [64436],
      Couch: [65690],
      Cowgill: [64637],
      Crane: [65633],
      Creighton: [64739],
      Crescent: [63025],
      'Creve Coeur': [63141],
      Crocker: [65452],
      'Cross Timbers': [65634],
      'Crystal City': [63019],
      Cuba: [65453],
      Curryville: [63339],
      Dadeville: [65635],
      Daisy: [63743],
      Dalton: [65246],
      Darlington: [64438],
      Davisville: [65456],
      Dawn: [64638],
      'De Kalb': [64440],
      'De Soto': [63020],
      'De Witt': [64639],
      Dearborn: [64439],
      Deepwater: [64740],
      Deerfield: [64741],
      Defiance: [63341],
      Delta: [63744],
      Denver: [64441],
      'Des Arc': [63636],
      'Des Peres': [63131],
      Desloge: [63601, 63624],
      'Devils Elbow': [65457],
      Dexter: [63841],
      Diamond: [64840],
      Dittmer: [63023],
      Dixon: [65459],
      'Doe Run': [63637],
      Dora: [65637],
      Dover: [64022],
      Downing: [63536],
      Drexel: [64742],
      Drury: [65638],
      Dudley: [63936],
      Dugginsville: [65761],
      Duke: [65461],
      Dunnegan: [65640],
      Durham: [63438],
      'Eagle Rock': [65641],
      Eagleville: [64442],
      'East Prairie': [63845],
      Easton: [64443],
      'Edgar Springs': [65462],
      Edgerton: [64444],
      Edina: [63537],
      Edwards: [65326],
      'El Dorado Spring': [64744],
      Eldon: [65026],
      Eldridge: [65463],
      'Elk Creek': [65464],
      Elkland: [65644],
      Ellington: [63638],
      Ellsinore: [63937],
      Elmer: [63538],
      Elmo: [64445],
      Elsberry: [63343],
      Emden: [63439],
      Eminence: [65466],
      Eolia: [63344],
      Essex: [63846],
      Ethel: [63539],
      Eugene: [65032],
      Eunice: [65468],
      Everton: [65646],
      Ewing: [63440],
      Excello: [65247],
      'Excelsior Spring': [64024],
      Exeter: [65647],
      'Fair Grove': [65648],
      'Fair Play': [65649],
      Fairdealing: [63939],
      Fairfax: [64446],
      Fairview: [64842],
      Falcon: [65470],
      Farber: [63345],
      Farmington: [63640],
      Faucett: [64448],
      Fayette: [65248],
      Fenton: [63026],
      Ferguson: [63135],
      Ferrelview: [64163],
      Festus: [63028],
      Fillmore: [64449],
      Fisk: [63940],
      Flemington: [65650],
      Fletcher: [63030],
      Florence: [65329],
      Florissant: [63031, 63033, 63034],
      Foley: [63347],
      Fordland: [65652],
      'Forest City': [64451],
      Foristell: [63348],
      Forsyth: [65653],
      'Fort Leonard Woo': [65473],
      Fortescue: [64452],
      Fortuna: [65034],
      Foster: [64745],
      'Four Seasons': [65049],
      Frankford: [63441],
      Franklin: [65250],
      Freeburg: [65035],
      Freeman: [64746],
      Freistatt: [65654],
      Fremont: [63941],
      'French Village': [63036],
      Friedheim: [63747],
      Frohna: [63748],
      Fulton: [65251],
      Gainesville: [65655],
      Galena: [65656],
      Gallatin: [64640],
      Galt: [64641],
      'Garden City': [64747],
      Garrison: [65657],
      Gatewood: [63942],
      Gentry: [64453],
      Gerald: [63037],
      Gibbs: [63540],
      Gideon: [63848],
      Gilliam: [65330],
      'Gilman City': [64642],
      Gipsy: [63750],
      Gladstone: [64118],
      Glasgow: [65254],
      Glenallen: [63751],
      Glencoe: [63038],
      Glenwood: [63541],
      Gobler: [63849],
      Golden: [65658],
      'Golden City': [64748],
      Goodman: [64843],
      Goodson: [65659],
      Gorin: [63543],
      Gower: [64454],
      Graff: [65660],
      Graham: [64455],
      'Grain Valley': [64029],
      Granby: [64844],
      'Grand Pass': [65339],
      Grandin: [63943],
      Grandview: [64030],
      'Grant City': [64456],
      Grassy: [63753],
      'Gravois Mills': [65037],
      'Gray Summit': [63039],
      'Green Castle': [63544],
      'Green City': [63545],
      'Green Ridge': [65332],
      Greenfield: [65661],
      Greentop: [63546],
      Greenville: [63944],
      Grover: [63040],
      Grovespring: [65662],
      Guilford: [64457],
      Hale: [64643],
      'Half Way': [65663],
      Hallsville: [65255],
      Hamilton: [64644],
      Hannibal: [63401],
      Hardenville: [65666],
      Hardin: [64035],
      Harris: [64645],
      Harrisburg: [65256],
      Harrisonville: [64701],
      Hartsburg: [65039],
      Hartshorn: [65479],
      Hartville: [65667],
      Harviell: [63945],
      Harwood: [64750],
      Hatfield: [64458],
      'Hawk Point': [63349],
      'Hayti Heights': [63851],
      Hazelwood: [63042],
      Helena: [64459],
      Hemple: [64490],
      Henley: [65040],
      Henrietta: [64036],
      Herculaneum: [63048],
      Hermitage: [65668],
      Higbee: [65257],
      Higginsville: [64037],
      'High Hill': [63350],
      'High Point': [65042],
      'High Ridge': [63049],
      Highlandville: [65669],
      Hillsboro: [63050],
      Hiram: [63947],
      Holcomb: [63852],
      Holden: [64040],
      Holliday: [65258],
      Hollister: [65672],
      Holt: [64048],
      'Holts Summit': [65043],
      Homestown: [63879],
      Hopkins: [64461],
      Hornersville: [63855],
      Horton: [64751],
      'House Springs': [63051],
      Houston: [65483],
      Houstonia: [65333],
      Huggins: [65484],
      Hughesville: [65334],
      Humansville: [65674],
      Humphreys: [64646],
      Hunnewell: [63443],
      Huntsville: [65259],
      Hurdland: [63547],
      Hurley: [65675],
      Iantha: [64759],
      Iberia: [65486],
      Independence: [64050, 64052, 64053, 64055, 64056, 64057, 64058],
      Ionia: [65335],
      'Iron Mountain': [63650],
      Irondale: [63648],
      Isabella: [65676],
      Jackson: [63755],
      Jacksonville: [65260],
      Jadwin: [65501],
      Jameson: [64647],
      Jamesport: [64648],
      Jamestown: [65046],
      Jane: [64856],
      Jasper: [64755],
      'Jefferson City': [65101, 65109],
      Jenkins: [65605],
      Jennings: [63136],
      'Jerico Springs': [64756],
      Jerome: [65529],
      Jonesburg: [63351],
      Joplin: [64801, 64804],
      Kahoka: [63445],
      Kaiser: [65047],
      'Kansas City': [
        64101, 64102, 64105, 64106, 64108, 64109, 64110, 64111, 64112, 64113,
        64114, 64119, 64120, 64123, 64124, 64125, 64126, 64127, 64128, 64129,
        64130, 64131, 64132, 64134, 64136, 64137, 64139, 64145, 64146, 64149,
        64150, 64153, 64154, 64155, 64156, 64157, 64158, 64164, 64165, 64166,
        64167,
      ],
      Kearney: [64060],
      Kennett: [63857],
      Keytesville: [65261],
      Kidder: [64649],
      'Kimberling City': [65686],
      'King City': [64463],
      'Kingdom City': [65262],
      Kingston: [64650],
      Kingsville: [64061],
      Kirbyville: [65679],
      Kirksville: [63501],
      Kirkwood: [63122],
      'Kissee Mills': [65680],
      'Knob Noster': [65336],
      'Knox City': [63446],
      Koeltztown: [65048],
      Koshkonong: [65692],
      'La Belle': [63447],
      'La Grange': [63448],
      'La Monte': [65337],
      'La Plata': [63549],
      'La Russell': [64848],
      Labadie: [63055],
      Laclede: [64651],
      Laddonia: [63352],
      Ladue: [63124],
      'Lake Forest Esta': [63670],
      'Lake Lotawana': [64063],
      'Lake Saint Louis': [63367],
      'Lake Sherwood': [63357],
      'Lake Tapawingo': [64015],
      'Lake Waukomis': [64151],
      'Lake Winnebago': [64034],
      Lampe: [65681],
      Lanagan: [64847],
      Lancaster: [63548],
      Laquey: [65534],
      Laredo: [64652],
      Latham: [65050],
      Lathrop: [64465],
      Latour: [64760],
      Lawson: [64062],
      Leadwood: [63653],
      Leasburg: [65535],
      Lebanon: [65536],
      'Lees Summit': [64064, 64081, 64082],
      Leeton: [64761],
      Lemay: [63125],
      Lenox: [65541],
      Lentner: [63450],
      Leonard: [63451],
      Leopold: [63760],
      Leslie: [63056],
      Lesterville: [63654],
      Lewistown: [63452],
      Lexington: [64067],
      Liberal: [64762],
      Licking: [65542],
      Lilbourn: [63862],
      Lincoln: [65338],
      Linn: [65051],
      'Linn Creek': [65052],
      Linneus: [64653],
      Livonia: [63551],
      'Lock Springs': [64654],
      Lockwood: [65682],
      Lodi: [63950],
      Lohman: [65053],
      'Lone Jack': [64070],
      Lonedell: [63060],
      'Long Lane': [65590],
      'Loose Creek': [65054],
      Louisburg: [65685],
      Louisiana: [63353],
      Lowndes: [63951],
      'Lowry City': [64763],
      Lucerne: [64655],
      Ludlow: [64656],
      Luebbering: [63061],
      Luray: [63453],
      Lynchburg: [65543],
      'Macks Creek': [65786],
      Macomb: [65702],
      Macon: [63552],
      Madison: [65263],
      Maitland: [64466],
      Malden: [63863],
      Manchester: [63011],
      Mansfield: [65704],
      Maplewood: [63143],
      Marceline: [64658],
      Marionville: [65705],
      Marquand: [63655],
      Marshfield: [65706],
      Marston: [63866],
      'Martin City': [64147],
      Martinsburg: [65264],
      Martinsville: [64467],
      'Marvel Cave Park': [65616],
      'Maryland Heights': [63043],
      Maryville: [64468],
      Matthews: [63867],
      Maysville: [64469],
      Mayview: [64071],
      Maywood: [63454],
      'Mc Clurg': [65701],
      'Mc Fall': [64657],
      'Mc Gee': [63763],
      Meadville: [64659],
      Memphis: [63555],
      Mendon: [64660],
      Mercer: [64661],
      Meta: [65058],
      Mexico: [65265],
      Miami: [65344],
      'Middle Brook': [63656],
      Middletown: [63359],
      Milan: [63556],
      'Mill Spring': [63952],
      Millcreek: [63645],
      Miller: [65707],
      Millersville: [63766],
      Milo: [64767],
      Mindenmines: [64769],
      'Mineral Point': [63660],
      Moberly: [65270],
      Mokane: [65059],
      Monett: [65708],
      'Monroe City': [63456],
      'Montgomery City': [63361],
      Monticello: [63457],
      Montreal: [65591],
      Montrose: [64770],
      Moody: [65777],
      Mooresville: [64664],
      Mora: [65345],
      Morehouse: [63868],
      Morrison: [65061],
      Morrisville: [65710],
      'Moscow Mills': [63362],
      'Mound City': [64470],
      Moundville: [64771],
      'Mount Moriah': [64665],
      'Mount Sterling': [65062],
      'Mount Vernon': [65712],
      'Mountain Grove': [65711],
      'Mountain View': [65548],
      Myrtle: [65778],
      Napoleon: [64074],
      Napton: [65340],
      Naylor: [63953],
      Neelyville: [63954],
      Nelson: [65347],
      Neosho: [64850],
      Nevada: [64772],
      'New Bloomfield': [65063],
      'New Boston': [63557],
      'New Cambria': [63558],
      'New Florence': [63363],
      'New Franklin': [65274],
      'New Hampton': [64471],
      'New Hartford': [63364],
      'New Haven': [63068],
      'New London': [63459],
      'New Madrid': [63869],
      'New Wells': [63732],
      Newark: [63458],
      Newburg: [65550],
      Newtown: [64667],
      Niangua: [65713],
      Nixa: [65714],
      Noble: [65715],
      Noel: [64854],
      Norborne: [64668],
      Normandy: [63121],
      'North County': [63137, 63138],
      'North Kansas Cit': [64116],
      Norwood: [65717],
      Nottinghill: [65762],
      Novelty: [63460],
      Novinger: [63559],
      'Oak Grove': [64075],
      'Oak Ridge': [63769],
      Odessa: [64076],
      'Old Appleton': [63770],
      'Old Monroe': [63369],
      Oldfield: [65720],
      Olean: [65064],
      Olivette: [63132],
      Olney: [63370],
      Oran: [63771],
      Oregon: [64473],
      Oronogo: [64855],
      Orrick: [64077],
      'Osage Beach': [65065],
      Osborn: [64474],
      Osceola: [64776],
      Otterville: [65348],
      Overland: [63114],
      Owensville: [65066],
      Oxly: [63955],
      Ozark: [65721],
      Pacific: [63069],
      Palmyra: [63461],
      Paris: [65275],
      Parkville: [64152],
      Parma: [63870],
      Parnell: [64475],
      Patterson: [63956],
      Patton: [63662],
      Pattonsburg: [64670],
      Paynesville: [63371],
      'Peace Valley': [65788],
      Peculiar: [64078],
      Perry: [63462],
      Perryville: [63775],
      Pevely: [63070],
      Philadelphia: [63463],
      Phillipsburg: [65722],
      Pickering: [64476],
      Piedmont: [63957],
      'Pierce City': [65723],
      'Pilot Grove': [65276],
      Pittsburg: [65724],
      Plato: [65552],
      'Platte City': [64079],
      Plattsburg: [64477],
      'Pleasant Hill': [64080],
      'Pleasant Hope': [65725],
      'Pleasant Valley': [64068],
      Plevna: [63464],
      Polk: [65727],
      Pollock: [63560],
      Polo: [64671],
      Pomona: [65789],
      'Ponce De Leon': [65728],
      Pontiac: [65729],
      'Poplar Bluff': [63901],
      'Portage Des Siou': [63373],
      Portageville: [63873],
      Portland: [65067],
      Potosi: [63664],
      Pottersville: [65790],
      Powell: [65730],
      Powersite: [65731],
      Powersville: [64672],
      Poynor: [63935],
      'Prairie Home': [65068],
      Preston: [65732],
      Princeton: [64673],
      Protem: [65733],
      Purdin: [64674],
      Purdy: [65734],
      Puxico: [63960],
      'Queen City': [63561],
      Quincy: [65735],
      Quitman: [64478],
      Qulin: [63961],
      Randolph: [64117, 64161],
      Ravenwood: [64479],
      Raymondville: [65555],
      Raymore: [64083],
      Raytown: [64133, 64138],
      Rayville: [64084],
      Rea: [64480],
      Redford: [63665],
      Reeds: [64859],
      Republic: [65738],
      Rhineland: [65069],
      'Rich Hill': [64779],
      Richards: [64778],
      Richland: [65556],
      Richmond: [64085],
      'Richmond Heights': [63117],
      Richwoods: [63071],
      Ridgedale: [65739],
      Ridgeway: [64481],
      Riverton: [65606],
      Roach: [65787],
      Robertsville: [63072],
      Roby: [65557],
      Rocheport: [65279],
      'Rock Port': [64482],
      'Rockaway Beach': [65740],
      Rockville: [64780],
      'Rocky Comfort': [64861],
      'Rocky Mount': [65072],
      Rogersville: [65742],
      Rolla: [65401],
      Rosebud: [63091],
      Rosendale: [64483],
      Rothville: [64676],
      Rueter: [65744],
      'Rush Hill': [65280],
      Rushville: [64484],
      Russellville: [65074],
      Rutledge: [63563],
      'Saint Ann': [63074],
      'Saint Catharine': [64677],
      'Saint Charles': [63301, 63303, 63304],
      'Saint Clair': [63077],
      'Saint Elizabeth': [65075],
      'Saint James': [65559],
      'Saint Joseph': [64501, 64503, 64504, 64505, 64506, 64507],
      'Saint Louis': [
        63101, 63102, 63103, 63104, 63106, 63107, 63108, 63109, 63110, 63111,
        63112, 63113, 63115, 63116, 63118, 63120, 63133, 63139, 63147,
      ],
      'Saint Mary': [63673],
      'Saint Patrick': [63466],
      'Saint Paul': [63366],
      'Saint Peters': [63376],
      'Saint Robert': [65583],
      'Saint Thomas': [65076],
      Salem: [65560],
      Salisbury: [65281],
      'Santa Fe': [65282],
      Sappington: [63126, 63127, 63128],
      Sarcoxie: [64862],
      Savannah: [64485],
      'Schell City': [64783],
      Scopus: [63764],
      'Scott City': [63780],
      Sedalia: [65301],
      Sedgewickville: [63781],
      Seligman: [65745],
      Senath: [63876],
      Seneca: [64865],
      Seymour: [65746],
      Shelbina: [63468],
      Shelbyville: [63469],
      Sheldon: [64784],
      'Shell Knob': [65747],
      Sheridan: [64486],
      Shook: [63963],
      Sibley: [64088],
      Sikeston: [63801],
      Silex: [63377],
      Silva: [63964],
      Skidmore: [64487],
      Slater: [65349],
      Smithton: [65350],
      Smithville: [64089],
      Solo: [65564],
      Souder: [65773],
      'South County': [63129],
      'South Fork': [65776],
      'South Greenfield': [65752],
      'South West City': [64863],
      Sparta: [65753],
      Spickard: [64679],
      Spokane: [65754],
      Springfield: [65802, 65803, 65804, 65806, 65807, 65809, 65810],
      Squires: [65755],
      Stanberry: [64489],
      'Stark City': [64866],
      Steedman: [65077],
      Steele: [63877],
      Steffenville: [63470],
      Stella: [64867],
      Stockton: [65785],
      Stotesbury: [64752],
      'Stotts City': [65756],
      Stoutland: [65567],
      Stoutsville: [65283],
      Stover: [65078],
      Strafford: [65757],
      Sturdivant: [63782],
      Sturgeon: [65284],
      Success: [65570],
      'Sugar Creek': [64054],
      Sullivan: [63080],
      Summersville: [65571],
      Sumner: [64681],
      'Sunrise Beach': [65079],
      'Sweet Springs': [65351],
      Sycamore: [65758],
      Syracuse: [65354],
      Taneyville: [65759],
      Tarkio: [64491],
      Taylor: [63471],
      Tebbetts: [65080],
      Tecumseh: [65760],
      Teresita: [65573],
      Thayer: [65791],
      Thompson: [65285],
      'Tiff City': [64868],
      Tightwad: [64735],
      Tina: [64682],
      Tipton: [65081],
      'Town And Country': [63017],
      Trenton: [64683],
      Trimble: [64492],
      Triplett: [65286],
      Troy: [63379],
      Truxton: [63381],
      Tunas: [65764],
      Turney: [64493],
      Tuscumbia: [65082],
      Udall: [65766],
      Ulman: [65083],
      Union: [63084],
      'Union Star': [64494],
      Uniontown: [63783],
      Unionville: [63565],
      'University City': [63130],
      Urbana: [65767],
      Urich: [64788],
      Utica: [64686],
      'Valley Park': [63088],
      'Van Buren': [63965],
      Vandalia: [63382],
      Vanzant: [65768],
      Verona: [65769],
      Versailles: [65084],
      Viburnum: [65566],
      Vichy: [65580],
      Vienna: [65582],
      'Villa Ridge': [63089],
      Vulcan: [63675],
      Walker: [64790],
      'Walnut Grove': [65770],
      'Walnut Shade': [65771],
      Wappapello: [63966],
      Warrensburg: [64093],
      Warrenton: [63383],
      Warsaw: [65355],
      Washburn: [65772],
      Washington: [63090],
      Watson: [64496],
      Waverly: [64096],
      Wayland: [63472],
      Weatherby: [64497],
      Weaubleau: [65774],
      'Webb City': [64870],
      'Webster Groves': [63119],
      Wellington: [64097],
      Wellsville: [63384],
      Wentworth: [64873],
      Wentzville: [63385],
      Wesco: [65586],
      'West Alton': [63386],
      'West County': [63146],
      'West Plains': [65775],
      Westboro: [64498],
      Weston: [64098],
      Westphalia: [65085],
      Wheatland: [65779],
      Wheaton: [64874],
      Wheeling: [64688],
      'Whiteman Afb': [65305],
      Whitewater: [63785],
      Willard: [65781],
      Williamsburg: [63388],
      Williamstown: [63473],
      Williamsville: [63967],
      'Willow Springs': [65793],
      Windsor: [65360],
      Windyville: [65783],
      Winfield: [63389],
      Winigan: [63566],
      Winona: [65588],
      Winston: [64689],
      Wittenberg: [63786],
      Wooldridge: [65287],
      Worth: [64499],
      Worthington: [63567],
      'Wright City': [63390],
      Wyaconda: [63474],
      Yukon: [65589],
      Zalma: [63787],
      Zanoni: [65784],
    },
    name: 'Missouri',
  },
  MS: {
    cities: {
      Abbeville: [38601],
      Aberdeen: [39730],
      Ackerman: [39735],
      Agricola: [39452],
      Alligator: [38720],
      Amory: [38821],
      Anguilla: [38721],
      Askew: [38621],
      Avalon: [38912],
      Bailey: [39320],
      Baird: [38751],
      Baldwyn: [38824],
      Banner: [38913],
      Bassfield: [39421],
      Batesville: [38606],
      'Bay Springs': [39422],
      Beaumont: [39423],
      Belden: [38826],
      Belmont: [38827],
      Belzoni: [39038],
      Benoit: [38725],
      Benton: [39039],
      Bentonia: [39040],
      Beulah: [38726],
      'Big Creek': [38914],
      Biloxi: [39530, 39531],
      'Blue Mountain': [38610],
      'Blue Springs': [38828],
      'Bogue Chitto': [39629],
      Bolton: [39041],
      Booneville: [38829],
      Boyle: [38730],
      Brandon: [39042],
      Braxton: [39044],
      Brookhaven: [39601],
      Brooklyn: [39425],
      Brooksville: [39739],
      Bruce: [38915],
      Buckatunna: [39322],
      Burnsville: [38833],
      Byhalia: [38611],
      Caledonia: [39740],
      'Calhoun City': [38916],
      Camden: [39045],
      Cannon: [38603],
      Canton: [39046],
      Carlisle: [39049],
      Carriere: [39426],
      Carrollton: [38917],
      Carson: [39427],
      Cascilla: [38920],
      Cedarbluff: [39741],
      Centreville: [39631],
      Charleston: [38921],
      Chunky: [39323],
      'Church Hill': [39055],
      Cleveland: [38732],
      Clinton: [39056],
      Coahoma: [38617],
      Coffeeville: [38922],
      Coila: [38923],
      Coldwater: [38618],
      Collins: [39428],
      Collinsville: [39325],
      Columbia: [39429],
      Columbus: [39701, 39702],
      Como: [38619],
      Conehatta: [39057],
      Courtland: [38620],
      Crawford: [39743],
      Crosby: [39633],
      Cruger: [38924],
      'Crystal Springs': [39059],
      Daleville: [39326],
      'De Kalb': [39328],
      Decatur: [39327],
      Dennis: [38838],
      Diamondhead: [39520],
      Doddsville: [38736],
      Drew: [38737],
      'Duck Hill': [38925],
      Dumas: [38625],
      Duncan: [38740],
      Dundee: [38626],
      Durant: [39063],
      Ecru: [38841],
      Edinburg: [39051],
      Edwards: [39066],
      Egypt: [38860],
      Elizabeth: [38756],
      Ellisville: [39437],
      Enid: [38927],
      Enterprise: [39330],
      Ethel: [39067],
      Etta: [38627],
      Falkner: [38629],
      Fayette: [39069],
      Flora: [39071],
      Florence: [39073],
      Forest: [39074],
      Foxworth: [39483],
      'French Camp': [39745],
      Fulton: [38843],
      Gattman: [38844],
      Gautier: [39553],
      Georgetown: [39078],
      Glen: [38846],
      'Glen Allan': [38744],
      Gloster: [39638],
      Golden: [38847],
      Goodman: [39079],
      'Gore Springs': [38929],
      Greenville: [38701, 38703],
      Greenwood: [38930],
      'Greenwood Spring': [38848],
      Grenada: [38901],
      Gulfport: [39501, 39503, 39507],
      Gunnison: [38746],
      Guntown: [38849],
      Hamilton: [39746],
      Harrisville: [39082],
      Hattiesburg: [39401, 39402],
      Hazlehurst: [39083],
      Heidelberg: [39439],
      Hermanville: [39086],
      Hernando: [38632],
      Hickory: [39332],
      'Hickory Flat': [38633],
      Holcomb: [38940],
      'Holly Bluff': [39088],
      'Holly Springs': [38635],
      'Horn Lake': [38637],
      Houlka: [38850],
      Houston: [38851],
      Inverness: [38753],
      Isola: [38754],
      'Itta Bena': [38941],
      Iuka: [38852],
      Jackson: [
        39201, 39202, 39203, 39204, 39206, 39209, 39211, 39212, 39213, 39216,
        39269,
      ],
      Jayess: [39641],
      Kilmichael: [39747],
      Kokomo: [39643],
      Kosciusko: [39090],
      Kossuth: [38834],
      Kreole: [39563],
      Lafayette: [38655],
      Lake: [39092],
      'Lake Cormorant': [38641],
      Lamar: [38642],
      Lambert: [38643],
      Lauderdale: [39335],
      Laurel: [39440],
      Lawrence: [39336],
      Leaf: [39456],
      Leakesville: [39451],
      Learned: [39154],
      Lena: [39094],
      Lexington: [39095],
      Liberty: [39645],
      'Little Rock': [39337],
      'Long Beach': [39560],
      Lorman: [39096],
      Louin: [39338],
      Louise: [39097],
      Louisville: [39339],
      Lumberton: [39455],
      Lyon: [38645],
      Maben: [39750],
      Macon: [39341],
      Madden: [39109],
      Madison: [39110],
      Magee: [39111],
      Magnolia: [39652],
      Mantachie: [38855],
      Mantee: [39751],
      Marietta: [38856],
      Marks: [38646],
      Matherville: [39360],
      Mathiston: [39752],
      Mayersville: [39113],
      'Mc Call Creek': [39647],
      'Mc Carley': [38943],
      'Mc Comb': [39648],
      'Mc Cool': [39108],
      'Mc Henry': [39561],
      Meadville: [39653],
      Mendenhall: [39114],
      Meridian: [39301, 39305, 39307],
      Merigold: [38759],
      'Michigan City': [38647],
      'Minter City': [38944],
      Mize: [39116],
      Monticello: [39654],
      Mooreville: [38857],
      Moorhead: [38761],
      Morton: [39117],
      Moselle: [39459],
      'Mound Bayou': [38762],
      'Mount Olive': [39119],
      Myrtle: [38650],
      Natchez: [39120],
      Neely: [39461],
      Nesbit: [38651],
      Nettleton: [38858],
      'New Albany': [38652],
      'New Augusta': [39462],
      'New Site': [38859],
      Newhebron: [39140],
      Newton: [39345],
      'North Bay': [39532],
      Noxapater: [39346],
      'Oak Vale': [39656],
      Oakland: [38948],
      'Ocean Springs': [39564],
      'Olive Branch': [38654],
      Osyka: [39657],
      Ovett: [39464],
      Pachuta: [39347],
      Pascagoula: [39567, 39581],
      'Pass Christian': [39571],
      Pattison: [39144],
      Paulding: [39348],
      Pearl: [39208],
      Pelahatchie: [39145],
      Percy: [38748],
      Perkinston: [39573],
      Petal: [39465],
      Pheba: [39755],
      Philadelphia: [39350],
      Philipp: [38950],
      Picayune: [39466],
      Pickens: [39146, 39179],
      Pinola: [39149],
      Pittsboro: [38951],
      Plantersville: [38862],
      'Pleasant Grove': [38657],
      Pontotoc: [38863],
      Pope: [38658],
      Poplarville: [39470],
      'Port Gibson': [39150],
      Porterville: [39352],
      'Potts Camp': [38659],
      Prairie: [39756],
      Prentiss: [39474],
      Preston: [39354],
      Pulaski: [39152],
      Purvis: [39475],
      Quitman: [39355],
      Raleigh: [39153],
      'Red Banks': [38661],
      Redwood: [39156],
      Richland: [39218],
      Richton: [39476],
      Ridgeland: [39157],
      Rienzi: [38865],
      Ripley: [38663],
      Robinsonville: [38664],
      'Rolling Fork': [39159],
      'Rose Hill': [39356],
      Rosedale: [38769],
      Roxie: [39661],
      Ruleville: [38771],
      Ruth: [39662],
      Sallis: [39160],
      Saltillo: [38866],
      'Sandy Hook': [39478],
      Sardis: [38666],
      Sarepta: [38864],
      Satartia: [39162],
      Saucier: [39574],
      Savage: [38665],
      Schlater: [38952],
      Scobey: [38953],
      Scooba: [39358],
      Seminary: [39479],
      Senatobia: [38668],
      Sessums: [39759],
      Shannon: [38868],
      Shaw: [38773],
      Shelby: [38774],
      Shuqualak: [39361],
      Sidon: [38954],
      'Silver City': [39166],
      'Silver Creek': [39663],
      Sledge: [38670],
      Smithdale: [39664],
      Smithville: [38870],
      Sontag: [39665],
      Soso: [39480],
      Southaven: [38671],
      'State Line': [39362],
      Steens: [39766],
      Stewart: [39767],
      Stonewall: [39363],
      Stovall: [38614],
      Stringer: [39481],
      Sturgis: [39769],
      Summit: [39666],
      Sumrall: [39482],
      Sunflower: [38778],
      Taylor: [38673],
      Taylorsville: [39168],
      Tchula: [39169],
      Terry: [39170],
      Thaxton: [38871],
      Tillatoba: [38961],
      Tiplersville: [38674],
      Tishomingo: [38873],
      Tomnolen: [39744],
      Toomsuba: [39364],
      Tremont: [38876],
      Tunica: [38676],
      Tupelo: [38801],
      Tutwiler: [38963],
      Tylertown: [39667],
      Union: [39365],
      'Union Church': [39668],
      University: [38677],
      Utica: [39175],
      Vaiden: [39176],
      'Valley Park': [39177],
      Vance: [38964],
      Vardaman: [38878],
      Vicksburg: [39180],
      Vossburg: [39366],
      Walls: [38680],
      Walnut: [38683],
      'Walnut Grove': [39189],
      'Water Valley': [38949, 38965],
      Waterford: [38685],
      Waveland: [39576],
      Waynesboro: [39367],
      Wayside: [38780],
      Weir: [39772],
      Wesson: [39191],
      West: [39192],
      'West Point': [39773],
      Wiggins: [39577],
      Winona: [38967],
      Woodland: [39776],
      Woodville: [39669],
      'Yazoo City': [39194],
    },
    name: 'Mississippi',
  },
  MT: {
    cities: {
      59080: [59080],
      Absarokee: [59001],
      Acton: [59002],
      Alberton: [59820],
      Alzada: [59311],
      Anaconda: [59711],
      Angela: [59312],
      Antelope: [59211],
      Arlee: [59821],
      Ashland: [59003],
      Augusta: [59410],
      Babb: [59411],
      Bainville: [59212],
      Baker: [59313],
      Ballantine: [59006],
      Bearcreek: [59007],
      Belfry: [59008],
      Belgrade: [59714],
      'Belle Creek': [59317],
      Belt: [59412],
      Biddle: [59314],
      'Big Arm': [59910],
      'Big Sandy': [59520],
      'Big Timber': [59011],
      Bighorn: [59010],
      Billings: [59101, 59102, 59106],
      'Billings Heights': [59105],
      Birney: [59012],
      'Black Eagle': [59414],
      Bloomfield: [59315],
      Bonner: [59823],
      Boulder: [59632],
      'Box Elder': [59521],
      Boyes: [59316],
      Bozeman: [59715],
      Brady: [59416],
      Bridger: [59014],
      Broadview: [59015],
      Brockton: [59213],
      Brockway: [59214],
      Brusett: [59318],
      Buffalo: [59418],
      Busby: [59016],
      Butte: [59750],
      Bynum: [59419],
      Cameron: [59720],
      'Canyon Creek': [59633],
      Capitol: [59319],
      Cardwell: [59721],
      Carter: [59420],
      Cascade: [59421],
      'Cat Creek': [59017],
      Chester: [59522],
      Chinook: [59523],
      Choteau: [59422],
      Circle: [59215],
      Clinton: [59825],
      'Coffee Creek': [59424],
      Cohagen: [59322],
      'Columbia Falls': [59912],
      Columbus: [59019],
      Condon: [59826],
      Conner: [59827],
      Conrad: [59425],
      Corvallis: [59828],
      'Crow Agency': [59022],
      Culbertson: [59218],
      Custer: [59024],
      'Cut Bank': [59427],
      Dagmar: [59219],
      Darby: [59829],
      Dayton: [59914],
      Decker: [59025],
      'Deer Lodge': [59722],
      Dell: [59724],
      Denton: [59430],
      Dillon: [59725],
      Divide: [59727],
      Dixon: [59831],
      Dodson: [59524],
      Drummond: [59832],
      Dutton: [59433],
      'East Glacier Par': [59434],
      'East Helena': [59635],
      Ekalaka: [59324],
      Elmo: [59915],
      Emigrant: [59027],
      Ennis: [59729],
      Essex: [59916],
      Eureka: [59917],
      Evergreen: [59901],
      Fairfield: [59436],
      Fairview: [59221],
      Fallon: [59326],
      Fishtail: [59028],
      Flaxville: [59222],
      Florence: [59833],
      Floweree: [59440],
      Forestgrove: [59441],
      Forsyth: [59327],
      'Fort Benton': [59442],
      'Fort Peck': [59223],
      'Fort Shaw': [59443],
      Frenchtown: [59834],
      Froid: [59226],
      Fromberg: [59029],
      Galata: [59444],
      'Gallatin Gateway': [59730],
      Gardiner: [59030],
      Garrison: [59731],
      Garryowen: [59031],
      Geraldine: [59446],
      Geyser: [59447],
      Gildford: [59525],
      Glasgow: [59230],
      Glendive: [59330],
      'Gold Creek': [59733],
      'Grass Range': [59032],
      'Great Falls': [59401, 59404, 59405],
      Greenough: [59836],
      Greycliff: [59033],
      Hall: [59837],
      Hamilton: [59840],
      Hammond: [59332],
      Hardin: [59034],
      Harlem: [59526],
      Harrison: [59735],
      Havre: [59501],
      Hays: [59527],
      'Heart Butte': [59448],
      Helena: [59601],
      Helmville: [59843],
      Heron: [59844],
      Highwood: [59450],
      Hilger: [59451],
      Hingham: [59528],
      Hinsdale: [59241],
      Hogeland: [59529],
      Homestead: [59242],
      'Hot Springs': [59845],
      Huntley: [59037],
      Huson: [59846],
      Hysham: [59038],
      Ingomar: [59039],
      Inverness: [59530],
      Ismay: [59336],
      Jackson: [59736],
      Joplin: [59531],
      Jordan: [59337],
      'Judith Gap': [59453],
      Kevin: [59454],
      Kila: [59920],
      Kinsey: [59338],
      Kremlin: [59532],
      Lakeside: [59922],
      Lambert: [59243],
      'Lame Deer': [59043],
      Larslan: [59244],
      Laurel: [59044],
      Lavina: [59046],
      Ledger: [59456],
      Lewistown: [59457],
      Libby: [59923],
      Lima: [59739],
      Lincoln: [59639],
      Lindsay: [59339],
      Livingston: [59047],
      Lloyd: [59535],
      'Lodge Grass': [59050],
      Lolo: [59847],
      Loma: [59460],
      Lonepine: [59848],
      Loring: [59537],
      Lustre: [59225],
      Luther: [59051],
      Malta: [59538],
      Manhattan: [59741],
      Marion: [59925],
      Martinsdale: [59053],
      'Mc Leod': [59052],
      'Medicine Lake': [59247],
      Melville: [59055],
      Mildred: [59341],
      'Miles City': [59301],
      Missoula: [59801, 59802, 59803],
      Moccasin: [59462],
      Moiese: [59824],
      Molt: [59057],
      Monarch: [59463],
      'Montana City': [59634],
      Moore: [59464],
      Mosby: [59058],
      Musselshell: [59059],
      Nashua: [59248],
      Neihart: [59465],
      Niarada: [59852],
      Norris: [59745],
      Noxon: [59853],
      Nye: [59061],
      Olive: [59343],
      Opheim: [59250],
      Otter: [59062],
      Outlook: [59252],
      Ovando: [59854],
      'Park City': [59063],
      Peerless: [59253],
      Pendroy: [59467],
      Philipsburg: [59858],
      Plains: [59859],
      Plentywood: [59254],
      Plevna: [59344],
      Polebridge: [59928],
      Polson: [59860],
      'Pompeys Pillar': [59064],
      Pony: [59747],
      Poplar: [59255],
      Powderville: [59345],
      Power: [59468],
      Pray: [59065],
      Proctor: [59929],
      Radersburg: [59641],
      Ramsay: [59748],
      Rapelje: [59067],
      Raymond: [59256],
      Raynesford: [59469],
      'Red Lodge': [59068],
      Redstone: [59257],
      Reedpoint: [59069],
      Reserve: [59258],
      Rexford: [59930],
      Richey: [59259],
      Richland: [59260],
      Ringling: [59642],
      Roberts: [59070],
      Rollins: [59931],
      Ronan: [59864],
      Roscoe: [59071],
      Rosebud: [59347],
      Roundup: [59072],
      Roy: [59471],
      Rudyard: [59540],
      Ryegate: [59074],
      Saco: [59261],
      'Saint Ignatius': [59865],
      'Saint Mary': [59417],
      'Saint Regis': [59866],
      'Saint Xavier': [59075],
      'Sand Coulee': [59472],
      'Sand Springs': [59077],
      Savage: [59262],
      Scobey: [59263],
      'Seeley Lake': [59868],
      Shawmut: [59078],
      Shelby: [59474],
      Shepherd: [59079],
      Sheridan: [59749],
      Sidney: [59270],
      Silesia: [59041],
      'Silver Star': [59751],
      Somers: [59932],
      Stanford: [59479],
      Stevensville: [59870],
      Stockett: [59480],
      Sula: [59871],
      'Sun River': [59483],
      Sunburst: [59482],
      Superior: [59872],
      'Swan Lake': [59911],
      Sweetgrass: [59484],
      Terry: [59349],
      'Thompson Falls': [59873],
      'Three Forks': [59752],
      Toston: [59643],
      Townsend: [59644],
      'Trout Creek': [59874],
      Troy: [59935],
      Turner: [59542],
      'Twin Bridges': [59754],
      Twodot: [59085],
      Utica: [59452],
      Valier: [59486],
      Vaughn: [59487],
      Victor: [59875],
      Vida: [59274],
      'Virginia City': [59755],
      Volborg: [59351],
      Walkerville: [59701],
      Warmsprings: [59756],
      'West Yellowstone': [59758],
      Westby: [59275],
      'White Sulphur Sp': [59645],
      Whitefish: [59937],
      Whitehall: [59759],
      Whitetail: [59276],
      Whitewater: [59544],
      Whitlash: [59545],
      Wibaux: [59353],
      Willard: [59354],
      Wilsall: [59086],
      Winifred: [59489],
      Winnett: [59087],
      Winston: [59647],
      Wisdom: [59761],
      'Wise River': [59762],
      'Wolf Creek': [59648],
      'Wolf Point': [59201],
      Worden: [59088],
      Wyola: [59089],
      Zortman: [59546],
    },
    name: 'Montana',
  },
  NC: {
    cities: {
      Aberdeen: [28315],
      Advance: [27006],
      Ahoskie: [27910],
      Albemarle: [28001],
      Albertson: [28508],
      Alexander: [28701],
      'Alexander Mills': [28043],
      Alexis: [28006],
      Almond: [28702],
      Andrews: [28901],
      Angier: [27501],
      Apex: [27502],
      Aquone: [28703],
      Arapahoe: [28510],
      Ararat: [27007],
      Archdale: [27263],
      Arden: [28704],
      Ash: [28420],
      Asheville: [28801, 28803, 28804, 28805, 28806],
      Atkinson: [28421],
      Atlantic: [28511],
      Aulander: [27805],
      Aurora: [27806],
      Autryville: [28318],
      Ayden: [28513],
      Aydlett: [27916],
      Bahama: [27503],
      Bailey: [27807],
      Bakersville: [28705],
      'Balsam Grove': [28708],
      'Banner Elk': [28604],
      Barco: [27917],
      Barnardsville: [28709],
      Bath: [27808],
      Battleboro: [27809],
      Bayboro: [28515],
      'Bear Creek': [27207],
      Beaufort: [28516],
      'Belews Creek': [27009],
      Belhaven: [27810],
      Belmont: [28012],
      Belvidere: [27919],
      Bennett: [27208],
      Benson: [27504],
      'Bessemer City': [28016],
      Bethel: [27812],
      Beulaville: [28518],
      Biscoe: [27209],
      'Black Mountain S': [28711],
      Bladenboro: [28320],
      Blanch: [27212],
      'Blounts Creek': [27814],
      'Blowing Rock': [28605],
      'Boger City': [28092],
      'Boiling Spring L': [28461],
      Bolivia: [28422],
      Bolton: [28423],
      'Bonnie Doone': [28303],
      Boomer: [28606],
      Boone: [28607],
      Boonville: [27011],
      Bostic: [28018],
      Bowdens: [28398],
      Brasstown: [28902],
      Brevard: [28712],
      Broadway: [27505],
      'Browns Summit': [27214],
      'Bryson City': [28713],
      Bullock: [27507],
      Bunnlevel: [28323],
      Burgaw: [28425],
      Burlington: [27217],
      Burnsville: [28714],
      Butner: [27509],
      Calabash: [28467],
      Camden: [27921],
      'Camp Lejeune': [28542],
      Candler: [28715],
      Candor: [27229],
      Canton: [28716],
      'Cape Fear': [28401],
      'Carolina Beach': [28428],
      Carrboro: [27510],
      Carthage: [28327],
      Cary: [27511, 27513],
      Casar: [28020],
      Cashiers: [28717],
      Castalia: [27816],
      'Castle Hayne': [28429],
      Catawba: [28609],
      'Cedar Grove': [27231],
      'Cedar Island': [28520],
      'Cerro Gordo': [28430],
      Chadbourn: [28431],
      'Chapel Hill': [27514, 27516],
      Charlotte: [
        28202, 28203, 28204, 28205, 28206, 28207, 28208, 28209, 28210, 28211,
        28212, 28213, 28214, 28215, 28216, 28217, 28226, 28227, 28262, 28269,
        28270, 28273, 28277, 28278,
      ],
      Cherokee: [28719],
      Cherryville: [28021],
      'China Grove': [28023],
      Chinquapin: [28521],
      Chocowinity: [27817],
      Claremont: [28610],
      Clarendon: [28432],
      Clarkton: [28433],
      Clayton: [27520],
      Clemmons: [27012],
      Cleveland: [27013],
      Climax: [27233],
      Clinton: [28328],
      Clyde: [28721],
      Coats: [27521],
      Cofield: [27922],
      Coinjock: [27923],
      Colerain: [27924],
      Coleridge: [27316],
      Colfax: [27235],
      Collettsville: [28611],
      Colon: [27330],
      Columbia: [27925],
      Columbus: [28722],
      Como: [27818],
      Concord: [28025, 28027],
      'Connellys Spring': [28612],
      Conover: [28613],
      Conway: [27820],
      Corapeake: [27926],
      Cornelius: [28036, 28078],
      Corolla: [27927],
      Council: [28434],
      'Cove City': [28523],
      Cramerton: [28032],
      Creedmoor: [27522],
      Creston: [28615],
      Creswell: [27928],
      Crisp: [27852],
      Crouse: [28033],
      Crumpler: [28617],
      Cullowhee: [28723],
      Currie: [28435],
      Currituck: [27929],
      Dallas: [28034],
      Danbury: [27016],
      'Deep Gap': [28618],
      'Deep Run': [28525],
      Delco: [28436],
      Denton: [27239],
      Denver: [28037],
      Dobson: [27017],
      Dover: [28526],
      Dudley: [28333],
      Dunn: [28334],
      'Durants Neck': [27944],
      Durham: [27701, 27703, 27704, 27705, 27706, 27707, 27712],
      'Eagle Springs': [27242],
      'East Bend': [27018],
      'East Fayettevill': [28301],
      'East Flat Rock': [28726],
      'East Lake': [27953],
      Eden: [27288],
      Edenton: [27932],
      Edward: [27821],
      Efland: [27243],
      'Elizabeth City': [27909],
      Elizabethtown: [28337],
      'Elk Park': [28622],
      Elkin: [28621],
      Ellenboro: [28040],
      Ellerbe: [28338],
      'Elm City': [27822],
      'Elon College': [27244],
      'Emerald Isle': [28594],
      Enfield: [27823],
      Ennice: [28623],
      Ernul: [28527],
      Erwin: [28339],
      Etowah: [28729],
      Eure: [27935],
      Eureka: [27830],
      Evergreen: [28438],
      'Fair Bluff': [28439],
      Fairfield: [27826],
      Fairview: [28730],
      Faison: [28341],
      Farmer: [27203],
      Farmville: [27828],
      Fayetteville: [28304, 28305, 28306, 28311, 28314],
      Ferguson: [28624],
      'Flat Rock': [28731],
      Fleetwood: [28626],
      Fletcher: [28732],
      'Fontana Dam': [28733],
      'Fort Bragg': [28307],
      Fountain: [27829],
      'Four Oaks': [27524],
      Frank: [28657],
      Franklin: [28734],
      Franklinton: [27525],
      Franklinville: [27248],
      'Fuquay Varina': [27526],
      Garland: [28441],
      Garner: [27529],
      Garysburg: [27831],
      Gaston: [27832],
      Gastonia: [28052, 28054, 28056],
      Gates: [27937],
      Gatesville: [27938],
      George: [27897],
      Germanton: [27019],
      Gerton: [28735],
      Gibson: [28343],
      Gibsonville: [27249],
      'Glade Valley': [28627],
      'Glen Raven': [27215],
      Glenville: [28736],
      Gloucester: [28528],
      Godwin: [28344],
      'Gold Hill': [28071],
      Goldsboro: [27534],
      Goldston: [27252],
      Graham: [27253],
      Grandy: [27939],
      'Granite Falls': [28630],
      Grantham: [27530],
      Grantsboro: [28529],
      'Grassy Creek': [28631],
      Greenmountain: [28740],
      Greensboro: [27401, 27403, 27405, 27406, 27407, 27408, 27409, 27410],
      Greenville: [27834, 27858],
      Grifton: [28530],
      Grimesland: [27837],
      Grover: [28073],
      Halifax: [27839],
      Hallsboro: [28442],
      Hamilton: [27840],
      Hamlet: [28345],
      Hampstead: [28443],
      Hamptonville: [27020],
      Harbinger: [27941],
      'Harkers Island': [28531],
      Harmony: [28634],
      Harrells: [28444],
      Harrellsville: [27942],
      Harrisburg: [28075],
      Havelock: [28532],
      'Haw River': [27258],
      Hayesville: [28904],
      Hays: [28635],
      Hazelwood: [28738],
      Henderson: [27536],
      Hendersonville: [28739, 28792],
      Henrico: [27842],
      Hickory: [28601, 28602],
      Hiddenite: [28636],
      'High Point': [27260, 27262, 27265],
      Highlands: [28741],
      Hillsborough: [27278],
      Hobbsville: [27946],
      Hobgood: [27843],
      Hobucken: [28537],
      Hoffman: [28347],
      'Holden Beach': [28462],
      Hollister: [27844],
      'Holly Springs': [27540],
      Hookerton: [28538],
      'Hope Mills': [28348],
      'Horse Shoe': [28742],
      'Hot Springs': [28743],
      Hubert: [28539],
      Hudson: [28638],
      'Hurdle Mills': [27541],
      'Indian Trail': [28079],
      'Iron Station': [28080],
      Ivanhoe: [28447],
      Jackson: [27845],
      'Jackson Springs': [27281],
      Jacksonville: [28540, 28546],
      Jamestown: [27282],
      Jamesville: [27846],
      Jarvisburg: [27947],
      Jefferson: [28640],
      Johnsonville: [28326],
      Jonesville: [28642],
      Julian: [27283],
      Kannapolis: [28081, 28083],
      Kelford: [27847],
      Kelly: [28448],
      Kenansville: [28349],
      Kenly: [27542],
      Kernersville: [27284],
      'Kill Devil Hills': [27948],
      King: [27021],
      'Kings Mountain': [28086],
      Kingstown: [28150],
      Kinston: [28501],
      Kittrell: [27544],
      Knightdale: [27545],
      'Knotts Island': [27950],
      'Kure Beach': [28449],
      'La Grange': [28551],
      'Lake Junaluska': [28745],
      'Lake Lure': [28746],
      'Lake Toxaway': [28747],
      'Lake Waccamaw': [28450],
      Landis: [28088],
      Lansing: [28643],
      Lasker: [27848],
      'Laurel Hill': [28351],
      'Laurel Springs': [28644],
      Laurinburg: [28352],
      Lawndale: [28090],
      Lawsonville: [27022],
      Leasburg: [27291],
      Leicester: [28748],
      Leland: [28451],
      Lenoir: [28645],
      'Lewiston Woodvil': [27849],
      Lewisville: [27023],
      Lexington: [27292],
      Liberty: [27298],
      Lilesville: [28091],
      Lillington: [27546],
      Linden: [28356],
      Linwood: [27299],
      Littleton: [27850],
      Locust: [28097],
      Longisland: [28648],
      Longwood: [28452],
      Louisburg: [27549],
      Lowell: [28098],
      Lowgap: [27024],
      Lowland: [28552],
      Lucama: [27851],
      'Lumber Bridge': [28357],
      Lumberton: [28358],
      Macon: [27551],
      Madison: [27025],
      'Maggie Valley': [28751],
      Magnolia: [28453],
      Maiden: [28650],
      Manson: [27553],
      Manteo: [27954],
      Maple: [27956],
      'Maple Hill': [28454],
      Marble: [28905],
      Margarettsville: [27853],
      Marion: [28752],
      'Mars Hill': [28754],
      Marshallberg: [28553],
      Marshville: [28103],
      Marston: [28363],
      Maxton: [28364],
      Mayodan: [27027],
      Maysville: [28555],
      'Mc Grady': [28649],
      'Mc Leansville': [27301],
      Mcdonald: [28340],
      Mebane: [27302],
      Merritt: [28556],
      'Merry Hill': [27957],
      Middlesex: [27557],
      Middletown: [27824],
      Midland: [28107],
      'Midway Park': [28544],
      'Mill Spring': [28756],
      'Millers Creek': [28651],
      Milton: [27305],
      Mocksville: [27028],
      Moncure: [27559],
      Monroe: [28110, 28112],
      Mooresboro: [28114],
      Mooresville: [28115],
      'Moravian Falls': [28654],
      'Morehead City': [28557],
      Morganton: [28655],
      Morrisville: [27560],
      Morven: [28119],
      'Mount Airy': [27030],
      'Mount Gilead': [27306],
      'Mount Holly': [28120],
      'Mount Olive': [28365],
      'Mount Pleasant': [28124],
      'Mount Ulla': [28125],
      Moyock: [27958],
      Murfreesboro: [27855],
      'Nags Head': [27959],
      Nakina: [28455],
      Nashville: [27856],
      Nebo: [28761],
      'New Bern': [28560, 28562],
      'New Hill': [27562],
      'New London': [28127],
      Newport: [28570],
      Newton: [28658],
      'Newton Grove': [28366],
      Norlina: [27563],
      'North Wilkesboro': [28659],
      Norwood: [28128],
      'Oak City': [27857],
      'Oak Island': [28465],
      'Oak Ridge': [27310],
      Oakboro: [28129],
      'Ocean Isle Beach': [28469],
      Ogden: [28405],
      'Old Fort': [28762],
      Olin: [28660],
      Oriental: [28571],
      Orrum: [28369],
      Otto: [28763],
      Oxford: [27565],
      Palmyra: [27859],
      Pantego: [27860],
      Parkton: [28371],
      Peachland: [28133],
      Pelham: [27311],
      Pembroke: [28372],
      Pendleton: [27862],
      Penrose: [28766],
      Pfafftown: [27040],
      Pikeville: [27863],
      'Pilot Mountain': [27041],
      'Pine Hall': [27042],
      'Pine Knoll Shore': [28512],
      Pinehurst: [28374],
      Pinetops: [27864],
      Pinetown: [27865],
      Pineville: [28134],
      'Pink Hill': [28572],
      Pinnacle: [27043],
      'Pisgah Forest': [28768],
      Pittsboro: [27312],
      'Pleasant Garden': [27313],
      'Pleasant Hill': [27866],
      Plymouth: [27962],
      'Point Harbor': [27964],
      Polkton: [28135],
      Pollocksville: [28573],
      'Poplar Branch': [27965],
      'Powells Point': [27966],
      Princeton: [27569],
      'Prospect Hill': [27314],
      Providence: [27315],
      Purlear: [28665],
      Raeford: [28376],
      Raleigh: [
        27601, 27603, 27604, 27605, 27606, 27607, 27608, 27609, 27610, 27612,
        27613, 27614, 27615,
      ],
      Randleman: [27317],
      'Red Springs': [28377],
      Reidsville: [27320],
      'Research Triangl': [27713],
      'Rich Square': [27869],
      Richfield: [28137],
      Richlands: [28574],
      Riegelwood: [28456],
      'Roanoke Rapids': [27870],
      'Roaring Gap': [28668],
      'Roaring River': [28669],
      Robbins: [27325],
      Robbinsville: [28771],
      Robersonville: [27871],
      Rockingham: [28379],
      Rockwell: [28138],
      'Rocky Mount': [27801, 27803],
      'Rocky Point': [28457],
      Rolesville: [27571],
      Ronda: [28670],
      Roper: [27970],
      'Rose Hill': [28458],
      Roseboro: [28382],
      Rosman: [28772],
      Rougemont: [27572],
      Rowland: [28383],
      Roxboro: [27573],
      Roxobel: [27872],
      Ruffin: [27326],
      'Rural Hall': [27045],
      Rutherfordton: [28139],
      'Saint Pauls': [28384],
      Salemburg: [28385],
      Salisbury: [28144, 28146],
      Saluda: [28773],
      'Sandy Ridge': [27046],
      Sapphire: [28774],
      Saratoga: [27873],
      'Scaly Mountain': [28775],
      'Scotland Neck': [27874],
      Scranton: [27875],
      Seaboard: [27876],
      Seagrove: [27341],
      Sealevel: [28577],
      Selma: [27576],
      Semora: [27343],
      'Seven Springs': [28578],
      'Seymour Johnson': [27531],
      Shallotte: [28459],
      Shannon: [28386],
      Shawboro: [27973],
      Shelby: [28152],
      'Sherrills Ford': [28673],
      Shiloh: [27974],
      'Siler City': [27344],
      Siloam: [27047],
      Sims: [27880],
      Smithfield: [27577],
      Smyrna: [28579],
      'Sneads Ferry': [28460],
      'Snow Camp': [27349],
      'Snow Hill': [28580],
      Sophia: [27350],
      'South Mills': [27976],
      'Southern Pines': [28387],
      'Southern Shores': [27949],
      Sparta: [28675],
      Spencer: [28159],
      Spindale: [28160],
      'Spring Hope': [27882],
      'Spring Lake': [28390],
      'Spruce Pine': [28777],
      Stacy: [28581],
      Staley: [27355],
      Stallings: [28105],
      Stanfield: [28163],
      Stanley: [28164],
      Stantonsburg: [27883],
      Star: [27356],
      'State Road': [28676],
      Statesville: [28677],
      Stedman: [28391],
      Stella: [28582],
      Stem: [27581],
      Stokes: [27884],
      Stokesdale: [27357],
      Stoneville: [27048],
      'Stony Point': [28678],
      'Stumpy Point': [27978],
      'Sugar Grove': [28679],
      Summerfield: [27358],
      Sunbury: [27979],
      'Sunset Beach': [28468],
      'Surf City': [28445],
      Swanquarter: [27885],
      Swansboro: [28584],
      Sylva: [28779],
      'Tabor City': [28463],
      Tapoco: [28780],
      'Tar Heel': [28392],
      'Tarawa Terrace': [28543],
      Tarboro: [27886],
      Taylorsville: [28681],
      Teachey: [28464],
      Terrell: [28682],
      Thomasville: [27360],
      Thurmond: [28683],
      Timberlake: [27583],
      Tobaccoville: [27050],
      Todd: [28684],
      Topton: [28781],
      Traphill: [28685],
      Trenton: [28585],
      Trinity: [27370],
      Triplett: [28686],
      Troutman: [28166],
      Troy: [27371],
      Tryon: [28782],
      Tuckasegee: [28783],
      Turkey: [28393],
      Tyner: [27980],
      Unaka: [28906],
      'Union Grove': [28689],
      'Union Mills': [28167],
      Valdese: [28690],
      Vale: [28168],
      'Valle Crucis': [28691],
      Vanceboro: [28586],
      Vandemere: [28587],
      Vass: [28394],
      Vilas: [28692],
      Wade: [28395],
      Wadesboro: [28170],
      Wagram: [28396],
      'Wake Forest': [27587],
      Walkertown: [27051],
      Wallace: [28466],
      Walnut: [28753],
      'Walnut Cove': [27052],
      Walstonburg: [27888],
      Warne: [28909],
      'Warren Wilson Co': [28778],
      Warrensville: [28693],
      Warrenton: [27589],
      Washington: [27889],
      Watha: [28471],
      Waynesville: [28786],
      Weaverville: [28787],
      Weddington: [28173],
      Weldon: [27890],
      Wendell: [27591],
      'Wesleyan College': [27804],
      'West End': [27376],
      'West Jefferson': [28694],
      Westfield: [27053],
      Whitakers: [27891],
      'White Oak': [28399],
      Whiteville: [28472],
      Whitsett: [27377],
      Whittier: [28789],
      Wilkesboro: [28697],
      Willard: [28478],
      Williamston: [27892],
      'Willow Spring': [27592],
      Wilmington: [28403, 28409, 28412],
      Wilson: [27893],
      Windsor: [27983],
      Wingate: [28174],
      Winnabow: [28479],
      'Winston Salem': [27101, 27103, 27104, 27105, 27106, 27107, 27127],
      Winterville: [28590],
      Winton: [27986],
      Woodleaf: [27054],
      'Wrightsville Bea': [28480],
      Yadkinville: [27055],
      Yanceyville: [27379],
      Youngsville: [27596],
      Zebulon: [27597],
      Zionville: [28698],
      Zirconia: [28790],
    },
    name: 'North Carolina',
  },
  ND: {
    cities: {
      58245: [58245],
      58246: [58246],
      58264: [58264],
      58373: [58373],
      Absaraka: [58002],
      Adams: [58210],
      Adrian: [58472],
      Alfred: [58411],
      Alice: [58003],
      Alkabo: [58845],
      Almont: [58520],
      Ambrose: [58833],
      Amenia: [58004],
      Amidon: [58620],
      Anamoose: [58710],
      Aneta: [58212],
      Antler: [58711],
      Appam: [58830],
      Ardoch: [58213],
      Arena: [58412],
      Argusville: [58005],
      Arnegard: [58835],
      Arthur: [58006],
      Arvilla: [58214],
      Ashley: [58413],
      Ayr: [58007],
      Backoo: [58282],
      Baker: [58386],
      Baldwin: [58521],
      Balfour: [58712],
      Bantry: [58713],
      Barney: [58008],
      Barton: [58315],
      Bathgate: [58216],
      Battleview: [58773],
      Beach: [58621],
      Belcourt: [58316],
      Belden: [58784],
      Benedict: [58716],
      Bentley: [58562],
      Bergen: [58792],
      Berlin: [58415],
      Berwick: [58788],
      Beulah: [58523],
      Binford: [58416],
      Bisbee: [58317],
      Bismarck: [58501],
      Blaisdell: [58718],
      Blanchard: [58009],
      Bonetraill: [58801],
      Bordulac: [58421],
      Bottineau: [58318],
      Bowdon: [58418],
      Bowesmont: [58225],
      Bowman: [58623],
      Braddock: [58524],
      Brampton: [58017],
      Brantford: [58356],
      Breien: [58570],
      Bremen: [58319],
      Briarwood: [58104],
      Brinsmade: [58320],
      Brocket: [58321],
      Buchanan: [58420],
      Bucyrus: [58639],
      Buffalo: [58011],
      Burlington: [58722],
      Burnstad: [58495],
      Burt: [58646],
      Butte: [58723],
      Buxton: [58218],
      Caledonia: [58219],
      Calio: [58352],
      Calvin: [58323],
      'Cannon Ball': [58528],
      Carbury: [58783],
      Carpio: [58725],
      Carson: [58529],
      Cartwright: [58838],
      Casselton: [58012],
      Cayuga: [58013],
      Chaffee: [58014],
      Charlson: [58763],
      Chaseley: [58423],
      Christine: [58015],
      'Churchs Ferry': [58325],
      Clifford: [58016],
      Coleharbor: [58531],
      Colfax: [58018],
      Colgan: [58844],
      Colgate: [58046],
      Concrete: [58220],
      Cooperstown: [58425],
      Coteau: [58721],
      Coulee: [58746],
      Courtenay: [58426],
      Crete: [58040],
      Crosby: [58730],
      Crystal: [58222],
      Cummings: [58223],
      Dahlen: [58224],
      Davenport: [58021],
      Dawson: [58428],
      Deering: [58731],
      Delamere: [58060],
      Denhoff: [58430],
      'Des Lacs': [58733],
      'Devils Lake': [58301],
      Dickey: [58431],
      Dodge: [58625],
      Donnybrook: [58734],
      Douglas: [58735],
      Doyon: [58328],
      Drake: [58736],
      Driscoll: [58532],
      'Dunn Center': [58626],
      Durbin: [58059],
      Dwight: [58075],
      Eckelson: [58432],
      Edmore: [58330],
      Edmunds: [58476],
      Egeland: [58331],
      Eldridge: [58401],
      Ellendale: [58436],
      Elliott: [58054],
      Embden: [58079],
      Emerado: [58228],
      Emmet: [58540],
      Emrick: [58422],
      Enderlin: [58027],
      Englevale: [58033],
      Erie: [58029],
      Fairdale: [58229],
      Fairmount: [58030],
      Fargo: [58103],
      Fessenden: [58438],
      Fillmore: [58332],
      Fingal: [58031],
      Finley: [58230],
      Flora: [58348],
      Forbes: [58439],
      Fordville: [58231],
      'Forest River': [58233],
      Forman: [58032],
      'Fort Clark': [58530],
      'Fort Yates': [58538],
      Foxholm: [58738],
      Fredonia: [58440],
      Fryburg: [58622],
      Fullerton: [58441],
      Gackle: [58442],
      Galesburg: [58035],
      Gardar: [58227],
      Gardena: [58739],
      Gardner: [58036],
      Gascoyne: [58653],
      Geneseo: [58053],
      Gladstone: [58630],
      'Glen Ullin': [58631],
      'Golden Valley': [58541],
      Golva: [58632],
      Goodrich: [58444],
      Gorham: [58627],
      'Grace City': [58445],
      'Grand Forks': [58201, 58203, 58205],
      'Grand Rapids': [58458],
      Grandin: [58038],
      Granville: [58741],
      'Grassy Butte': [58634],
      'Great Bend': [58039],
      Guelph: [58474],
      Hague: [58542],
      Hamar: [58380],
      Hamberg: [58337],
      Hamilton: [58238],
      Hamlet: [58795],
      Hampden: [58338],
      Hankinson: [58041],
      Hannah: [58239],
      Hannover: [58563],
      Hansboro: [58339],
      Harlow: [58346],
      Hastings: [58049],
      Hatton: [58240],
      Havana: [58043],
      Hazelton: [58544],
      Hazen: [58545],
      Heaton: [58450],
      Hebron: [58638],
      Heil: [58533],
      Heimdal: [58342],
      Hensel: [58241],
      Hickson: [58047],
      Honeyford: [58235],
      Hoople: [58243],
      Huff: [58537],
      Hunter: [58048],
      Hurdsfield: [58451],
      Joliette: [58271],
      Juanita: [58443],
      Karlsruhe: [58744],
      Keene: [58847],
      Kelso: [58045],
      Kempton: [58267],
      Kensal: [58455],
      Kief: [58747],
      Killdeer: [58640],
      Kindred: [58051],
      Kintyre: [58549],
      Kloten: [58254],
      Knox: [58343],
      Kramer: [58748],
      Kulm: [58456],
      'Lake Williams': [58478],
      Langdon: [58249],
      Lankin: [58250],
      Lansford: [58750],
      Lark: [58535],
      Larson: [58727],
      Lawton: [58345],
      Leal: [58479],
      Lefor: [58641],
      Lehr: [58460],
      Leith: [58551],
      Leonard: [58052],
      Lignite: [58752],
      Lincoln: [58504],
      Litchville: [58461],
      Loma: [58311],
      Loraine: [58761],
      Luverne: [58056],
      Maida: [58255],
      Makoti: [58756],
      Mandan: [58554],
      Mandaree: [58757],
      Manfred: [58341, 58465],
      Manning: [58642],
      Mantador: [58058],
      Manvel: [58256],
      Mapes: [58344],
      Marion: [58466],
      Marmarth: [58643],
      Martin: [58758],
      Max: [58759],
      Maxbass: [58760],
      Mayville: [58257],
      Maza: [58324],
      Mccanna: [58251],
      Mcclusky: [58463],
      Mcgregor: [58755],
      Mchenry: [58464],
      Mckenzie: [58553],
      Mcleod: [58057],
      Medina: [58467],
      Medora: [58645],
      Mekinock: [58258],
      Menoken: [58558],
      Mercer: [58559],
      Merricourt: [58433],
      Milton: [58260],
      Minnewaukan: [58351],
      Minot: [58701],
      'Minot Afb': [58704],
      Moffit: [58560],
      Monango: [58471],
      Mooreton: [58061],
      Mountain: [58262],
      Mylo: [58353],
      Nanson: [58366],
      Napoleon: [58561],
      Nash: [58237],
      Neche: [58265],
      'New England': [58647],
      'New Hradec': [58601],
      Newburg: [58762],
      Niagara: [58266],
      Nome: [58062],
      Noonan: [58765],
      'North River': [58102],
      Northgate: [58737],
      Nortonville: [58454],
      Norwich: [58768],
      Oberon: [58357],
      Oriska: [58063],
      Orr: [58244],
      Osnabrock: [58269],
      Overly: [58360],
      Page: [58064],
      Palermo: [58769],
      'Park River': [58270],
      Parshall: [58770],
      Pekin: [58361],
      Penn: [58362],
      Perth: [58363],
      Petersburg: [58272],
      Pettibone: [58475],
      Pisek: [58273],
      Plaza: [58771],
      'Pleasant Lake': [58368],
      Portal: [58772],
      Portland: [58274],
      Prosper: [58042],
      Raleigh: [58564],
      Raub: [58779],
      Rawson: [58831],
      Reeder: [58649],
      Regan: [58477],
      Regent: [58650],
      Reynolds: [58275],
      Rhame: [58651],
      Richardton: [58652],
      Riverdale: [58565],
      Riverside: [58078],
      Rocklake: [58365],
      Rolla: [58367],
      Roseglen: [58775],
      Ross: [58776],
      Ruso: [58778],
      Rutland: [58067],
      'Saint Anthony': [58566],
      'Saint John': [58369],
      'Saint Michael': [58370],
      'Saint Thomas': [58276],
      'San Haven': [58329],
      Sanborn: [58480],
      Sarles: [58372],
      Sawyer: [58781],
      Selfridge: [58568],
      'Sentinel Butte': [58654],
      Sharon: [58277],
      Sheldon: [58068],
      Sherwood: [58782],
      Sheyenne: [58374],
      Shields: [58569],
      Sibley: [58429],
      'South Heart': [58655],
      Southam: [58327],
      Spiritwood: [58481],
      Springbrook: [58843],
      Stanton: [58571],
      Starkweather: [58377],
      Steele: [58482],
      Sterling: [58572],
      Stirum: [58069],
      Strasburg: [58573],
      Streeter: [58483],
      Surrey: [58785],
      Sutton: [58484],
      Sykeston: [58486],
      Tappen: [58487],
      Taylor: [58656],
      Temple: [58852],
      Temvik: [58552],
      Thompson: [58278],
      Tolley: [58787],
      'Tower City': [58071],
      Trenton: [58853],
      Trotters: [58657],
      'Turtle Lake': [58575],
      Tuttle: [58488],
      Underwood: [58576],
      Upham: [58789],
      'Valley City': [58072],
      Velva: [58790],
      Venturia: [58489],
      Verona: [58490],
      Voss: [58261],
      Walcott: [58077],
      Wales: [58281],
      Walum: [58448],
      Warwick: [58381],
      Washburn: [58577],
      'Watford City': [58854],
      Webster: [58382],
      Werner: [58636],
      Westhope: [58793],
      Wheelock: [58849],
      'White Earth': [58794],
      Whitman: [58259],
      'Willow City': [58384],
      Wilton: [58579],
      Wimbledon: [58492],
      Windsor: [58424],
      Wing: [58494],
      Wolford: [58385],
      Wolseth: [58740],
      Woodworth: [58496],
      Wyndmere: [58081],
      Ypsilanti: [58497],
      Zahl: [58856],
      Zap: [58580],
      Zeeland: [58581],
    },
    name: 'North Dakota',
  },
  NE: {
    cities: {
      68782: [68782],
      Abie: [68001],
      Adams: [68301],
      Agnew: [68428],
      Ainsworth: [69210],
      Albion: [68620],
      Alda: [68810],
      Alexandria: [68303],
      Allen: [68710],
      Alliance: [69301],
      Alma: [68920],
      Almeria: [68879],
      Alvo: [68304],
      Amelia: [68711],
      Ames: [68621],
      Amherst: [68812],
      Angora: [69331],
      Ansley: [68814],
      Arapahoe: [68922],
      Arcadia: [68815],
      Archer: [68816],
      Arlington: [68002],
      Arnold: [69120],
      Arthur: [69121],
      Ashby: [69333],
      Ashland: [68003],
      Ashton: [68817],
      Atkinson: [68713],
      Atlanta: [68923],
      Auburn: [68305],
      Aurora: [68818],
      Avoca: [68307],
      Axtell: [68924],
      Ayr: [68925],
      Bancroft: [68004],
      Bartlett: [68622],
      Bartley: [69020],
      Bassett: [68714],
      'Battle Creek': [68715],
      Bayard: [69334],
      Beatrice: [68310],
      'Beaver City': [68926],
      'Beaver Crossing': [68313],
      Bee: [68314],
      Beemer: [68716],
      Belden: [68717],
      Belgrade: [68623],
      Bellevue: [68005],
      Bellwood: [68624],
      Belvidere: [68315],
      Benedict: [68316],
      Benkelman: [69021],
      Bennet: [68317],
      Bennington: [68007],
      Bertrand: [68927],
      Berwyn: [68819],
      'Big Springs': [69122],
      Bingham: [69335],
      Bladen: [68928],
      Blair: [68008],
      Bloomfield: [68718],
      Bloomington: [68929],
      'Blue Hill': [68930],
      'Blue Springs': [68318],
      Boelus: [68820],
      Bradshaw: [68319],
      Brady: [69123],
      Brainard: [68626],
      Brewster: [68821],
      Bridgeport: [69336],
      Bristow: [68719],
      Broadwater: [69125],
      Brock: [68320],
      'Broken Bow': [68822],
      Brownlee: [69166],
      Brownville: [68321],
      Brule: [69127],
      Bruning: [68322],
      Bruno: [68014],
      Brunswick: [68720],
      Burchard: [68323],
      Burr: [68324],
      Burwell: [68823],
      Bushnell: [69128],
      Butte: [68722],
      Byron: [68325],
      Cairo: [68824],
      Callaway: [68825],
      Cambridge: [69022],
      Campbell: [68932],
      Carleton: [68326],
      Carroll: [68723],
      'Cedar Bluffs': [68015],
      'Cedar Rapids': [68627],
      Center: [68724],
      'Central City': [68826],
      Ceresco: [68017],
      Chadron: [69337],
      Chambers: [68725],
      Champion: [69023],
      Chapman: [68827],
      Chappell: [69129],
      Chester: [68327],
      Clarks: [68628],
      Clarkson: [68629],
      Clatonia: [68328],
      'Clay Center': [68933],
      Clearwater: [68726],
      Cody: [69211],
      Coleridge: [68727],
      Colon: [68018],
      Comstock: [68828],
      Concord: [68728],
      Cook: [68329],
      Cordova: [68330],
      Cortland: [68331],
      Cotesfield: [68829],
      Cozad: [69130],
      'Crab Orchard': [68332],
      Craig: [68019],
      Crawford: [69339],
      Creighton: [68729],
      Creston: [68631],
      Crete: [68333],
      Crofton: [68730],
      Crookston: [69212],
      Culbertson: [69024],
      Curtis: [69025],
      'Dakota City': [68731],
      Dalton: [69131],
      Danbury: [69026],
      Dannebrog: [68831],
      Davenport: [68335],
      Davey: [68336],
      Dawson: [68337],
      Daykin: [68338],
      'De Witt': [68341],
      Decatur: [68020],
      Denton: [68339],
      Deshler: [68340],
      Deweese: [68934],
      Dickens: [69132],
      Diller: [68342],
      Dix: [69133],
      Dixon: [68732],
      Dodge: [68633],
      Doniphan: [68832],
      Dorchester: [68343],
      Douglas: [68344],
      'Du Bois': [68345],
      Dunbar: [68346],
      Dunning: [68833],
      Dwight: [68635],
      Eagle: [68347],
      Eddyville: [68834],
      Edgar: [68935],
      Edison: [68936],
      Elba: [68835],
      Elgin: [68636],
      'Elk Creek': [68348],
      Elkhorn: [68022],
      Ellsworth: [69340],
      'Elm Creek': [68836],
      Elmwood: [68349],
      Elsie: [69134],
      Elsmere: [69135],
      Elwood: [68937],
      Elyria: [68837],
      Emerson: [68733],
      Emmet: [68734],
      Enders: [69027],
      Endicott: [68350],
      Ericson: [68637],
      Eustis: [69028],
      Ewing: [68735],
      Exeter: [68351],
      Fairbury: [68352],
      Fairfield: [68938],
      Fairmont: [68354],
      'Falls City': [68355],
      Farnam: [69029],
      Farwell: [68838],
      Filley: [68357],
      Firth: [68358],
      Fordyce: [68736],
      'Fort Calhoun': [68023],
      Foster: [68737],
      Franklin: [68939],
      Fremont: [68025],
      Friend: [68359],
      Fullerton: [68638],
      Funk: [68940],
      Garland: [68360],
      Garrison: [68632],
      Geneva: [68361],
      Genoa: [68640],
      Gering: [69341],
      Gibbon: [68840],
      Gilead: [68362],
      Giltner: [68841],
      Glenvil: [68941],
      Goehner: [68364],
      Gordon: [69343],
      Gothenburg: [69138],
      Grafton: [68365],
      'Grand Island': [68801, 68803],
      Grant: [69140],
      Greeley: [68842],
      Greenwood: [68366],
      Gresham: [68367],
      Gretna: [68028],
      'Guide Rock': [68942],
      Gurley: [69141],
      Haigler: [69030],
      Hallam: [68368],
      Halsey: [69142],
      Hamlet: [69031],
      Hampton: [68843],
      Hardy: [68943],
      Harrisburg: [69345],
      Harrison: [69346],
      Hartington: [68739],
      Harvard: [68944],
      Hastings: [68901],
      'Hay Springs': [69347],
      'Hayes Center': [69032],
      Hazard: [68844],
      Heartwell: [68945],
      Hebron: [68370],
      Hemingford: [69348],
      Henderson: [68371],
      Hendley: [68946],
      Henry: [69349],
      Herman: [68029],
      Hershey: [69143],
      Hildreth: [68947],
      Holbrook: [68948],
      Holdrege: [68949],
      Holland: [68372],
      Holmesville: [68374],
      Holstein: [68950],
      Hooper: [68031],
      Hordville: [68846],
      Hoskins: [68740],
      Howells: [68641],
      Hubbard: [68741],
      Hubbell: [68375],
      Humboldt: [68376],
      Humphrey: [68642],
      Huntley: [68951],
      Hyannis: [69350],
      Imperial: [69033],
      Inavale: [68952],
      Indianola: [69034],
      Inland: [68954],
      Inman: [68742],
      Ithaca: [68033],
      Jackson: [68743],
      Jansen: [68377],
      Johnson: [68378],
      Johnstown: [69214],
      Julian: [68379],
      Juniata: [68955],
      Kearney: [68847],
      Kenesaw: [68956],
      Kennard: [68034],
      Keystone: [69144],
      Kilgore: [69216],
      Kimball: [69145],
      Lakeside: [69351],
      Lamar: [69035],
      Laurel: [68745],
      Lawrence: [68957],
      Lebanon: [69036],
      Leigh: [68643],
      Lemoyne: [69146],
      Leshara: [68035],
      Lewellen: [69147],
      Lewiston: [68380],
      Lexington: [68850],
      Liberty: [68381],
      Lincoln: [
        68502, 68503, 68504, 68505, 68506, 68507, 68508, 68510, 68512, 68514,
        68516, 68517, 68520, 68521, 68522, 68523, 68524, 68526, 68527, 68528,
        68531, 68532,
      ],
      Lindsay: [68644],
      Linwood: [68036],
      Lisco: [69148],
      Litchfield: [68852],
      Lodgepole: [69149],
      'Long Pine': [69217],
      Loomis: [68958],
      Louisville: [68037],
      'Loup City': [68853],
      Lyman: [69352],
      Lynch: [68746],
      Lyons: [68038],
      Macy: [68039],
      Madison: [68748],
      Madrid: [69150],
      Magnet: [68749],
      Malcolm: [68402],
      Malmo: [68040],
      Marquette: [68854],
      Marsland: [69354],
      Martell: [68404],
      Maskell: [68751],
      'Mason City': [68855],
      Max: [69037],
      Maxwell: [69151],
      Maywood: [69038],
      'Mc Cook': [69001],
      'Mc Cool Junction': [68401],
      Mclean: [68747],
      Mead: [68041],
      'Meadow Grove': [68752],
      Merna: [68856],
      Merriman: [69218],
      Milburn: [68813],
      Milford: [68405],
      Millard: [68137, 68144],
      Miller: [68858],
      Milligan: [68406],
      Mills: [68753],
      Minatare: [69356],
      Minden: [68959],
      Mitchell: [69357],
      Monroe: [68647],
      Moorefield: [69039],
      Morrill: [69358],
      'Morse Bluff': [68648],
      Mullen: [69152],
      Murdock: [68407],
      Murray: [68409],
      Naper: [68755],
      Naponee: [68960],
      'Nebraska City': [68410],
      Nehawka: [68413],
      Neligh: [68756],
      Nemaha: [68414],
      Newcastle: [68757],
      'Newman Grove': [68758],
      Newport: [68759],
      Nickerson: [68044],
      Nora: [68961],
      Norfolk: [68701],
      'North Bend': [68649],
      'North Loup': [68859],
      'North Platte': [69101],
      Oak: [68964],
      Oakdale: [68761],
      Oakland: [68045],
      Obert: [68762],
      Oconto: [68860],
      Octavia: [68650],
      Odell: [68415],
      Odessa: [68861],
      'Offutt A F B': [68113],
      Ogallala: [69153],
      Ohiowa: [68416],
      Omaha: [
        68102, 68104, 68105, 68106, 68107, 68108, 68110, 68111, 68112, 68114,
        68116, 68117, 68118, 68122, 68123, 68124, 68130, 68131, 68132, 68134,
        68135, 68136, 68142, 68147, 68152, 68154, 68164,
      ],
      Oneill: [68763],
      Ong: [68452],
      Orchard: [68764],
      Ord: [68862],
      Orleans: [68966],
      Osceola: [68651],
      Oshkosh: [69154],
      Osmond: [68765],
      Otoe: [68417],
      Overton: [68863],
      Oxford: [68967],
      Page: [68766],
      Palisade: [69040],
      Palmer: [68864],
      Palmyra: [68418],
      Papillion: [68046, 68128, 68133, 68138, 68157],
      Parks: [69041],
      'Pawnee City': [68420],
      Paxton: [69155],
      Pender: [68047],
      Peru: [68421],
      Petersburg: [68652],
      Phillips: [68865],
      Pickrell: [68422],
      Pierce: [68767],
      Pilger: [68768],
      Plainview: [68769],
      'Platte Center': [68653],
      Plattsmouth: [68048],
      'Pleasant Dale': [68423],
      Pleasanton: [68866],
      Plymouth: [68424],
      Polk: [68654],
      Ponca: [68770],
      Potter: [69156],
      Prague: [68050],
      Primrose: [68655],
      Prosser: [68868],
      Purdum: [69157],
      Ragan: [68969],
      Ralston: [68127],
      Randolph: [68771],
      Ravenna: [68869],
      'Red Cloud': [68970],
      'Republican City': [68971],
      Reynolds: [68429],
      Richfield: [68054],
      Richland: [68601],
      'Rising City': [68658],
      Riverdale: [68870],
      Riverton: [68972],
      Roca: [68430],
      Rockville: [68871],
      Rogers: [68659],
      Rosalie: [68055],
      Rose: [68772],
      Roseland: [68973],
      Royal: [68773],
      Rulo: [68431],
      Rushville: [69360],
      Ruskin: [68974],
      'Saint Edward': [68660],
      'Saint Helena': [68774],
      'Saint Libory': [68872],
      'Saint Mary': [68432],
      'Saint Paul': [68873],
      Salem: [68433],
      Sargent: [68874],
      Saronville: [68975],
      Schuyler: [68661],
      Scotia: [68875],
      Scottsbluff: [69361],
      Scribner: [68057],
      Seneca: [69161],
      Seward: [68434],
      Shelby: [68662],
      Shelton: [68876],
      Shickley: [68436],
      Shubert: [68437],
      Sidney: [69162],
      'Silver Creek': [68663],
      Smithfield: [68976],
      'South Sioux City': [68776],
      Spalding: [68665],
      Spencer: [68777],
      Springfield: [68059],
      Springview: [68778],
      Stamford: [68977],
      Stanton: [68779],
      Staplehurst: [68439],
      Stapleton: [69163],
      'Steele City': [68440],
      Steinauer: [68441],
      Stella: [68442],
      Sterling: [68443],
      Stockville: [69042],
      Strang: [68444],
      Stratton: [69043],
      Stromsburg: [68666],
      Stuart: [68780],
      Sumner: [68878],
      Superior: [68978],
      Sutherland: [69165],
      Sutton: [68979],
      Swanton: [68445],
      Syracuse: [68446],
      'Table Rock': [68447],
      Talmage: [68448],
      Tecumseh: [68450],
      Tekamah: [68061],
      Thurston: [68062],
      Tilden: [68781],
      Tobias: [68453],
      Trenton: [69044],
      Trumbull: [68980],
      Tryon: [69167],
      Ulysses: [68667, 68669],
      Unadilla: [68454],
      Union: [68455],
      Upland: [68981],
      Utica: [68456],
      Valentine: [69201],
      Valley: [68064],
      Valparaiso: [68065],
      Venango: [69168],
      Verdel: [68760],
      Verdigre: [68783],
      Verdon: [68457],
      Virginia: [68458],
      Waco: [68460],
      Wahoo: [68066],
      Wakefield: [68784],
      Wallace: [69169],
      Walthill: [68067],
      Walton: [68461],
      Waterbury: [68785],
      Waterloo: [68069],
      Wauneta: [69045],
      Wausa: [68786],
      Waverly: [68462],
      Wayne: [68787],
      'Weeping Water': [68463],
      Wellfleet: [69170],
      'West Point': [68788],
      Western: [68464],
      Westerville: [68881],
      Weston: [68070],
      Whitman: [69366],
      Whitney: [69367],
      Wilber: [68465],
      Wilcox: [68982],
      Wilsonville: [69046],
      Winnebago: [68071],
      Winnetoon: [68789],
      Winside: [68790],
      Wisner: [68791],
      Wolbach: [68882],
      'Wood Lake': [69221],
      'Wood River': [68883],
      Wymore: [68466],
      Wynot: [68792],
      York: [68467],
      Yutan: [68073],
    },
    name: 'Nebraska',
  },
  NH: {
    cities: {
      Allenstown: ['03275'],
      Alstead: ['03602'],
      Alton: ['03809'],
      'Alton Bay': ['03810'],
      Amherst: ['03031'],
      Andover: ['03216'],
      Antrim: ['03440'],
      Ashland: ['03217'],
      Ashuelot: ['03441'],
      Atkinson: ['03811'],
      Auburn: ['03032'],
      Barnstead: ['03218'],
      Barrington: ['03825'],
      Bartlett: ['03812'],
      Bath: ['03740'],
      Bedford: ['03110'],
      'Beebe River': ['03223'],
      Belmont: ['03220'],
      Bennington: ['03442'],
      Berlin: ['03570'],
      Bethlehem: ['03574'],
      Boscawen: ['03303'],
      Bow: ['03304'],
      Bradford: ['03221'],
      Brentwood: ['03833'],
      Bristol: ['03222'],
      Brookline: ['03033'],
      Canaan: ['03741'],
      Candia: ['03034'],
      Canterbury: ['03224'],
      'Center Barnstead': ['03225'],
      'Center Conway': ['03813'],
      'Center Harbor': ['03226'],
      'Center Ossipee': ['03814'],
      'Center Sandwich': ['03227'],
      'Center Strafford': ['03815'],
      'Center Tuftonbor': ['03816'],
      Charlestown: ['03603'],
      Chester: ['03036'],
      Chesterfield: ['03443'],
      Chocorua: ['03817'],
      Claremont: ['03743'],
      Colebrook: ['03576'],
      Concord: ['03301'],
      Conway: ['03818'],
      Cornish: ['03745'],
      Danbury: ['03230'],
      Danville: ['03819'],
      Deerfield: ['03037'],
      Derry: ['03038'],
      Dublin: ['03444'],
      Dunbarton: ['03045'],
      'East Andover': ['03231'],
      'East Hampstead': ['03826'],
      'East Hebron': ['03232'],
      'East Lempster': ['03605'],
      'East Rochester': ['03868'],
      'East Sullivan': ['03445'],
      'East Swanzey': ['03446'],
      'East Wakefield': ['03830'],
      Enfield: ['03748'],
      Epping: ['03042'],
      Epsom: ['03234'],
      Errol: ['03579'],
      Etna: ['03750'],
      Farmington: ['03835'],
      Fitzwilliam: ['03447'],
      Francestown: ['03043'],
      Franconia: ['03580'],
      Franklin: ['03235'],
      Freedom: ['03836'],
      Fremont: ['03044'],
      Gilford: ['03246'],
      Gilmanton: ['03237'],
      'Gilmanton Iron W': ['03837'],
      Gilsum: ['03448'],
      Glen: ['03838'],
      Gonic: ['03839'],
      Gorham: ['03581'],
      Goshen: ['03752'],
      Grafton: ['03240'],
      Grantham: ['03753'],
      Greenfield: ['03047'],
      Greenland: ['03840'],
      Groveton: ['03582'],
      Hampstead: ['03841'],
      Hampton: ['03842'],
      'Hampton Falls': ['03844'],
      Hancock: ['03449'],
      Hanover: ['03755'],
      Harrisville: ['03450'],
      Haverhill: ['03765'],
      Hebron: ['03241'],
      Henniker: ['03242'],
      Hill: ['03243'],
      Hillsboro: ['03244'],
      Hinsdale: ['03451'],
      Hollis: ['03049'],
      Hooksett: ['03106'],
      Hopkinton: ['03229'],
      Hudson: ['03051'],
      Intervale: ['03845'],
      Jackson: ['03846'],
      Jaffrey: ['03452'],
      Jefferson: ['03583'],
      Kingston: ['03848'],
      Lancaster: ['03584'],
      Lebanon: ['03766'],
      Lee: ['03824'],
      Lincoln: ['03251'],
      Lisbon: ['03585'],
      Littleton: ['03561'],
      Londonderry: ['03053'],
      Lyme: ['03768'],
      Lyndeborough: ['03082'],
      Madbury: ['03820'],
      Madison: ['03849'],
      Manchester: ['03101', '03102', '03103', '03104', '03109'],
      Marlborough: ['03455'],
      Marlow: ['03456'],
      Mason: ['03048'],
      Meredith: ['03253'],
      Meriden: ['03770'],
      Merrimack: ['03054'],
      Milan: ['03588'],
      Milford: ['03055'],
      'Milton Mills': ['03852'],
      'Mirror Lake': ['03853'],
      Monroe: ['03771'],
      'Mont Vernon': ['03057'],
      Moultonborough: ['03254'],
      Munsonville: ['03457'],
      Nashua: ['03060', '03062', '03063'],
      'New Boston': ['03070'],
      'New Castle': ['03854'],
      'New Durham': ['03855'],
      'New Hampton': ['03256'],
      'New Ipswich': ['03071'],
      'New London': ['03257'],
      Newington: ['03801'],
      Newmarket: ['03857'],
      Newport: ['03773'],
      Newton: ['03858'],
      'North Conway': ['03860'],
      'North Hampton': ['03862'],
      'North Haverhill': ['03774'],
      'North Sandwich': ['03259'],
      'North Stratford': ['03590'],
      'North Walpole': ['03609'],
      'North Woodstock': ['03262'],
      Northwood: ['03261'],
      Nottingham: ['03290'],
      Orford: ['03777'],
      Ossipee: ['03864'],
      Pelham: ['03076'],
      Peterborough: ['03458'],
      Piermont: ['03779'],
      Pike: ['03780'],
      Pittsburg: ['03592'],
      Pittsfield: ['03263'],
      Plainfield: ['03781'],
      Plaistow: ['03865'],
      Plymouth: ['03264'],
      Raymond: ['03077'],
      Richmond: ['03470'],
      Rindge: ['03461'],
      Rochester: ['03867'],
      Rollinsford: ['03869'],
      Rumney: ['03266'],
      Rye: ['03870'],
      Salem: ['03079'],
      Salisbury: ['03268'],
      Sanbornton: ['03269'],
      Sanbornville: ['03872'],
      Sandown: ['03873'],
      Seabrook: ['03874'],
      'Silver Lake': ['03875'],
      Somersworth: ['03878'],
      'South Acworth': ['03607'],
      'South Effingham': ['03882'],
      'South Hampton': ['03827'],
      'South Tamworth': ['03883'],
      Spofford: ['03462'],
      Stoddard: ['03464'],
      Strafford: ['03884'],
      Stratham: ['03885'],
      Sunapee: ['03782'],
      Surry: ['03431'],
      Tamworth: ['03886'],
      Temple: ['03084'],
      Tilton: ['03276'],
      Troy: ['03465'],
      Union: ['03887'],
      Walpole: ['03608'],
      Warner: ['03278'],
      Warren: ['03279'],
      Washington: ['03280'],
      Weare: ['03281'],
      Wentworth: ['03282'],
      'West Chesterfiel': ['03466'],
      'West Lebanon': ['03784'],
      'West Nottingham': ['03291'],
      'West Ossipee': ['03890'],
      'West Springfield': ['03284'],
      'West Swanzey': ['03469'],
      Westmoreland: ['03467'],
      Whitefield: ['03598'],
      'Wilmot Flat': ['03287'],
      Wilton: ['03086'],
      Windham: ['03087'],
      Wolfeboro: ['03894'],
      Woodsville: ['03785'],
    },
    name: 'New Hampshire',
  },
  NJ: {
    cities: {
      Allendale: ['07401'],
      Allenhurst: ['07711'],
      Allentown: ['08501'],
      Alpha: ['08865'],
      Alpine: ['07620'],
      Andover: ['07821'],
      Annandale: ['08801'],
      'Atlantic City': ['08401'],
      'Atlantic Highlan': ['07716'],
      Audubon: ['08106'],
      Augusta: ['07822'],
      Avalon: ['08202'],
      Avenel: ['07001'],
      'Avon By The Sea': ['07717'],
      Barnegat: ['08005'],
      Barrington: ['08007'],
      'Basking Ridge': ['07920'],
      Batsto: ['08037'],
      'Bay Head': ['08742'],
      Bayonne: ['07002'],
      Bayville: ['08721'],
      Beachwood: ['08722'],
      Bedminster: ['07921'],
      Belford: ['07718'],
      'Belle Mead': ['08502'],
      Belleville: ['07109'],
      Bellmawr: ['08031'],
      Belvidere: ['07823'],
      Bergenfield: ['07621'],
      'Berkeley Heights': ['07922'],
      Berlin: ['08009'],
      Bernardsville: ['07924'],
      Beverly: ['08010'],
      Blairstown: ['07825'],
      Bloomfield: ['07003'],
      Bloomingdale: ['07403'],
      Bloomsbury: ['08804'],
      Bogota: ['07603'],
      Boonton: ['07005'],
      Bordentown: ['08505'],
      'Bound Brook': ['08805'],
      'Bradley Beach': ['07720'],
      Branchville: ['07826'],
      Brick: ['08724'],
      Bridgeport: ['08014'],
      Bridgewater: ['08807'],
      Brielle: ['08730'],
      Brigantine: ['08203'],
      'Browns Mills': ['08015'],
      'Budd Lake': ['07828'],
      Buena: ['08310'],
      Burlington: ['08016'],
      Califon: ['07830'],
      Camden: ['08102', '08103', '08104', '08105'],
      'Cape May Court H': ['08210'],
      Carlstadt: ['07072'],
      'Carneys Point': ['08069'],
      Carteret: ['07008'],
      'Cedar Grove': ['07009'],
      'Cedar Knolls': ['07927'],
      Cedarville: ['08311'],
      Chatham: ['07928'],
      Chatsworth: ['08019'],
      'Cherry Hill': ['08002', '08003', '08034'],
      Chester: ['07930'],
      Cinnaminson: ['08077'],
      Clark: ['07066'],
      Clarksboro: ['08020'],
      Clarksburg: ['08510'],
      Clayton: ['08312'],
      'Cliffside Park': ['07010'],
      Cliffwood: ['07721'],
      Clifton: ['07011', '07012', '07013', '07014'],
      Clinton: ['08809'],
      Closter: ['07624'],
      Collingswood: ['08108'],
      Colonia: ['07067'],
      'Colts Neck': ['07722'],
      Columbia: ['07832'],
      Columbus: ['08022'],
      Cookstown: ['08511'],
      'Corbin City': ['08270'],
      Cranbury: ['08512'],
      Cranford: ['07016'],
      Creamridge: ['08514'],
      Cresskill: ['07626'],
      Crosswicks: ['08515'],
      Dayton: ['08810'],
      Deal: ['07723'],
      Delair: ['08110'],
      Delanco: ['08075'],
      Delmont: ['08314'],
      Demarest: ['07627'],
      Denville: ['07834'],
      Deptford: ['08096'],
      Dorothy: ['08317'],
      Dumont: ['07628'],
      'East Brunswick': ['08816'],
      'East Hanover': ['07936'],
      'East Orange': ['07017', '07018'],
      'East Rutherford': ['07073'],
      'Eastampton Twp': ['08060'],
      Eatontown: ['07724'],
      Edgewater: ['07020'],
      Edison: ['08817', '08820', '08837'],
      'Egg Harbor City': ['08215'],
      Elizabeth: ['07201', '07202', '07206', '07208'],
      Elmer: ['08318'],
      'Elmwood Park': ['07407'],
      Emerson: ['07630'],
      Englewood: ['07631'],
      'Englewood Cliffs': ['07632'],
      'Essex Fells': ['07021'],
      'Estell Manor': ['08319'],
      'Fair Haven': ['07704'],
      'Fair Lawn': ['07410'],
      Fairfield: ['07004'],
      Fairview: ['07022'],
      Fanwood: ['07023'],
      'Far Hills': ['07931'],
      Farmingdale: ['07727'],
      Flanders: ['07836'],
      Flemington: ['08822'],
      Florence: ['08518'],
      'Florham Park': ['07932'],
      Fords: ['08863'],
      'Forked River': ['08731'],
      'Fort Dix': ['08640'],
      'Fort Hancock': ['07732'],
      'Fort Lee': ['07024'],
      'Fort Monmouth': ['07703'],
      Franklin: ['07416'],
      'Franklin Lakes': ['07417'],
      'Franklin Park': ['08823'],
      Franklinville: ['08322'],
      'Fredon Township': ['07860'],
      Freehold: ['07728'],
      Frenchtown: ['08825'],
      Garfield: ['07026'],
      Garwood: ['07027'],
      Gibbsboro: ['08026'],
      Gibbstown: ['08027'],
      Gillette: ['07933'],
      Gladstone: ['07934'],
      Glassboro: ['08028'],
      'Glen Gardner': ['08826'],
      'Glen Ridge': ['07028'],
      'Glen Rock': ['07452'],
      Glendora: [8029],
      Glenwood: ['07418'],
      'Gloucester City': ['08030'],
      'Great Meadows': ['07838'],
      'Green Brook': ['08812'],
      'Green Village': ['07935'],
      'Greystone Park': ['07950'],
      Guttenberg: ['07093'],
      Hackensack: ['07601'],
      Hackettstown: ['07840'],
      'Haddon Heights': ['08035'],
      Haddonfield: ['08033'],
      Haledon: ['07508'],
      Hamburg: ['07419'],
      Hamilton: ['08609', '08610', '08611', '08629', '08690', '08691'],
      Hampton: ['08827'],
      'Harrington Park': ['07640'],
      'Harvey Cedars': ['08008'],
      'Hasbrouck Height': ['07604'],
      Haskell: ['07420'],
      Haworth: ['07641'],
      Hawthorne: ['07506'],
      Hazlet: ['07730'],
      Heislerville: ['08324'],
      Helmetta: ['08828'],
      Hewitt: ['07421'],
      'High Bridge': ['08829'],
      'Highland Lakes': ['07422'],
      'Highland Park': ['08904'],
      Hightstown: ['08520'],
      Hillsdale: ['07642'],
      Hillside: ['07205'],
      'Ho Ho Kus': ['07423'],
      Hoboken: ['07030'],
      Holmdel: ['07733'],
      Hopatcong: ['07843'],
      Hopewell: ['08525'],
      Howell: ['07731'],
      Imlaystown: ['08526'],
      Irvington: ['07111'],
      Iselin: ['08830'],
      'Island Heights': ['08732'],
      Jackson: ['08527'],
      Jamesburg: ['08831'],
      'Jersey City': ['07302', '07304', '07305', '07306', '07307', '07310'],
      Jobstown: ['08041'],
      Keansburg: ['07734'],
      Kearny: ['07029', '07032'],
      Keasbey: ['08832'],
      'Kendall Park': ['08824'],
      Kenilworth: ['07033'],
      Kenvil: ['07847'],
      Keyport: ['07735'],
      Kingston: ['08528'],
      Kinnelon: ['07405'],
      Lafayette: ['07848'],
      'Lake Hiawatha': ['07034'],
      'Lake Hopatcong': ['07849'],
      'Lakehurst Naec': ['08733'],
      Lakewood: ['08701'],
      Lambertville: ['08530'],
      Landing: ['07850'],
      Landisville: ['08326'],
      'Lanoka Harbor': ['08734'],
      'Laurel Springs': ['08021'],
      'Laurence Harbor': ['08879'],
      Lavallette: ['08735'],
      Lawnside: ['08045'],
      Lawrenceville: ['08648'],
      Layton: ['07851'],
      Lebanon: ['08833'],
      Ledgewood: ['07852'],
      Leesburg: ['08327'],
      Leonardo: ['07737'],
      Leonia: ['07605'],
      'Lincoln Park': ['07035'],
      Lincroft: ['07738'],
      Linden: ['07036'],
      Linwood: ['08221'],
      'Little Ferry': ['07643'],
      'Little Silver': ['07739'],
      Livingston: ['07039'],
      Lodi: ['07644'],
      'Long Branch': ['07740'],
      'Long Valley': ['07853'],
      Longport: ['08403'],
      Lumberton: ['08048'],
      Lyndhurst: ['07071'],
      Madison: ['07940'],
      Magnolia: ['08049'],
      Mahwah: ['07430'],
      Malaga: ['08328'],
      Manahawkin: ['08050'],
      Manalapan: ['07726'],
      Manasquan: ['08736'],
      Mantoloking: ['08738'],
      Mantua: ['08051'],
      Manville: ['08835'],
      'Maple Shade': ['08052'],
      Maplewood: ['07040'],
      'Margate City': ['08402'],
      Marlboro: ['07746'],
      Marlton: ['08053'],
      Marmora: ['08223'],
      Martinsville: ['08836'],
      Matawan: ['07747'],
      'Mays Landing': ['08330'],
      Maywood: ['07607'],
      'Mc Guire Afb': ['08641'],
      'Medford Lakes': ['08055'],
      Mendham: ['07945'],
      Mercerville: ['08619'],
      Merchantville: ['08109'],
      Metuchen: ['08840'],
      Mickleton: ['08056'],
      Middlesex: ['08846'],
      'Midland Park': ['07432'],
      Milford: ['08848'],
      Millburn: ['07041'],
      Millington: ['07946'],
      Milltown: ['08850'],
      Millville: ['08332'],
      Milmay: ['08340'],
      Milton: ['07438'],
      'Mine Hill': ['07801'],
      Minotola: ['08341'],
      'Monmouth Beach': ['07750'],
      'Monmouth Junctio': ['08852'],
      Monroeville: ['08343'],
      Montague: ['07827'],
      Montclair: ['07042', '07043'],
      Montvale: ['07645'],
      Montville: ['07045'],
      Moonachie: ['07074'],
      Moorestown: ['08057'],
      Morganville: ['07751'],
      Morristown: ['07960'],
      'Mount Arlington': ['07856'],
      'Mount Ephraim': ['08059'],
      'Mount Laurel': ['08054'],
      'Mount Royal': ['08061'],
      'Mountain Lakes': ['07046'],
      Mountainside: ['07092'],
      'Mullica Hill': ['08062'],
      'National Park': ['08063'],
      'Neptune City': ['07753'],
      'Neshanic Station': ['08853'],
      Netcong: ['07857'],
      'New Brunswick': ['08901'],
      'New Egypt': ['08533'],
      'New Milford': ['07646'],
      'New Monmouth': ['07748'],
      'New Providence': ['07974'],
      'New Vernon': ['07976'],
      Newark: [
        '07102',
        '07103',
        '07104',
        '07105',
        '07106',
        '07107',
        '07108',
        '07112',
        '07114',
      ],
      Newfield: ['08344'],
      Newfoundland: ['07435'],
      Newport: ['08345'],
      Newtonville: ['08346'],
      'North Arlington': ['07031'],
      'North Bergen': ['07047'],
      'North Branch': ['08876'],
      'North Brunswick': ['08902'],
      'North Cape May': ['08204'],
      'North Plainfield': ['07060', '07062', '07063'],
      'North Wildwood': ['08260'],
      Northfield: ['08225'],
      Norwood: ['07648'],
      Nutley: ['07110'],
      Oakhurst: ['07755'],
      Oakland: ['07436'],
      Oaklyn: ['08107'],
      Ocean: ['07712'],
      'Ocean City': ['08226'],
      'Ocean Gate': ['08740'],
      'Ocean Grove': ['07756'],
      'Ocean View': ['08230'],
      Oceanport: ['07757'],
      Ogdensburg: ['07439'],
      'Old Bridge': ['08857'],
      'Old Tappan': ['07675'],
      Oradell: ['07649'],
      Orange: ['07050'],
      Osbornsville: ['08723'],
      Oxford: ['07863'],
      'Palisades Park': ['07650'],
      Palmyra: ['08065'],
      Paramus: ['07652'],
      'Park Ridge': ['07656'],
      Parlin: ['08859'],
      Parsippany: ['07054'],
      Passaic: ['07055'],
      Paterson: [
        '07501',
        '07502',
        '07503',
        '07504',
        '07505',
        '07513',
        '07514',
        '07522',
        '07524',
      ],
      Pattenburg: ['08802'],
      Paulsboro: ['08066'],
      Pedricktown: ['08067'],
      Pemberton: ['08068'],
      Pennington: ['08534'],
      Pennsville: ['08070'],
      Pequannock: ['07440'],
      Perrineville: ['08535'],
      'Perth Amboy': ['08861'],
      'Pine Beach': ['08741'],
      'Pine Brook': ['07058'],
      Piscataway: ['08854'],
      Pitman: ['08071'],
      Pittstown: ['08867'],
      Plainsboro: ['08536'],
      Pleasantville: ['08232'],
      'Pompton Lakes': ['07442'],
      'Pompton Plains': ['07444'],
      'Port Monmouth': ['07758'],
      'Port Murray': ['07865'],
      'Port Norris': ['08349'],
      'Port Reading': ['07064'],
      'Port Republic': ['08241'],
      Princeton: ['08540', '08542'],
      'Princeton Juncti': ['08550'],
      'Princeton Univer': ['08544'],
      Rahway: ['07065'],
      Ramsey: ['07446'],
      Randolph: ['07869'],
      Raritan: ['08869'],
      Richland: ['08350'],
      Ridgefield: ['07657'],
      'Ridgefield Park': ['07660'],
      Ridgewood: ['07450'],
      Ringoes: ['08551'],
      Ringwood: ['07456'],
      'Rio Grande': ['08242'],
      'River Edge': ['07661'],
      Riverdale: ['07457'],
      Rockaway: ['07866'],
      Rockleigh: ['07647'],
      'Rocky Hill': ['08553'],
      Roebling: ['08554'],
      Roseland: ['07068'],
      Roselle: ['07203'],
      'Roselle Park': ['07204'],
      Rosemont: ['08556'],
      Runnemede: ['08078'],
      Rutherford: ['07070'],
      'Saddle Brook': ['07662'],
      Salem: ['08079'],
      Sayreville: ['08872'],
      'Scotch Plains': ['07076'],
      'Sea Bright': ['07760'],
      'Sea Girt': ['08750'],
      Seabrook: ['08302'],
      'Seaside Heights': ['08751'],
      'Seaside Park': ['08752'],
      Secaucus: ['07094'],
      Sewaren: ['07077'],
      Sewell: ['08080'],
      'Short Hills': ['07078'],
      Shrewsbury: ['07702'],
      Sicklerville: ['08081'],
      Skillman: ['08558'],
      Smithville: ['08201'],
      Somerdale: ['08083'],
      'Somers Point': ['08244'],
      Somerset: ['08873'],
      'South Bound Broo': ['08880'],
      'South Hackensack': ['07606'],
      'South Orange': ['07079'],
      'South Plainfield': ['07080'],
      'South River': ['08882'],
      Southampton: ['08088'],
      Sparta: ['07871'],
      Spotswood: ['08884'],
      'Spring Lake': ['07762'],
      Springfield: ['07081'],
      Stanhope: ['07874'],
      Stewartsville: ['08886'],
      Stirling: ['07980'],
      Stockholm: ['07460'],
      Stockton: ['08559'],
      'Stone Harbor': ['08247'],
      Stratford: ['08084'],
      Strathmere: ['08248'],
      Suburban: ['07701'],
      Succasunna: ['07876'],
      Summit: ['07901'],
      Sussex: ['07461'],
      Swedesboro: ['08085'],
      Teaneck: ['07666'],
      Tenafly: ['07670'],
      Teterboro: ['07608'],
      Thorofare: ['08086'],
      'Three Bridges': ['08887'],
      Titusville: ['08560'],
      'Toms River': ['08753', '08755', '08757'],
      Totowa: ['07512'],
      Towaco: ['07082'],
      'Townsends Inlet': ['08243'],
      Trenton: ['08608', '08618', '08638'],
      Tuckerton: ['08087'],
      Union: ['07083'],
      'Upper Saddle Riv': ['07458'],
      Vauxhall: ['07088'],
      'Ventnor City': ['08406'],
      Vernon: ['07462'],
      Verona: ['07044'],
      Villas: ['08251'],
      Vineland: ['08360'],
      Voorhees: ['08043'],
      Waldwick: ['07463'],
      Wall: ['07719'],
      Wallington: ['07057'],
      'Wallpack Center': ['07881'],
      Wanaque: ['07465'],
      Waretown: ['08758'],
      Warren: ['07059'],
      Washington: ['07882', '08012'],
      'Waterford Works': ['08089'],
      Wayne: ['07470'],
      Weehawken: ['07087'],
      Wenonah: ['08090'],
      'West Berlin': ['08091'],
      'West Caldwell': ['07006'],
      'West Creek': ['08092'],
      'West Long Branch': ['07764'],
      'West Milford': ['07480'],
      'West Orange': ['07052'],
      'West Paterson': ['07424'],
      'West Trenton': ['08628'],
      Westfield: ['07090'],
      Westville: ['08093'],
      Wharton: ['07885'],
      Whippany: ['07981'],
      'Whitehouse Stati': ['08889'],
      Whiting: ['08759'],
      Williamstown: ['08094'],
      Willingboro: ['08046'],
      Winslow: ['08004'],
      'Wood Ridge': ['07075'],
      Woodbridge: ['07095'],
      'Woodbury Heights': ['08097'],
      Woodstown: ['08098'],
      Wrightstown: ['08562'],
      Wyckoff: ['07481'],
      Yardville: ['08620'],
    },
    name: 'New Jersey',
  },
  NM: {
    cities: {
      Abiquiu: [87510],
      Alameda: [87114],
      Alamo: [87825],
      Alamogordo: [88310],
      Albert: [87733],
      Albuquerque: [
        87102, 87104, 87105, 87106, 87107, 87108, 87109, 87110, 87111, 87112,
        87113, 87116, 87118, 87120, 87121, 87122, 87123,
      ],
      Algodones: [87001],
      Amistad: [88410],
      Animas: [88020],
      'Anton Chico': [87711],
      Aragon: [87820],
      Arrey: [87930],
      'Arroyo Hondo': [87513],
      'Arroyo Seco': [87514],
      Artesia: [88210],
      Aztec: [87410],
      Bard: [88411],
      'Bell Ranch': [88441],
      Bent: [88314],
      Bernalillo: [87004],
      Bingham: [87815],
      Blanco: [87412],
      Bloomfield: [87413],
      Bluewater: [87005],
      Bosque: [87006],
      'Bosque Farms': [87068],
      'Boys Ranch': [87002],
      Brimhall: [87310],
      Broadview: [88112],
      Buckhorn: [88025],
      Bueyeros: [88412],
      Caballo: [87931],
      Canoncito: [87026],
      Capitan: [88316],
      Caprock: [88213],
      Capulin: [88414],
      Carlsbad: [88220],
      Carrizozo: [88301],
      'Casa Blanca': [87007],
      Causey: [88113],
      'Cedar Crest': [87008],
      Cedarvale: [87009],
      Central: [88026],
      Cerrillos: [87010],
      Chacon: [87713],
      Chama: [87520],
      Chamisal: [87521],
      Chaparral: [88021],
      Cimarron: [87714],
      Clayton: [88415],
      Cleveland: [87715],
      Cloudcroft: [88317],
      Clovis: [88101],
      'Cochiti Pueblo': [87041],
      'Conchas Dam': [88416],
      'Continental Divi': [87312],
      Corona: [88318],
      Corrales: [87048],
      Costilla: [87524],
      Counselor: [87018],
      Crossroads: [88114],
      Crownpoint: [87313],
      Cuba: [87013],
      Cubero: [87014],
      Cuchillo: [87932],
      Cuervo: [88417],
      Cundiyo: [87522],
      Datil: [87821],
      Deming: [88030],
      Derry: [87933],
      'Des Moines': [88418],
      Dexter: [88230],
      Dixon: [87527],
      Dulce: [87528],
      'Eagle Nest': [87718],
      Edgewood: [87015],
      'El Rito': [87530],
      Elida: [88116],
      Embudo: [87531],
      Encino: [88321],
      Espanola: [87532],
      Estancia: [87016],
      Eunice: [88231],
      Farmington: [87401, 87402],
      'Fence Lake': [87315],
      'Flora Vista': [87415],
      Floyd: [88118],
      Folsom: [88419],
      'Fort Sumner': [88119],
      Fruitland: [87416],
      Gallina: [87017],
      Gallup: [87301],
      Garfield: [87936],
      Garita: [88421],
      Gladstone: [88422],
      Glencoe: [88324],
      Glenwood: [88039],
      Glorieta: [87535],
      Grady: [88120],
      Grants: [87020],
      Grenville: [88424],
      Guadalupita: [87722],
      Hagerman: [88232],
      Hatch: [87937],
      Hernandez: [87537],
      Hillsboro: [88042],
      Hobbs: [88240],
      'Holloman Air For': [88330],
      Hondo: [88336],
      Hope: [88250],
      House: [88121],
      Hurley: [88043],
      Jal: [88252],
      Jarales: [87023],
      'Jemez Pueblo': [87024],
      'Jemez Springs': [87025],
      Kirtland: [87417],
      'Kirtland A F B E': [87115],
      'La Jara': [87027],
      'La Loma': [87724],
      'La Luz': [88337],
      'La Madera': [87539],
      'La Mesa': [88044],
      'La Plata': [87418],
      Lajoya: [87028],
      'Lake Arthur': [88253],
      Lamy: [87540],
      'Las Cruces': [88001, 88005],
      'Las Vegas': [87701],
      Ledoux: [87725],
      Lemitar: [87823],
      Lincoln: [88338],
      Lindrith: [87029],
      Lingo: [88123],
      Logan: [88426],
      'Los Alamos': [87544],
      'Los Lunas': [87031],
      Loving: [88256],
      Lovington: [88260],
      Maljamar: [88264],
      Maxwell: [87728],
      Mayhill: [88339],
      'Mc Alister': [88427],
      Melrose: [88124],
      Mescalero: [88340],
      'Mesilla Park': [88047],
      Mesquite: [88048],
      'Mexican Springs': [87320],
      Miami: [87729],
      Mills: [87730],
      Milnesand: [88125],
      Mimbres: [88049],
      Montezuma: [87731],
      Monument: [88265],
      Mora: [87732],
      Moriarty: [87035],
      'Mount Dora': [88429],
      Mountainair: [87036],
      'Nara Visa': [88430],
      Navajo: [87328],
      'Navajo Dam': [87419],
      Newkirk: [88431],
      Nogal: [88341],
      Ocate: [87734],
      'Oil Center': [88266],
      'Ojo Caliente': [87549],
      Pastura: [88435],
      Pecos: [87552],
      Penasco: [87553],
      Pep: [88126],
      Peralta: [87042],
      Picacho: [88343],
      'Pie Town': [87827],
      Pinon: [88344],
      Placitas: [87043],
      'Pojoaque Valley': [87501],
      Polvadera: [87828],
      Ponderosa: [87044],
      Portales: [88130],
      Prewitt: [87045],
      'Puerto De Luna': [88432],
      Quay: [88433],
      Quemado: [87829],
      Questa: [87556],
      Ramah: [87321],
      'Ranchos De Taos': [87557],
      Raton: [87740],
      Regina: [87046],
      Reserve: [87830],
      Ribera: [87560],
      Rincon: [87940],
      'Rio Rancho': [87124],
      'Road Forks': [88045],
      Rociada: [87742],
      Rogers: [88132],
      Roswell: [88201],
      Roy: [87743],
      Ruidoso: [88345],
      'Ruidoso Downs': [88346],
      Rutheron: [87563],
      Sacramento: [88347],
      'Saint Vrain': [88133],
      Salem: [87941],
      'San Acacia': [87831],
      'San Cristobal': [87564],
      'San Jon': [88434],
      'San Jose': [87565],
      'San Juan Pueblo': [87566],
      'San Lorenzo': [88041],
      'San Mateo': [87050],
      'San Patricio': [88348],
      'Sandia Park': [87047],
      'Santa Cruz': [87567],
      'Santa Fe': [87505],
      'Santo Domingo Pu': [87052],
      Sapello: [87745],
      Seboyeta: [87055],
      Sedan: [88436],
      Seneca: [88437],
      Shiprock: [87420],
      'Silver City': [88061],
      Socorro: [87801],
      Solano: [87746],
      Springer: [87747],
      Stanley: [87056],
      Stead: [88438],
      Taiban: [88134],
      Taos: [87571],
      Tatum: [88267],
      Tererro: [87573],
      Texico: [88135],
      Thoreau: [87323],
      'Tierra Amarilla': [87575],
      Tijeras: [87059],
      Tinnie: [88351],
      Toadlena: [87324],
      Tohatchi: [87325],
      Trementina: [88439],
      'Truth Or Consequ': [87901],
      Tucumcari: [88401],
      Tularosa: [88352],
      Vadito: [87579],
      Valdez: [87580],
      Vallecitos: [87581],
      Valmora: [87750],
      Vanadium: [88023],
      Vaughn: [88353],
      Veguita: [87062],
      'Wagon Mound': [87752],
      Waterflow: [87421],
      Weed: [88354],
      'White Sands Miss': [88002],
      Willard: [87063],
      Williamsburg: [87942],
      Winston: [87943],
      Yeso: [88136],
      'Zia Pueblo': [87053],
      Zuni: [87327],
    },
    name: 'New Mexico',
  },
  NV: {
    cities: {
      Alamo: [89001],
      'Amargosa Valley': [89020],
      Austin: [89310],
      Baker: [89311],
      'Battle Mountain': [89820],
      Beowawe: [89821],
      'Boulder City': [89005],
      Caliente: [89008],
      Carlin: [89822],
      'Carson City': [89701, 89703, 89704, 89705],
      'Cottonwood Cove': [89046],
      Dayton: [89403],
      Deeth: [89823],
      Denio: [89404],
      Ely: [89301],
      Empire: [89405],
      Eureka: [89316],
      Fallon: [89406],
      Fernley: [89408],
      Gabbs: [89409],
      Gardnerville: [89410],
      Gerlach: [89412],
      Glenbrook: [89413],
      Golconda: [89414],
      Goldfield: [89013],
      Goodsprings: [89019],
      Hawthorne: [89415],
      Henderson: [89014, 89015],
      Hiko: [89017],
      'Incline Village': [89451],
      'Indian Springs': [89018],
      Jackpot: [89825],
      Jiggs: [89801],
      'Las Vegas': [
        89101, 89102, 89103, 89104, 89106, 89107, 89108, 89109, 89110, 89113,
        89115, 89117, 89118, 89119, 89120, 89121, 89122, 89123, 89124, 89128,
        89129, 89130, 89131, 89134,
      ],
      Laughlin: [89029],
      Lovelock: [89419],
      Lund: [89317],
      Luning: [89420],
      Minden: [89423],
      Moundhouse: [89706],
      'Mountain City': [89831],
      Nixon: [89424],
      'North Las Vegas': [89030, 89031],
      Oasis: [89835],
      Orovada: [89425],
      Overton: [89040],
      Pahrump: [89041],
      'Paradise Valley': [89426],
      Pioche: [89043],
      Reno: [89501, 89502, 89503, 89506, 89509, 89510, 89511, 89512, 89523],
      'Round Mountain': [89045],
      'Ruby Valley': [89833],
      Schurz: [89427],
      'Silver Springs': [89429],
      Silverpeak: [89047],
      Smith: [89430],
      Sparks: [89431, 89434, 89436],
      'Sun Valley': [89433],
      Tonopah: [89049],
      Tuscarora: [89834],
      Unionville: [89418],
      'Virginia City': [89440],
      Wadsworth: [89442],
      Wellington: [89444],
      Winnemucca: [89445],
      Yerington: [89447],
    },
    name: 'Nevada',
  },
  NY: {
    cities: {
      12462: [12462],
      Accord: [12404],
      Acra: [12405],
      'Adams Basin': [14410],
      'Adams Center': [13606],
      Addison: [14801],
      Adirondack: [12808],
      Afton: [13730],
      Akron: [14001],
      Alabama: [14003],
      Albany: [12202, 12204, 12206, 12207, 12208, 12209, 12210],
      Albertson: [11507],
      Albion: [14411],
      Alcove: [12007],
      Alden: [14004],
      'Alden Manor': [11003],
      'Alder Creek': [13301],
      Alexander: [14005],
      Alfred: [14802],
      'Alfred Station': [14803],
      Allegany: [14706],
      Alma: [14708],
      Almond: [14804],
      Alpine: [14805],
      Alplaus: [12008],
      Altamont: [12009],
      Altmar: [13302],
      Altona: [12910],
      Amawalk: [10501],
      Amenia: [12501],
      Ames: [13317],
      Amherst: [14226, 14228],
      Amityville: [11701],
      Ancram: [12502],
      Ancramdale: [12503],
      Andes: [13731],
      Andover: [14806],
      Angelica: [14709],
      Angola: [14006],
      Antwerp: [13608],
      Apalachin: [13732],
      Appleton: [14008],
      Arcade: [14009],
      Ardsley: [10502],
      Argyle: [12809],
      Arkport: [14807],
      Arkville: [12406],
      Arlington: [12603],
      Armonk: [10504],
      Ashland: [12407],
      Ashville: [14710],
      Astoria: [11101, 11102, 11103, 11105, 11106],
      Athens: [12015],
      Athol: [12810],
      Atlanta: [14808],
      'Atlantic Beach': [11509],
      Attica: [14011],
      'Au Sable Chasm': [12911],
      'Au Sable Forks': [12912],
      Auburn: [13021],
      Aurora: [13026],
      Austerlitz: [12017],
      Ava: [13303],
      'Averill Park': [12018],
      Avon: [14414],
      Bainbridge: [13733],
      Baldwin: [11510],
      Baldwinsville: [13027],
      'Ballston Lake': [12019],
      'Ballston Spa': [12020],
      Bangor: [12966],
      Bardonia: [10954],
      Barker: [14012],
      Barneveld: [13304],
      Barrytown: [12507],
      Barryville: [12719],
      Barton: [13734],
      Basom: [14013],
      Batavia: [14020],
      Bayberry: [13090],
      Bayport: [11705],
      Bayside: [11360, 11361],
      Bayville: [11709],
      Beacon: [12508],
      'Bear Mountain': [10911],
      'Beaver Dams': [14812],
      'Beaver River': [13367],
      Bedford: [10506],
      'Bedford Hills': [10507],
      Belfast: [14711],
      Bellerose: [11426],
      Belleville: [13611],
      Bellona: [14415],
      Bellport: [11713],
      Belmont: [14813],
      'Bemus Point': [14712],
      Bergen: [14416],
      Berkshire: [13736],
      Berlin: [12022],
      Berne: [12023],
      'Bernhards Bay': [13028],
      Bethel: [12720],
      Bethpage: [11714],
      'Big Flats': [14814],
      Binghamton: [13901, 13903, 13904, 13905],
      'Black Creek': [14714],
      'Black River': [13612],
      Blasdell: [14219],
      Blauvelt: [10913],
      Bliss: [14024],
      Bloomfield: [14469],
      Bloomingburg: [12721],
      Bloomingdale: [12913],
      Bloomington: [12411],
      Bloomville: [13739],
      Blossvale: [13308],
      'Blue Mountain La': [12812],
      'Blue Point': [11715],
      'Bluff Point': [14478],
      Bohemia: [11716],
      Boiceville: [12412],
      Bolivar: [14715],
      'Bolton Landing': [12814],
      Bombay: [12914],
      Boonville: [13309],
      Boston: [14025],
      Bouckville: [13310],
      'Bovina Center': [13740],
      Bowmansville: [14026],
      Bradford: [14815],
      Brainard: [12024],
      Branchport: [14418],
      'Brant Lake': [12815],
      'Brasher Falls': [13613],
      Breesport: [14816],
      Brewerton: [13029],
      Brewster: [10509],
      'Briarcliff Manor': [10510],
      Bridgeport: [13030],
      'Brier Hill': [13614],
      Brightwaters: [11718],
      Brisben: [13830],
      Broadalbin: [12025],
      Brockport: [14420],
      Brocton: [14716],
      Bronx: [
        10451, 10452, 10453, 10454, 10455, 10456, 10457, 10458, 10459, 10460,
        10461, 10462, 10463, 10464, 10465, 10466, 10467, 10468, 10469, 10470,
        10471, 10472, 10473, 10474, 10475,
      ],
      Bronxville: [10708],
      Brookfield: [13314],
      Brookhaven: [11719],
      Brooklyn: [
        11201, 11203, 11204, 11205, 11206, 11207, 11208, 11209, 11210, 11211,
        11212, 11213, 11214, 11215, 11216, 11217, 11218, 11219, 11220, 11221,
        11222, 11223, 11224, 11225, 11226, 11228, 11229, 11230, 11231, 11232,
        11233, 11234, 11235, 11236, 11237, 11238, 11239,
      ],
      'Brooklyn Navy Ya': [11251],
      Brooktondale: [14817],
      Brushton: [12916],
      Buchanan: [10511],
      Buffalo: [
        14201, 14202, 14203, 14204, 14206, 14207, 14208, 14209, 14210, 14211,
        14212, 14213, 14214, 14215, 14216, 14220, 14222, 14223,
      ],
      Burdett: [14818],
      Burke: [12917],
      'Burlington Flats': [13315],
      'Burnt Hills': [12027],
      Burt: [14028],
      Buskirk: [12028],
      Byron: [14422],
      Cadosia: [13783],
      Cadyville: [12918],
      Cairo: [12413],
      Calcium: [13616],
      Caledonia: [14423],
      Callicoon: [12723],
      Calverton: [11933],
      'Cambria Heights': [11411],
      Cambridge: [12816],
      Camden: [13316],
      Cameron: [14819],
      'Cameron Mills': [14820],
      Camillus: [13031],
      Campbell: [14821],
      'Campbell Hall': [10916],
      Canaan: [12029],
      Canandaigua: [14424, 14425],
      Canaseraga: [14822],
      Canastota: [13032],
      Candor: [13743],
      Caneadea: [14717],
      Canisteo: [14823],
      Canton: [13617],
      'Cape Vincent': [13618],
      'Carle Place': [11514],
      Carlisle: [12031],
      Carmel: [10512],
      'Caroga Lake': [12032],
      Carthage: [13619],
      Cassadaga: [14718],
      Cassville: [13318],
      Castile: [14427],
      'Castle Creek': [13744],
      'Castleton On Hud': [12033],
      Castorland: [13620],
      Cato: [13033],
      Catskill: [12414],
      Cattaraugus: [14719],
      Cayuga: [13034],
      Cayuta: [14824],
      Cazenovia: [13035],
      Cedarhurst: [11516],
      'Center Moriches': [11934],
      Centereach: [11720],
      Centerport: [11721],
      'Central Bridge': [12035],
      'Central Islip': [11722],
      'Central Square': [13036],
      'Central Valley': [10917],
      Ceres: [14721],
      Chadwicks: [13319],
      Chaffee: [14030],
      Champlain: [12919],
      Chappaqua: [10514],
      Charlotteville: [12036],
      'Chase Mills': [13621],
      Chateaugay: [12920],
      Chatham: [12037],
      Chaumont: [13622],
      Chazy: [12921],
      Cheektowaga: [14225, 14227],
      Chemung: [14825],
      'Chenango Forks': [13746],
      'Cherry Creek': [14723],
      'Cherry Grove': [11782],
      'Cherry Valley': [13320],
      Chester: [10918],
      Chestertown: [12817],
      'Chestnut Ridge': [10977],
      Chichester: [12416],
      Childwold: [12922],
      Chittenango: [13037],
      Churubusco: [12923],
      Cicero: [13039],
      Cincinnatus: [13040],
      Circleville: [10919],
      Clarence: [14031],
      'Clarence Center': [14032],
      Clarksville: [12041],
      Claryville: [12725],
      Claverack: [12513],
      Clay: [13041],
      Clayville: [13322],
      Clemons: [12819],
      Cleveland: [13042],
      Clifton: [14428],
      'Clifton Park': [12065],
      'Clifton Springs': [14432],
      Climax: [12042],
      Clinton: [13323],
      'Clinton Corners': [12514],
      Clintondale: [12515],
      Clyde: [14433],
      Clymer: [14724],
      Cobleskill: [12043],
      'Cochecton Center': [12727],
      'Coeymans Hollow': [12046],
      Cohocton: [14826],
      Cohoes: [12047],
      'Cold Brook': [13324],
      'Cold Spring': [10516],
      'Cold Spring Harb': [11724],
      Colden: [14033],
      'College Point': [11356],
      Collins: [14034],
      Colton: [13625],
      Commack: [11725],
      Comstock: [12821],
      Conesus: [14435],
      'Conewango Valley': [14726],
      Congers: [10920],
      Conklin: [13748],
      Constable: [12926],
      Constableville: [13325],
      Constantia: [13044],
      'Cook Falls': [12776],
      Cooperstown: [13326],
      Copake: [12516],
      'Copake Falls': [12517],
      Copenhagen: [13626],
      Copiague: [11726],
      Coram: [11727],
      Corfu: [14036],
      Corinth: [12822],
      Corning: [14830],
      Cornwall: [12518],
      'Cornwall On Huds': [12520],
      Cornwallville: [12418],
      Corona: [11368],
      Cortland: [13045],
      'Cortlandt Manor': [10566],
      Cossayuna: [12823],
      Cottekill: [12419],
      Cowlesville: [14037],
      Coxsackie: [12051],
      Craryville: [12521],
      Croghan: [13327],
      Cropseyville: [12052],
      'Cross River': [10518],
      'Croton On Hudson': [10520],
      'Crown Point': [12928],
      Cuba: [14727],
      Cuddebackville: [12729],
      Cutchogue: [11935],
      Cuyler: [13050],
      Dale: [14039],
      Dalton: [14836],
      Dansville: [14437],
      'Darien Center': [14040],
      Davenport: [13750],
      'Davenport Center': [13751],
      'Davis Park': [11772],
      Dayton: [14041],
      'De Kalb Junction': [13630],
      'De Lancey': [13752],
      'De Peyster': [13633],
      'De Ruyter': [13052],
      'De Witt': [13214],
      Deansboro: [13328],
      'Deer Park': [11729],
      Degrasse: [13684],
      Delanson: [12053],
      Delevan: [14042],
      Delmar: [12054],
      Denver: [12421],
      Depew: [14043],
      Deposit: [13754],
      Derby: [14047],
      Dewittville: [14728],
      Dexter: [13634],
      'Diamond Point': [12824],
      'Dickinson Center': [12930],
      'Dix Hills': [11746],
      'Dobbs Ferry': [10522],
      Dolgeville: [13329],
      Dormansville: [12055],
      'Dover Plains': [12522],
      Downsville: [13755],
      Dresden: [14441],
      Dryden: [13053],
      Duanesburg: [12056],
      Dundee: [14837],
      Durham: [12422],
      Durhamville: [13054],
      'Eagle Bay': [13331],
      Earlton: [12058],
      Earlville: [13332],
      'East Aurora': [14052],
      'East Berne': [12059],
      'East Bethany': [14054],
      'East Branch': [13756],
      'East Chatham': [12060],
      'East Concord': [14055],
      'East Durham': [12423],
      'East Elmhurst': [11369, 11370],
      'East Freetown': [13055],
      'East Greenbush': [12061],
      'East Greenwich': [12826],
      'East Hampton': [11937],
      'East Islip': [11730],
      'East Jewett': [12424],
      'East Marion': [11939],
      'East Meadow': [11554],
      'East Meredith': [13757],
      'East Moriches': [11940],
      'East Nassau': [12062],
      'East Norwich': [11732],
      'East Otto': [14729],
      'East Quogue': [11942],
      'East Rochester': [14445],
      'East Rockaway': [11518],
      'East Springfield': [13333],
      'East Syracuse': [13057],
      'East White Plain': [10604],
      'East Windham': [12439],
      'East Worcester': [12064],
      Eastchester: [10709],
      Eastport: [11941],
      Eaton: [13334],
      Eddyville: [12401],
      Eden: [14057],
      Edinburg: [12134],
      Edmeston: [13335],
      Edwards: [13635],
      Elba: [14058],
      Elbridge: [13060],
      Eldred: [12732],
      Elizabethtown: [12932],
      Elizaville: [12523],
      'Elka Park': [12427],
      'Ellenburg Center': [12934],
      'Ellenburg Depot': [12935],
      Ellenville: [12428],
      Ellicottville: [14731],
      Ellisburg: [13636],
      Elma: [14059],
      Elmira: [14901, 14904, 14905],
      'Elmira Heights': [14903],
      Elmsford: [10523],
      Elwood: [11731],
      Endwell: [13760],
      Erieville: [13061],
      Erin: [14838],
      Esperance: [12066],
      Essex: [12936],
      'Evans Mills': [13637],
      Fabius: [13063],
      Fairport: [14450],
      Falconer: [14733],
      Fallsburg: [12733],
      'Far Rockaway': [11691, 11692, 11693, 11694, 11697],
      'Farmersville Sta': [14060],
      Farmingville: [11738],
      Fayetteville: [13066],
      'Felts Mills': [13638],
      'Feura Bush': [12067],
      Fillmore: [14735],
      'Findley Lake': [14736],
      'Fishers Island': ['06390'],
      Fishkill: [12524],
      'Floral Park': [11001],
      Florida: [10921],
      Flushing: [11354, 11355, 11358, 11364, 11367, 11371],
      'Fly Creek': [13337],
      Fonda: [12068],
      'Forest Hills': [11375],
      Forestburgh: [12777],
      Forestport: [13338],
      Forestville: [14062],
      'Fort Ann': [12827],
      'Fort Covington': [12937],
      'Fort Drum': [13602, 13603],
      'Fort Edward': [12828],
      'Fort Johnson': [12070],
      'Fort Plain': [13339],
      'Fort Totten': [11359],
      Fosterdale: [12726],
      Frankfort: [13340],
      Franklin: [13775],
      'Franklin Square': [11010],
      Franklinville: [14737],
      Fredonia: [14063],
      Freedom: [14065],
      Freehold: [12431],
      Freeport: [11520],
      Freeville: [13068],
      'Fremont Center': [12736],
      'Fresh Meadows': [11365, 11366],
      Frewsburg: [14738],
      Friendship: [14739],
      Frontenac: [13624],
      Fulton: [13069],
      Fultonham: [12071],
      Fultonville: [12072],
      Gainesville: [14066],
      Galway: [12074],
      Gansevoort: [12831],
      'Garden City': [11530],
      Gardiner: [12525],
      Garnerville: [10923],
      Garrattsville: [13342],
      Garrison: [10524],
      Gasport: [14067],
      Geneseo: [14454],
      Geneva: [14456],
      Genoa: [13071],
      Georgetown: [13072],
      Germantown: [12526],
      Gerry: [14740],
      Getzville: [14068],
      Ghent: [12075],
      Gilbertsville: [13776],
      Gilboa: [12076],
      'Glen Aubrey': [13777],
      'Glen Cove': [11542],
      'Glen Head': [11545],
      'Glen Oaks': [11004],
      'Glen Spey': [12737],
      'Glen Wild': [12738],
      Glenfield: [13343],
      Glenford: [12433],
      Glenmont: [12077],
      Glenwood: [14069],
      Gloversville: [12078],
      Godeffroy: [12739],
      Goshen: [10924],
      Gouverneur: [13642],
      'Governors Island': [10004],
      Gowanda: [14070],
      Grahamsville: [12740],
      'Grand Gorge': [12434],
      'Grand Island': [14072],
      'Granite Springs': [10527],
      Granville: [12832],
      'Great Neck': [11020, 11021, 11023],
      'Great Valley': [14741],
      Greece: [14616],
      'Green Island': [12183],
      Greene: [13778],
      'Greenfield Cente': [12833],
      'Greenfield Park': [12435],
      Greenlawn: [11740],
      Greenport: [11944],
      Greenvale: [11548],
      Greenville: [12083],
      Greenwood: [14839],
      'Greenwood Lake': [10925],
      Greig: [13345],
      Grossinger: [12734],
      Groton: [13073],
      Groveland: [14462],
      Guilderland: [12084],
      Guilford: [13780],
      Hadley: [12835],
      Hagaman: [12086],
      Hague: [12836],
      'Halcott Center': [12430],
      Halesite: [11743],
      Hamburg: [14075],
      Hamden: [13782],
      Hamilton: [13346],
      Hamlin: [14464],
      Hammond: [13646],
      Hammondsport: [14840],
      Hampton: [12837],
      'Hampton Bays': [11946],
      Hannacroix: [12087],
      Hannibal: [13074],
      Harpersfield: [13786],
      Harpursville: [13787],
      Harriman: [10926],
      Harris: [12742],
      Harrison: [10528],
      Harrisville: [13648],
      Hartford: [12838],
      Hartsdale: [10530],
      Hartwick: [13348],
      Hastings: [13076],
      'Hastings On Huds': [10706],
      Hauppauge: [11788],
      Haverstraw: [10927],
      Hawthorne: [10532],
      'Hayt Corners': [14521],
      Heathcote: [10583],
      Hector: [14841],
      Hemlock: [14466],
      Hempstead: [11550],
      Henderson: [13650],
      Henrietta: [14467],
      Herkimer: [13350],
      Hermon: [13652],
      Heuvelton: [13654],
      Hewlett: [11557],
      Hicksville: [11801],
      'High Falls': [12440],
      Highland: [12528],
      'Highland Falls': [10928],
      'Highland Lake': [12743],
      'Highland Mills': [10930],
      Hillburn: [10931],
      Hillsdale: [12529],
      'Hillside Manor': [11040],
      Hilton: [14468],
      Himrod: [14842],
      Hobart: [13788],
      Hoffmeister: [13353],
      Hogansburg: [13655],
      Holbrook: [11741],
      Holland: [14080],
      'Holland Patent': [13354],
      Hollis: [11423],
      Holmes: [12531],
      Holtsville: [11742],
      Homer: [13077],
      Honeoye: [14471],
      'Honeoye Falls': [14472],
      'Hoosick Falls': [12090],
      'Hopewell Junctio': [12533],
      Hornell: [14843],
      Horseheads: [14845],
      Hortonville: [12745],
      Houghton: [14744],
      'Howes Cave': [12092],
      Hubbardsville: [13355],
      Hudson: [12534],
      'Hudson Falls': [12839],
      Huguenot: [12746],
      Hulberton: [14470],
      Hunt: [14846],
      Hunter: [12442],
      Hurley: [12443],
      Hurleyville: [12747],
      'Hyde Park': [12538],
      Ilion: [13357],
      'Indian Lake': [12842],
      Inlet: [13360],
      Interlaken: [14847],
      Inwood: [11696],
      Ionia: [14475],
      Irving: [14081],
      Irvington: [10533],
      Ischua: [14743],
      'Island Park': [11558],
      Islip: [11751],
      'Islip Terrace': [11752],
      Ithaca: [14853],
      'Ithaca College': [14850],
      'Jackson Heights': [11372, 11373],
      Jamaica: [11430, 11432, 11433, 11434, 11435, 11436],
      Jamestown: [14701],
      Jamesville: [13078],
      Jasper: [14855],
      'Java Center': [14082],
      'Java Village': [14083],
      Jay: [12941],
      Jefferson: [12093],
      'Jefferson Valley': [10535],
      Jeffersonville: [12748],
      Jericho: [11753],
      Jewett: [12444],
      Johnsburg: [12843],
      'Johnson City': [13790],
      Johnsonville: [12094],
      Johnstown: [12095],
      Jordan: [13080],
      Jordanville: [13361],
      Katonah: [10536],
      Keene: [12942],
      Keeseville: [12924, 12944],
      'Kelly Corners': [12455],
      Kendall: [14476],
      Kenmore: [14217],
      Kennedy: [14747],
      'Kenoza Lake': [12750],
      Kent: [14477],
      Kerhonkson: [12446],
      'Kew Gardens': [11412, 11414, 11415],
      'Kiamesha Lake': [12751],
      'Kill Buck': [14748],
      Kinderhook: [12106],
      'King Ferry': [13081],
      'Kings Park': [11754],
      'Kings Point Cont': [11024],
      Kirkville: [13082],
      Kirkwood: [13795],
      Kismet: [11706],
      Krumville: [12461],
      'La Fargeville': [13656],
      'La Fayette': [13084],
      Lackawanna: [14218],
      Lacona: [13083],
      Lagrangeville: [12540],
      'Lake George': [12845],
      'Lake Grove': [11755],
      'Lake Hill': [12448],
      'Lake Huntington': [12752],
      'Lake Katrine': [12449],
      'Lake Luzerne': [12846],
      'Lake Peekskill': [10537],
      'Lake Pleasant': [12108],
      'Lake Ronkonkoma': [11779],
      'Lake View': [14085],
      Lakeville: [14480],
      Lakewood: [14750],
      Lancaster: [14086],
      Lanesville: [12450],
      Lansing: [14882],
      Larchmont: [10538],
      Latham: [12110],
      Laurel: [11948],
      Laurens: [13796],
      Lawrence: [11559],
      Lawrenceville: [12949],
      Lawtons: [14091],
      Lawyersville: [12113],
      'Le Roy': [14482],
      Lebanon: [13085],
      'Lee Center': [13363],
      Leeds: [12451],
      Leicester: [14481],
      Levittown: [11756],
      'Lew Beach': [12753],
      Lewis: [12950],
      Lewiston: [14092],
      Liberty: [12754],
      Lima: [14485],
      Limestone: [14753],
      Lindenhurst: [11757],
      Lindley: [14858],
      Linwood: [14486, 14525],
      Lisbon: [13658],
      Lisle: [13797],
      'Little Falls': [13365],
      'Little Genesee': [14754],
      'Little Neck': [11362, 11363],
      'Little Valley': [14755],
      Liverpool: [13088],
      'Livingston Manor': [12758],
      Livonia: [14487],
      'Loch Sheldrake': [12759],
      Locke: [13092],
      Lockport: [14094],
      Lockwood: [14859],
      'Locust Valley': [11560],
      Lodi: [14860],
      'Long Beach': [11561],
      'Long Eddy': [12760],
      'Long Lake': [12847],
      Lorraine: [13659],
      Loudonville: [12211],
      Lowman: [14861],
      Lynbrook: [11563],
      Lyndonville: [14098],
      'Lyon Mountain': [12952],
      Lyons: [14489],
      'Lyons Falls': [13368],
      'Mac Dougall': [14541],
      Macedon: [14502],
      Machias: [14101],
      Madison: [13402],
      Madrid: [13660],
      Mahopac: [10541],
      Maine: [13802],
      'Malden Bridge': [12115],
      Mallory: [13103],
      Malone: [12953],
      Malverne: [11565],
      Mamaroneck: [10543],
      Manchester: [14504],
      Manlius: [13104],
      Mannsville: [13661],
      Manorville: [11949],
      Maplecrest: [12454],
      Marathon: [13803],
      Marcellus: [13108],
      Marcy: [13403],
      Marietta: [13110],
      Marilla: [14102],
      Marion: [14505],
      Marlboro: [12542],
      Martville: [13111],
      Maryland: [12116],
      Masonville: [13804],
      Maspeth: [11378],
      'Massapequa Park': [11762],
      Massena: [13662],
      Mastic: [11950],
      'Mastic Beach': [11951],
      Mattituck: [11952],
      Mattydale: [13211],
      Maybrook: [12543],
      Mayfair: [12302],
      Mayfield: [12117],
      Mayville: [14757],
      'Mc Connellsville': [13401],
      'Mc Donough': [13801],
      'Mc Graw': [13101],
      'Mc Kownville': [12203],
      Mechanicville: [12118],
      Medford: [11763],
      Medina: [14103],
      Medusa: [12120],
      Melrose: [12121],
      Melville: [11747],
      Memphis: [13112],
      Mendon: [14506],
      Meredith: [13753],
      Meridale: [13806],
      Merrill: [12955],
      Mexico: [13114],
      'Middle Granville': [12849],
      'Middle Grove': [12850],
      'Middle Hope': [12550],
      'Middle Island': [11953],
      'Middle Village': [11379],
      Middleburgh: [12122],
      Middleport: [14105],
      Middlesex: [14507],
      Middleville: [13406],
      Mileses: [12741],
      Milford: [13807],
      'Mill Neck': [11765],
      Millbrook: [12545],
      'Miller Place': [11764],
      Millerton: [12546],
      Millport: [14864],
      Millwood: [10546],
      Milton: [12547],
      Mineola: [11501],
      Minerva: [12851],
      Mineville: [12956],
      Minoa: [13116],
      Modena: [12548],
      Mohawk: [13407],
      'Mohegan Lake': [10547],
      'Mohonk Lake': [12561],
      Moira: [12957],
      'Mongaup Valley': [12762],
      Monroe: [10950],
      Monsey: [10952],
      Montauk: [11954],
      Montgomery: [12549],
      Monticello: [12701],
      'Montour Falls': [14865],
      Montrose: [10548],
      Mooers: [12958],
      'Mooers Forks': [12959],
      Moravia: [13118],
      Moriah: [12960],
      'Moriah Center': [12961],
      Moriches: [11955],
      Morris: [13808],
      Morrisonville: [12962],
      Morrisville: [13408],
      'Mount Kisco': [10549],
      'Mount Marion': [12456],
      'Mount Sinai': [11766],
      'Mount Tremper': [12457],
      'Mount Upton': [13809],
      'Mount Vernon': [10550, 10552, 10553],
      'Mount Vision': [13810],
      'Mountain Dale': [12763],
      Munnsville: [13409],
      Napanoch: [12458],
      Naples: [14512],
      Narrowsburg: [12764],
      Nassau: [12123],
      'Natural Bridge': [13665],
      Nedrow: [13120],
      Nesconset: [11767],
      Neversink: [12765],
      'New Berlin': [13411],
      'New City': [10956],
      'New Hamburg': [12590],
      'New Hampton': [10958],
      'New Hartford': [13413],
      'New Hyde Park': [11042],
      'New Lebanon': [12125],
      'New Lisbon': [13415],
      'New Rochelle': [10801, 10804, 10805],
      'New Russia': [12964],
      'New Windsor': [12553],
      'New Woodstock': [13122],
      'New York': [
        10001, 10002, 10003, 10005, 10006, 10007, 10009, 10010, 10011, 10012,
        10013, 10014, 10016, 10017, 10018, 10019, 10020, 10021, 10022, 10023,
        10024, 10025, 10026, 10027, 10028, 10029, 10030, 10031, 10032, 10033,
        10034, 10035, 10036, 10037, 10038, 10039, 10040, 10044, 10128, 10280,
      ],
      'New York Mills': [13417],
      Newark: [14513],
      'Newark Valley': [13811],
      Newcomb: [12852],
      Newfane: [14108],
      Newfield: [14867],
      Newport: [13416],
      'Newton Falls': [13666],
      'Niagara Falls': [14301, 14303, 14304, 14305],
      Nichols: [13812],
      Nicholville: [12938, 12965],
      Nineveh: [13813],
      Niskayuna: [12309],
      Niverville: [12130],
      Norfolk: [13667],
      'North Babylon': [11703],
      'North Bellmore': [11710],
      'North Blenheim': [12131],
      'North Branch': [12766],
      'North Brookfield': [13418],
      'North Chili': [14514],
      'North Collins': [14111],
      'North Creek': [12853],
      'North Granville': [12854],
      'North Hudson': [12855],
      'North Java': [14113],
      'North Lawrence': [12967],
      'North Massapequa': [11758],
      'North Merrick': [11566],
      'North Pitcher': [13124],
      'North Pole': [12946],
      'North Rose': [14516],
      'North Salem': [10560],
      'North Syracuse': [13212],
      'North Tarrytown': [10591],
      'North Tonawanda': [14120],
      'North Woodmere': [11581],
      Northport: [11768],
      'Norton Hill': [12135],
      Norwich: [13815],
      Norwood: [13668],
      Nunda: [14517],
      Nyack: [10960],
      'Oak Beach': [11702],
      'Oak Hill': [12460],
      Oakdale: [11769],
      Oakfield: [14125],
      Oceanside: [11572],
      Odessa: [14869],
      Ogdensburg: [13669],
      'Old Bethpage': [11804],
      'Old Chatham': [12136],
      'Old Forge': [13420],
      'Old Westbury': [11568],
      Olean: [14760],
      Oliverea: [12410],
      Olmstedville: [12857],
      Onchiota: [12968],
      Oneida: [13421],
      Oneonta: [13820],
      Onondaga: [13215],
      Ontario: [14519],
      Orangeburg: [10962],
      'Orchard Park': [14127],
      Orient: [11957],
      Oriskany: [13424],
      'Oriskany Falls': [13425],
      Ossining: [10562],
      Oswegatchie: [13670],
      Oswego: [13126],
      Otego: [13825],
      Otisville: [10963],
      Ouaquaga: [13826],
      Owego: [13827],
      'Owls Head': [12969],
      'Oyster Bay': [11771],
      'Ozone Park': [11416, 11417],
      'Painted Post': [14870],
      'Palatine Bridge': [13428],
      Palenville: [12463],
      Palisades: [10964],
      Palmyra: [14522],
      Panama: [14767],
      Panorama: [14625],
      Paradox: [12858],
      Parish: [13131],
      Parishville: [13672],
      Parksville: [12768],
      Patterson: [12563],
      Pattersonville: [12137],
      'Paul Smiths': [12970],
      Pawling: [12564],
      'Pearl River': [10965],
      Pelham: [10803],
      Penfield: [14526],
      'Penn Yan': [14527],
      Pennellville: [13132],
      Perry: [14530],
      Perrysburg: [14129],
      Peru: [12972],
      Phelps: [14532],
      Philadelphia: [13673],
      Phoenicia: [12464],
      Phoenix: [13135],
      Piercefield: [12973],
      Piermont: [10968],
      'Pilot Knob': [12844],
      'Pine Bush': [12566],
      'Pine City': [14871],
      'Pine Hill': [12465],
      'Pine Island': [10969],
      'Pine Plains': [12567],
      'Pine Valley': [14872],
      Piseco: [12139],
      Pitcher: [13136],
      Pittsford: [14534],
      Plainview: [11803],
      Plandome: [11030],
      Plattsburgh: [12901],
      'Pleasant Valley': [12569],
      Pleasantville: [10570],
      Plessis: [13675],
      Plymouth: [13832],
      Poestenkill: [12140],
      'Point Vivian': [13607],
      Poland: [13431],
      Pomona: [10970],
      'Pond Eddy': [12770],
      'Port Byron': [13140],
      'Port Ewen': [12466],
      'Port Henry': [12974],
      'Port Jefferson': [11777],
      'Port Jefferson S': [11776],
      'Port Jervis': [12771],
      'Port Leyden': [13433],
      'Port Washington': [11050],
      Portageville: [14536],
      'Porter Corners': [12859],
      Portland: [14769],
      Portlandville: [13834],
      Portville: [14770],
      Potsdam: [13676],
      Pottersville: [12860],
      Poughquag: [12570],
      'Pound Ridge': [10576],
      Prattsburg: [14873],
      Prattsville: [12468],
      Preble: [13141],
      'Preston Hollow': [12469],
      Pulaski: [13142],
      Pulteney: [14874],
      Purchase: [10577],
      Purdys: [10578],
      Purling: [12470],
      'Putnam Station': [12861],
      'Putnam Valley': [10579],
      'Queens Village': [11427, 11428, 11429],
      Queensbury: [12801, 12804],
      Randolph: [14772],
      Ransomville: [14131],
      'Raquette Lake': [13436],
      Ravena: [12143],
      'Red Creek': [13143],
      'Red Hook': [12571],
      Redfield: [13437],
      Redford: [12978],
      Redwood: [13679],
      'Rego Park': [11374],
      Remsen: [13438],
      Rensselaer: [12144],
      'Rensselaer Falls': [13680],
      Rensselaerville: [12147],
      Rexford: [12148],
      Rexville: [14877],
      Rhinebeck: [12572],
      'Richfield Spring': [13439],
      Richford: [13835],
      Richland: [13144],
      'Richmond Hill': [11418],
      Richmondville: [12149],
      Richville: [13681],
      Ridge: [11961],
      Ridgewood: [11385],
      Ripley: [14775],
      Riverhead: [11901],
      Rochester: [
        14604, 14605, 14606, 14607, 14608, 14609, 14610, 14611, 14612, 14613,
        14614, 14615, 14617, 14619, 14620, 14621, 14622, 14623, 14626,
      ],
      'Rock City Falls': [12863],
      'Rock Glen': [14550],
      'Rock Hill': [12775],
      'Rock Stream': [14878],
      'Rock Tavern': [12575],
      'Rockville Centre': [11570],
      'Rocky Point': [11778],
      Rodman: [13682],
      Roessleville: [12205],
      Rome: [13440],
      Roosevelt: [11575],
      Roseboom: [13450],
      Rosedale: [11422],
      Rosendale: [12472],
      Roslyn: [11576],
      'Roslyn Heights': [11577],
      Rotterdam: [12303],
      'Rotterdam Juncti': [12150],
      'Round Lake': [12151],
      'Round Top': [12473],
      'Rouses Point': [12979],
      Roxbury: [12474],
      Rushford: [14777],
      Rushville: [14544],
      Rye: [10580],
      'Rye Brook': [10573],
      'S Ozone Park': [11420],
      'S Richmond Hill': [11419],
      'Sackets Harbor': [13685],
      'Sag Harbor': [11963],
      'Saint Huberts': [12943],
      'Saint James': [11780],
      'Saint Johnsville': [13452],
      'Saint Regis Fall': [12980],
      Salamanca: [14779],
      Salem: [12865],
      'Salisbury Center': [13454],
      'Salisbury Mills': [12577],
      'Salt Point': [12578],
      Sanborn: [14132],
      'Sand Lake': [12153],
      'Sandy Creek': [13145],
      'Sanitaria Spring': [13833],
      Saranac: [12981],
      'Saranac Lake': [12983],
      Sardinia: [14134],
      Saugerties: [12477],
      Sauquoit: [13456],
      Savannah: [13146],
      Savona: [14879],
      Schaghticoke: [12154],
      Schenectady: [12304, 12305, 12306, 12307, 12308],
      Schenevus: [12155],
      'Schodack Landing': [12156],
      Schoharie: [12157],
      'Schroon Lake': [12870],
      'Schuyler Falls': [12985],
      Schuylerville: [12871],
      Scio: [14880],
      Scotchtown: [10940],
      Scottsburg: [14545],
      Scottsville: [14546],
      'Sea Cliff': [11579],
      Seaford: [11783],
      Selden: [11784],
      Selkirk: [12158],
      'Seneca Falls': [13148],
      Setauket: [11733],
      Severance: [12872],
      Shady: [12409],
      Shandaken: [12480],
      'Sharon Springs': [13459],
      'Shelter Island': [11964],
      'Shelter Island H': [11965],
      Sherburne: [13460],
      Sherman: [14781],
      Sherrill: [13461],
      Shirley: [11967],
      Shokan: [12481],
      Shoreham: [11786],
      Shortsville: [14548],
      'Shrub Oak': [10588],
      Shushan: [12873],
      Sidney: [13838],
      'Sidney Center': [13839],
      'Silver Bay': [12874],
      'Silver Creek': [14136],
      Sinclairville: [14782],
      Skaneateles: [13152],
      'Slate Hill': [10973],
      'Slaterville Spri': [14881],
      Slingerlands: [12159],
      Sloansville: [12160],
      Smithtown: [11787],
      Smithville: [13605],
      'Smithville Flats': [13841],
      Smyrna: [13464],
      Sodus: [14551],
      'Sodus Point': [14555],
      Solvay: [13209],
      Somers: [10589],
      'Sound Beach': [11789],
      'South Cairo': [12482],
      'South Colton': [13687],
      'South Dayton': [14138],
      'South Edmeston': [13466],
      'South Fallsburg': [12779],
      'South Farmingdal': [11735],
      'South Glens Fall': [12803],
      'South Kortright': [13842],
      'South New Berlin': [13843],
      'South Otselic': [13155],
      'South Plymouth': [13844],
      'South Road': [12601],
      'South Salem': [10590],
      'South Wales': [14139],
      Southampton: [11968],
      Southfields: [10975],
      Southold: [11971],
      Sparkill: [10976],
      Sparrowbush: [12780],
      Speculator: [12164],
      Spencer: [14883],
      Spencerport: [14559],
      Spencertown: [12165],
      Sprakers: [12166],
      'Springfield Cent': [13468],
      'Springfield Gard': [11413],
      Springville: [14141],
      Springwater: [14560],
      Staatsburg: [12580],
      Stafford: [14143],
      Stamford: [12167],
      Stanfordville: [12581],
      Stanley: [14561],
      'Star Lake': [13690],
      'Staten Island': [
        10301, 10302, 10303, 10304, 10305, 10306, 10307, 10308, 10309, 10310,
        10312, 10314,
      ],
      Stephentown: [12168, 12169],
      Sterling: [13156],
      Sterlington: [10974],
      Stillwater: [12170],
      Stittville: [13469],
      Stockton: [14784],
      'Stone Ridge': [12484],
      'Stony Brook': [11790],
      'Stony Creek': [12878],
      'Stony Point': [10980],
      Stormville: [12582],
      Stratford: [13470],
      Strykersville: [14145],
      Stuyvesant: [12173],
      Suffern: [10901],
      Summit: [12175],
      Sundown: [12782],
      Sunmount: [12986],
      Sunnyside: [11104],
      'Suny Stony Brook': [11794],
      Surprise: [12176],
      Swain: [14884],
      'Swan Lake': [12783],
      Swormville: [14051],
      Syosset: [11791],
      Syracuse: [
        13202, 13203, 13204, 13205, 13206, 13207, 13208, 13210, 13219, 13224,
      ],
      Taberg: [13471],
      'Taconic Lake': [12138],
      Tannersville: [12485],
      Tappan: [10983],
      Theresa: [13691],
      Thiells: [10984],
      'Thompson Ridge': [10985],
      Thomson: [12834],
      Thornwood: [10594],
      'Three Mile Bay': [13693],
      Ticonderoga: [12883],
      Tillson: [12486],
      Tivoli: [12583],
      'Tomkins Cove': [10986],
      Tonawanda: [14150],
      Treadwell: [13846],
      Troupsburg: [14885],
      Troy: [12180, 12182],
      Trumansburg: [14886],
      Truxton: [13158],
      Tuckahoe: [10707],
      Tully: [13159],
      Turin: [13473],
      Tuscarora: [14510],
      'Tuxedo Park': [10987],
      'Twelve Corners': [14618],
      'Ulster Park': [12487],
      Unadilla: [13849],
      'Union Springs': [13160],
      Uniondale: [11553],
      'Upper Jay': [12987],
      'Upper Saint Regi': [12945],
      Utica: [13501, 13502],
      Valatie: [12184],
      Valhalla: [10595],
      'Valley Cottage': [10989],
      'Valley Falls': [12185],
      'Valley Stream': [11580],
      Valois: [14888],
      'Van Buren Bay': [14048],
      'Van Etten': [14889],
      'Van Hornesville': [13475],
      Varysburg: [14167],
      'Venice Center': [13147],
      Verbank: [12585],
      Vermontville: [12989],
      Vernon: [13476],
      'Vernon Center': [13477],
      Verona: [13478],
      Vestal: [13850],
      'Veterans Adminis': [14810],
      Victor: [14564],
      Voorheesville: [12186],
      Waccabuc: [10597],
      Waddington: [13694],
      'Wading River': [11792],
      Wadsworth: [14533],
      Walden: [12586],
      Wallace: [14809],
      Wallkill: [12589],
      Walton: [13856],
      Walworth: [14568],
      Wanakena: [13695],
      Wantagh: [11793],
      Warners: [13164],
      Warnerville: [12187],
      Warrensburg: [12885],
      Warsaw: [14569],
      Warwick: [10990],
      Washingtonville: [10992],
      Wassaic: [12592],
      'Water Mill': [11976],
      Waterford: [12188],
      Waterloo: [13165],
      Waterport: [14571],
      Watertown: [13601],
      Waterville: [13480],
      Watervliet: [12189],
      'Watkins Glen': [14891],
      Waverly: [14892],
      Wayland: [14572],
      Webster: [14580],
      Weedsport: [13166],
      Wells: [12190],
      'Wells Bridge': [13859],
      Wellsburg: [14894],
      Wellsville: [14895],
      'West Babylon': [11704],
      'West Brentwood': [11717],
      'West Burlington': [13482],
      'West Charlton': [12010],
      'West Chazy': [12992],
      'West Coxsackie': [12192],
      'West Edmeston': [13485],
      'West Falls': [14170],
      'West Fulton': [12194],
      'West Haverstraw': [10993],
      'West Hempstead': [11552],
      'West Henrietta': [14586],
      'West Hurley': [12491],
      'West Islip': [11795],
      'West Kill': [12492],
      'West Leyden': [13489],
      'West Monroe': [13167],
      'West Nyack': [10994],
      'West Oneonta': [13861],
      'West Point': [10996],
      'West Rush': [14543],
      'West Sand Lake': [12196],
      'West Sayville': [11796],
      'West Seneca': [14224],
      'West Shokan': [12494],
      'West Stockholm': [13696],
      'West Valley': [14171],
      'West Winfield': [13491],
      Westbury: [11590],
      Westdale: [13483],
      Westerlo: [12193],
      Westernville: [13486],
      Westfield: [14787],
      Westford: [13488],
      Westgate: [14624],
      Westhampton: [11977],
      'Westhampton Beac': [11978],
      Westmoreland: [13490],
      Westport: [12993],
      Westtown: [10998],
      Wevertown: [12886],
      Whallonsburg: [12994],
      'Wheatley Heights': [11798],
      'White Creek': [12057],
      'White Lake': [12786],
      'White Plains': [10601, 10603, 10605, 10606, 10607],
      'White Sulphur Sp': [12787],
      Whitehall: [12887],
      Whitesboro: [13492],
      Whitestone: [11357],
      Whitesville: [14897],
      'Whitney Point': [13862],
      Willet: [13863],
      Williamson: [14589],
      Williamstown: [13493],
      Williamsville: [14221],
      'Williston Park': [11596],
      Willow: [12495],
      Willsboro: [12996],
      Willseyville: [13864],
      Wilmington: [12997],
      Wilson: [14172],
      Wilton: [12866],
      Windham: [12496],
      Windsor: [13865],
      Wingdale: [12594],
      Winthrop: [13697],
      Wolcott: [14590],
      Woodbourne: [12788],
      Woodbury: [11797],
      Woodgate: [13494],
      Woodhaven: [11421],
      Woodhull: [14898],
      Woodmere: [11598],
      Woodridge: [12789],
      Woodside: [11377],
      Woodstock: [12498],
      Woodville: [13698],
      Worcester: [12197],
      Wurtsboro: [12790],
      Wynantskill: [12198],
      Wyoming: [14591],
      Yaphank: [11980],
      Yonkers: [10701, 10703, 10704, 10705, 10710],
      'Yorktown Heights': [10598],
      Yorkville: [13495],
      Youngstown: [14174],
      Youngsville: [12791],
      Yulan: [12792],
    },
    name: 'New York',
  },
  OH: {
    cities: {
      45774: [45774],
      Aberdeen: [45101],
      Ada: [45810],
      'Adams Mills': [43821],
      Adamsville: [43802],
      Addyston: [45001],
      Adena: [43901],
      Akron: [
        44301, 44302, 44303, 44304, 44305, 44306, 44307, 44308, 44310, 44311,
        44312, 44313, 44314, 44319, 44320,
      ],
      Albany: [45710],
      Alexandria: [43001],
      Alger: [45812],
      Alledonia: [43902],
      Allensville: [45651],
      Alliance: [44601],
      Alvada: [44802],
      Alvordton: [43501],
      Amanda: [43102],
      Amelia: [45102],
      Amesville: [45711],
      Amlin: [43002],
      Amsterdam: [43903],
      Anderson: [45230, 45255],
      Andover: [44003],
      Anna: [45302],
      Ansonia: [45303],
      Antioch: [43793],
      Antwerp: [45813],
      'Apple Creek': [44606],
      Arcadia: [44804],
      Archbold: [43502],
      Arlington: [45814],
      'Armstrong Mills': [43933],
      Ashland: [44805],
      Ashley: [43003],
      Ashtabula: [44004],
      Ashville: [43103],
      Athens: [45701],
      Atwater: [44201],
      Austinburg: [44010],
      Austintown: [44515],
      Avon: [44011],
      'Avon Lake': [44012],
      Bainbridge: [45612],
      Baltic: [43804],
      Baltimore: [43105],
      Batavia: [45103],
      'Bay Village': [44140],
      'Beach City': [44608],
      Beachwood: [44122],
      Beallsville: [43716],
      Beaver: [45613],
      Beavercreek: [45430, 45431, 45432, 45434],
      Bedford: [44146],
      Bellaire: [43906],
      Bellbrook: [45305],
      'Belle Center': [43310],
      Bellefontaine: [43311],
      Bellevue: [44811],
      Bellville: [44813],
      Belmont: [43718],
      Beloit: [44609],
      Belpre: [45714],
      Berea: [44017],
      Bergholz: [43908],
      Berkey: [43504],
      'Berlin Center': [44401],
      'Berlin Heights': [44814],
      Bethel: [45106],
      Bethesda: [43719],
      Beverly: [45715],
      Bexley: [43209],
      Bidwell: [45614],
      'Big Prairie': [44611],
      Blacklick: [43004],
      Blanchester: [45107],
      Bloomdale: [44817],
      Bloomingburg: [43106],
      Bloomingdale: [43910],
      Bloomville: [44818],
      'Blue Creek': [45616],
      'Blue Rock': [43720],
      Bluffton: [45817],
      Boardman: [44512],
      Bolivar: [44612],
      Bono: [43445],
      Botkins: [45306],
      Bowerston: [44695],
      'Bowling Green': [43402],
      Bradford: [45308],
      Bradner: [43406],
      Brecksville: [44141],
      Brewster: [44613],
      Bridgeport: [43912],
      Brilliant: [43913],
      Brinkhaven: [43006],
      Bristolville: [44402],
      'Broadview Height': [44147],
      Brookfield: [44403],
      Brooklyn: [44144],
      Brookpark: [44142],
      Brookville: [45309],
      Brunswick: [44212],
      Bryan: [43506],
      Bucyrus: [44820],
      Burbank: [44214],
      Burghill: [44404],
      Burgoon: [43407],
      Burton: [44021],
      Butler: [44822],
      Byesville: [43723],
      Cable: [43009],
      Calcutta: [43920],
      Caldwell: [43724],
      Caledonia: [43314],
      Camden: [45311],
      'Camp Dennison': [45111],
      Campbell: [44405],
      'Canal Fulton': [44614],
      'Canal Winchester': [43110],
      Canfield: [44406],
      Canton: [44702, 44703, 44704, 44705, 44706, 44708, 44710, 44714, 44721],
      Cardington: [43315],
      Carey: [43316],
      Carlisle: [45005],
      Carroll: [43112],
      Carrollton: [44615],
      Carrothers: [44807],
      Carthagena: [45822],
      Casstown: [45312],
      Castalia: [44824],
      Castine: [45304],
      Cecil: [45821],
      Cedarville: [45314],
      Centerburg: [43011],
      Centerville: [45458, 45459],
      'Chagrin Falls': [44022],
      Chandlersville: [43727],
      Chardon: [44024],
      Chatfield: [44825],
      Chesapeake: [45619],
      Cheshire: [45620],
      Chesterhill: [43728],
      Chesterland: [44026],
      Chillicothe: [45601],
      'Chippewa Lake': [44215],
      Cincinnati: [
        45202, 45203, 45204, 45205, 45206, 45207, 45208, 45209, 45210, 45211,
        45214, 45219, 45220, 45223, 45225, 45226, 45228, 45229, 45231, 45232,
        45237, 45252,
      ],
      Circleville: [43113],
      Clarington: [43915],
      Clarksburg: [43115],
      Clarksville: [45113],
      Claysville: [43725],
      Clayton: [45315],
      Cleveland: [
        44102, 44103, 44104, 44105, 44106, 44108, 44109, 44110, 44111, 44113,
        44114, 44115, 44119, 44120, 44127, 44128, 44135,
      ],
      'Cleveland Height': [44118],
      Cleves: [45002],
      Clinton: [44216],
      Cloverdale: [45827],
      Clyde: [43410],
      Coldwater: [45828],
      'College Corner': [45003],
      'College Hill': [45224],
      Collins: [44826],
      'Columbia Station': [44028],
      Columbiana: [44408],
      Columbus: [
        43201, 43202, 43203, 43204, 43205, 43206, 43207, 43210, 43211, 43212,
        43214, 43215, 43217, 43220, 43222, 43223, 43224, 43227, 43229, 43231,
        43232,
      ],
      'Columbus Grove': [45830],
      Conesville: [43811],
      Conneaut: [44030],
      Conover: [45317],
      Continental: [45831],
      Convoy: [45832],
      Coolville: [45723],
      Copley: [44321],
      Cortland: [44410],
      Coshocton: [43812],
      Covington: [45318],
      Creola: [45622],
      Crestline: [44827],
      Creston: [44217],
      Cridersville: [45806],
      Crooksville: [43731],
      Croton: [43013],
      'Crown City': [45623],
      Cumberland: [43732],
      Curtice: [43412],
      Custar: [43511],
      Cutler: [45724],
      'Cuyahoga Falls': [44221, 44223],
      Cygnet: [43413],
      Dalton: [44618],
      Danville: [43014],
      'Day Heights': [45150],
      Dayton: [
        45402, 45403, 45404, 45405, 45406, 45407, 45408, 45409, 45410, 45414,
        45415, 45417, 45418, 45419, 45427, 45433, 45440,
      ],
      'De Graff': [43318],
      Deerfield: [44411],
      Defiance: [43512],
      Delaware: [43015],
      Dellroy: [44620],
      Delphos: [45833],
      Delta: [43515],
      Dennison: [44621],
      Deshler: [43516],
      Dexter: [45741],
      'Dexter City': [45727],
      Diamond: [44412],
      Dillonvale: [43917],
      Dola: [45835],
      Dorset: [44032],
      Dover: [44622],
      Doylestown: [44230],
      Dublin: [43017],
      'Duncan Falls': [43734],
      Dundee: [44624],
      Dunkirk: [45836],
      'East Canton': [44730],
      'East Cleveland': [44112],
      'East Liberty': [43319],
      'East Orwell': [44076],
      'East Palestine': [44413],
      'East Rochester': [44625],
      'East Sparta': [44626],
      Eaton: [45320],
      Edgerton: [43517],
      Edgewater: [44107],
      Edison: [43320],
      Edon: [43518],
      Eldorado: [45321],
      Elida: [45807],
      Elliston: [43432],
      Elmore: [43416],
      'Elmwood Place': [45216],
      Elyria: [44035],
      Enon: [45323],
      Euclid: [44117],
      Excello: [45044],
      Fairborn: [45324],
      Fairfield: [45014],
      Fairlawn: [44333],
      'Fairport Harbor': [44077],
      'Fairview Park': [44126],
      Farmdale: [44417],
      Farmersville: [45325],
      Fayette: [43521],
      Fayetteville: [45118],
      Felicity: [45120],
      Findlay: [45840],
      Fleming: [45729],
      Fletcher: [45326],
      Flushing: [43977],
      'Fort Jennings': [45844],
      'Fort Loramie': [45845],
      'Fort Recovery': [45846],
      Fostoria: [44830],
      Fowler: [44418],
      Frankfort: [45628],
      'Franklin Furnace': [45629],
      Frazeysburg: [43822],
      Fredericksburg: [44627],
      Fredericktown: [43019],
      Freeport: [43973],
      Fremont: [43420],
      Fresno: [43824],
      Fulton: [43321],
      Gahanna: [43230],
      Galena: [43021],
      Galion: [44833],
      Gallipolis: [45631],
      Galloway: [43119],
      Gambier: [43022],
      'Garfield Heights': [44125],
      Garrettsville: [44231],
      'Gates Mills': [44040],
      Geneva: [44041],
      Genoa: [43430],
      Georgetown: [45121],
      Germantown: [45327],
      Gibsonburg: [43431],
      Gilboa: [45875],
      Girard: [44420],
      Glendale: [45246],
      Glenford: [43739],
      Glenmont: [44628],
      Glouster: [45732],
      Gnadenhutten: [44629],
      Goshen: [45122],
      Grafton: [44044],
      'Grand Rapids': [43522],
      Granville: [43023],
      'Green Springs': [44836],
      Greenfield: [45123],
      Greenhills: [45218],
      Greenville: [45331],
      Greenwich: [44837],
      Groesbeck: [45239, 45247, 45251],
      'Grove City': [43123],
      Groveport: [43125],
      'Grover Hill': [45849],
      Guernsey: [43749],
      Guysville: [45735],
      Hamden: [45634],
      Hamersville: [45130],
      Hamilton: [45011],
      Hamler: [43524],
      Hammondsville: [43930],
      Hanoverton: [44423],
      Harpster: [43323],
      Harrison: [45030],
      Harrod: [45850],
      Hartville: [44632],
      Haskins: [43525],
      Haviland: [45851],
      Heath: [43056],
      Hebron: [43025],
      Hemlock: [43730],
      Hicksville: [43526],
      'Hide A Way Hills': [43107],
      Hilliard: [43026],
      Hillsboro: [45133],
      Hinckley: [44233],
      Hiram: [44234],
      Holgate: [43527],
      Holland: [43528],
      Hollansburg: [45332],
      Holmesville: [44633],
      Homerville: [44235],
      Homeworth: [44634],
      Hopedale: [43976],
      Hopewell: [43746],
      Houston: [45333],
      Howard: [43028],
      Hubbard: [44425],
      'Huber Heights': [45424],
      Hudson: [44236],
      Huntsburg: [44046],
      Huntsville: [43324],
      Idaho: [45661],
      Independence: [44131],
      Irondale: [43932],
      Ironton: [45638],
      Irwin: [43029],
      'Isle Saint Georg': [43436],
      Jackson: [45640],
      'Jackson Belden': [44718],
      'Jackson Center': [45334],
      Jamestown: [45335],
      Jefferson: [44047],
      Jeffersonville: [43128],
      Jenera: [45841],
      Jeromesville: [44840],
      Jerusalem: [43747],
      Jewett: [43986],
      Johnstown: [43031],
      'Junction City': [43748],
      Kansas: [44841],
      'Kelleys Island': [43438],
      Kensington: [44427],
      Kent: [44240],
      Kenton: [43326],
      Kettering: [45420, 45429],
      Killbuck: [44637],
      Kingston: [45644],
      Kingsville: [44048],
      Kinsman: [44428],
      'Kitts Hill': [45645],
      'La Rue': [43332],
      Lacarne: [43439],
      Lagrange: [44050],
      'Lake Milton': [44429],
      Lakeside: [43440],
      Lakeview: [43331],
      Lakeville: [44638],
      Lancaster: [43130],
      Latham: [45646],
      Laura: [45337],
      Laurelville: [43135],
      Leavittsburg: [44430],
      Leesburg: [45135],
      Leetonia: [44431],
      Leipsic: [45856],
      Lewisburg: [45338],
      Lewistown: [43333],
      Lewisville: [43754],
      Lexington: [44904],
      'Liberty Center': [43532],
      Lima: [45801, 45804, 45805],
      Lincoln: [44905],
      'Lincoln Village': [43228],
      Lindenwald: [45015],
      Lindsey: [43442],
      Lisbon: [44432],
      Litchfield: [44253],
      'Little Hocking': [45742],
      Lockbourne: [43137],
      Lockland: [45215],
      Lodi: [44254],
      Logan: [43138],
      London: [43140],
      Londonderry: [45647],
      'Long Bottom': [45743],
      Lorain: [44052, 44053, 44055],
      'Lore City': [43755],
      Loudonville: [44842],
      Louisville: [44641],
      Loveland: [45140],
      Lowell: [45744],
      Lowellville: [44436],
      Lucas: [44843],
      Lucasville: [45648],
      Luckey: [43443],
      'Ludlow Falls': [45339],
      Lynchburg: [45142],
      'Lyndhurst Mayfie': [44124],
      Lyons: [43533],
      Macedonia: [44056],
      Macksburg: [45746],
      Madeira: [45243],
      Madison: [44057],
      Madisonville: [45227],
      'Magnetic Springs': [43036],
      Magnolia: [44643],
      Maineville: [45039],
      Malinta: [43535],
      Malta: [43758],
      Malvern: [44644],
      Manchester: [45144],
      Mansfield: [44902, 44903, 44906, 44907],
      Mantua: [44255],
      'Maple Heights': [44137],
      Maplewood: [45340],
      Marengo: [43334],
      'Maria Stein': [45860],
      Marietta: [45750],
      Marion: [43302],
      'Mark Center': [43536],
      Marshallville: [44645],
      Martel: [43335],
      'Martins Ferry': [43935],
      Martinsburg: [43037],
      Martinsville: [45146],
      Marysville: [43040],
      Mason: [45040],
      Massillon: [44646, 44647],
      Masury: [44438],
      Maumee: [43537],
      'Mc Clure': [43534],
      'Mc Comb': [45858],
      'Mc Connelsville': [43756],
      'Mc Cutchenville': [44844],
      'Mc Dermott': [45652],
      'Mc Donald': [44437],
      Mechanicsburg: [43044],
      Mechanicstown: [44651],
      Medina: [44256],
      Medway: [45341],
      Melmore: [44845],
      Mendon: [45862],
      Mentor: [44060],
      Metamora: [43540],
      'Miami University': [45056],
      Miamisburg: [45342],
      'Middle Point': [45863],
      Middlefield: [44062],
      Middleport: [45760],
      Middletown: [45042],
      Midland: [45148],
      Midpark: [44130],
      Milan: [44846],
      'Milford Center': [43045],
      Millbury: [43447],
      Millersburg: [44654],
      Millersport: [43046],
      Millersville: [43435],
      Millfield: [45761],
      'Mineral Ridge': [44440],
      Minerva: [44657],
      Minford: [45653],
      'Mingo Junction': [43938],
      Minster: [45865],
      Mogadore: [44260],
      Monclova: [43542],
      Monroe: [45050],
      Monroeville: [44847],
      Montpelier: [43543],
      Montville: [44064],
      Moorefield: [43907],
      Morral: [43337],
      Morrow: [45152],
      Moscow: [45153],
      'Mount Blanchard': [45867],
      'Mount Cory': [45868],
      'Mount Gilead': [43338],
      'Mount Orab': [45154],
      'Mount Perry': [43760],
      'Mount Sterling': [43143],
      'Mount Vernon': [43050],
      'Mount Victory': [43340],
      'Munroe Falls': [44262],
      Napoleon: [43545],
      Nashport: [43830],
      Navarre: [44662],
      Negley: [44441],
      Nelsonville: [45764],
      Nevada: [44849],
      'New Albany': [43054],
      'New Bavaria': [43548],
      'New Bloomington': [43341],
      'New Boston': [45662],
      'New Bremen': [45869],
      'New Carlisle': [45344],
      'New Concord': [43762],
      'New Holland': [43145],
      'New Knoxville': [45871],
      'New Lebanon': [45345],
      'New Lexington': [43764],
      'New London': [44851],
      'New Madison': [45346],
      'New Marshfield': [45766],
      'New Matamoras': [45767],
      'New Middletown': [44442],
      'New Paris': [45347],
      'New Philadelphia': [44663],
      'New Plymouth': [45654],
      'New Richmond': [45157],
      'New Riegel': [44853],
      'New Springfield': [44443],
      'New Straitsville': [43766],
      'New Vienna': [45159],
      'New Washington': [44854],
      'New Waterford': [44445],
      'New Weston': [45348],
      Newark: [43055],
      Newbury: [44065],
      Newcomerstown: [43832],
      Newport: [45768],
      'Newton Falls': [44444],
      Newtown: [45244, 45245],
      Ney: [43549],
      Niles: [44446],
      Noble: [44132],
      'North Baltimore': [45872],
      'North Bend': [45052],
      'North Benton': [44449],
      'North Bloomfield': [44450],
      'North Canton': [44709, 44720],
      'North Fairfield': [44855],
      'North Industry': [44707],
      'North Jackson': [44451],
      'North Lawrence': [44666],
      'North Lewisburg': [43060],
      'North Lima': [44452],
      'North Olmsted': [44070],
      'North Ridgeville': [44039],
      'North Royalton': [44133],
      Northfield: [44067],
      Northwood: [43619],
      Norton: [44203],
      Norwalk: [44857],
      Norwich: [43767],
      Norwood: [45212],
      Nova: [44859],
      Novelty: [44072],
      'Oak Harbor': [43449],
      'Oak Hill': [45656],
      Oakwood: [45873],
      Oberlin: [44074],
      'Ohio City': [45874],
      Okeana: [45053],
      'Olmsted Falls': [44138],
      Oregon: [43605, 43616, 43618],
      Oregonia: [45054],
      Orient: [43146],
      Orrville: [44667],
      Ostrander: [43061],
      'Otterbien Home': [45036],
      Ottoville: [45876],
      Otway: [45657],
      Pandora: [45877],
      Paris: [44669],
      Parkdale: [45240],
      Parma: [44129, 44134],
      Pataskala: [43062],
      Patriot: [45658],
      Patterson: [45843],
      Paulding: [45879],
      Payne: [45880],
      Pedro: [45659],
      Peebles: [45660],
      Pemberville: [43450],
      Peninsula: [44264],
      Pennsville: [43787],
      Perry: [44081],
      Perrysburg: [43551],
      Perrysville: [44864],
      Petersburg: [44454],
      Philo: [43771],
      Phoneton: [45371],
      Pickerington: [43147],
      Piedmont: [43983],
      Pierpont: [44082],
      Pioneer: [43554],
      Piqua: [45356],
      'Plain City': [43064],
      'Pleasant City': [43772],
      'Pleasant Hill': [45359],
      'Pleasant Plain': [45162],
      Pleasantville: [43148],
      Plymouth: [44865],
      Poland: [44514],
      Polk: [44866],
      Pomeroy: [45769],
      'Port Clinton': [43452],
      'Port Washington': [43837],
      Portage: [43451],
      Portland: [45770],
      Portsmouth: [45663],
      'Powhatan Point': [43942],
      Proctorville: [45669],
      Prospect: [43342],
      'Put In Bay': [43456],
      'Quaker City': [43773],
      Quincy: [43343],
      Racine: [45771],
      Radcliff: [45670],
      Radnor: [43066],
      Rarden: [45671],
      Ravenna: [44266],
      Rawson: [45881],
      Ray: [45672],
      Rayland: [43943],
      Raymond: [43067],
      Reedsville: [45772],
      Reminderville: [44202],
      Reno: [45773],
      Republic: [44867],
      Reynoldsburg: [43068],
      Richfield: [44286],
      Richmond: [43944],
      'Richmond Dale': [45673],
      'Richmond Heights': [44143],
      Richwood: [43344],
      Ridgeway: [43345],
      'Rinard Mills': [45734],
      Ripley: [45167],
      Risingsun: [43457],
      Rittman: [44270],
      'Roaming Shores': [44084, 44085],
      'Rock Camp': [45675],
      Rockbridge: [43149],
      Rockford: [45882],
      'Rocky River': [44116],
      Rogers: [44455],
      Rootstown: [44272],
      Roseville: [43777],
      Rossburg: [45362],
      Rossford: [43460],
      Rossville: [45013],
      Roundhead: [43346],
      Rudolph: [43462],
      Rushsylvania: [43347],
      Rushville: [43150],
      'Russells Point': [43348],
      Russellville: [45168],
      Russia: [45363],
      Rutland: [45775],
      Sabina: [45169],
      'Saint Bernard': [45217],
      'Saint Clairsvill': [43950],
      'Saint Henry': [45883],
      'Saint Louisville': [43071],
      'Saint Marys': [45885],
      'Saint Paris': [43072],
      Salem: [44460],
      Salesville: [43778],
      Salineville: [43945],
      Sandusky: [44870],
      Sarahsville: [43779],
      Sardinia: [45171],
      Sardis: [43946],
      Savannah: [44874],
      'Saylor Park': [45233],
      Scio: [43988],
      Scott: [45886],
      Scottown: [45678],
      Seaman: [45679],
      Sebring: [44672],
      Selma: [45368],
      Senecaville: [43780],
      Seville: [44273],
      Shade: [45776],
      Shadyside: [43947],
      Sharonville: [45241],
      Shawnee: [43782],
      'Shawnee Hills': [43065],
      'Sheffield Lake': [44054],
      Shelby: [44875],
      Shepard: [43219],
      Sherrodsville: [44675],
      Sherwood: [43556],
      Shiloh: [44878],
      Shinrock: [44839],
      Shore: [44123],
      Shreve: [44676],
      Sidney: [45365],
      Smithville: [44677],
      Solon: [44139],
      Somerset: [43783],
      Somerton: [43713],
      Somerville: [45064],
      Sonora: [43701],
      'South Amherst': [44001],
      'South Bloomingvi': [43152],
      'South Euclid': [44121],
      'South Lebanon': [45065],
      'South Point': [45680],
      'South Salem': [45681],
      'South Solon': [43153],
      'South Vienna': [45369],
      'South Webster': [45682],
      Southington: [44470],
      Sparta: [43350],
      Spencer: [44275],
      Spencerville: [45887],
      'Spring Valley': [45370],
      Springboro: [45066],
      Springfield: [45502, 45503, 45504, 45505, 45506],
      Sterling: [44276],
      Stewart: [45778],
      'Stone Creek': [43840],
      Stout: [45684],
      Stoutsville: [43154],
      Stow: [44224],
      Strasburg: [44680],
      Streetsboro: [44241],
      Strongsville: [44136],
      Struthers: [44471],
      Stryker: [43557],
      'Sugar Grove': [43155],
      Sugarcreek: [44681],
      Sullivan: [44880],
      Summerfield: [43788],
      Sunbury: [43074],
      Swanton: [43558],
      Sycamore: [44882, 45242, 45249],
      Sylvania: [43560],
      Taft: [45213, 45236],
      Tallmadge: [44278],
      'Terrace Park': [45174],
      'The Plains': [45780],
      Thompson: [44086],
      Thornville: [43076],
      Thurman: [45685],
      Tiffin: [44883],
      Tiltonsville: [43963],
      Tippecanoe: [44699],
      Tiro: [44887],
      Toledo: [
        43602, 43604, 43606, 43607, 43608, 43609, 43610, 43611, 43612, 43613,
        43614, 43615, 43617, 43620, 43623, 43624,
      ],
      Toronto: [43964],
      Trenton: [45067],
      Trotwood: [45416, 45426],
      Troy: [45373],
      Twinsburg: [44087],
      Uhrichsville: [44683],
      Union: [45322],
      'Union City': [45390],
      Uniontown: [44685],
      'Upper Arlington': [43221],
      'Upper Sandusky': [43351],
      Urbana: [43078],
      Utica: [43080],
      'Valley City': [44280],
      'Van Buren': [45889],
      'Van Wert': [45891],
      Vandalia: [45377],
      Vanlue: [45890],
      Venedocia: [45894],
      Vermilion: [44089],
      Versailles: [45380],
      Vickery: [43464],
      Vienna: [44473],
      Vincent: [45784],
      Vinton: [45686],
      Wadsworth: [44281],
      Wakeman: [44889],
      Walbridge: [43465],
      Waldo: [43356],
      Walhonding: [43843],
      Wapakoneta: [45895],
      Warner: [45745],
      Warren: [44481, 44483, 44484, 44485],
      Warsaw: [43844],
      'Washington Court': [43160],
      Washingtonville: [44490],
      Waterford: [45786],
      Waterloo: [45688],
      Waterville: [43566],
      Wauseon: [43567],
      Waverly: [45690],
      Wayne: [43466],
      Waynesburg: [44688],
      Waynesfield: [45896],
      Waynesville: [45068],
      Wellington: [44090],
      Wellston: [45692],
      Wellsville: [43968],
      'West Alexandria': [45381],
      'West Carrollton': [45439, 45449],
      'West Chester': [45069],
      'West Farmington': [44491],
      'West Jefferson': [43162],
      'West Lafayette': [43845],
      'West Liberty': [43357],
      'West Manchester': [45382],
      'West Mansfield': [43358],
      'West Milton': [45383],
      'West Salem': [44287],
      'West Union': [45693],
      'West Unity': [43570],
      'West Worthington': [43235],
      'Western Hills': [45238],
      Westerville: [43081],
      Westlake: [44145],
      Weston: [43569],
      Westwood: [45248],
      Wharton: [43359],
      Wheelersburg: [45694],
      Whipple: [45788],
      Whitehall: [43213],
      Whitehouse: [43571],
      Wickliffe: [44092],
      Willard: [44890],
      Williamsburg: [45176],
      Williamsfield: [44093],
      Williamsport: [43164],
      Willoughby: [44094],
      'Willow Wood': [45696],
      Willowick: [44095],
      Willshire: [45898],
      Wilmington: [45177],
      Wilmot: [44689],
      Winchester: [45697],
      Windham: [44288],
      Windsor: [44099],
      'Wingett Run': [45789],
      Wintersville: [43952],
      Woodstock: [43084],
      Woodville: [43469],
      Wooster: [44691],
      Worthington: [43085],
      Xenia: [45385],
      'Yellow Springs': [45387],
      Yorkshire: [45388],
      Yorkville: [43971],
      Youngstown: [
        44502, 44503, 44504, 44505, 44506, 44507, 44509, 44510, 44511,
      ],
      Zanesfield: [43360],
      Zoarville: [44656],
    },
    name: 'Ohio',
  },
  OK: {
    cities: {
      Ada: [74820],
      Adair: [74330],
      Agra: [74824],
      Alex: [73002],
      Aline: [73716],
      Allen: [74825],
      Altus: [73521],
      Alva: [73717],
      Amber: [73004],
      Ames: [73718],
      Amorita: [73719],
      Anadarko: [73005],
      Antlers: [74523],
      Apache: [73006],
      Arapaho: [73620],
      Arcadia: [73007],
      Arkoma: [74901],
      Asher: [74826],
      Atoka: [74525],
      Atwood: [74827],
      Baker: [73950],
      Balko: [73931],
      Barnsdall: [74002],
      Bartlesville: [74003, 74006],
      Bearden: [74859],
      Beggs: [74421],
      Bennington: [74723],
      Bernice: [74331],
      Bessie: [73622],
      Bethany: [73008],
      Bethel: [74724],
      'Big Cabin': [74332],
      Billings: [74630],
      Binger: [73009],
      Bison: [73720],
      Bixby: [74008],
      Blackwell: [74631],
      Blair: [73526],
      Blanchard: [73010],
      Blanco: [74528],
      Bluejacket: [74333],
      'Boise City': [73933],
      Bokchito: [74726],
      Bokoshe: [74930],
      Boley: [74829],
      Boswell: [74727],
      Boynton: [74422],
      Bradley: [73011],
      Braggs: [74423],
      Braman: [74632],
      Bristow: [74010],
      'Broken Arrow': [74011, 74012, 74014],
      'Broken Bow': [74728],
      Bunch: [74931],
      Burbank: [74633],
      Burlington: [73722],
      Burneyville: [73430],
      Butler: [73625],
      Byars: [74831],
      Byron: [73723],
      Cache: [73527],
      Caddo: [74729],
      Calera: [74730],
      Calumet: [73014],
      Calvin: [74531],
      Camargo: [73835],
      Cameron: [74932],
      Canadian: [74425],
      Caney: [74533],
      Canton: [73724],
      Canute: [73626],
      Capron: [73725],
      Carmen: [73726],
      Carnegie: [73015],
      Carney: [74832],
      Carrier: [73727],
      Carter: [73627],
      Cartwright: [74731],
      Cashion: [73016],
      Castle: [74833],
      Catoosa: [74015],
      Cement: [73017],
      Centrahoma: [74534],
      Chandler: [74834],
      Chattanooga: [73528],
      Checotah: [74426],
      Chelsea: [74016],
      Cherokee: [73728],
      Chester: [73838],
      Chickasha: [73018],
      Choctaw: [73020],
      Chouteau: [74337],
      Claremore: [74017],
      Clayton: [74536],
      Clearview: [74835],
      'Cleo Springs': [73729],
      Cleveland: [74020],
      Clinton: [73601],
      Coalgate: [74538],
      Colbert: [74733],
      Colcord: [74338],
      Coleman: [73432],
      Collinsville: [74021],
      Colony: [73021],
      Comanche: [73529],
      Commerce: [74339],
      Cookson: [74427],
      Copan: [74022],
      Cordell: [73632],
      Corn: [73024],
      'Council Hill': [74428],
      Covington: [73730],
      Coweta: [74429],
      Coyle: [73027],
      Crawford: [73638],
      Crescent: [73028],
      Cushing: [74023],
      'Custer City': [73639],
      Cyril: [73029],
      Dacoma: [73731],
      Daisy: [74540],
      Davidson: [73530],
      Davis: [73030],
      'Deer Creek': [74636],
      'Del City': [73115],
      Delaware: [74027],
      Depew: [74028],
      Devol: [73531],
      Dewey: [74029],
      'Dill City': [73641],
      Douglas: [73733],
      Dover: [73734],
      Drummond: [73735],
      Drumright: [74030],
      Duke: [73532],
      Duncan: [73533],
      Durant: [74701],
      Durham: [73642],
      Dustin: [74839],
      'Eagle City': [73658],
      Eagletown: [74734],
      Earlsboro: [74840],
      Edmond: [73013, 73034],
      'El Reno': [73036],
      Eldorado: [73537],
      Elgin: [73538],
      'Elk City': [73644],
      Elmer: [73539],
      'Elmore City': [73035],
      Elmwood: [73932],
      Enid: [73701, 73703],
      Erick: [73645],
      Eucha: [74342],
      Eufaula: [74432],
      Fairfax: [74637],
      Fairland: [74343],
      Fairmont: [73736],
      Fargo: [73840],
      Farris: [74542],
      Faxon: [73540],
      Fay: [73646],
      Felt: [73937],
      Finley: [74543],
      Fittstown: [74842],
      Fitzhugh: [74843],
      Fletcher: [73541],
      Foraker: [74652],
      Forgan: [73938],
      'Fort Cobb': [73038],
      'Fort Gibson': [74434],
      'Fort Sill': [73503],
      'Fort Supply': [73841],
      'Fort Towson': [74735],
      Foss: [73647],
      Foster: [73039],
      Frederick: [73542],
      Freedom: [73842],
      Gage: [73843],
      Garber: [73738],
      Garvin: [74736],
      Gate: [73844],
      Geary: [73040],
      Geronimo: [73543],
      Glencoe: [74032],
      Glenpool: [74033],
      Goltry: [73739],
      Goodwell: [73939],
      Gore: [74435],
      Gotebo: [73041],
      Gould: [73544],
      Gracemont: [73042],
      Grady: [73569],
      Graham: [73437],
      Grandfield: [73546],
      Granite: [73547],
      Grant: [74738],
      Greenfield: [73043],
      Grove: [74344],
      Guthrie: [73044],
      Guymon: [73942],
      Hammon: [73650],
      'Harden City': [74871],
      Hardesty: [73944],
      Harmon: [73832],
      Harrah: [73045],
      Hartshorne: [74547],
      Haskell: [74436],
      Hastings: [73548],
      Haywood: [74548],
      Headrick: [73549],
      Healdton: [73438],
      Heavener: [74937],
      Helena: [73741],
      Hendrix: [74741],
      Hennepin: [73046],
      Hennessey: [73742],
      Hinton: [73047],
      Hitchcock: [73744],
      Hobart: [73651],
      Hodgen: [74939],
      Hoffman: [74437],
      Holdenville: [74848],
      Hollis: [73550],
      Hollister: [73551],
      Hominy: [74035],
      Honobia: [74549],
      Howe: [74940],
      Hoyt: [74440],
      Hugo: [74743],
      Hulbert: [74441],
      Hunter: [74640],
      Hydro: [73048],
      Idabel: [74745],
      Indiahoma: [73552],
      Indianola: [74442],
      Inola: [74036],
      Isabella: [73747],
      Jay: [74346],
      Jenks: [74037],
      Jennings: [74038],
      Jet: [73749],
      Jones: [73049],
      Kansas: [74347],
      'Kaw City': [74641],
      Kellyville: [74039],
      Kendrick: [74079],
      Kenefic: [74748],
      Kenton: [73946],
      Keota: [74941],
      Keyes: [73947],
      Kingfisher: [73750],
      Kingston: [73439],
      Kinta: [74552],
      Kiowa: [74553],
      Knowles: [73847],
      Konawa: [74849],
      Kremlin: [73753],
      Lahoma: [73754],
      Lamar: [74850],
      Lamont: [74643],
      Lane: [74555],
      Laverne: [73848],
      Lawton: [73501, 73505, 73507],
      Leach: [74364],
      Lebanon: [73440],
      Leedey: [73654],
      Lenapah: [74042],
      Leon: [73441],
      Lexington: [73051],
      Lindsay: [73052],
      Loco: [73442],
      'Locust Grove': [74352],
      Logan: [73849],
      'Lone Grove': [73443],
      'Lone Wolf': [73655],
      Longdale: [73755],
      Lookeba: [73053],
      Loveland: [73553],
      Loyal: [73756],
      Lucien: [73757],
      Luther: [73054],
      Macomb: [74852],
      Manchester: [73758],
      Mannford: [74044],
      Mannsville: [73447],
      Maramec: [74045],
      Marietta: [73448],
      Marland: [74644],
      Marlow: [73055],
      Marshall: [73056],
      Maud: [74854],
      May: [73851],
      Maysville: [73057],
      'Mc Loud': [74851],
      'Mc Millan': [73446],
      Mcalester: [74501],
      Mccurtain: [74944],
      Mead: [73449],
      Medford: [73759],
      Meeker: [74855],
      Meno: [73760],
      Meridian: [73058],
      Miami: [74354],
      'Midwest City': [73110, 73130],
      Milburn: [73450],
      'Mill Creek': [74856],
      Milo: [73401],
      Minco: [73059],
      Moore: [73160, 73165, 73170],
      Mooreland: [73852],
      Morris: [74445],
      Morrison: [73061],
      Mounds: [74047],
      'Mountain Park': [73559],
      'Mountain View': [73062],
      Moyers: [74557],
      Muldrow: [74948],
      Mulhall: [73063],
      Muse: [74949],
      Muskogee: [74401, 74403],
      Mustang: [73064],
      Mutual: [73853],
      Nardin: [74646],
      Nash: [73761],
      Nashoba: [74558],
      'New Lima': [74884],
      Newalla: [74857],
      Newcastle: [73065],
      'Nichols Hills': [73116],
      Ninnekah: [73067],
      Noble: [73068],
      Norman: [73069, 73071, 73072],
      Nowata: [74048],
      Oaks: [74359],
      Ochelata: [74051],
      Octavia: [74957],
      Okarche: [73762],
      Okeene: [73763],
      'Oklahoma City': [
        73102, 73103, 73104, 73105, 73106, 73107, 73108, 73109, 73111, 73112,
        73114, 73117, 73118, 73119, 73120, 73121, 73127, 73128, 73129, 73131,
        73134, 73135, 73139, 73141, 73142, 73149, 73150, 73151, 73159, 73162,
        73169, 73173, 73179,
      ],
      Okmulgee: [74447],
      Oktaha: [74450],
      Olustee: [73560],
      Omega: [73764],
      Oologah: [74053],
      Optima: [73945],
      Orienta: [73737],
      Orlando: [73073],
      Osage: [74054],
      Oscar: [73561],
      Overbrook: [73453],
      Owasso: [74055],
      Paden: [74860],
      Paoli: [73074],
      'Park Hill': [74451],
      'Pauls Valley': [73075],
      Pawhuska: [74056],
      Pawnee: [74058],
      Peckham: [74647],
      Peggs: [74452],
      Perkins: [74059],
      Perry: [73077],
      Picher: [74360],
      Piedmont: [73078],
      Pittsburg: [74560],
      Pocasset: [73079],
      Pocola: [74902],
      'Ponca City': [74601, 74604],
      'Pond Creek': [73766],
      Porter: [74454],
      Porum: [74455],
      Poteau: [74953],
      Prague: [74864],
      Proctor: [74457],
      Prue: [74060],
      Pryor: [74361],
      Purcell: [73080],
      Putnam: [73659],
      Quapaw: [74363],
      Quinton: [74561],
      Ralston: [74650],
      Ramona: [74061],
      Randlett: [73562],
      'Ratliff City': [73081],
      Rattan: [74562],
      'Red Oak': [74563],
      'Red Rock': [74651],
      Reed: [73554],
      Reydon: [73660],
      Ringling: [73456],
      Ringold: [74754],
      Ringwood: [73768],
      Ripley: [74062],
      Rocky: [73661],
      Roff: [74865],
      Roland: [74954],
      Roosevelt: [73564],
      Rosston: [73855],
      Rubottom: [73463],
      Rufe: [74755],
      'Rush Springs': [73082],
      Ryan: [73565],
      'S Coffeyville': [74072],
      Salina: [74365],
      Sallisaw: [74955],
      'Sand Springs': [74063],
      Sapulpa: [74066],
      Sasakwa: [74867],
      Sawyer: [74756],
      Sayre: [73662],
      Seiling: [73663],
      Selman: [73834],
      Seminole: [74868],
      Sentinel: [73664],
      'Shady Point': [74956],
      Sharon: [73857],
      Shattuck: [73858],
      Shawnee: [74801],
      Skiatook: [74070],
      Snow: [74567],
      Snyder: [73566],
      Soper: [74759],
      Southard: [73770],
      Sparks: [74869],
      Spavinaw: [74366],
      Spencer: [73084],
      Spencerville: [74760],
      Sperry: [74073],
      Spiro: [74959],
      Springer: [73458],
      Stidham: [74461],
      Stigler: [74462],
      Stillwater: [74074, 74075],
      Stilwell: [74960],
      Strang: [74367],
      Stratford: [74872],
      Stringtown: [74569],
      'Strong City': [73628],
      Stuart: [74570],
      Sulphur: [73086],
      Sweetwater: [73666],
      Taft: [74463],
      Tahlequah: [74464],
      Talala: [74080],
      Talihina: [74571],
      Taloga: [73667],
      Tecumseh: [74873],
      Temple: [73568],
      Terlton: [74081],
      Texhoma: [73949],
      Texola: [73668],
      Thackerville: [73459],
      Thomas: [73669],
      'Tinker Afb': [73145],
      Tipton: [73570],
      Tishomingo: [73460],
      Tom: [74740],
      Tonkawa: [74653],
      Tryon: [74875],
      Tulsa: [
        74103, 74104, 74105, 74106, 74107, 74108, 74110, 74112, 74114, 74115,
        74116, 74117, 74119, 74120, 74126, 74127, 74128, 74129, 74130, 74131,
        74132, 74133, 74134, 74135, 74136, 74137, 74145, 74146,
      ],
      Tupelo: [74572],
      Tuskahoma: [74574],
      Tussy: [73088],
      Tuttle: [73089],
      'Twin Oaks': [74368],
      Tyrone: [73951],
      'Union City': [73090],
      Valliant: [74764],
      Verden: [73092],
      Vernon: [74845],
      Vian: [74962],
      Vici: [73859],
      Vinita: [74301],
      Vinson: [73571],
      Wagoner: [74467],
      Wakita: [73771],
      Walters: [73572],
      Wanette: [74878],
      Wann: [74083],
      Wapanucka: [73461],
      Wardville: [74576],
      Warner: [74469],
      'Warr Acres': [73122, 73132],
      Washington: [73093],
      Watonga: [73772],
      Watson: [74963],
      Watts: [74964],
      Waukomis: [73773],
      Waurika: [73573],
      Wayne: [73095],
      Waynoka: [73860],
      Weatherford: [73096],
      'Webbers Falls': [74470],
      Welch: [74369],
      Weleetka: [74880],
      Welling: [74471],
      Wellston: [74881],
      Welty: [74882],
      Westville: [74965],
      Wetumka: [74883],
      Whitefield: [74472],
      Whitesboro: [74577],
      Wilburton: [74578],
      Willow: [73673],
      Wister: [74966],
      Woodward: [73801],
      'Wright City': [74766],
      Wyandotte: [74370],
      Wynnewood: [73098],
      Wynona: [74084],
      Yale: [74085],
      Yukon: [73099],
    },
    name: 'Oklahoma',
  },
  OR: {
    cities: {
      Adams: [97810],
      Adel: [97620],
      Adrian: [97901],
      Agness: [97406],
      Albany: [97321],
      Aloha: [97006, 97007],
      Alsea: [97324],
      Amity: [97101],
      Antelope: [97001],
      Applegate: [97530],
      Arlington: [97812],
      Arock: [97902],
      Ashland: [97520],
      Ashwood: [97711],
      Astoria: [97103],
      Athena: [97813],
      Aurora: [97002],
      Azalea: [97410],
      Bandon: [97411],
      Banks: [97106],
      'Bay City': [97107],
      Beatty: [97621],
      Beaver: [97108],
      Beavercreek: [97004],
      Beaverton: [97005],
      Bend: [97701, 97702],
      Blachly: [97412],
      'Black Butte Ranc': [97759],
      Blodgett: [97326],
      Boardman: [97818],
      Bonanza: [97623],
      Bonneville: [97014],
      Boring: [97009],
      'Bridal Veil': [97010],
      Brightwood: [97011],
      Broadbent: [97414],
      Brogan: [97903],
      Brooks: [97305],
      Brothers: [97712],
      Brownsville: [97327],
      Burns: [97720],
      'Butte Falls': [97522],
      Buxton: [97109],
      'Camas Valley': [97416],
      'Camp Sherman': [97730],
      Canby: [97013],
      'Canyon City': [97820],
      Canyonville: [97417],
      Carlton: [97111],
      Cascadia: [97329],
      'Cave Junction': [97523],
      'Cedar Hills': [97225],
      'Central Point': [97502],
      Charleston: [97420],
      Cheshire: [97419],
      Chiloquin: [97624],
      Clackamas: [97015],
      Cloverdale: [97112],
      Coburg: [97401],
      Colton: [97017],
      'Columbia City': [97018],
      Condon: [97823],
      Coquille: [97423],
      Corbett: [97019],
      Cornelius: [97113],
      Corvallis: [97330, 97331, 97333],
      'Cottage Grove': [97424],
      Cove: [97824],
      Crane: [97732],
      Crescent: [97733],
      Creswell: [97426],
      'Crooked River Ra': [97760],
      'Culp Creek': [97427],
      Culver: [97734],
      Dairy: [97625],
      Dallas: [97338],
      'Days Creek': [97429],
      Dayton: [97114],
      Dayville: [97825],
      'Deer Island': [97054],
      'Depoe Bay': [97341],
      Detroit: [97342],
      Dexter: [97431],
      'Diamond Lake': [97731],
      Dorena: [97434],
      Drain: [97435],
      Drewsey: [97904],
      Dundee: [97115],
      'Eagle Creek': [97022],
      'Eagle Point': [97524],
      Echo: [97826],
      Eddyville: [97343],
      Elgin: [97827],
      Elkton: [97436],
      Elmira: [97437],
      Enterprise: [97828],
      Estacada: [97023],
      Eugene: [97402, 97403, 97404, 97405],
      'Fall Creek': [97438],
      'Falls City': [97344],
      Florence: [97439],
      'Fort Rock': [97735],
      Foster: [97345],
      Fox: [97831],
      Friend: [97021],
      'Gales Creek': [97117],
      'Garden Home': [97223],
      Gardiner: [97441],
      Gaston: [97119],
      Gates: [97346],
      Gearhart: [97138],
      Gervais: [97026],
      Gilchrist: [97737],
      Gladstone: [97027],
      Glendale: [97442],
      Glenwood: [97116],
      Glide: [97443],
      'Gold Hill': [97525],
      'Grand Ronde': [97347],
      'Grants Pass': [97526, 97527],
      'Grass Valley': [97029],
      Greenleaf: [97430],
      Gresham: [97030, 97080],
      Haines: [97833],
      Halfway: [97834],
      Halsey: [97348],
      Hammond: [97121],
      Harbor: [97415],
      Harper: [97906],
      Harrisburg: [97446],
      Hebo: [97122],
      Helix: [97835],
      Heppner: [97836],
      Hereford: [97837],
      Hermiston: [97838],
      Hillsboro: [97123, 97124],
      'Hood River': [97031],
      Hubbard: [97032],
      Huntington: [97907],
      Idanha: [97350],
      'Idleyld Park': [97447],
      Imbler: [97841],
      Imnaha: [97842],
      Independence: [97351],
      Ione: [97843],
      Ironside: [97908],
      Irrigon: [97844],
      Jamieson: [97909],
      Jefferson: [97352],
      'John Day': [97845],
      'Jordan Valley': [97910],
      Joseph: [97846],
      'Junction City': [97448],
      Juntura: [97911],
      Keizer: [97303],
      Keno: [97627],
      Kent: [97033],
      Kerby: [97531],
      Kimberly: [97848],
      Kinzua: [97830],
      'Klamath Falls': [97603],
      'La Grande': [97850],
      'La Pine': [97739],
      Lafayette: [97127],
      'Lake Oswego': [97034, 97035],
      Lakeside: [97449],
      Lakeview: [97630],
      Langlois: [97450],
      Lawen: [97740],
      Leaburg: [97489],
      Lebanon: [97355],
      Lexington: [97839],
      'Lincoln City': [97367],
      Logsden: [97357],
      'Long Creek': [97856],
      Lorane: [97451],
      Lostine: [97857],
      Lowell: [97452],
      Lyons: [97358],
      Madras: [97741],
      Malin: [97632],
      Manning: [97125],
      Mapleton: [97453],
      Marcola: [97454],
      Maupin: [97037],
      'Mc Kenzie Bridge': [97413],
      Mcminnville: [97128],
      Mcnary: [97882],
      Medford: [97504],
      'Medical Springs': [97814],
      Merlin: [97532],
      Merrill: [97633],
      'Mill City': [97360],
      'Milton Freewater': [97862],
      Milwaukie: [97222],
      Mitchell: [97750],
      Molalla: [97038],
      Monmouth: [97361],
      Monroe: [97456],
      Monument: [97864],
      Moro: [97039],
      Mosier: [97040],
      'Mount Angel': [97362],
      'Mount Hood Parkd': [97041],
      'Mount Vernon': [97865],
      Mulino: [97042],
      'Myrtle Creek': [97457],
      'Myrtle Point': [97458],
      Nehalem: [97131],
      Neotsu: [97364],
      Neskowin: [97149],
      'New Pine Creek': [97635],
      Newberg: [97132],
      Newport: [97365],
      'North Bend': [97459],
      'North Powder': [97867],
      Noti: [97461],
      Nyssa: [97913],
      'O Brien': [97534],
      'Oak Grove': [97267],
      Oakland: [97462],
      Oakridge: [97463],
      Odell: [97044],
      Ontario: [97914],
      'Oregon City': [97045],
      Oretech: [97601],
      Otis: [97368],
      Paisley: [97636],
      Paulina: [97751],
      Pendleton: [97801],
      Philomath: [97370],
      Phoenix: [97535],
      'Pilot Rock': [97868],
      'Pistol River': [97444],
      'Pleasant Hill': [97455],
      Plush: [97637],
      'Port Orford': [97465],
      Portland: [
        97201, 97202, 97203, 97204, 97205, 97206, 97209, 97210, 97211, 97212,
        97213, 97214, 97215, 97216, 97217, 97218, 97219, 97220, 97221, 97227,
        97229, 97231, 97232, 97233, 97236, 97266,
      ],
      Post: [97752],
      'Powell Butte': [97753],
      Powers: [97466],
      'Prairie City': [97869],
      Prineville: [97754],
      Prospect: [97536],
      Rainier: [97048],
      Redmond: [97756],
      Remote: [97468],
      Richland: [97870],
      Rickreall: [97371],
      Riddle: [97469],
      Riley: [97758],
      Ritter: [97872],
      Riverside: [97917],
      Rockaway: [97136],
      'Rockwood Corners': [97230],
      'Rogue River': [97537],
      Roseburg: [97470],
      Rufus: [97050],
      'Saint Helens': [97051],
      'Saint Paul': [97137],
      Salem: [97301, 97302, 97304, 97306],
      Sandy: [97055],
      Scappoose: [97056],
      Scio: [97374],
      'Scotts Mills': [97375],
      Scottsburg: [97473],
      'Seal Rock': [97376],
      Selma: [97538],
      Seneca: [97873],
      'Shady Cove': [97539],
      Shaniko: [97057],
      Shedd: [97377],
      Sheridan: [97378],
      Sherwood: [97140],
      Siletz: [97380],
      'Silver Lake': [97638],
      Silverton: [97381],
      Sixes: [97476],
      'South Beach': [97366],
      Spray: [97874],
      Springfield: [97477, 97478],
      Stanfield: [97875],
      Stayton: [97383],
      Sublimity: [97385],
      'Summer Lake': [97640],
      Summerville: [97876],
      Sumpter: [97877],
      'Sunny Valley': [97497],
      Sunriver: [97707],
      Sutherlin: [97479],
      'Sweet Home': [97386],
      Swisshome: [97480],
      Talent: [97540],
      Tangent: [97389],
      Tenmile: [97481],
      'The Dalles': [97058],
      Tidewater: [97390],
      Tigard: [97224],
      Tillamook: [97141],
      Tiller: [97484],
      Timber: [97144],
      'Timberline Lodge': [97028],
      Toledo: [97391],
      'Tolovana Park': [97145],
      Trail: [97541],
      Troutdale: [97060],
      Tualatin: [97062],
      Turner: [97392],
      Umpqua: [97486],
      Union: [97883],
      Unity: [97884],
      Vale: [97918],
      Veneta: [97487],
      Vernonia: [97064],
      Vida: [97488],
      Waldport: [97394],
      Wallowa: [97885],
      Walton: [97490],
      Wamic: [97063],
      'Warm Springs': [97761],
      Warren: [97053],
      Warrenton: [97146],
      Wasco: [97065],
      Welches: [97067],
      'West Linn': [97068],
      'West Main': [97501],
      'West Stayton': [97325],
      Westfall: [97920],
      Westfir: [97492],
      Westlake: [97493],
      Weston: [97886],
      Westport: [97016],
      'White City': [97503],
      Wilderville: [97543],
      Willamina: [97396],
      Williams: [97544],
      Wilsonville: [97070],
      'Winchester Bay': [97467],
      Winston: [97496],
      Woodburn: [97071],
      Yachats: [97498],
      Yamhill: [97148],
      Yoncalla: [97499],
      Zigzag: [97049],
    },
    name: 'Oregon',
  },
  PA: {
    cities: {
      Aaronsburg: [16820],
      Abbottstown: [17301],
      Acme: [15610],
      Adah: [15410],
      Adamsburg: [15611],
      Adamstown: [19501],
      Adamsville: [16110],
      Addison: [15411],
      Adrian: [16210],
      Airville: [17302],
      Akron: [17501],
      Albrightsville: [18210],
      Alburtis: [18011],
      Aldenville: [18401],
      Aleppo: [15310],
      Allegheny: [15212],
      Allenport: [15412],
      Allensville: [17002],
      Allentown: [18101, 18102, 18103, 18104],
      Allenwood: [17810],
      Allison: [15413],
      'Allison Park': [15101],
      Allport: [16821],
      Altoona: [16601, 16602],
      'Alum Bank': [15521],
      Alverton: [15612],
      Amity: [15311],
      Andreas: [18211],
      Anita: [15711],
      Annville: [17003],
      Apollo: [15613],
      Ardara: [15615],
      Ardmore: [19003],
      Armagh: [15920],
      Armbrust: [15616],
      Arnold: [15068],
      Arona: [15617],
      Arsenal: [15201],
      Artemas: [17211],
      Ashland: [17921],
      Ashley: [18706],
      Ashville: [16613],
      Aspers: [17304],
      Aspinwall: [15215],
      Aston: [19014],
      Atglen: [19310],
      Athens: [18810],
      Atlantic: [16111],
      Auburn: [17922],
      Aultman: [15713],
      Austin: [16720],
      Avella: [15312],
      Avoca: [18641],
      Avondale: [19311],
      Avonmore: [15618],
      Baden: [15005],
      Bainbridge: [17502],
      Bakerstown: [15007],
      'Bala Cynwyd': [19004],
      Bally: [19503],
      Barnesboro: [15714],
      Barnesville: [18214],
      Barree: [16611],
      Barto: [19504],
      Bartonsville: [18321],
      Bath: [18014],
      'Beach Lake': [18405],
      Beallsville: [15313],
      'Bear Lake': [16402],
      Beaver: [15009],
      'Beaver Meadows': [18216],
      'Beaver Springs': [17812, 17843],
      Beavertown: [17813],
      Beccaria: [16616],
      Bechtelsville: [19505],
      Bedford: [15522],
      'Beech Creek': [16822],
      Belleville: [17004],
      Bellevue: [15202],
      Bellwood: [16617],
      Benezett: [15821],
      Bensalem: [19020],
      Bentleyville: [15314],
      Benton: [17814],
      Berlin: [15530],
      Bernville: [19506],
      Berrysburg: [17005],
      Berwick: [18603],
      Berwyn: [19312],
      Bessemer: [16112],
      Bethel: [19507],
      'Bethel Park': [15102],
      Bethlehem: [18015, 18018],
      Bethton: [18964],
      'Big Cove Tannery': [17212],
      Biglerville: [17307],
      'Bird In Hand': [17505],
      Birdsboro: [19508],
      'Black Lick': [15716],
      Blain: [17006],
      'Blairs Mills': [17213],
      Blairsville: [15717],
      Blakeslee: [18610],
      Blandon: [19510],
      Blawnox: [15238],
      Bloomfield: [15224],
      Bloomsburg: [17815],
      Blossburg: [16912],
      'Blue Ridge Summi': [17214],
      Boalsburg: [16827],
      'Boiling Springs': [17007],
      Bolivar: [15923],
      'Bon Aire': [16001],
      Boothwyn: [19061],
      Boston: [15135],
      Boswell: [15531],
      Boyers: [16020],
      Boyertown: [19512],
      Brackenridge: [15014],
      Brackney: [18812],
      Bradenville: [15620],
      Bradford: [16701],
      Bradfordwoods: [15015],
      Branchdale: [17923],
      Breezewood: [15533],
      Breinigsville: [18031],
      Brentwood: [15227],
      Bridgeport: [19405],
      Bridgeville: [15017],
      Brisbin: [16620],
      'Broad Top': [16621],
      Brockport: [15823],
      Brockton: [17925],
      Brockway: [15824],
      Brodbecks: [17329],
      Brodheadsville: [18322],
      Brogue: [17309],
      Brookhaven: [19015],
      Brookline: [15226],
      Broomall: [19008],
      Browndale: [18421],
      Bruin: [16022],
      Brunnerville: [17543],
      'Brush Valley': [15720],
      'Bryn Mawr': [19010],
      'Buena Vista': [15018],
      'Buffalo Mills': [15534],
      Bulger: [15019],
      Burnham: [17009],
      Burnside: [15721],
      'Burnt Cabins': [17215],
      Bushkill: [18324],
      Butztown: [18017],
      Byrnedale: [15827],
      Cadogan: [16212],
      Cairnbrook: [15924],
      California: [15419],
      Callensburg: [16213],
      Calvin: [16622],
      'Cambridge Spring': [16403],
      Cammal: [17723],
      Canadensis: [18325],
      Canton: [17724],
      'Carlisle Barrack': [17013],
      Carlton: [16311],
      Carmichaels: [15320],
      Carnegie: [15106],
      Carrolltown: [15722],
      Carson: [15203],
      Carversville: [18913],
      Cassville: [16623],
      'Caste Village': [15236],
      'Castle Shannon': [15234],
      Catasauqua: [18032],
      Catawissa: [17820],
      Cecil: [15321],
      'Cedar Run': [17727],
      Cedarhurst: [15243],
      'Center Moreland': [18657],
      'Center Valley': [18034],
      Centerville: [16404],
      'Central City': [15926],
      Centralia: [17927],
      'Centre Hall': [16828],
      'Chadds Ford': [19317],
      Chalfont: [18914],
      Chambersburg: [17201],
      Champion: [15622],
      Charleroi: [15022],
      Cheltenham: [19012],
      'Cherry Tree': [15724],
      Cherryville: [18035],
      Chester: [19013],
      'Chester Springs': [19425],
      Cheswick: [15024],
      Cheyney: [19319],
      Chicora: [16025],
      Clarence: [16829],
      Clarendon: [16313],
      Clarington: [15828],
      Clarion: [16214],
      'Clarks Mills': [16114],
      'Clarks Summit': [18411],
      Clarksburg: [15725],
      Clarksville: [15322],
      Claysburg: [16625],
      Claysville: [15323],
      Clearfield: [16830],
      Clearville: [15535],
      Cleona: [17042],
      Clinton: [15026],
      Clintonville: [16372],
      Clymer: [15728],
      'Coal Center': [15423],
      Coaldale: [18218],
      Coalport: [16627],
      Coatesville: [19320],
      Coburn: [16832],
      Cochranton: [16314],
      Cochranville: [19330],
      Cocolamus: [17014],
      'Cogan Station': [17728],
      Cokeburg: [15324],
      'College Miserico': [18612],
      Collegeville: [19426],
      Collingdale: [19023],
      Colmar: [18915],
      'Colonial Park': [17109],
      Columbia: [17512],
      'Columbia Cross R': [16914],
      Columbus: [16405],
      Colver: [15927],
      Commodore: [15729],
      Concord: [17217],
      Conestoga: [17516],
      'Conneaut Lake': [16316],
      Conneautville: [16406],
      Conway: [15027],
      Cooksburg: [16217],
      Coolspring: [15730],
      Coopersburg: [18036],
      Cooperstown: [16317],
      Coplay: [18037],
      Corliss: [15204],
      Corry: [16407],
      Corsica: [15829],
      Covington: [16917],
      Cowansville: [16218],
      Crafton: [15205],
      Craigsville: [16262],
      Cranberry: [16319],
      Cranesville: [16410],
      Creekside: [15732],
      Creighton: [15030],
      Cresco: [18326],
      Cresson: [16630],
      Cressona: [17929],
      Crosby: [16724],
      'Cross Fork': [17729],
      Croydon: [19021],
      'Crum Lynne': [19022],
      'Crystal Spring': [15536],
      Cuddy: [15031],
      Curwensville: [16833],
      Daisytown: [15427],
      Dalmatia: [17017],
      Dalton: [18414],
      Damascus: [18415],
      Danielsville: [18038],
      Danville: [17821],
      Darlington: [16115],
      Darragh: [15625],
      Dauphin: [17018],
      Davidsville: [15928],
      Davistown: [15349],
      Dawson: [15428],
      Dayton: [16222],
      Delano: [18220],
      'Delaware Water G': [18327],
      Delmont: [15626],
      Delta: [17314],
      Denver: [17517],
      'Derrick City': [16727],
      Derry: [15627],
      Devon: [19333],
      'Dickson City': [18519],
      Dilliner: [15327],
      Dillsburg: [17019],
      'Dingmans Ferry': [18328],
      Donaldson: [17981],
      Donegal: [15628],
      Donora: [15033],
      Dornsife: [17823],
      Douglassville: [19518],
      Dover: [17315],
      Downingtown: [19335],
      Downtown: [15222],
      Doylesburg: [17219],
      Dravosburg: [15034],
      Dresher: [19025],
      Driftwood: [15832],
      Drumore: [17518],
      Drums: [18222],
      'Dry Run': [17220],
      'Du Bois': [15801],
      Dublin: [18917],
      Dudley: [16634],
      'Duke Center': [16729],
      Dunbar: [15431],
      Duncannon: [17020],
      Duncansville: [16635],
      Dunlevy: [15432],
      Dunmore: [18512],
      Duquesne: [15110],
      Duryea: [18642],
      Dushore: [18614],
      Dysart: [16636],
      Eagleville: [19403],
      'East Berlin': [17316],
      'East Brady': [16028],
      'East Earl': [17519],
      'East Freedom': [16637],
      'East Greenville': [18041],
      'East Hickory': [16321],
      'East Liberty': [15206],
      'East Mc Keesport': [15035],
      'East Millsboro': [15433],
      'East Petersburg': [17520],
      'East Pittsburgh': [15112],
      'East Smithfield': [18817],
      'East Springfield': [16411],
      'East Stroudsburg': [18301],
      'East Waterford': [17021],
      'East York': [17402],
      'Eau Claire': [16030],
      Ebensburg: [15931],
      Edinboro: [16412],
      Edinburg: [16116],
      Effort: [18330],
      'Eighty Four': [15330],
      Elco: [15434],
      Eldred: [16731],
      Elizabeth: [15037],
      Elizabethtown: [17022],
      Elizabethville: [17023],
      'Elkins Park': [19117],
      Elkland: [16920],
      Elliottsburg: [17024],
      Ellport: [16117],
      Ellsworth: [15331],
      Elverson: [19520],
      Elysburg: [17824],
      Emerald: [18080],
      Emlenton: [16373],
      Emmaus: [18049],
      Emporium: [15834],
      Enola: [17025],
      'Enon Valley': [16120],
      Ephrata: [17522],
      Equinunk: [18417],
      Erie: [
        16501, 16502, 16503, 16504, 16506, 16507, 16508, 16509, 16511, 16565,
      ],
      Ernest: [15739],
      Erwinna: [18920],
      Espyville: [16424],
      Etna: [15223],
      Etters: [17319],
      'Evans City': [16033],
      Evansville: [19522],
      Everett: [15537],
      Everson: [15631],
      Excelsior: [17872],
      Export: [15632],
      Exton: [19341],
      Eynon: [18403],
      Factoryville: [18419],
      Fairchance: [15436],
      'Fairless Hills': [19030],
      'Fairmount City': [16224],
      Fairoaks: [15003],
      Fairview: [16415],
      Fallentimber: [16639],
      Falls: [18615],
      'Falls Creek': [15840],
      Fannettsburg: [17221],
      Farmington: [15437],
      Farrell: [16121],
      'Fawn Grove': [17321],
      'Fayette City': [15438],
      Fayetteville: [17222],
      'Feasterville Tre': [19053],
      Felton: [17322],
      Fenelton: [16034],
      Finleyville: [15332],
      Fisher: [16225],
      Flinton: [16640],
      Florin: [17552],
      Flourtown: [19031],
      Fogelsville: [18051],
      Folcroft: [19032],
      Folsom: [19033],
      Fombell: [16123],
      'Ford City': [16226],
      'Forks Township': [18042],
      Forksville: [18616],
      'Fort Hill': [15540],
      'Fort Littleton': [17223],
      'Fort Loudon': [17224],
      'Fort Washington': [19034],
      Fountainville: [18923],
      Foxburg: [16036],
      Frackville: [17931],
      Franklin: [16323],
      Frazer: [19355],
      Frederick: [19435],
      Fredericksburg: [17026],
      Fredericktown: [15333],
      Fredonia: [16124],
      Freeburg: [17827],
      Freedom: [15042],
      Freeland: [18224],
      Freeport: [16229],
      Frenchville: [16836],
      Friedens: [15541],
      Friendsville: [18818],
      Fryburg: [16326],
      Furlong: [18925],
      Gaines: [16921],
      Galeton: [16922],
      Gallitzin: [16641],
      Ganister: [16693],
      Gap: [17527],
      Gardners: [17324],
      Garrett: [15542],
      Genesee: [16941],
      'George School': [18940],
      Georgetown: [15043],
      Germansville: [18053],
      Gettysburg: [17325],
      'Gibbon Glade': [15440],
      Gibsonia: [15044],
      Gifford: [16732],
      Gilbert: [18331],
      Gilbertsville: [19525],
      Gillett: [16925],
      Girard: [16417],
      Girardville: [17935],
      Gladwyne: [19035],
      Glassport: [15045],
      'Glen Campbell': [15742],
      'Glen Hope': [16645],
      'Glen Lyon': [18617],
      'Glen Mills': [19342],
      'Glen Richey': [16837],
      'Glen Riddle Lima': [19063],
      'Glen Rock': [17327],
      Glencoe: [15538],
      Glenmoore: [19343],
      Glenolden: [19036],
      Glenshaw: [15116],
      Glenside: [19038],
      Gordonville: [17529],
      Gouldsboro: [18424],
      'Gowen City': [17828],
      Graceton: [15748],
      Grampian: [16838],
      'Grand Valley': [16420],
      Grantville: [17028],
      Granville: [17029],
      'Granville Summit': [16926],
      Grapeville: [15634],
      Grassflat: [16839],
      Gratz: [17030],
      'Grays Landing': [15461],
      Graysville: [15337],
      'Great Bend': [18821],
      Greeley: [18425],
      'Green Lane': [18054],
      'Green Park': [17031],
      Greencastle: [17225],
      Greensboro: [15338],
      Greensburg: [15601],
      Greenstone: [17320],
      Greentown: [18426],
      Grindstone: [15442],
      'Grove City': [16127],
      'Guys Mills': [16327],
      Gwynedd: [19436],
      Hadley: [16130],
      Halifax: [17032],
      Hallstead: [18822],
      Hamburg: [19526],
      Hamilton: [15744],
      Hamlin: [18427],
      Hampden: [17055],
      Hanover: [17331],
      'Hanover Township': [18702],
      Harborcreek: [16421],
      Harford: [18823],
      Harleysville: [19438],
      Harmony: [16037],
      Harrisburg: [17101, 17102, 17104, 17110, 17112],
      'Harrison City': [15636],
      'Harrison Valley': [16927],
      Harrisonville: [17228],
      Harrisville: [16038],
      Hartstown: [16131],
      'Harveys Lake': [18618],
      Harwick: [15049],
      Hastings: [16646],
      Hatboro: [19040],
      Hatfield: [19440],
      Haverford: [19041],
      Havertown: [19083],
      'Hawk Run': [16840],
      Hawley: [18428],
      Hazelwood: [15207],
      Hazen: [15825],
      Hegins: [17938],
      Hellam: [17406],
      Hellertown: [18055],
      Henryville: [18332],
      Hereford: [18056],
      Herminie: [15637],
      Hermitage: [16148],
      Herndon: [17830],
      'Herrick Center': [18430],
      Hershey: [17033],
      Hesston: [16647],
      Hickory: [15340],
      Highspire: [17034],
      Hiller: [15444],
      Hilliards: [16040],
      Hillsgrove: [18619],
      Hilltown: [18927],
      Hokendauqua: [18052],
      Holbrook: [15341],
      Holland: [18966],
      Hollidaysburg: [16648],
      Hollsopple: [15935],
      Holmes: [19043],
      Holtwood: [17532],
      Home: [15747],
      Homewood: [15208],
      Honesdale: [18431],
      'Honey Brook': [19344],
      'Honey Grove': [17035],
      Hookstown: [15050],
      Hooversville: [15936],
      'Hop Bottom': [18824],
      Hopewell: [16650],
      Hopwood: [15445],
      Horsham: [19044],
      Houston: [15342],
      Houtzdale: [16651],
      Howard: [16841],
      Huey: [16248],
      Hughesville: [17737],
      Hummelstown: [17036],
      Hunker: [15639],
      'Hunlock Creek': [18621],
      Huntingdon: [16652],
      'Huntingdon Valle': [19006],
      'Huntington Mills': [18622],
      Hustontown: [17229],
      'Hyde Park': [15641],
      Hyndman: [15545],
      Ickesburg: [17037],
      Imler: [16655],
      Imperial: [15126],
      'Indian Head': [15446],
      Indiana: [15701],
      Indianola: [15051],
      Industry: [15052],
      Irvine: [16329],
      Irvona: [16656],
      Jackson: [18825],
      'Jackson Center': [16133],
      Jacobus: [17407],
      'James City': [16734],
      'James Creek': [16657],
      Jamison: [18929],
      Jeannette: [15644],
      Jefferson: [15344],
      Jenners: [15546],
      Jessup: [18434],
      'Jim Thorpe': [18229],
      Joffre: [15053],
      Johnsonburg: [15845],
      Johnstown: [15901, 15902, 15904, 15905, 15906, 15909],
      'Jones Mills': [15646],
      Jonestown: [17038],
      Julian: [16844],
      Kane: [16735],
      'Karns City': [16041],
      Karthaus: [16845],
      Kaska: [17959],
      Kelton: [19346],
      Kempton: [19529],
      Kennerdell: [16374],
      'Kennett Square': [19348],
      Kersey: [15846],
      Kilbuck: [15233],
      'King Of Prussia': [19406],
      Kingsley: [18826],
      Kingston: [18704],
      Kintnersville: [18930],
      Kinzers: [17535],
      Kirkwood: [17536],
      Kittanning: [16201],
      Klingerstown: [17941],
      Knox: [16232],
      Knoxville: [16928],
      Kossuth: [16331],
      Kresgeville: [18333],
      Kulpmont: [17834],
      Kunkletown: [18058],
      Kutztown: [19530],
      'La Belle': [15450],
      'La Jose': [15753],
      Laceyville: [18623],
      Lackawaxen: [18435],
      'Lafayette Hill': [19444],
      Lairdsville: [17742],
      'Lake Ariel': [18436],
      'Lake City': [16423],
      'Lake Como': [18437],
      'Lake Harmony': [18624],
      'Lake Lynn': [15451],
      Lakeville: [18438],
      Lakewood: [18439],
      Lamberton: [15458],
      Lancaster: [17602],
      Landenberg: [19350],
      Landisburg: [17040],
      Lansdale: [19446],
      Lansford: [18232],
      Large: [15025],
      Larimer: [15647],
      Latrobe: [15650],
      Laughlintown: [15655],
      Laurelton: [17835],
      Lawrence: [15055],
      Lawrenceville: [16929],
      Lawton: [18828],
      Layton: [15473],
      'Le Raysville': [18829],
      'Leck Kill': [17836],
      Leechburg: [15656],
      Leeper: [16233],
      Leesport: [19533],
      Leetsdale: [15056],
      'Lemont Furnace': [15456],
      Lenhartsville: [19534],
      Lenoxville: [18441],
      Leola: [17540],
      Lester: [19029],
      'Level Green': [15085],
      Levittown: [19054, 19055, 19056, 19057],
      'Lewis Run': [16738],
      Lewisberry: [17339],
      Lewisburg: [17837],
      Lewistown: [17044],
      Liberty: [16930],
      Library: [15129],
      Lickingville: [16332],
      Lilly: [15938],
      Limerick: [19468],
      Limestone: [16234],
      'Lincoln Universi': [19352],
      Linden: [17744],
      'Line Lexington': [18932],
      Listonburg: [15424],
      'Little Marsh': [16950],
      'Little Meadows': [18830],
      Littlestown: [17340],
      Liverpool: [17045],
      'Lock Haven': [17745],
      Loganton: [17747],
      'Long Pond': [18334],
      Lopez: [18628],
      Loretto: [15940],
      Loyalhanna: [15661],
      Loysburg: [16659],
      Loysville: [17047],
      Lucernemines: [15754],
      Lucinda: [16235],
      Ludlow: [16333],
      Lumberville: [18933],
      'Lundys Lane': [16401],
      Lurgan: [17232],
      Luthersburg: [15848],
      Luzerne: [18709],
      Lykens: [17048],
      Lyndora: [16045],
      Macarthur: [15001],
      Macungie: [18062],
      Madera: [16661],
      Madison: [15663],
      Madisonburg: [16852],
      'Mahanoy City': [17948],
      Mainesburg: [16932],
      Manchester: [17345],
      Manheim: [17545],
      'Manns Choice': [15550],
      Manor: [15665],
      Manorville: [16238],
      Mansfield: [16933],
      'Maple Glen': [19002],
      'Mapleton Depot': [17052],
      Marble: [16334],
      Marchand: [15758],
      Marianna: [15345],
      Marienville: [16239],
      Marietta: [17547],
      'Marion Center': [15759],
      'Marion Heights': [17832],
      Markleton: [15551],
      Markleysburg: [15459],
      Mars: [16046],
      Marsteller: [15760],
      Martinsburg: [16662],
      Marwood: [16023],
      Marysville: [17053],
      Matamoras: [18336],
      Mather: [15346],
      Mayfield: [18433],
      Mayport: [16240],
      'Mc Alisterville': [17049],
      'Mc Clure': [17841],
      'Mc Connellsburg': [17233],
      'Mc Donald': [15057],
      'Mc Gees Mills': [15757],
      'Mc Grann': [16236],
      'Mc Kean': [16426],
      'Mc Kees Rocks': [15136],
      'Mc Keesport': [15132, 15133],
      'Mc Knight': [15237],
      'Mc Murray': [15317],
      'Mc Sherrystown': [17344],
      'Mc Veytown': [17051],
      Mcadoo: [18237],
      Meadowbrook: [19046],
      Meadville: [16335],
      Mechanicsville: [18934],
      Mehoopany: [18629],
      Melcroft: [15462],
      Mercer: [16137],
      Mercersburg: [17236],
      'Merion Station': [19066],
      Merrittstown: [15463],
      Mertztown: [19539],
      Meshoppen: [18630],
      Meyersdale: [15552],
      Middleburg: [17842],
      'Middlebury Cente': [16935],
      Middletown: [17057],
      Midland: [15059],
      Midway: [15060],
      Mifflin: [17058],
      Mifflinburg: [17844],
      Mifflintown: [17059],
      Mifflinville: [18631],
      Milan: [18831],
      Milanville: [18443],
      Mildred: [18632],
      Milford: [18337],
      'Mill Creek': [17060],
      'Mill Hall': [17751],
      'Mill Run': [15464],
      Millersburg: [17061],
      Millerstown: [17062],
      Millersville: [17551],
      Millerton: [16936],
      Millheim: [16854],
      Millmont: [17845],
      Millrift: [18340],
      Mills: [16937],
      Millvale: [15209],
      Millville: [17846],
      Milroy: [17063],
      Milton: [17847],
      'Mineral Point': [15942],
      Minersville: [17954],
      Mocanaqua: [18655],
      Mohnton: [19540],
      Mohrsville: [19541],
      Monaca: [15061],
      Monessen: [15062],
      Monongahela: [15063],
      Monroeton: [18832],
      Monroeville: [15146],
      'Mont Alto': [17237],
      'Mont Clare': [19453],
      Montandon: [17850],
      Montgomery: [17752],
      Montgomeryville: [18936],
      Montoursville: [17754],
      Montrose: [18801],
      'Moon Twp': [15108],
      Moosic: [18507],
      Morgan: [15064],
      Morgantown: [19543],
      Morris: [16938],
      'Morris Run': [16939],
      Morrisdale: [16858],
      Morton: [19070],
      Moscow: [18444],
      Moshannon: [16859],
      'Mount Bethel': [18343],
      'Mount Carmel': [17851],
      'Mount Holly Spri': [17065],
      'Mount Jewett': [16740],
      'Mount Lebanon': [15228],
      'Mount Oliver': [15210],
      'Mount Penn': [19606],
      'Mount Pleasant': [15666],
      'Mount Pleasant M': [17853],
      'Mount Pocono': [18344],
      'Mount Union': [17066],
      'Mount Washington': [15211],
      'Mount Wolf': [17347],
      'Mountain Top': [18707],
      Mountville: [17554],
      Muir: [17957],
      Muncy: [17756],
      'Muncy Valley': [17758],
      Munhall: [15120],
      Munson: [16860],
      Murrysville: [15668],
      Myerstown: [17067],
      Nanticoke: [18634],
      'Nanty Glo': [15943],
      Narberth: [19072],
      Narvon: [17555],
      Natrona: [15065],
      Nazareth: [18064],
      Needmore: [17238],
      Neelyton: [17239],
      Neffsville: [17601],
      Nelson: [16940],
      Nescopeck: [18635],
      Neshannock: [16105],
      Nesquehoning: [18240],
      'Neville Island': [15225],
      'New Albany': [18833],
      'New Alexandria': [15670],
      'New Berlin': [17855],
      'New Bethlehem': [16242],
      'New Bloomfield': [17068],
      'New Brighton': [15066],
      'New Britain': [18901],
      'New Castle': [16101, 16102],
      'New Columbia': [17856],
      'New Cumberland': [17070],
      'New Derry': [15671],
      'New Eagle': [15067],
      'New Enterprise': [16664],
      'New Florence': [15944],
      'New Freedom': [17349],
      'New Freeport': [15352],
      'New Galilee': [16141],
      'New Germantown': [17071],
      'New Holland': [17557],
      'New Hope': [18938],
      'New Milford': [18834],
      'New Millport': [16861],
      'New Oxford': [17350],
      'New Paris': [15554],
      'New Park': [17352],
      'New Providence': [17560],
      'New Ringgold': [17960],
      'New Salem': [15468],
      'New Stanton': [15672],
      'New Tripoli': [18066],
      'New Wilmington': [16142],
      Newburg: [17240],
      Newfoundland: [18445],
      Newmanstown: [17073],
      Newport: [17074],
      'Newtown Square': [19073],
      Newville: [17241],
      Nicholson: [18446],
      Nicktown: [15762],
      Ninepoints: [17509],
      Nineveh: [15353],
      Noblestown: [15071],
      Normalville: [15469],
      Norristown: [19401],
      'North Bingham': [16923],
      'North East': [16428],
      'North Huntingdon': [15642],
      'North Versailles': [15137],
      'North Wales': [19454],
      'North Warren': [16365],
      Northampton: [18067],
      Northpoint: [15763],
      Northumberland: [17857],
      Norwood: [19074],
      Nottingham: [19362],
      Noxen: [18636],
      Oakland: [15213],
      'Oakland Mills': [17076],
      Oakmont: [15139],
      Observatory: [15214],
      'Ogontz Campus': [19001],
      Ohiopyle: [15470],
      'Oil City': [16301],
      Olanta: [16863],
      'Old Forge': [18518],
      Oley: [19547],
      Oliveburg: [15764],
      Oliver: [15472],
      Olyphant: [18447],
      Orangeville: [17859],
      Orbisonia: [17243],
      Orefield: [18069],
      Oreland: [19075],
      Ormsby: [16726],
      Orrstown: [17244],
      Orrtanna: [17353],
      Orviston: [16864],
      Orwigsburg: [17961],
      Osceola: [16942],
      'Osceola Mills': [16666],
      Oswayo: [16915],
      Ottsville: [18942],
      Oxford: [19363],
      Palm: [18070],
      Palmerton: [18071],
      Palmyra: [17078],
      Paoli: [19301],
      Paradise: [17562],
      Paris: [15021],
      Park: [15690],
      Parker: [16049],
      Parkesburg: [19365],
      Parkhill: [15945],
      'Parkway Center': [15220],
      Patton: [16668],
      Paupack: [18451],
      Paxinos: [17860],
      'Peach Bottom': [17563],
      Peckville: [18452],
      'Pen Argyl': [18072],
      Penbrook: [17103],
      Penfield: [15849],
      Penllyn: [19422],
      Penn: [15675],
      'Penn Hills': [15235],
      'Penn Run': [15765],
      Penndel: [19047],
      Pennsburg: [18073],
      'Pennsylvania Fur': [16865],
      Pequea: [17565],
      Perkasie: [18944],
      Perkiomenville: [18074],
      Petersburg: [16669],
      Petrolia: [16050],
      Philadelphia: [
        19102, 19103, 19104, 19106, 19107, 19111, 19112, 19113, 19114, 19115,
        19116, 19118, 19119, 19120, 19121, 19122, 19123, 19124, 19125, 19126,
        19127, 19128, 19129, 19130, 19131, 19132, 19133, 19134, 19135, 19136,
        19137, 19138, 19139, 19140, 19141, 19142, 19143, 19144, 19145, 19146,
        19147, 19148, 19149, 19150, 19151, 19152, 19153, 19154,
      ],
      Philipsburg: [16866],
      Phoenixville: [19460],
      'Pilgrim Gardens': [19026],
      'Pine Grove': [17963],
      Pipersville: [18947],
      Pitcairn: [15140],
      Pitman: [17964],
      Pittsfield: [16340],
      Pittston: [18640],
      'Pleasant Gap': [16823],
      'Pleasant Hall': [17246],
      'Pleasant Mount': [18453],
      Pleasantville: [16341],
      Plum: [15239],
      Plymouth: [18651],
      'Plymouth Meeting': [19462],
      'Pocono Lake': [18347],
      'Pocono Pines': [18350],
      'Pocono Summit': [18346],
      'Point Marion': [15474],
      Polk: [16342],
      'Port Allegany': [16743],
      'Port Carbon': [17965],
      'Port Clinton': [19549],
      'Port Matilda': [16870],
      'Port Royal': [17082],
      'Port Trevorton': [17864],
      Portersville: [16051],
      'Portland Mills': [15853],
      Pottersdale: [16871],
      Pottsville: [17901],
      'Presque Isle': [16505],
      Presto: [15142],
      'Preston Park': [18455],
      'Primos Secane': [19018],
      Prompton: [18456],
      Prospect: [16052],
      'Prospect Park': [19076],
      Prosperity: [15329],
      Pulaski: [16143],
      Punxsutawney: [15767],
      Puritan: [15946],
      Quakake: [18245],
      Quakertown: [18951],
      Quarryville: [17566],
      Racine: [15010],
      Radnor: [19087],
      Ralston: [17763],
      Ramey: [16671],
      Rankin: [15104],
      Ranshaw: [17866],
      Reading: [19601, 19602, 19604, 19605, 19611],
      Rebersburg: [16872],
      Rebuck: [17867],
      Rector: [15677],
      'Red Hill': [18076],
      'Red Lion': [17356],
      Reeders: [18352],
      Reedsville: [17084],
      Reinholds: [17569],
      Renfrew: [16053],
      Renovo: [17764],
      Republic: [15475],
      Rew: [16744],
      Reynoldsville: [15851],
      'Rices Landing': [15357],
      Richboro: [18954],
      Richfield: [17086],
      Richland: [17087],
      Richlandtown: [18955],
      'Ridley Park': [19078],
      Riegelsville: [18077],
      Rillton: [15678],
      Ringgold: [15770],
      Ringtown: [17967],
      Riverside: [17868],
      Rixford: [16745],
      'Roaring Branch': [17765],
      'Roaring Spring': [16673],
      Robertsdale: [16674],
      Robesonia: [19551],
      Robinson: [15949],
      Rochester: [15074],
      'Rochester Mills': [15771],
      'Rock Glen': [18246],
      Rockton: [15856],
      Rockwood: [15557],
      Rogersville: [15359],
      Rohrerstown: [17603],
      Rome: [18837],
      Ronks: [17572],
      Roscoe: [15477],
      Roseto: [18013],
      Rossiter: [15772],
      Rostraver: [15012],
      Roulette: [16746],
      'Ruffs Dale': [15679],
      'Rural Valley': [16249],
      Rushville: [18839],
      Russell: [16345],
      Russellton: [15076],
      Sabinsville: [16943],
      Sacramento: [17968],
      Saegertown: [16433],
      'Saint Benedict': [15773],
      'Saint Clair': [17970],
      'Saint Marys': [15857],
      'Saint Michael': [15951],
      'Saint Thomas': [17252],
      Salisbury: [15558],
      Salix: [15952],
      Salladasburg: [17740],
      Saltsburg: [15681],
      Salunga: [17538],
      Sanatoga: [19464],
      'Sandy Lake': [16145],
      Sarver: [16055],
      Saxonburg: [16056],
      Saxton: [16678],
      Saylorsburg: [18353],
      Sayre: [18840],
      'Scenery Hill': [15360],
      Schellsburg: [15559],
      Schnecksville: [18078],
      'Schuylkill Haven': [17972],
      Schwenksville: [19473],
      Sciota: [18354],
      Scotrun: [18355],
      Scottdale: [15683],
      Scranton: [18503, 18504, 18505, 18508, 18509, 18510],
      Seanor: [15953],
      Selinsgrove: [17870],
      Sellersville: [18960],
      Seneca: [16346],
      'Seven Valleys': [17360],
      Seward: [15954],
      Sewickley: [15143],
      'Shade Gap': [17255],
      Shadyside: [15232],
      Sharon: [16146],
      'Sharon Hill': [19079],
      Sharpsville: [16150],
      Shavertown: [18708],
      Sheffield: [16347],
      Shelocta: [15774],
      Shenandoah: [17976],
      Shenango: [16125],
      Sheppton: [18248],
      'Shermans Dale': [17090],
      Shillington: [19607],
      Shinglehouse: [16748],
      Shippensburg: [17257],
      Shippenville: [16254],
      Shippingport: [15077],
      Shiremanstown: [17011],
      Shirleysburg: [17260],
      Shoemakersville: [19555],
      Shohola: [18458],
      Shrewsbury: [17361],
      Shunk: [17768],
      Sidman: [15955],
      Sigel: [15860],
      Simpson: [18407],
      'Sinking Spring': [19608],
      Sinnamahoning: [15861],
      'Six Mile Run': [16679],
      Slickville: [15684],
      Sligo: [16255],
      'Slippery Rock': [16057],
      Slovan: [15078],
      Smethport: [16749],
      Smicksburg: [16256],
      Smithfield: [15478],
      Smithmill: [16680],
      Smock: [15480],
      Smoketown: [17576],
      'Snow Shoe': [16874],
      Snydertown: [17877],
      Somerset: [15501],
      'South Connellsvi': [15425],
      'South Fork': [15956],
      'South Gibson': [18842],
      'South Hills': [15216],
      'South Sterling': [18460],
      'South Williamspo': [17701],
      Spangler: [15775],
      Spartansburg: [16434],
      Spraggs: [15362],
      'Sprankle Mills': [15776],
      'Spring Church': [15686],
      'Spring City': [19475],
      'Spring Creek': [16436],
      'Spring Glen': [17978],
      'Spring Grove': [17362],
      'Spring House': [19477],
      'Spring Mills': [16875],
      'Spring Run': [17262],
      Springboro: [16435],
      Springdale: [15144],
      Springfield: [19064],
      Springs: [15562],
      Springville: [18844],
      'Spruce Creek': [16683],
      'Squirrel Hill': [15217],
      'St Clairsville': [16667],
      Stahlstown: [15687],
      'Star Junction': [15482],
      Starford: [15777],
      Starlight: [18461],
      Starrucca: [18462],
      'State College': [16801, 16803],
      Steelton: [17113],
      Sterling: [18463],
      Stevens: [17578],
      Stevensville: [18845],
      Stewartstown: [17363],
      Stillwater: [17878],
      Stockdale: [15483],
      Stoneboro: [16153],
      Stoystown: [15563],
      Strabane: [15363],
      Strasburg: [17579],
      Strattanville: [16258],
      Strongstown: [15957],
      Stroudsburg: [18360],
      'Sugar Grove': [16350],
      'Sugar Run': [18846],
      Sugarloaf: [18249],
      Summerhill: [15958],
      Summerville: [15864],
      'Summit Hill': [18250],
      Sunbury: [17801],
      Susquehanna: [18847],
      Sutersville: [15083],
      Swarthmore: [19081],
      Swatara: [17111],
      'Sweet Valley': [18656],
      Swiftwater: [18370],
      Swissvale: [15218],
      Sycamore: [15364],
      Sykesville: [15865],
      Tafton: [18464],
      Tamaqua: [18252],
      Tamiment: [18371],
      Tannersville: [18372],
      Tarentum: [15084],
      Tarrs: [15688],
      Taylor: [18517],
      Telford: [18969],
      Temple: [19560],
      Templeton: [16259],
      'Terre Hill': [17581],
      Thomasville: [17364],
      Thompson: [18465],
      Thompsontown: [17094],
      Thorndale: [19372],
      Thornton: [19373],
      'Three Springs': [17264],
      Tidioute: [16351],
      Timblin: [15778],
      Tioga: [16946],
      Tionesta: [16353],
      Titusville: [16354],
      Tobyhanna: [18466],
      Todd: [16685],
      Topton: [19562],
      Toughkenamon: [19374],
      Towanda: [18848],
      'Tower City': [17980],
      Townville: [16360],
      Transfer: [16154],
      Trevorton: [17881],
      Trexlertown: [18087],
      'Trout Run': [17771],
      Troy: [16947],
      Tullytown: [19007],
      Turbotville: [17772],
      'Turtle Creek': [15145],
      Turtlepoint: [16750],
      'Twin Rocks': [15960],
      'Tyler Hill': [18469],
      Tyrone: [16686],
      Ulster: [18850],
      Ulysses: [16948],
      'Union City': [16438],
      'Union Dale': [18470],
      Uniontown: [15401],
      Unityville: [17774],
      'Upper Black Eddy': [18972],
      'Upper Darby': [19082],
      'Upper Saint Clai': [15241],
      Upperstrasburg: [17265],
      Uptown: [15219],
      Utica: [16362],
      Valencia: [16059],
      Valier: [15780],
      'Valley View': [17983],
      'Van Meter': [15479],
      Vanderbilt: [15486],
      Venango: [16440],
      Venetia: [15367],
      Venus: [16364],
      Verona: [15147],
      Villanova: [19085],
      Vintondale: [15961],
      Volant: [16156],
      Vowinckel: [16260],
      'W Mifflin Fin': [15122],
      Wall: [15148],
      Wallingford: [19086],
      'Walnut Bottom': [17266],
      Walnutport: [18088],
      Waltersburg: [15488],
      Wampum: [16157],
      Wapwallopen: [18660],
      Warfordsburg: [17267],
      Warminster: [18974],
      'Warren Center': [18851],
      Warrendale: [15086],
      Warrington: [18976],
      'Warriors Mark': [16877],
      Washington: [15301],
      'Washington Boro': [17582],
      'Washington Cross': [18977],
      Waterfall: [16689],
      Waterford: [16441],
      Waterville: [17776],
      Watsontown: [17777],
      Wattsburg: [16442],
      Waymart: [18472],
      Waynesboro: [17268],
      Waynesburg: [15370],
      Weatherly: [18255],
      Weedville: [15868],
      Weissport: [18235],
      'Wells Tannery': [16691],
      Wellsboro: [16901],
      Wellsville: [17365],
      Wernersville: [19565],
      Wescosville: [18106],
      Wesleyville: [16510],
      'West Alexander': [15376],
      'West Brownsville': [15417],
      'West Chester': [19380, 19382],
      'West Conshohocke': [19428],
      'West Decatur': [16878],
      'West Finley': [15377],
      'West Grove': [19390],
      'West Hazleton': [18201],
      'West Lawn': [19609],
      'West Middlesex': [16159],
      'West Newton': [15089],
      'West Pittston': [18643],
      'West Springfield': [16443],
      'West Sunbury': [16061],
      'West View': [15229],
      'West York': [17404],
      Westford: [16134],
      'Westmoreland Cit': [15692],
      Westover: [16692],
      Westport: [17778],
      Wexford: [15090],
      White: [15490],
      'White Haven': [18661],
      'White Oak': [15131],
      Wiconisco: [17097],
      Wilburton: [17888],
      Wilcox: [15870],
      'Wilkes Barre': [18701, 18705],
      Wilkinsburg: [15221],
      Williamstown: [17098],
      'Willow Grove Nas': [19090],
      'Willow Hill': [17271],
      'Willow Street': [17584],
      Wilpen: [15658],
      Winburne: [16879],
      'Wind Gap': [18091],
      'Wind Ridge': [15380],
      Windber: [15963],
      Windsor: [17366],
      Winfield: [17889],
      Womelsdorf: [19567],
      Woodbury: [16695],
      Woodland: [16881],
      Woodlyn: [19094],
      Woodward: [16882],
      Woolrich: [17779],
      Wormleysburg: [17043],
      Worthville: [15784],
      Wrightsville: [17368],
      Wyalusing: [18853],
      Wyncote: [19095],
      Wynnewood: [19096],
      Wyoming: [18644],
      Wyomissing: [19610],
      Wysox: [18854],
      Yardley: [19067],
      Yeadon: [19050],
      Yeagertown: [17099],
      Yoe: [17313],
      York: [17401, 17403],
      'York Haven': [17370],
      'York Springs': [17372],
      Youngsville: [16371],
      Youngwood: [15697],
      Yukon: [15698],
      Zelienople: [16063],
      Zieglersville: [19492],
      'Zion Grove': [17985],
      Zionsville: [18092],
    },
    name: 'Pennsylvania',
  },
  RI: {
    cities: {
      2821: ['02821'],
      Ashaway: ['02804'],
      Barrington: ['02806'],
      'Block Island': ['02807'],
      Bradford: ['02808'],
      Bristol: ['02809'],
      'Central Falls': ['02863'],
      Centredale: ['02904', '02911'],
      Charlestown: ['02813'],
      Chepachet: ['02814'],
      Clayville: ['02815'],
      Coventry: ['02816'],
      Cranston: ['02905', '02907', '02909', '02910', '02919', '02920', '02921'],
      Cumberland: ['02864'],
      'East Greenwich': ['02818'],
      'East Providence': ['02914'],
      Exeter: ['02822'],
      Foster: ['02825'],
      Greene: ['02827'],
      Greenville: ['02828'],
      Harrisville: ['02830'],
      Hope: ['02831'],
      Jamestown: ['02835'],
      Kingston: ['02881'],
      Lincoln: ['02865'],
      'Little Compton': ['02837'],
      Manville: ['02838'],
      Middletown: ['02840'],
      Narragansett: ['02879', '02882'],
      'North Kingstown': ['02852'],
      'North Scituate': ['02857'],
      'North Smithfield': ['02895'],
      Oakland: ['02858'],
      Pascoag: ['02859'],
      Pawtucket: ['02860', '02861'],
      'Peace Dale': ['02883'],
      Portsmouth: ['02871'],
      Providence: ['02903', '02906', '02908'],
      'Prudence Island': ['02872'],
      Richmond: ['02812', '02832', '02836', '02892', '02898'],
      Riverside: ['02915'],
      Rumford: ['02916'],
      Saunderstown: ['02874'],
      Slatersville: ['02876'],
      Slocum: ['02877'],
      Smithfield: ['02917'],
      Tiverton: ['02878'],
      Warren: ['02885'],
      Warwick: ['02886', '02888', '02889'],
      'West Greenwich': ['02817'],
      'West Warwick': ['02893'],
      Westerly: ['02891'],
      'Wood River Junct': ['02894'],
    },
    name: 'Rhode Island',
  },
  SC: {
    cities: {
      Abbeville: [29620],
      Aiken: [29801, 29803],
      Alcolu: [29001],
      Allendale: [29810],
      Alvin: [29479],
      Anderson: [29621, 29624, 29625],
      Andrews: [29510],
      Awendaw: [29429],
      Aynor: [29511],
      Bamberg: [29003],
      Barnwell: [29812],
      Batesburg: [29006],
      'Beech Island': [29841],
      Belton: [29627],
      Bennettsville: [29512],
      Bethune: [29009],
      Bishopville: [29010],
      Blackstock: [29014],
      Blackville: [29817],
      Blair: [29015],
      Blenheim: [29516],
      Bluffton: [29910],
      Blythewood: [29016],
      Bonneau: [29431],
      Bowman: [29018],
      Bradley: [29819],
      Branchville: [29432],
      Brunson: [29911],
      Bucksport: [29527],
      Buffalo: [29321],
      Burton: [29902],
      Cades: [29518],
      'Calhoun Falls': [29628],
      Camden: [29020],
      Cameron: [29030],
      Campobello: [29322],
      Carlisle: [29031],
      Cassatt: [29032],
      Catawba: [29704],
      Cateechee: [29667],
      Cayce: [29033],
      Central: [29630],
      Chapin: [29036],
      Chappells: [29037],
      Charleston: [
        29401, 29403, 29404, 29405, 29407, 29412, 29414, 29418, 29420,
      ],
      Cheraw: [29520],
      'Cherokee Falls': [29702],
      'Cherry Grove Bea': [29582],
      Chesnee: [29323],
      Chester: [29706],
      Chesterfield: [29709],
      'Clarks Hill': [29821],
      Clemson: [29631],
      Cleveland: [29635],
      Clinton: [29325],
      Clio: [29525],
      Columbia: [29201, 29203, 29204, 29205, 29206, 29209, 29210, 29212, 29223],
      Conway: [29526],
      Coosawatchie: [29936],
      Cope: [29038],
      Cordesville: [29434],
      Cordova: [29039],
      Cottageville: [29435],
      Coward: [29530],
      Cowpens: [29330],
      Cross: [29436],
      'Cross Hill': [29332],
      Dalzell: [29040],
      Darlington: [29532],
      Denmark: [29042],
      Dillon: [29536],
      Dorchester: [29437],
      'Due West': [29639],
      Duncan: [29334],
      'Early Branch': [29916],
      Easley: [29640, 29642],
      Eastover: [29044],
      Edgefield: [29824],
      Edgemoor: [29712],
      'Edisto Island': [29438],
      Effingham: [29541],
      Ehrhardt: [29081],
      Elgin: [29045],
      Elliott: [29046],
      Elloree: [29047],
      Enoree: [29335],
      Estill: [29918],
      Eutawville: [29048],
      'Fair Play': [29643],
      Fairfax: [29827],
      Florence: [29501, 29505],
      Fork: [29543],
      'Fort Lawn': [29714],
      'Fort Motte': [29135],
      'Fountain Inn': [29644],
      Gable: [29051],
      Gadsden: [29052],
      Gaffney: [29340],
      'Galivants Ferry': [29544],
      Garnett: [29922],
      Gaston: [29053],
      Georgetown: [29440],
      Gilbert: [29054],
      'Glenn Springs': [29374],
      Graniteville: [29829],
      'Great Falls': [29055],
      Greeleyville: [29056],
      'Green Pond': [29446],
      'Green Sea': [29545],
      Greenville: [29601, 29605, 29607, 29609, 29611, 29615],
      Greenwood: [29646, 29649],
      Greer: [29650, 29651],
      Gresham: [29546],
      Hampton: [29924],
      Hardeeville: [29927],
      Harleyville: [29448],
      Hartsville: [29550],
      'Heath Springs': [29058],
      Hemingway: [29554],
      'Hickory Grove': [29717],
      'Hilton Head Isla': [29926, 29928],
      Hodges: [29653],
      'Holly Hill': [29059],
      'Honea Path': [29654],
      Hopkins: [29061],
      Huger: [29450],
      Inman: [29349],
      Irmo: [29063],
      Islandton: [29929],
      'Isle Of Palms': [29451],
      Iva: [29655],
      Jackson: [29831],
      Jefferson: [29718],
      Jenkinsville: [29065],
      Jericho: [29426],
      Joanna: [29351],
      'Johns Island': [29455],
      Johnsonville: [29555],
      Johnston: [29832],
      Kelton: [29353],
      Kershaw: [29067],
      Kinards: [29355],
      Kingstree: [29556],
      Ladson: [29456],
      'Lake City': [29560],
      'Lake View': [29563],
      'Lake Wylie': [29710],
      Lamar: [29069],
      Lancaster: [29720],
      Landrum: [29356],
      Lane: [29564],
      Latta: [29565],
      Leesville: [29070],
      Lexington: [29072, 29073],
      Liberty: [29657],
      'Little Mountain': [29075],
      'Little River': [29566],
      'Little Rock': [29567],
      Lodge: [29082],
      'Lone Star': [29077],
      'Long Creek': [29658],
      Longs: [29568],
      Loris: [29569],
      Lowndesville: [29659],
      Lugoff: [29078],
      Luray: [29932],
      Lyman: [29365],
      Lynchburg: [29080],
      Madison: [29693],
      Marietta: [29661],
      Marion: [29571],
      Martin: [29836],
      Mauldin: [29662],
      'Mc Bee': [29101],
      'Mc Clellanville': [29458],
      'Mc Coll': [29570],
      'Mc Connells': [29726],
      'Mc Cormick': [29835],
      Meggett: [29449],
      Modoc: [29838],
      Monetta: [29105],
      Moore: [29369],
      'Mount Carmel': [29840],
      'Mount Croghan': [29727],
      'Mount Holly': [29445],
      'Mount Pleasant': [29464],
      'Mountain Rest': [29664],
      Mountville: [29370],
      Mullins: [29574],
      'Murrells Inlet': [29576],
      'Myrtle Beach': [29572, 29577],
      Neeses: [29107],
      Nesmith: [29580],
      'New Ellenton': [29809],
      'New Zion': [29111],
      Newberry: [29108],
      Nichols: [29581],
      'Ninety Six': [29666],
      North: [29112],
      'North Charleston': [29406],
      Norway: [29113],
      Oakley: [29461],
      Olanta: [29114],
      Olar: [29843],
      Ora: [29360, 29645],
      Orangeburg: [29115],
      Oswego: [29150],
      Pacolet: [29372],
      Pageland: [29728],
      Pamplico: [29583],
      Patrick: [29584],
      'Pawleys Island': [29585],
      Paxville: [29102],
      Pelion: [29123],
      Pelzer: [29669],
      Pendleton: [29670],
      Pickens: [29671],
      Piedmont: [29673],
      Pineland: [29934],
      Pineville: [29468],
      Pinewood: [29125],
      Pinopolis: [29469],
      'Plum Branch': [29845],
      Pomaria: [29126],
      'Port Royal': [29935],
      Prosperity: [29127],
      Quinby: [29506],
      Ravenel: [29470],
      Reevesville: [29471],
      Rembert: [29128],
      Richburg: [29729],
      'Ridge Spring': [29129],
      Ridgeville: [29472],
      Ridgeway: [29130],
      Rimini: [29131],
      Ritter: [29488],
      'Rock Hill': [29730, 29732],
      Roebuck: [29376],
      'Round O': [29474],
      Rowesville: [29133],
      Ruby: [29741],
      Ruffin: [29475],
      'Saint Charles': [29104],
      'Saint George': [29477],
      Salem: [29676],
      Salley: [29137],
      Salters: [29590],
      Saluda: [29138],
      Santee: [29142],
      Scranton: [29591],
      Seabrook: [29940],
      Sellers: [29592],
      Seneca: [29678],
      Sharon: [29742],
      'Shaw A F B': [29152],
      'Shoals Junction': [29638],
      Shulerville: [29453],
      Silverstreet: [29145],
      Simpsonville: [29681],
      'Six Mile': [29682],
      Smoaks: [29481],
      Smyrna: [29743],
      'Society Hill': [29593],
      'South Of The Bor': [29547],
      Spartanburg: [29301, 29302],
      Springfield: [29146],
      'St Helena Island': [29920],
      Starr: [29684],
      'Sullivans Island': [29482],
      Summerton: [29148],
      Summerville: [29483, 29485],
      Sumter: [29154],
      Sunset: [29685],
      'Surfside Beach': [29575],
      Swansea: [29160],
      Tamassee: [29686],
      Taylors: [29687],
      'Tega Cay': [29715],
      Tigerville: [29688],
      Tillman: [29943],
      Timmonsville: [29161],
      Townville: [29689],
      'Travelers Rest': [29690],
      Trenton: [29847],
      Troy: [29848],
      Turbeville: [29162],
      Ulmer: [29849],
      Union: [29379],
      'Valley Falls': [29303],
      Vance: [29163],
      Varnville: [29944],
      'Wadmalaw Island': [29487],
      Wagener: [29164],
      Walhalla: [29691],
      Wallace: [29596],
      Wando: [29492],
      Ward: [29166],
      'Ware Shoals': [29692],
      Warrenville: [29851],
      Waterloo: [29384],
      Wedgefield: [29168],
      Wellford: [29385],
      'West Columbia': [29169, 29170, 29172],
      'West Union': [29696],
      Westville: [29175],
      Whitmire: [29178],
      Williamston: [29697],
      Williston: [29853],
      Windsor: [29856],
      Winnsboro: [29180],
      Woodruff: [29388],
      Yemassee: [29945],
      York: [29745],
    },
    name: 'South Carolina',
  },
  SD: {
    cities: {
      57230: [57230],
      57336: [57336],
      57425: [57425],
      Aberdeen: [57401],
      Academy: [57369],
      Agar: [57520],
      'Agency Village': [57262],
      Akaska: [57420],
      Albee: [57259],
      Alcester: [57001],
      Allen: [57714],
      Alpena: [57312],
      Altamont: [57226],
      Amherst: [57421],
      Andover: [57422],
      Arlington: [57212],
      Armour: [57313],
      Artas: [57437],
      Astoria: [57213],
      Athol: [57424],
      Aurora: [57002],
      Avon: [57315],
      Badger: [57214],
      Baltic: [57003],
      Bancroft: [57316],
      Barnard: [57426],
      Bath: [57427],
      'Belle Fourche': [57717],
      Belvidere: [57521],
      Bemis: [57238],
      Beresford: [57004],
      Bethlehem: [57708],
      'Big Stone City': [57216],
      Bison: [57620],
      'Black Hawk': [57718],
      Blunt: [57522],
      Bonesteel: [57317],
      Bowdle: [57428],
      'Box Elder': [57719],
      Bradley: [57217],
      Brandt: [57218],
      Brentford: [57429],
      Britton: [57430],
      Brookings: [57006],
      Bruce: [57220],
      Bryant: [57221],
      Buffalo: [57720],
      'Buffalo Gap': [57722],
      'Buffalo Ridge': [57115],
      Burbank: [57010],
      Butler: [57219],
      Canistota: [57012],
      Canova: [57321],
      Canton: [57013],
      Caputa: [57725],
      Carpenter: [57322],
      Carter: [57526],
      Carthage: [57323],
      Castlewood: [57223],
      Cavour: [57324],
      Cedarbutte: [57527],
      Centerville: [57014],
      Chamberlain: [57325],
      Chancellor: [57015],
      'Cherry Creek': [57622],
      Chester: [57016],
      'Claire City': [57224],
      Claremont: [57432],
      Clark: [57225],
      Clearfield: [57580],
      Colman: [57017],
      Colome: [57528],
      Colton: [57018],
      Columbia: [57433],
      Corona: [57227],
      Corsica: [57328],
      Corson: [57005],
      Cottonwood: [57775],
      'Crazy Horse': [57730],
      Creighton: [57729],
      Cresbard: [57435],
      Crooks: [57020],
      'Dakota Dunes': [57049],
      Dallas: [57529],
      Dante: [57329],
      Davis: [57021],
      'De Smet': [57231],
      Deadwood: [57732],
      'Dell Rapids': [57022],
      Delmont: [57330],
      Dempster: [57234],
      Denby: [57716],
      Dimock: [57331],
      Dixon: [57533],
      Doland: [57436],
      Dolton: [57319],
      Draper: [57531],
      Dupree: [57623],
      Eden: [57232],
      Edgemont: [57735],
      Egan: [57024],
      'Elk Point': [57025],
      Elkton: [57026],
      'Ellsworth Afb': [57706],
      'Elm Springs': [57736],
      Emery: [57332],
      Enning: [57737],
      Erwin: [57233],
      Ethan: [57334],
      Fairburn: [57738],
      Fairfax: [57335],
      Fairview: [57027],
      Faith: [57626],
      Farmer: [57311],
      Fedora: [57337],
      Firesteel: [57628],
      Flandreau: [57028],
      Florence: [57235],
      Forestburg: [57314],
      'Fort Meade': [57741],
      'Fort Pierre': [57532],
      'Fort Thompson': [57339],
      Frankfort: [57440],
      Frederick: [57441],
      Freeman: [57029],
      Fruitdale: [57742],
      Fulton: [57340],
      'Gann Valley': [57341],
      'Garden City': [57236],
      Garretson: [57030],
      Gary: [57237],
      Gayville: [57031],
      Geddes: [57342],
      Gettysburg: [57442],
      'Glad Valley': [57629],
      Glencross: [57630],
      Glenham: [57631],
      Grenville: [57239],
      Groton: [57445],
      Hamill: [57534],
      Harrisburg: [57032],
      Harrison: [57344],
      Harrold: [57536],
      Hartford: [57033],
      Hayes: [57537],
      Hayti: [57241],
      Hazel: [57242],
      Hecla: [57446],
      Henry: [57243],
      Hereford: [57785],
      Hermosa: [57744],
      Herreid: [57632],
      Herrick: [57538],
      Hetland: [57244],
      Highmore: [57345],
      'Hill City': [57745],
      Hitchcock: [57348],
      Holabird: [57540],
      Hosmer: [57448],
      'Hot Springs': [57747],
      Houghton: [57449],
      Hoven: [57450],
      Hudson: [57034],
      Humboldt: [57035],
      Hurley: [57036],
      Huron: [57350],
      Ideal: [57541],
      Interior: [57750],
      Iona: [57542],
      Ipswich: [57451],
      Irene: [57037],
      Iroquois: [57353],
      Isabel: [57633],
      Java: [57452],
      Jefferson: [57038],
      Kadoka: [57543],
      Kaylor: [57354],
      Keldron: [57634],
      Kennebec: [57544],
      Keyapaha: [57545],
      Keystone: [57751],
      Kimball: [57355],
      Kranzburg: [57245],
      Kyle: [57752],
      Labolt: [57246],
      'Lake Andes': [57356],
      'Lake City': [57247],
      'Lake Norden': [57248],
      'Lake Preston': [57249],
      Lane: [57358],
      Langford: [57454],
      Lebanon: [57455],
      Lemmon: [57638],
      Lennox: [57039],
      Leola: [57456],
      Lesterville: [57040],
      Letcher: [57359],
      Lily: [57274],
      Lodgepole: [57640],
      'Long Valley': [57547],
      Longlake: [57457],
      Loomis: [57301],
      'Lower Brule': [57548],
      Lucas: [57523],
      Ludlow: [57755],
      Madison: [57042],
      Mahto: [57643],
      Manderson: [57756],
      Mansfield: [57460],
      Marcus: [57757],
      Marion: [57043],
      Marty: [57361],
      Marvin: [57251],
      'Mc Intosh': [57641],
      'Mc Laughlin': [57642],
      Meadow: [57644],
      Meckling: [57044],
      Mellette: [57461],
      Menno: [57045],
      Milbank: [57252],
      Milesville: [57553],
      Miller: [57362],
      Mina: [57462],
      Miranda: [57438],
      Mission: [57555],
      'Mission Hill': [57046],
      'Mission Ridge': [57557],
      Mobridge: [57601],
      Monroe: [57047],
      Montrose: [57048],
      Morristown: [57645],
      'Mound City': [57646],
      'Mount Vernon': [57363],
      'Mud Butte': [57758],
      Murdo: [57559],
      Nemo: [57759],
      'New Effington': [57255],
      'New Holland': [57364],
      'New Underwood': [57761],
      Newell: [57760],
      Nisland: [57762],
      Norris: [57560],
      Northville: [57465],
      Nunda: [57050],
      Oelrichs: [57763],
      Okaton: [57562],
      Oldham: [57051],
      Olivet: [57052],
      Onaka: [57466],
      Onida: [57564],
      Opal: [57765],
      Oral: [57766],
      Orient: [57467],
      Ortley: [57256],
      Ottumwa: [57552],
      Owanka: [57767],
      Parade: [57647],
      Parker: [57053],
      Parkston: [57366],
      Parmelee: [57566],
      Peever: [57257],
      Philip: [57567],
      Piedmont: [57769],
      Pierpont: [57468],
      Pierre: [57501],
      'Pine Ridge': [57770],
      Plainview: [57748],
      Plankinton: [57368],
      Pollock: [57648],
      Porcupine: [57772],
      'Prairie City': [57649],
      Presho: [57568],
      Provo: [57774],
      Pukwana: [57370],
      Ralph: [57650],
      Ramona: [57054],
      Ravinia: [57357],
      Raymond: [57258],
      Redfield: [57469],
      Redowl: [57777],
      'Ree Heights': [57371],
      Reliance: [57569],
      Renner: [57055],
      Reva: [57651],
      Rochford: [57778],
      Rockerville: [57701],
      Rockham: [57470],
      Roscoe: [57471],
      Rosholt: [57260],
      Roslyn: [57261],
      Roswell: [57349],
      Rutland: [57057],
      'Saint Charles': [57571],
      'Saint Francis': [57572],
      'Saint Lawrence': [57373],
      'Saint Onge': [57779],
      Salem: [57058],
      Scenic: [57780],
      Scotland: [57059],
      Selby: [57472],
      Seneca: [57473],
      Shadehill: [57653],
      Sherman: [57060],
      'Silver City': [57702],
      Sinai: [57061],
      'Sioux Falls': [57102, 57103, 57104, 57105, 57106, 57107, 57116],
      'Sky Ranch': [57724],
      Smithwick: [57782],
      'South Shore': [57263],
      Spearfish: [57783],
      'Spearfish Canyon': [57754],
      Spencer: [57374],
      Springfield: [57062],
      Stickney: [57375],
      Stockholm: [57264],
      Stoneville: [57787],
      Strandburg: [57265],
      Stratford: [57474],
      Summit: [57266],
      Tabor: [57063],
      Tea: [57064],
      'Timber Lake': [57656],
      Tolstoy: [57475],
      Toronto: [57268],
      'Trail City': [57657],
      Trent: [57065],
      Tripp: [57376],
      Tulare: [57476],
      Turton: [57477],
      Tuthill: [57574],
      'Twin Brooks': [57269],
      Tyndall: [57066],
      Utica: [57067],
      Vale: [57788],
      'Valley Springs': [57068],
      Veblen: [57270],
      Verdon: [57434],
      Vermillion: [57069],
      Vetal: [57551],
      Viborg: [57070],
      Vienna: [57271],
      Virgil: [57379],
      Vivian: [57576],
      Volga: [57071],
      Volin: [57072],
      Wagner: [57380],
      Wakonda: [57073],
      Wakpala: [57658],
      Wall: [57790],
      Wallace: [57272],
      Wanblee: [57577],
      Ward: [57074],
      Warner: [57479],
      Wasta: [57791],
      Watauga: [57660],
      Watertown: [57201],
      Waubay: [57273],
      Waverly: [57202],
      Wentworth: [57075],
      Wessington: [57381],
      'Wessington Sprin': [57382],
      Wetonka: [57481],
      Wewela: [57578],
      White: [57276],
      'White Lake': [57383],
      'White Owl': [57792],
      'White River': [57579],
      Whitewood: [57793],
      'Willow Lake': [57278],
      Wilmot: [57279],
      Winfred: [57076],
      Witten: [57584],
      Wolsey: [57384],
      Wood: [57585],
      Woonsocket: [57385],
      Worthing: [57077],
      'Wounded Knee': [57794],
      Yale: [57386],
      Yankton: [57078],
      Zell: [57483],
      Zeona: [57795],
    },
    name: 'South Dakota',
  },
  TN: {
    cities: {
      Adams: [37010],
      Adamsville: [38310],
      Afton: [37616],
      Alamo: [38001],
      Alcoa: [37701],
      Alexandria: [37012],
      Algood: [38501],
      Allardt: [38504],
      Allons: [38541],
      Allred: [38542],
      Alpine: [38543],
      Altamont: [37301],
      Andersonville: [37705],
      Antioch: [37013],
      Apison: [37302],
      Ardmore: [38449, 38453],
      Arlington: [38002],
      Arrington: [37014],
      'Ashland City': [37015],
      Athens: [37303],
      Atoka: [38004],
      Atwood: [38220],
      Auburntown: [37016],
      Baileyton: [37743],
      Baneberry: [37890],
      Bartlett: [38134],
      'Bath Springs': [38311],
      Baxter: [38544],
      'Bean Station': [37708],
      'Beech Bluff': [38313],
      Beechgrove: [37018],
      'Beersheba Spring': [37305],
      Belfast: [37019],
      'Bell Buckle': [37020],
      Bellevue: [37221],
      Bells: [38006],
      Belvidere: [37306],
      Benton: [37307],
      'Bethel Springs': [38315],
      Bethpage: [37022],
      'Big Rock': [37023],
      'Big Sandy': [38221],
      Birchwood: [37308],
      Blaine: [37709],
      Bloomingdale: [37660],
      'Bloomington Spri': [38545],
      Blountville: [37617],
      'Bluff City': [37618],
      Bolivar: [38008],
      'Bon Aqua': [37025],
      'Bone Cave': [38581],
      Bradford: [38316],
      Bradyville: [37026],
      Brentwood: [37027],
      Brighton: [38011],
      Bristol: [37620],
      Brownsville: [38012],
      Bruceton: [38317],
      'Brush Creek': [38547],
      Buchanan: [38222],
      'Buena Vista': [38318],
      'Buffalo Valley': [38548],
      'Bulls Gap': [37711],
      'Bumpus Mills': [37028],
      Burlison: [38015],
      Burns: [37029],
      Butler: [37640],
      Bybee: [37713],
      Byrdstown: [38549],
      Calhoun: [37309],
      Camden: [38320],
      Caryville: [37714],
      'Castalian Spring': [37031],
      'Cedar Grove': [38321],
      'Cedar Hill': [37032],
      Celina: [38551],
      Centerville: [37033],
      'Chapel Hill': [37034],
      Chapmansboro: [37035],
      Charleston: [37310],
      Charlotte: [37036],
      Chattanooga: [
        37402, 37403, 37404, 37405, 37406, 37407, 37408, 37409, 37410, 37411,
        37416, 37419, 37421,
      ],
      'Chestnut Mound': [38552],
      Christiana: [37037],
      Chuckey: [37641],
      'Church Hill': [37642],
      Clairfield: [37715],
      Clarkrange: [38553],
      Clarksville: [37040, 37042, 37043],
      Cleveland: [37311, 37312],
      Clifton: [38425],
      Clinton: [37716],
      Coalmont: [37313],
      'College Grove': [37046],
      Collierville: [38017],
      Collinwood: [38450],
      'Colonial Heights': [37663],
      Columbia: [38401],
      Concord: [37922],
      'Concord Farragut': [37932],
      Cordova: [38018],
      Cornersville: [37047],
      Corryton: [37721],
      Cosby: [37722],
      'Cottage Grove': [38224],
      Cottontown: [37048],
      Counce: [38326],
      Covington: [38019],
      Cowan: [37318],
      'Crab Orchard': [37723],
      Crawford: [38554],
      'Cross Plains': [37049],
      Crump: [38327],
      Culleoka: [38451],
      'Cumberland City': [37050],
      'Cumberland Furna': [37051],
      'Cumberland Gap': [37724],
      Cunningham: [37052],
      'Cypress Inn': [38452],
      Dandridge: [37725],
      Darden: [38328],
      Dayton: [37321],
      Decatur: [37322],
      Decaturville: [38329],
      Decherd: [37324],
      'Deer Lodge': [37726],
      Defeated: [37030],
      'Del Rio': [37727],
      Delano: [37325],
      Denmark: [38391],
      Devonia: [37710],
      Dickel: [37388],
      Dickson: [37055],
      'Dixon Springs': [37057],
      Dover: [37058],
      Dowelltown: [37059],
      Doyle: [38559],
      Dresden: [38225],
      Drummonds: [38023],
      'Duck River': [38454],
      Duff: [37729],
      Dukedom: [38226],
      Dunlap: [37327],
      Dyer: [38330],
      Dyersburg: [38024],
      Eads: [38028],
      Eagleville: [37060],
      'East Ridge': [37412],
      Eidson: [37731],
      Elizabethton: [37643],
      Elmwood: [38560],
      Elora: [37328],
      Englewood: [37329],
      Enville: [38332],
      Erin: [37061],
      Erwin: [37650],
      'Estill Springs': [37330],
      Ethridge: [38456],
      Etowah: [37331],
      Eva: [38333],
      Evensville: [37332],
      'Fairfield Glade': [38555],
      Fairview: [37062],
      'Fall Branch': [37656],
      Farner: [37333],
      Fayetteville: [37334],
      Finger: [38334],
      Finley: [38030],
      'Five Points': [38457],
      'Flag Pond': [37657],
      Flatwoods: [37096],
      Flintville: [37335],
      'Fort Campbell': [42223],
      'Fort Pillow': [38041],
      Frankewing: [38459],
      Franklin: [37064],
      Friendship: [38034],
      Friendsville: [37737],
      Gadsden: [38337],
      Gainesboro: [38562],
      Gallatin: [37066],
      Gassaway: [37095],
      Gates: [38037],
      Gatlinburg: [37738],
      Georgetown: [37336],
      Germantown: [38138, 38139],
      Gleason: [38229],
      Goodlettsville: [37072],
      Goodspring: [38460],
      Gordonsville: [38563],
      'Grand Junction': [38039],
      Grandview: [37337],
      Granville: [38564],
      Gray: [37615],
      Graysville: [37338],
      Greenback: [37742],
      Greenbrier: [37073],
      Greenfield: [38230],
      Grimsley: [38565],
      'Gruetli Laager': [37339],
      Guild: [37340],
      Guys: [38339],
      Halls: [38040],
      Hampshire: [38461],
      Hampton: [37658],
      Harriman: [37748],
      Harrison: [37341],
      Harrogate: [37752],
      Hartford: [37753],
      Hartsville: [37074],
      Heiskell: [37754],
      Helenwood: [37755],
      Henderson: [38340],
      Hendersonville: [37075],
      Henry: [38231],
      Hermitage: [37076],
      Hickman: [38567],
      'Hickory Hill': [38115],
      'Hickory Valley': [38042],
      Hilham: [38568],
      Hillsboro: [37342],
      'Hiwassee College': [37354],
      Hixson: [37343],
      Holladay: [38341],
      'Hollow Rock': [38342],
      Hornbeak: [38232],
      Hornsby: [38044],
      Humboldt: [38343],
      Huntingdon: [38344],
      Huntland: [37345],
      Huntsville: [37756],
      Huron: [38345],
      'Hurricane Mills': [37078],
      'Indian Mound': [37079],
      'Iron City': [38463],
      'Jacks Creek': [38347],
      Jacksboro: [37757],
      Jackson: [38301, 38305],
      Jamestown: [38556],
      'Jefferson City': [37760],
      Jellico: [37762],
      Joelton: [37080],
      'Johnson City': [37601, 37604],
      Jonesborough: [37659],
      Karns: [37921],
      Kelso: [37348],
      Kenton: [38233],
      Kimball: [37347],
      'Kimberlin Height': [37920],
      Kimmins: [38462],
      Kingsport: [37664],
      Kingston: [37763],
      'Kingston Springs': [37082],
      Knoxville: [
        37902, 37909, 37912, 37914, 37915, 37916, 37917, 37918, 37919, 37923,
        37924, 37931, 37938,
      ],
      Kodak: [37764],
      'Kyles Ford': [37765],
      'La Vergne': [37086],
      Lafayette: [37083],
      'Lake City': [37769],
      Lancaster: [38569],
      Lancing: [37770],
      Lascassas: [37085],
      'Laurel Bloomery': [37680],
      Lavinia: [38348],
      Lawrenceburg: [38464],
      Lebanon: [37087],
      'Lenoir City': [37771],
      Leoma: [38468],
      Lewisburg: [37091],
      Lexington: [38351],
      Livingston: [38570],
      Lobelville: [37097],
      'Lookout Mountain': [37350],
      Loretto: [38469],
      Loudon: [37774],
      Louisville: [37777],
      Lowland: [37778],
      Luray: [38352],
      Luttrell: [37779],
      Lutts: [38471],
      Lynchburg: [37352],
      'Lynn Garden': [37665],
      Lynnville: [38472],
      Madison: [37115],
      Manchester: [37355],
      Mansfield: [38236],
      Martin: [38237],
      Maryville: [37801, 37804],
      Mascot: [37806],
      Mason: [38049],
      Maynardville: [37807],
      'Mc Donald': [37353],
      'Mc Ewen': [37101],
      'Mc Kenzie': [38201],
      Medina: [38355],
      Medon: [38356],
      Melrose: [37204],
      Memphis: [
        38103, 38104, 38105, 38106, 38107, 38108, 38109, 38111, 38112, 38113,
        38114, 38116, 38117, 38118, 38119, 38120, 38122, 38125, 38126, 38127,
        38128, 38131, 38132, 38133, 38135, 38141,
      ],
      Mercer: [38392],
      Michie: [38357],
      Middleton: [38052],
      Midway: [37809],
      Milan: [38358],
      Milledgeville: [38359],
      Millington: [38053],
      Milton: [37118],
      'Minor Hill': [38473],
      Mohawk: [37810],
      Monroe: [38573],
      Monteagle: [37356],
      Monterey: [38574],
      Mooresburg: [37811],
      Morley: [37766],
      'Morris Chapel': [38361],
      Morrison: [37357],
      Morristown: [37813, 37814],
      Moscow: [38057],
      Mosheim: [37818],
      Moss: [38575],
      'Mount Carmel': [37645],
      'Mount Juliet': [37122],
      'Mount Pleasant': [38474],
      'Mountain City': [37683],
      Mulberry: [37359],
      Murfreesboro: [37129, 37130],
      Nashville: [
        37201, 37203, 37205, 37206, 37207, 37208, 37209, 37210, 37211, 37212,
        37213, 37214, 37215, 37216, 37217, 37218, 37219, 37220, 37228,
      ],
      'New Johnsonville': [37134],
      'New Market': [37820],
      'New Tazewell': [37825],
      Newbern: [38059],
      Newcomb: [37819],
      Newport: [37821],
      Niota: [37826],
      Nolensville: [37135],
      Normandy: [37360],
      Nunnelly: [37137],
      'Oak Ridge': [37830],
      Oakdale: [37829],
      Oakfield: [38362],
      Oakland: [38060],
      Obion: [38240],
      Ocoee: [37361],
      'Old Hickory': [37138],
      Oldfort: [37362],
      Olivehill: [38475],
      'Oliver Springs': [37840],
      Oneida: [37841],
      Only: [37140],
      Ooltewah: [37363],
      Orlinda: [37141],
      'Pall Mall': [38577],
      Palmer: [37365],
      Palmersville: [38241],
      Palmyra: [37142],
      Paris: [38242],
      Parrottsville: [37843],
      Parsons: [38363],
      Pegram: [37143],
      Pelham: [37366],
      Petersburg: [37144],
      Petros: [37845],
      Philadelphia: [37846],
      'Pigeon Forge': [37863],
      Pikeville: [37367],
      'Piney Flats': [37686],
      Pinson: [38366],
      Pioneer: [37847],
      Plaza: [37110],
      'Pleasant Hill': [38578],
      'Pleasant Shade': [37145],
      'Pleasant View': [37146],
      Pleasantville: [37147],
      Pocahontas: [38061],
      Portland: [37148],
      Postelle: [37317],
      'Powder Springs': [37848],
      Powell: [37849],
      'Primm Springs': [38476],
      Prospect: [38477],
      Pulaski: [38478],
      Puryear: [38251],
      Quebeck: [38579],
      Ramer: [38367],
      Ravenscroft: [38583],
      Readyville: [37149],
      Reagan: [38368],
      'Red Bank': [37415],
      'Red Boiling Spri': [37150],
      Reliance: [37369],
      Riceville: [37370],
      Rickman: [38580],
      Riddleton: [37151],
      Ridgely: [38080],
      Ripley: [38063],
      Rives: [38253],
      'Roan Mountain': [37687],
      Robbins: [37852],
      Rockford: [37853],
      Rockvale: [37153],
      Rockwood: [37854],
      Rogersville: [37857],
      Rossville: [38066],
      Royal: [37160],
      Russellville: [37860],
      Rutherford: [38369],
      Rutledge: [37861],
      'Saint Joseph': [38481],
      'Sale Creek': [37373],
      Saltillo: [38370],
      'Santa Fe': [38482],
      Sardis: [38371],
      Saulsbury: [38067],
      Savannah: [38372],
      'Scotts Hill': [38374],
      Selmer: [38375],
      Sequatchie: [37374],
      Sevierville: [37862],
      Sewanee: [37375],
      Seymour: [37865],
      'Shady Valley': [37688],
      Sharon: [38255],
      'Sharps Chapel': [37866],
      Sherwood: [37376],
      Shiloh: [38376],
      'Signal Mountain': [37377],
      'Silver Point': [38582],
      Smithville: [37166],
      Smyrna: [37167],
      Sneedville: [37869],
      'Soddy Daisy': [37379],
      Somerville: [38068],
      'South Fulton': [38257],
      'South Pittsburg': [37380],
      Southside: [37171],
      Speedwell: [37870],
      Spencer: [38585],
      'Spring City': [37381],
      'Spring Hill': [37174],
      Springfield: [37172],
      Springville: [38256],
      Stanton: [38069],
      Stantonville: [38379],
      Stewart: [37175],
      'Strawberry Plain': [37871],
      'Sugar Tree': [38380],
      Summertown: [38483],
      Sunbright: [37872],
      Surgoinsville: [37873],
      Sweetwater: [37874],
      Taft: [38488],
      Talbott: [37877],
      Tallassee: [37878],
      Tazewell: [37879],
      Telford: [37690],
      'Tellico Plains': [37385],
      'Ten Mile': [37880],
      'Tennessee Ridge': [37178],
      'Thompsons Statio': [37179],
      'Thorn Hill': [37881],
      Tiptonville: [38079],
      Toone: [38381],
      Townsend: [37882],
      'Tracy City': [37387],
      Trade: [37691],
      Treadway: [37883],
      Trenton: [38382],
      Trezevant: [38258],
      Trimble: [38259],
      Troy: [38260],
      Turtletown: [37391],
      Unicoi: [37692],
      'Union City': [38261],
      Unionville: [37180],
      Vanleer: [37181],
      Vonore: [37885],
      Walland: [37886],
      Walling: [38587],
      Wartburg: [37887],
      Wartrace: [37183],
      Washburn: [37888],
      'Washington Colle': [37681],
      Watauga: [37694],
      Watertown: [37184],
      Waverly: [37185],
      Waynesboro: [38485],
      Westmoreland: [37186],
      Westpoint: [38486],
      Westport: [38387],
      'White Bluff': [37187],
      'White House': [37188],
      'Whites Creek': [37189],
      Whitesburg: [37891],
      Whiteside: [37396],
      Whiteville: [38075],
      Whitleyville: [38588],
      Whitwell: [37397],
      Wilder: [38589],
      Wildersville: [38388],
      Williamsport: [38487],
      Williston: [38076],
      Winchester: [37398],
      Winfield: [37892],
      Woodbury: [37190],
      Woodlawn: [37191],
      Wrigley: [37098],
      Yuma: [38390],
    },
    name: 'Tennessee',
  },
  TX: {
    cities: {
      76350: [76350],
      76378: [76378],
      76447: [76447],
      76850: [76850],
      79542: [79542],
      Abbott: [76621],
      Abernathy: [79311],
      Abilene: [79601, 79602, 79603, 79605, 79606],
      Ackerly: [79713],
      Adkins: [78101],
      Adrian: [79001],
      Afton: [79220],
      Alamo: [78516],
      'Alamo Heights': [78209],
      Alba: [75410],
      Albany: [76430],
      Albert: [78671],
      Aledo: [76008],
      Alice: [78332],
      Allen: [75002],
      Alleyton: [78935],
      Alpine: [79830],
      'Alta Loma': [77510],
      Alton: [78572],
      Alvarado: [76009],
      Alvin: [77511],
      Alvord: [76225],
      Amarillo: [
        79101, 79102, 79103, 79104, 79106, 79107, 79108, 79109, 79110, 79111,
        79118, 79119, 79121, 79124,
      ],
      Ames: [77575],
      Amherst: [79312],
      Anderson: [77830],
      Andice: [78628],
      Andrews: [79714],
      Angleton: [77515],
      Anna: [75409],
      Annona: [75550],
      Anson: [79501],
      Anthony: [79821],
      Anton: [79313],
      'Apple Springs': [75926],
      Appleby: [75961],
      Aquilla: [76622],
      'Aransas Pass': [78336],
      Arcadia: [77517],
      Argyle: [76226],
      Arlington: [
        76006, 76010, 76011, 76012, 76013, 76014, 76015, 76016, 76017, 76018,
      ],
      Armstrong: [78338],
      Arp: [75750],
      Art: [76820],
      'Arthur City': [75411],
      Asherton: [78827],
      Aspermont: [79502],
      Atascosa: [78002],
      Athens: [75751],
      Atlanta: [75551],
      Aubrey: [76227],
      Austin: [
        78701, 78702, 78703, 78704, 78705, 78717, 78719, 78721, 78722, 78723,
        78724, 78725, 78726, 78727, 78728, 78729, 78730, 78731, 78732, 78733,
        78735, 78736, 78737, 78738, 78739, 78741, 78742, 78744, 78745, 78748,
        78749, 78750, 78751, 78752, 78753, 78754, 78756, 78757, 78758, 78759,
      ],
      Austonio: [75835],
      Avery: [75554],
      Avinger: [75630],
      Avoca: [79503],
      Axtell: [76624],
      Azle: [76020],
      Bacliff: [77518],
      Bagwell: [75412],
      Baird: [79504],
      'Balch Springs': [75180],
      'Balcones Heights': [78201],
      Ballinger: [76821],
      Balmorhea: [79718],
      Bandera: [78003],
      Bangs: [76823],
      Barksdale: [78828],
      Barnhart: [76930],
      Barnum: [75939],
      Barrett: [77532],
      Barry: [75102],
      Barstow: [79719],
      Bartlett: [76511],
      Bastrop: [78602],
      Batesville: [78829],
      Batson: [77519],
      Bayside: [78340],
      Baytown: [77520, 77521],
      Bayview: [78566],
      Beasley: [77417],
      Beaumont: [77701, 77702, 77703, 77705, 77706, 77707, 77708, 77713],
      Bebe: [78603],
      Beckville: [75631],
      Bedford: [76021, 76022],
      'Bee House': [76525],
      Beeville: [78102],
      Bellaire: [77401],
      Bellevue: [76228],
      Bellmead: [76704, 76705],
      Bells: [75414],
      Bellville: [77418],
      Belton: [76513],
      'Ben Franklin': [75415],
      'Ben Wheeler': [75754],
      Benbrook: [76126],
      Bend: [76824],
      Bergheim: [78004],
      Bertram: [78605],
      Best: [76932],
      'Beverly Hills': [76711],
      'Big Bend Nationa': [79834],
      'Big Sandy': [75755],
      'Big Wells': [78830],
      Bigfoot: [78005],
      Bishop: [78343],
      Bivins: [75555],
      Black: [79035],
      Blackwell: [79506],
      Blanco: [78606],
      Blanket: [76432],
      Bleiblerville: [78931],
      Blessing: [77419],
      Bloomburg: [75556],
      'Blooming Grove': [76626],
      Bloomington: [77951],
      Blossom: [75416],
      'Blue Ridge': [75424],
      'Bluff Dale': [76433],
      Bluffton: [78607],
      Blum: [76627],
      Bogata: [75417],
      Boling: [77420],
      'Bon Ami': [75956],
      'Bon Wier': [75928],
      Bonanza: [76692],
      Bonham: [75418],
      Booker: [79005],
      Boston: [75570],
      Bovina: [79009],
      Bowie: [76230],
      Boyd: [76023],
      Brackettville: [78832],
      Brashear: [75420],
      Brazoria: [77422],
      Breckenridge: [76424],
      Bremond: [76629],
      Brenham: [77833],
      'Bridge City': [77611],
      Bridgeport: [76426],
      Briggs: [78608],
      Briscoe: [79011],
      Broaddus: [75929],
      Bronson: [75930],
      Bronte: [76933],
      Brookeland: [75931],
      Brookesmith: [76827],
      'Brooks A F B': [78235],
      Brookshire: [77423],
      Brookston: [75421],
      Brownfield: [79316],
      Brownsville: [78520, 78521],
      Bruceville: [76630],
      Bruni: [78344],
      Bryan: [77801, 77802, 77803],
      Bryson: [76427],
      'Buchanan Dam': [78609],
      Buckholts: [76518],
      Buda: [78610],
      Bula: [79320],
      Buna: [77612],
      Burkburnett: [76354],
      Burkett: [76828],
      Burkeville: [75932],
      Burleson: [76028],
      Burlington: [76519],
      Burnet: [78611],
      Burton: [77835],
      Byers: [76357],
      Bynum: [76631],
      Caddo: [76429],
      'Caddo Mills': [75135],
      Caldwell: [77836],
      Call: [75933],
      Calliham: [78007],
      Calvert: [77837],
      Cameron: [76520],
      'Camp Verde': [78010],
      'Camp Wood': [78833],
      Campbell: [75422],
      Campbellton: [78008],
      Canton: [75103],
      Canutillo: [79835],
      Canyon: [79015],
      'Canyon Lake': [78130, 78132, 78133],
      Carbon: [76435],
      Carlsbad: [76934],
      Carlton: [76436],
      Carmine: [78932],
      'Carrizo Springs': [78834],
      Carrollton: [75006, 75007, 75008, 75010],
      'Carswell Afb': [76127],
      Carthage: [75633],
      Castell: [76831],
      'Castle Hills': [78213],
      Castroville: [78009],
      'Cat Spring': [78933],
      'Cedar Creek': [78612],
      'Cedar Hill': [75104],
      'Cedar Park': [78613],
      Celeste: [75423],
      Celina: [75009],
      Center: [75935],
      Centerville: [75833],
      Chalk: [79248],
      Chandler: [75758],
      Channelview: [77530],
      Channing: [79018],
      'Chappell Hill': [77426],
      Charlotte: [78011],
      Chatfield: [75105],
      Cherokee: [76832],
      Chester: [75936],
      Chico: [76431],
      Chillicothe: [79225],
      Chilton: [76632],
      'China Spring': [76633],
      Chireno: [75937],
      Christoval: [76935],
      Cibolo: [78108],
      Cisco: [76437],
      Clarendon: [79226],
      Clarksville: [75426],
      'Clarksville City': [75693],
      Claude: [79019],
      'Clear Lake Shore': [77565],
      Cleburne: [76031],
      Cleveland: [77327],
      Clint: [79836],
      Clodine: [77469],
      Clute: [77531],
      Clyde: [79510],
      Coahoma: [79511],
      'Cockrell Hill': [75211],
      Coldspring: [77331],
      Coleman: [76834],
      'College Station': [77840, 77843, 77845],
      Colleyville: [76034],
      Collinsville: [76233],
      'Colorado City': [79512],
      Columbus: [78934],
      Comanche: [76442],
      Comfort: [78013],
      Commerce: [75428],
      Como: [75431],
      Comstock: [78837],
      Concan: [78838],
      Concepcion: [78349],
      Concord: [77850],
      Cone: [79357],
      Conroe: [77301, 77384, 77385],
      Converse: [78109],
      Cookville: [75558],
      Coolidge: [76635],
      Cooper: [75432],
      Coppell: [75019],
      'Corpus Christi': [
        78401, 78402, 78404, 78405, 78406, 78407, 78408, 78409, 78410, 78411,
        78412, 78413, 78414, 78415, 78416, 78417, 78418, 78419, 78473,
      ],
      Corsicana: [75110],
      Cost: [78614],
      Cotulla: [78014],
      Coupland: [78615],
      Covington: [76636],
      Coyanosa: [79730],
      Crandall: [75114],
      Crane: [79731],
      'Cranfills Gap': [76637],
      Crawford: [76638],
      Creedmoor: [78747],
      Cresson: [76035],
      Crosbyton: [79322],
      'Cross Plains': [76443],
      Crowell: [79227],
      Crowley: [76036],
      'Crystal Beach': [77650],
      'Crystal City': [78839],
      Cuero: [77954],
      Cumby: [75433],
      Cushing: [75760],
      'Cut And Shoot': [77303],
      Cypress: [77429, 77433],
      'Cypress Mill': [78654],
      'D Hanis': [78850],
      Daingerfield: [75638],
      Dale: [78616],
      Dalhart: [79022],
      Dallas: [
        75201, 75202, 75203, 75204, 75206, 75207, 75208, 75209, 75210, 75212,
        75214, 75215, 75216, 75217, 75218, 75219, 75220, 75223, 75224, 75225,
        75226, 75227, 75228, 75229, 75230, 75231, 75232, 75233, 75235, 75236,
        75237, 75238, 75239, 75240, 75241, 75243, 75246, 75247, 75248, 75249,
        75251, 75252, 75253, 75287,
      ],
      Damon: [77430],
      Danbury: [77534],
      Danevang: [77432],
      Davilla: [76523],
      Dawson: [76639],
      Dayton: [77535],
      'De Berry': [75639],
      'De Kalb': [75559],
      'De Leon': [76444],
      'De Soto': [75115],
      Decatur: [76234],
      'Deer Park': [77536],
      'Del Valle': [78617],
      'Dell City': [79837],
      Delmita: [78536],
      Denison: [75020],
      Denton: [76201, 76205],
      'Denver City': [79323],
      Deport: [75435],
      Dermott: [79549],
      Desdemona: [76445],
      Detroit: [75436],
      Devers: [77538],
      Devine: [78016],
      Deweyville: [77614],
      Dialville: [75785],
      Diboll: [75941],
      Dickens: [79229],
      Dike: [75437],
      Dilley: [78017],
      'Dime Box': [77853],
      Dimmitt: [79027],
      'Dodd City': [75438],
      Dodson: [79230],
      Dogwood: [75979],
      Donie: [75838],
      Donna: [78537],
      Doole: [76836],
      Doss: [78618],
      Douglass: [75943],
      Douglassville: [75560],
      Driftwood: [78619],
      'Dripping Springs': [78620],
      Dryden: [78851],
      Dublin: [76446],
      Dumas: [79029],
      Dumont: [79232],
      Duncanville: [75116, 75137],
      Dunlay: [78861],
      'Dyess Afb': [79607],
      'Eagle Lake': [77434],
      'Eagle Pass': [78852],
      Early: [76801],
      Earth: [79031],
      'East Bernard': [77435],
      'East Texas Cente': [75708],
      Eastland: [76448],
      Ecleto: [78111],
      Ector: [75439],
      Eddy: [76524],
      Eden: [76837],
      Edgewood: [75117],
      Edinburg: [78539],
      Edna: [77957],
      Edom: [75756],
      'El Campo': [77437],
      'El Lago': [77586],
      'El Paso': [
        79901, 79902, 79903, 79904, 79905, 79907, 79912, 79915, 79922, 79924,
        79925, 79930, 79932, 79934, 79935, 79936,
      ],
      Elbert: [76359],
      Eldorado: [76936],
      Electra: [76360],
      Elgin: [78621],
      Ellinger: [78938],
      'Elm Mott': [76640],
      Elmaton: [77440],
      Elmendorf: [78112],
      Emory: [75440],
      Encinal: [78019],
      Encino: [78353],
      Ennis: [75119],
      Enochs: [79324],
      Eola: [76937],
      Era: [76238],
      Euless: [76039, 76040],
      Eustace: [75124],
      Everman: [76140],
      Fairfield: [75840],
      Falfurrias: [78355],
      'Falls City': [78113],
      'Farmers Branch': [75234, 75244],
      Farmersville: [75442],
      Farwell: [79325],
      Fayetteville: [78940],
      Ferris: [75125],
      Fieldton: [79326],
      Fife: [76825],
      Fischer: [78623],
      Flat: [76526],
      Flatonia: [78941],
      Flint: [75762],
      Flomot: [79234],
      Florence: [76527],
      Floresville: [78114],
      'Flower Mound': [75028],
      Floydada: [79235],
      Fluvanna: [79517],
      Follett: [79034],
      Forest: [75925],
      Forestburg: [76239],
      Forney: [75126],
      Forreston: [76041],
      'Fort Bliss': [79906, 79908, 79916],
      'Fort Davis': [79734],
      'Fort Hancock': [79839],
      'Fort Hood': [76544],
      'Fort Mc Kavett': [76841],
      'Fort Sam Houston': [78234],
      'Fort Stockton': [79735],
      'Fort Worth': [
        76102, 76103, 76104, 76105, 76106, 76107, 76109, 76110, 76111, 76112,
        76115, 76116, 76119, 76120, 76123, 76131, 76132, 76133, 76134, 76135,
        76137, 76155, 76177,
      ],
      Fowlerton: [78021],
      Franklin: [77856],
      Frankston: [75763],
      Fred: [77616],
      Fredericksburg: [78624],
      Fredonia: [76842],
      Freer: [78357],
      Freestone: [75831],
      Fresno: [77545],
      Friendswood: [77546],
      Frisco: [75034],
      Fritch: [79036],
      Frost: [76641],
      Fruitvale: [75127],
      Fulshear: [77441],
      Fulton: [78358],
      Gail: [79738],
      'Galena Park': [77547],
      Galveston: [77550, 77551, 77554],
      Ganado: [77962],
      Garciasville: [78547],
      'Garden City': [79739],
      'Garden Ridge': [78266],
      Gardendale: [79758],
      Garland: [75040, 75041, 75042, 75043, 75044],
      Garrison: [75946],
      Garwood: [77442],
      Gary: [75643],
      'George West': [78022],
      Georgetown: [78626],
      Giddings: [78942],
      Gillett: [78116],
      Gilmer: [75644],
      Girard: [79518],
      Gladewater: [75647],
      Glazier: [79014],
      'Glen Rose': [76043],
      Godley: [76044],
      Goldsboro: [79519],
      Goldsmith: [79741],
      Goldthwaite: [76844],
      Goliad: [77963],
      Gonzales: [78629],
      Goodrich: [77335],
      Gordon: [76453],
      Gordonville: [76245],
      Goree: [76363],
      Gorman: [76454],
      Gouldbusk: [76845],
      Graford: [76449],
      Graham: [76450],
      Granbury: [76048, 76049],
      'Grand Prairie': [75050, 75051, 75052],
      'Grand Saline': [75140],
      Grandfalls: [79742],
      Grandview: [76050],
      Granger: [76530],
      Grangerland: [77302],
      Grapeland: [75844],
      Grapevine: [76051, 76092],
      Greenville: [75401],
      'Grey Forest': [78023],
      Groesbeck: [76642],
      Groom: [79039],
      Groves: [77619],
      Groveton: [75845],
      Grulla: [78548],
      Gruver: [79040],
      Guerra: [78360],
      'Gun Barrel City': [75147],
      Gunter: [75058],
      Gustine: [76455],
      Guy: [77444],
      'Hale Center': [79041],
      Hallettsville: [77964],
      Hallsville: [75650],
      'Haltom City': [76117],
      Hamilton: [76531],
      Hamlin: [79520],
      Hamshire: [77622],
      Hankamer: [77560],
      Happy: [79042],
      Hargill: [78549],
      'Harker Heights': [76542, 76543],
      Harleton: [75651],
      Harlingen: [78550, 78552],
      Harper: [78631],
      Harrold: [76364],
      Hart: [79043],
      Hartley: [79044],
      Harwood: [78632],
      Haskell: [79521],
      Haslet: [76052],
      Hawkins: [75765],
      Hawley: [79525],
      Hearne: [77859],
      Heath: [75087],
      Hebbronville: [78361],
      Hedley: [79237],
      Hemphill: [75948],
      Hempstead: [77445],
      Henderson: [75652],
      Henrietta: [76365],
      Hereford: [79045],
      Hermleigh: [79526],
      Hewitt: [76643],
      Hext: [76848],
      Hico: [76457],
      Hidalgo: [78557],
      Higgins: [79046],
      'Highland Village': [75067],
      Highlands: [77562],
      Hillister: [77624],
      Hillsboro: [76645],
      'Hilltop Lakes': [77871],
      Hitchcock: [77563],
      Hobson: [78117],
      Hockley: [77447],
      Holland: [76534],
      Holliday: [76366],
      'Hollywood Park': [78232],
      'Honey Grove': [75446],
      'Horizon City': [79927],
      Houston: [
        77002, 77003, 77004, 77005, 77006, 77007, 77008, 77009, 77010, 77011,
        77012, 77013, 77014, 77015, 77016, 77017, 77018, 77019, 77020, 77021,
        77022, 77023, 77024, 77025, 77026, 77027, 77028, 77031, 77032, 77033,
        77034, 77035, 77036, 77037, 77038, 77039, 77041, 77042, 77043, 77044,
        77045, 77046, 77047, 77048, 77049, 77050, 77051, 77053, 77054, 77055,
        77056, 77057, 77058, 77059, 77060, 77061, 77062, 77063, 77064, 77065,
        77066, 77067, 77068, 77069, 77070, 77071, 77072, 77073, 77074, 77075,
        77076, 77077, 77078, 77079, 77080, 77081, 77082, 77083, 77084, 77085,
        77086, 77087, 77088, 77089, 77090, 77091, 77092, 77093, 77094, 77095,
        77096, 77098, 77099,
      ],
      Howe: [75459],
      Hubbard: [76648],
      Huffman: [77336],
      'Hughes Springs': [75656],
      Hull: [77564],
      Humble: [77338, 77339, 77345, 77346, 77396],
      Hunt: [78024],
      Huntington: [75949],
      Huntsville: [77340],
      Hurst: [76053, 76054],
      Hutchins: [75141],
      Hutto: [78634],
      Hye: [78635],
      Idalou: [79329],
      Imperial: [79743],
      Industry: [78944],
      Inez: [77968],
      Ingleside: [78362],
      Ingram: [78025],
      Iola: [77861],
      'Iowa Park': [76367],
      Ira: [79527],
      Iraan: [79744],
      Iredell: [76649],
      Irving: [75038, 75039, 75060, 75061, 75062, 75063],
      Italy: [76651],
      Itasca: [76055],
      Ivanhoe: [75447],
      Izoro: [76522],
      'Jacinto City': [77029],
      Jacksboro: [76458],
      Jacksonville: [75766],
      Jarrell: [76537],
      Jayton: [79528],
      Jermyn: [76459],
      'Jersey Village': [77040],
      Jewett: [75846],
      Joaquin: [75954],
      'Johnson City': [78636],
      Jonesboro: [76538],
      Jonestown: [78645],
      Joshua: [76058],
      Jourdanton: [78026],
      Junction: [76849],
      Justin: [76247],
      Karnack: [75661],
      'Karnes City': [78118],
      Kaufman: [75142],
      Keene: [76059],
      Keller: [76248],
      Kellerville: [79057],
      'Kelly A F B': [78241],
      Keltys: [75901],
      Kempner: [76539],
      Kendalia: [78027],
      Kenedy: [78119],
      Kennard: [75847],
      Kennedale: [76060],
      Kent: [79855],
      Kerens: [75144],
      Kermit: [79745],
      Kerrville: [78028],
      Kilgore: [75662],
      Killeen: [76541],
      Kingsbury: [78638],
      Kingsland: [78639],
      'Kingsville Naval': [78363],
      Kirby: [78219],
      Kirkland: [79201],
      Klein: [77379],
      Klondike: [75448],
      Knippa: [78870],
      Knott: [79748],
      'Knox City': [79529],
      Kopperl: [76652],
      Kosse: [76653],
      Kountze: [77625],
      Kress: [79052],
      Krum: [76249],
      'La Coste': [78039],
      'La Feria': [78559],
      'La Grange': [78945],
      'La Marque': [77568],
      'La Pryor': [78872],
      'La Vernia': [78121],
      Ladonia: [75449],
      'Laguna Park': [76634],
      'Lake Creek': [75450],
      'Lake Dallas': [75065],
      'Lake Jackson': [77566],
      'Lake Kiowa': [76240],
      Lakehills: [78063],
      Lakeview: [79239],
      Lakeway: [78734],
      'Lakewood Village': [75068],
      Lamesa: [79331],
      Lampasas: [76550],
      Lancaster: [75134, 75146],
      Laneville: [75667],
      Laredo: [78040, 78041],
      Larue: [75770],
      'Laughlin A F B': [78840],
      Lawn: [79530],
      Leaday: [76888],
      'League City': [77573],
      Leakey: [78873],
      Leander: [78641],
      Leary: [75561],
      Ledbetter: [78946],
      Leesburg: [75451],
      Leesville: [78122],
      Lenorah: [79749],
      'Leon Valley': [78238],
      Leona: [75850],
      Leonard: [75452],
      Levelland: [79336],
      Lewisville: [75057],
      Lexington: [78947],
      'Liberty Hill': [78642],
      Lincoln: [78948],
      Linden: [75563],
      Lindsay: [76250],
      Linn: [78563],
      Lipan: [76462],
      Lipscomb: [79056],
      Littlefield: [79339],
      'Live Oak': [78233],
      Liverpool: [77577],
      Lockhart: [78644],
      Lockney: [79241],
      Lohn: [76852],
      Lolita: [77971],
      Lometa: [76853],
      London: [76854],
      'Lone Oak': [75453],
      'Lone Star': [75668],
      'Long Branch': [75669],
      Longview: [75601, 75602, 75603, 75604, 75605],
      Loop: [79342],
      Loraine: [79532],
      Lorena: [76655],
      Lorenzo: [79343],
      Lott: [76656],
      Louise: [77455],
      Lovelady: [75851],
      Loving: [76460],
      Lubbock: [
        79401, 79403, 79404, 79405, 79406, 79407, 79410, 79411, 79412, 79413,
        79414, 79415, 79416, 79423, 79424,
      ],
      Lueders: [79533],
      Luling: [78648],
      Lyford: [78569],
      Lytle: [78052],
      Madisonville: [77864],
      Magnolia: [77355],
      'Magnolia Springs': [75957],
      Malakoff: [75148],
      Malone: [76660],
      Manchaca: [78652],
      Manor: [78653],
      Mansfield: [76063],
      Manvel: [77578],
      Maple: [79344],
      Marathon: [79842],
      Marfa: [79843],
      Marietta: [75566],
      Marion: [78124],
      Markham: [77456],
      Marlin: [76661],
      Marquez: [77865],
      Marshall: [75670],
      Mart: [76664],
      Martindale: [78655],
      Maryneal: [79535],
      Mason: [76856],
      Matador: [79244],
      Matagorda: [77457],
      Mathis: [78368],
      Maud: [75567],
      Maxwell: [78656],
      May: [76857],
      Maypearl: [76064],
      'Mc Camey': [79752],
      'Mc Caulley': [79534],
      'Mc Coy': [78053],
      'Mc Dade': [78650],
      'Mc Gregor': [76657],
      'Mc Kinney': [75069, 75070],
      'Mc Queeney': [78123],
      Mcadoo: [79243],
      Mcallen: [78501, 78503, 78504],
      Meadow: [79345],
      Medina: [78055],
      Melissa: [75454],
      Melvin: [76858],
      Memphis: [79245],
      Menard: [76859],
      Mentone: [79754],
      Mercedes: [78570],
      Mereta: [76940],
      Meridian: [76665],
      Merkel: [79536],
      Mertens: [76666],
      Mertzon: [76941],
      Mesquite: [75149, 75150, 75181, 75182],
      Mexia: [76667],
      Meyersville: [77974],
      Miami: [79059],
      Mico: [78056],
      Midfield: [77458],
      Midkiff: [79755],
      Midland: [79701, 79703, 79705, 79707],
      Midlothian: [76065],
      Midway: [75852],
      Milam: [75959],
      Milano: [76556],
      Miles: [76861],
      Milford: [76670],
      Millersview: [76862],
      Millsap: [76066],
      Mineola: [75773],
      'Mineral Wells': [76067],
      Mingus: [76463],
      'Mirando City': [78369],
      'Missouri City': [77459, 77489],
      Mobeetie: [79061],
      Monahans: [79756],
      'Monroe City': [77514],
      Montague: [76251],
      Montalba: [75853],
      'Monte Alto': [78538],
      Montgomery: [77356],
      Moody: [76557],
      Moore: [78057],
      Moran: [76464],
      Morgan: [76671],
      Morse: [79062],
      Morton: [79346],
      Moscow: [75960],
      Moulton: [77975],
      'Mount Calm': [76673],
      'Mount Enterprise': [75681],
      'Mount Pleasant': [75455],
      'Mount Selman': [75757],
      'Mount Vernon': [75457],
      'Mountain Home': [78058],
      'Mt Sylvan': [75771],
      Muenster: [76252],
      Muldoon: [78949],
      Muleshoe: [79347],
      Mullin: [76864],
      Munday: [76371],
      Murchison: [75778],
      Murphy: [75094],
      Naples: [75568],
      Nash: [75569],
      Natalia: [78059],
      Navasota: [77868],
      Nazareth: [79063],
      Nederland: [77627],
      Needville: [77461],
      Nemo: [76070],
      Nevada: [75173],
      'New Caney': [77357],
      'New Diana': [75640],
      'New Ulm': [78950],
      'New Waverly': [77358],
      Newark: [76071],
      Newcastle: [76372],
      Newton: [75966],
      Nixon: [78140],
      Nocona: [76255],
      Nolan: [79537],
      Nolanville: [76559],
      Nordheim: [78141],
      'North Richland H': [76118, 76180],
      'North Zulch': [77872],
      Norton: [76865],
      Novice: [79538],
      'O Brien': [79539],
      Oakhurst: [77359],
      Oakville: [78060],
      Oakwood: [75855],
      Odem: [78370],
      Odessa: [79761, 79762, 79763, 79764, 79765, 79766],
      Odonnell: [79351],
      Oglesby: [76561],
      Oklaunion: [76373],
      'Old Glory': [79540],
      'Olmos Park': [78212],
      Olney: [76374],
      Olton: [79064],
      Omaha: [75571],
      'Orange Grove': [78372],
      'Ore City': [75683],
      Otto: [76675],
      Ovalo: [79541],
      Overton: [75684],
      Ovilla: [75154],
      Ozona: [76943],
      Paige: [78659],
      'Paint Rock': [76866],
      Palacios: [77465],
      Palestine: [75801],
      Palmer: [75152],
      'Palo Pinto': [76484],
      Pampa: [79065],
      Panhandle: [79068],
      'Panorama Village': [77304],
      Paradise: [76073],
      Paris: [75460],
      'Park Row': [77449, 77450, 77493, 77494],
      Pasadena: [77502, 77503, 77504, 77505, 77506, 77507],
      Pattonville: [75468],
      'Pear Valley': [76867],
      Pearland: [77581, 77584],
      Pearsall: [78061],
      'Pecan Gap': [75469],
      Penelope: [76676],
      Pennington: [75856],
      Pep: [79353],
      Perrin: [76486],
      Perryton: [79070],
      Petersburg: [79250],
      Petrolia: [76377],
      Petty: [75470],
      Pflugerville: [78660],
      Pharr: [78577],
      Phillips: [79007],
      Pickton: [75471],
      'Pilot Point': [76258],
      Pinehurst: [77362],
      Pineland: [75968],
      Pittsburg: [75686],
      Plains: [79355],
      Plainview: [79072],
      Plano: [75023, 75024, 75025, 75074, 75075, 75093],
      Plantersville: [77363],
      Pleasanton: [78064],
      Pledger: [77468],
      Point: [75472],
      Pointblank: [77364],
      Pollok: [75969],
      Ponder: [76259],
      Pontotoc: [76869],
      Poolville: [76487],
      'Port Acres': [77640],
      'Port Arthur': [77642],
      'Port Isabel': [78578],
      'Port Lavaca': [77979],
      'Port Mansfield': [78598],
      'Port Neches': [77651],
      'Port O Connor': [77982],
      Porter: [77365],
      Portland: [78374],
      Post: [79356],
      Poteet: [78065],
      Poth: [78147],
      Pottsboro: [75076],
      Pottsville: [76565],
      Powderly: [75473],
      Powell: [75153],
      'Prairie Hill': [76678],
      Premont: [78375],
      Presidio: [79845],
      Price: [75687],
      Priddy: [76870],
      Princeton: [75407],
      Prosper: [75078],
      Purdon: [76679],
      Purmela: [76566],
      Pyote: [79777],
      Quail: [79251],
      Quanah: [79252],
      'Queen City': [75572],
      Quinlan: [75474],
      Quintana: [77541],
      Quitaque: [79255],
      Quitman: [75783],
      Rainbow: [76077],
      'Randolph A F B': [78148, 78150],
      Ranger: [76470],
      'Ransom Canyon': [79364, 79366],
      Ravenna: [75476],
      Raymondville: [78580],
      Reagan: [76680],
      Realitos: [78376],
      'Red Rock': [78662],
      'Reese Air Force': [79489],
      Refugio: [78377],
      Reklaw: [75784],
      Rhome: [76078],
      Rice: [75155],
      Richards: [77873],
      Richardson: [75080, 75081, 75082],
      Richland: [76681],
      'Richland Springs': [76871],
      Riesel: [76682],
      Ringgold: [76261],
      'Rio Bravo': [78043],
      'Rio Frio': [78879],
      'Rio Grande City': [78582],
      'Rio Hondo': [78583],
      'Rio Vista': [76093],
      Riomedina: [78066],
      'Rising Star': [76471],
      'River Oaks': [76114],
      Riviera: [78379],
      'Roaring Springs': [79256],
      'Robert Lee': [76945],
      Robstown: [78380],
      Roby: [79543],
      Rochelle: [76872],
      Rochester: [79544],
      Rockdale: [76567],
      Rockland: [75938],
      Rockport: [78382],
      Rocksprings: [78880],
      Rockwood: [76873],
      Rogers: [76569],
      Roma: [78584],
      Roosevelt: [76874],
      Ropesville: [79358],
      Rosanky: [78953],
      Roscoe: [79545],
      Rosebud: [76570],
      Rosenberg: [77471],
      Rosharon: [77583],
      Rosston: [76263],
      Rotan: [79546],
      'Round Mountain': [78663],
      'Round Rock': [78664, 78681],
      'Round Top': [78954],
      Rowena: [76875],
      Rowlett: [75088],
      Roxton: [75477],
      'Royse City': [75189],
      Rule: [79547],
      Runge: [78151],
      Sabinal: [78881],
      Sachse: [75048],
      Sadler: [76264],
      Sagerton: [79548],
      Saginaw: [76179],
      'Saint Hedwig': [78152],
      'Saint Jo': [76265],
      Salado: [76571],
      'Salt Flat': [79847],
      Saltillo: [75478],
      'Sam Rayburn': [75951],
      'San Angelo': [76901, 76903, 76904, 76905],
      'San Antonio': [
        78202, 78203, 78204, 78205, 78207, 78208, 78210, 78211, 78214, 78215,
        78216, 78217, 78218, 78220, 78221, 78222, 78223, 78224, 78225, 78226,
        78227, 78228, 78229, 78230, 78237, 78240, 78242, 78244, 78245, 78248,
        78249, 78250, 78251, 78252, 78253, 78254, 78255, 78256, 78257, 78258,
        78259, 78260, 78261, 78263, 78264,
      ],
      'San Augustine': [75972],
      'San Benito': [78586],
      'San Diego': [78384],
      'San Isidro': [78588],
      'San Juan': [78589],
      'San Leon': [77539],
      'San Marcos': [78666],
      'San Perlita': [78590],
      'San Saba': [76877],
      'San Ygnacio': [78067],
      Sandia: [78383],
      Sandy: [78665],
      Sanger: [76266],
      'Santa Anna': [76878],
      'Santa Elena': [78591],
      'Santa Rosa': [78593],
      Santo: [76472],
      Saratoga: [77585],
      Sargent: [77414],
      Sarita: [78385],
      Savoy: [75479],
      Schulenburg: [78956],
      Scotland: [76379],
      Scroggins: [75480],
      Scurry: [75158],
      Seadrift: [77983],
      Seagoville: [75159],
      Seagraves: [79359],
      Sealy: [77474],
      Sebastian: [78594],
      Segno: [77351],
      Seguin: [78155],
      Selma: [78154],
      Seminole: [79360],
      'Seven Points': [75143],
      Seymour: [76380],
      Shallowater: [79363],
      'Shavano Park': [78231],
      Sheffield: [79781],
      Shelbyville: [75973],
      Shepherd: [77371],
      'Sheppard Afb': [76311],
      Sherman: [75090],
      Shiner: [77984],
      Shoreacres: [77571],
      Sidney: [76474],
      'Sierra Blanca': [79851],
      Silsbee: [77656],
      Silver: [76949],
      Silverton: [79257],
      Simms: [75574],
      Singleton: [77831],
      Sinton: [78387],
      Sisterdale: [78006],
      Skellytown: [79080],
      Skidmore: [78389],
      Slocum: [75839],
      Smiley: [78159],
      Smithland: [75657],
      Smithville: [78957],
      Somerset: [78069],
      Somerville: [77879],
      Sonora: [76950],
      'Sour Lake': [77659],
      'South Houston': [77587],
      'South Padre Isla': [78597],
      Spearman: [79081],
      Spicewood: [78669],
      Splendora: [77372],
      Spofford: [78877],
      Spring: [77373, 77386, 77388, 77389],
      'Spring Branch': [78070],
      Springlake: [79082],
      Springtown: [76082],
      Spur: [79370],
      Spurger: [77660],
      Stafford: [77477],
      Stamford: [79553],
      Stanton: [79782],
      Star: [76880],
      Stephenville: [76401],
      'Sterling City': [76951],
      Stinnett: [79083],
      Stockdale: [78160],
      Stratford: [79084],
      Strawn: [76475],
      Streetman: [75859],
      Sudan: [79371],
      'Sugar Land': [77478, 77479],
      'Sullivan City': [78595],
      'Sulphur Bluff': [75481],
      'Sulphur Springs': [75482],
      Summerfield: [79085],
      Sumner: [75486],
      Sunray: [79086],
      'Sunrise Beach': [78643],
      Sunset: [76270],
      'Sutherland Sprin': [78161],
      Sweeny: [77480],
      Sweetwater: [79556],
      Sylvester: [79560],
      Taft: [78390],
      Tahoka: [79373],
      Talco: [75487],
      Talpa: [76882],
      Tarpley: [78883],
      Tarzan: [79783],
      Tatum: [75691],
      Taylor: [76574],
      Teague: [75860],
      Telegraph: [76883],
      Telephone: [75488],
      Tell: [79259],
      Temple: [76501, 76502, 76504],
      Tenaha: [75974],
      'Tennessee Colony': [75861],
      Terlingua: [79852],
      Terrell: [75160],
      Texarkana: [75503],
      'Texas City': [77590, 77591],
      Texline: [79087],
      'The Colony': [75056],
      'The Woodlands': [77380, 77381],
      Thorndale: [76577],
      Thornton: [76687],
      Thrall: [76578],
      'Three Rivers': [78071],
      Throckmorton: [76483],
      Tilden: [78072],
      Timpson: [75975],
      Tioga: [76271],
      Tivoli: [77990],
      Tokio: [79376],
      Tolar: [76476],
      Tomball: [77375],
      Tow: [78672],
      Trent: [79561],
      Trenton: [75490],
      Trinidad: [75163],
      Trinity: [75862],
      'Trophy Club': [76262],
      Troup: [75789],
      Troy: [76579],
      Truscott: [79260],
      Turkey: [79261],
      Turnersville: [76528],
      Turnertown: [75689],
      Tuscola: [79562],
      Twitty: [79079],
      Tye: [79563],
      Tyler: [75701, 75702, 75703, 75704, 75705, 75706, 75707, 75709],
      Tynan: [78391],
      Uhland: [78640],
      Utopia: [78884],
      Uvalde: [78801],
      'V A Hospital': [77030],
      Valentine: [79854],
      Valera: [76884],
      'Valley Mills': [76689],
      'Valley Spring': [76885],
      'Valley View': [76272],
      Van: [75790],
      'Van Alstyne': [75495],
      'Van Vleck': [77482],
      Vancourt: [76955],
      Vanderpool: [78885],
      Vealmoor: [79720],
      Vega: [79092],
      Venus: [76084],
      Vera: [76383],
      Verhalen: [79772],
      Vernon: [76384],
      Victoria: [77901, 77904],
      Vidor: [77662],
      'Vigo Park': [79088],
      Village: [75205],
      Voca: [76887],
      'Von Ormy': [78073],
      Waco: [76701, 76706, 76707, 76708, 76710],
      Wadsworth: [77483],
      Waelder: [78959],
      'Wake Village': [75501],
      Wall: [76957],
      Waller: [77484],
      Wallis: [77485],
      Wallisville: [77597],
      'Walnut Springs': [76690],
      Warren: [77664],
      Washington: [77880],
      Waskom: [75692],
      Watauga: [76148],
      Waxahachie: [75165],
      Wayside: [79094],
      Weatherford: [76086, 76087],
      Webster: [77598],
      Weimar: [78962],
      Weinert: [76388],
      Welch: [79377],
      Wellington: [79095],
      Wells: [75976],
      Weslaco: [78596],
      West: [76691],
      'West Columbia': [77486],
      'West Lake Hills': [78746],
      'West Orange': [77630],
      'West Point': [78963],
      Westbrook: [79565],
      Westhoff: [77994],
      Wetmore: [78163, 78247],
      Wharton: [77488],
      Wheeler: [79096],
      'White Deer': [79097],
      'White Settlement': [76108],
      Whiteface: [79379],
      Whitehouse: [75791],
      Whitesboro: [76273],
      Whitewright: [75491],
      Whitsett: [78075],
      Whitt: [76490],
      'Wichita Falls': [
        76301, 76302, 76303, 76304, 76305, 76306, 76308, 76309, 76310,
      ],
      Wiergate: [75977],
      Wildorado: [79098],
      'Wilford Hall U S': [78236],
      Willis: [77378],
      'Willow City': [78675],
      'Wills Point': [75169],
      Wilmer: [75172],
      Wilson: [79381],
      Wimberley: [78676],
      Windcrest: [78239],
      Windom: [75492],
      Windthorst: [76389],
      Winfield: [75493],
      Wingate: [79566],
      Wink: [79789],
      Winnie: [77665],
      Winnsboro: [75494],
      Winona: [75792],
      Winters: [79567],
      'Wolfe City': [75496],
      Wolfforth: [79382],
      Woodsboro: [78393],
      Woodson: [76491],
      Woodway: [76712],
      Wortham: [76693],
      Wrightsboro: [78677],
      Wylie: [75098],
      Yancey: [78886],
      Yantis: [75497],
      Yoakum: [77995],
      Yorktown: [78164],
      Zapata: [78076],
      Zavalla: [75980],
      Zephyr: [76890],
    },
    name: 'Texas',
  },
  UT: {
    cities: {
      Alpine: [84004],
      Alta: [84092],
      Altamont: [84001],
      Alton: [84710],
      Altonah: [84002],
      'American Fork': [84003],
      Aneth: [84510],
      Antimony: [84712],
      Austin: [84754],
      Axtell: [84621],
      Beaver: [84713],
      Beryl: [84714],
      'Big Water': [84741],
      'Bingham Canyon': [84006],
      Blanding: [84511],
      Bluebell: [84007],
      Boulder: [84716],
      Bountiful: [84010],
      'Brian Head': [84719],
      Bridgeland: [84012],
      'Brigham City': [84302],
      'Bryce Canyon': [84717],
      Bullfrog: [84533],
      'Cedar Valley': [84013],
      Centerfield: [84622],
      Centerville: [84014],
      Central: [84722],
      Clarkston: [84305],
      Clearfield: [84015],
      Coalville: [84017],
      Collinston: [84306],
      Corinne: [84307],
      Cornish: [84308],
      Cottonwood: [84121],
      Croydon: [84018],
      'Dammeron Valley': [84783],
      Delta: [84624],
      Deweyville: [84309],
      Draper: [84020],
      Duchesne: [84021],
      Dugway: [84022],
      'Dutch John': [84023],
      'East Carbon': [84520],
      Eden: [84310],
      Ephraim: [84627],
      Escalante: [84726],
      Eureka: [84628],
      Fairview: [84629],
      Farmington: [84025],
      Fayette: [84630],
      Ferron: [84523],
      Fielding: [84311],
      Fillmore: [84631],
      'Fort Duchesne': [84026],
      Fremont: [84747],
      'Garden City': [84028],
      Garland: [84312],
      Garrison: [84728],
      Genola: [84655],
      Glendale: [84729],
      Grantsville: [84029],
      'Green River': [84525],
      Greenville: [84731],
      'Grouse Creek': [84313],
      Gunnison: [84634],
      Hanksville: [84734],
      Hanna: [84031],
      'Heber City': [84032],
      Helper: [84526],
      'Hill Air Force B': [84056],
      Hinckley: [84635],
      Holladay: [84117, 84124],
      Honeyville: [84314],
      Hooper: [84315],
      Huntington: [84528],
      Huntsville: [84317],
      Hurricane: [84737],
      Hyrum: [84319],
      Jensen: [84035],
      Joseph: [84739],
      Kamas: [84036],
      Kaysville: [84037],
      Kearns: [84118],
      Kingston: [84743],
      Laketown: [84038],
      Lapoint: [84039],
      Lark: [84065],
      Layton: [84040, 84041],
      Lehi: [84043],
      Lewiston: [84320],
      Lindon: [84042],
      Logan: [84321],
      Magna: [84044],
      Manila: [84046],
      Manti: [84642],
      Mantua: [84324],
      Mapleton: [84664],
      Marysvale: [84750],
      Mendon: [84325],
      'Mexican Hat': [84531],
      Midvale: [84047],
      Midway: [84049],
      Milford: [84751],
      Moab: [84532],
      Modena: [84753],
      Mona: [84645],
      Monticello: [84535],
      'Monument Valley': [84536],
      Morgan: [84050],
      'Mount Carmel': [84755],
      'Mount Pleasant': [84647],
      'Mountain Home': [84051],
      Murray: [84107, 84123],
      Myton: [84052],
      Neola: [84053],
      Nephi: [84648],
      Newcastle: [84756],
      'North Salt Lake': [84054],
      Oasis: [84650],
      Ogden: [84401, 84403, 84404, 84405, 84414],
      Orderville: [84758],
      Orem: [84057],
      Panguitch: [84759],
      Paradise: [84328],
      Paragonah: [84760],
      'Park City': [84060],
      'Park Valley': [84329],
      Parowan: [84761],
      Payson: [84651],
      Peoa: [84061],
      'Pine Valley': [84781],
      Pintura: [84720],
      'Pleasant Grove': [84062],
      Price: [84501],
      Providence: [84332],
      Provo: [84601, 84604, 84606],
      Randlett: [84063],
      Randolph: [84064],
      Richmond: [84333],
      Roosevelt: [84066],
      Roy: [84067],
      'Rush Valley': [84069],
      Salina: [84654],
      'Salt Lake City': [
        84101, 84102, 84103, 84104, 84105, 84106, 84108, 84109, 84111, 84112,
        84113, 84116,
      ],
      Sandy: [84070, 84093, 84094],
      Sevier: [84766],
      Smithfield: [84335],
      Snowville: [84336],
      'South Salt Lake': [84115],
      'Spanish Fork': [84660],
      Springville: [84663],
      'St George': [84770],
      Stockton: [84071],
      Summit: [84772],
      Syracuse: [84075],
      Tabiona: [84072],
      Talmage: [84073],
      Teasdale: [84773],
      Thompson: [84540],
      Tooele: [84074],
      Torrey: [84775],
      Tremonton: [84337],
      Trenton: [84338],
      Tridell: [84076],
      'Trout Creek': [84083],
      Venice: [84701],
      Vernal: [84078],
      Vernon: [84080],
      Veyo: [84782],
      Vineyard: [84058],
      Wallsburg: [84082],
      Washington: [84780],
      Wellington: [84542],
      Wellsville: [84339],
      'West Jordan': [84084, 84088],
      'West Valley City': [84119, 84120],
      Whiterocks: [84085],
      Willard: [84340],
      'Woodland Hills': [84653],
      Woodruff: [84086],
      'Woods Cross': [84087],
    },
    name: 'Utah',
  },
  VA: {
    cities: {
      23013: [23013],
      23020: [23020],
      23042: [23042],
      23114: [23114],
      23137: [23137],
      23157: [23157],
      23973: [23973],
      24329: [24329],
      24633: [24633],
      Abingdon: [24210],
      Accomac: [23301],
      'Advance Mills': [22968],
      Afton: [22920],
      Airlie: [22186],
      Alberene: [22959],
      Alberta: [23821],
      Aldie: [22001],
      Alexandria: [22301, 22302, 22304, 22305, 22311, 22312, 22314],
      Alleghany: [24426],
      Allisonia: [24347],
      Altavista: [24517],
      Alton: [24520],
      'Alum Ridge': [24091],
      'Amelia Court Hou': [23002],
      Amherst: [24521],
      Amissville: [22002],
      Ammon: [23850],
      Ampthill: [23234],
      Annandale: [22003],
      Appomattox: [24522],
      Ararat: [24053],
      Arcola: [22010],
      Arlington: [
        22201, 22202, 22203, 22204, 22205, 22206, 22207, 22209, 22211, 22213,
      ],
      Aroda: [22709],
      Arvonia: [23004],
      Ashburn: [22011],
      Ashland: [23005],
      Assawoman: [23302],
      Atkins: [24311],
      Austinville: [24312],
      Axton: [24054],
      Aylett: [23009],
      Aylor: [22727],
      'Baileys Crossroa': [22041],
      Bandy: [24602],
      Barhamsville: [23011],
      'Barren Springs': [24313],
      Baskerville: [23915],
      Bassett: [24055],
      Bastian: [24314],
      Basye: [22810],
      Bavon: [23138],
      Beaverdam: [23015],
      Beaverlett: [23016],
      Bedford: [24523],
      Bee: [24217],
      'Belle Haven': [23306],
      'Belle View': [22307],
      Bellevue: [23227],
      'Bent Mountain': [24059],
      Bergton: [22811],
      Berryville: [22611],
      'Big Island': [24526],
      'Big Stone Gap': [24219],
      Birchleaf: [24220],
      Birdsnest: [23307],
      Blackridge: [23950],
      Blackstone: [23824],
      Blackwater: [24221],
      'Blackwater Bridg': [23457],
      Blairs: [24527],
      Bland: [24315],
      Bloxom: [23308],
      'Blue Grass': [24413],
      'Blue Ridge': [24064],
      Bluefield: [24605],
      Bluemont: [22012],
      Bohannon: [23021],
      Bolar: [24484],
      'Bon Air': [23235],
      'Boones Mill': [24065],
      Boonesville: [22935],
      Boston: [22713],
      'Bowers Hill': [23321],
      'Bowling Green': [22427],
      Boyce: [22620],
      'Boyd Tavern': [22947],
      Boydton: [23917],
      Boykins: [23827],
      Bracey: [23919],
      Branchville: [23828],
      'Brandy Station': [22714],
      'Bremo Bluff': [23022],
      Bridgewater: [22812],
      Brightwood: [22715],
      Bristol: [24201],
      Bristow: [22013],
      'Broad Run': [22014],
      Broadford: [24316],
      Broadway: [22815],
      Brodnax: [23920],
      Brookneal: [24528],
      Browntown: [22610],
      Bruington: [23023],
      Buckingham: [23921],
      'Buena Vista': [24416],
      'Buffalo Junction': [24529],
      Bumpass: [23024],
      Burgess: [22432],
      Burke: [22015],
      Burkeville: [23922],
      Burnleys: [22923],
      Burnsville: [24487],
      'Burr Hill': [22433],
      Bybee: [22963],
      Callands: [24530],
      Callao: [22435],
      Callaway: [24067],
      Cana: [24317],
      'Cape Charles': [23310],
      Capron: [23829],
      Caret: [22436],
      Carrollton: [23314],
      Carrsville: [23315],
      Carson: [23830],
      Cascade: [24069],
      'Cashs Corner': [22942],
      Castleton: [22716],
      Castlewood: [24224],
      Catawba: [24070],
      Catharpin: [22018],
      Catlett: [22019],
      Cauthornville: [23029],
      'Cave Spring': [24018],
      'Cedar Bluff': [24609],
      'Center Cross': [22437],
      Centreville: [22020],
      Ceres: [24318],
      Champlain: [22438],
      Chance: [22439],
      Chantilly: [22021],
      'Charles City': [23030],
      'Charlotte Court': [23923],
      Charlottesville: [22901],
      'Chase City': [23924],
      Chatham: [24531],
      Chesapeake: [23320, 23323, 23324, 23325],
      Chester: [23831],
      Chesterfield: [23832],
      Chilhowie: [24319],
      Chincoteague: [23336],
      Christiansburg: [24073],
      'Church Road': [23833],
      'Church View': [23032],
      Churchville: [24421],
      Clarksville: [23927],
      Claudville: [24076],
      'Clear Brook': [22624],
      Cleveland: [24225],
      Clifton: [22024],
      'Clifton Forge': [24422],
      Clinchco: [24226],
      Clinchport: [24244],
      Clintwood: [24228],
      Clover: [24534],
      Cloverdale: [24077],
      Cobham: [22929],
      Coeburn: [24230],
      'Coleman Falls': [24536],
      Collinsville: [24078],
      Cologne: [23037],
      'Colonial Heights': [23834],
      Columbia: [23038],
      Community: [22306],
      Conaway: [24603],
      Concord: [24538],
      Conicville: [22842],
      'Copper Hill': [24079],
      Council: [24260],
      Courtland: [23837],
      Covesville: [22931],
      Craigsville: [24430],
      Crewe: [23930],
      Criders: [22820],
      Crimora: [24431],
      'Cripple Creek': [24322],
      Critz: [24082],
      Crockett: [24323],
      Crozier: [23039],
      'Crystal Hill': [24539],
      Cullen: [23934],
      Cumberland: [23040],
      Dabneys: [23102],
      Dahlgren: [22448],
      'Dale City': [22193],
      Daleville: [24083],
      Damascus: [24236],
      Dante: [24237],
      Danville: [24540, 24541],
      Davenport: [24239],
      Deerfield: [24432],
      Delaplane: [22025],
      Deltaville: [23043],
      Dendron: [23839],
      Dewitt: [23840],
      Diggs: [23045],
      Dinwiddie: [23841],
      Disputanta: [23842],
      'Doe Hill': [24433],
      Dolphin: [23843],
      Doswell: [23047],
      'Drakes Branch': [23937],
      Draper: [24324],
      Drewryville: [23844],
      'Dry Fork': [24549],
      Dryden: [24243],
      Dublin: [24084],
      Dugspur: [24325],
      Dumfries: [22026],
      Dundas: [23938],
      Dungannon: [24245],
      'Dunn Loring': [22027],
      Dutton: [23050],
      'Eagle Rock': [24085],
      Earlysville: [22936],
      Ebony: [23845],
      Edinburg: [22824],
      Eggleston: [24086],
      Elberon: [23846],
      'Elk Creek': [24326],
      Elkton: [22827],
      Elkwood: [22718],
      Emporia: [23847],
      Engleside: [22309],
      Esmont: [22937],
      Etlan: [22719],
      Ettrick: [23803],
      Evington: [24550],
      Ewing: [24248],
      Exeter: [24216],
      Exmore: [23350],
      Faber: [22938],
      Fairfax: [22030, 22031, 22032, 22033],
      'Fairfax Station': [22039],
      Fairfield: [24435],
      Fairlawn: [24141],
      'Falls Church': [22046],
      'Falls Mills': [24613],
      Falmouth: [22405],
      'Fancy Gap': [24328],
      Farmville: [23901],
      Farnham: [22460],
      Fentress: [23322],
      Ferrum: [24088],
      Fieldale: [24089],
      Fincastle: [24090],
      Fleet: [23511],
      'Flint Hill': [22627],
      Forest: [24551],
      'Fork Union': [23055],
      'Fort Belvoir': [22060],
      'Fort Blackmore': [24250],
      'Fort Defiance': [24437],
      'Fort Lee': [23801],
      'Foster Falls': [24360],
      Franconia: [22310],
      Franklin: [23851],
      Franktown: [23354],
      Fredericksburg: [22401, 22406, 22407, 22408],
      Freeman: [23856],
      Fries: [24330],
      'Front Royal': [22630],
      'Fulks Run': [22830],
      Gainesville: [22065],
      Galax: [24333],
      Gasburg: [23857],
      'Gate City': [24251],
      Geer: [22973],
      'Glade Spring': [24340],
      Gladehill: [24092],
      Gladstone: [24553],
      Gladys: [24554],
      Glasgow: [24555],
      'Glen Allen': [23060],
      'Glen Lyn': [24093],
      'Gloucester Point': [23062],
      Goldbond: [24094],
      Goldvein: [22720],
      Goochland: [23063],
      Goode: [24556],
      Goodview: [24095],
      Gore: [22637],
      Goshen: [24439],
      Grafton: [23692],
      'Great Falls': [22066],
      'Green Bay': [23942],
      Greenbackville: [23356],
      Greenbush: [23357],
      Greenville: [24440],
      Greenwood: [22943],
      Gretna: [24557],
      Grottoes: [24441],
      Grundy: [24614],
      'Gum Spring': [23065],
      Gwynn: [23066],
      Hague: [22469],
      Halifax: [24558],
      Hallwood: [23359],
      Hamilton: [22068],
      Hampton: [23651, 23661, 23663, 23664, 23665, 23666, 23669],
      Handsom: [23859],
      Hanover: [23069],
      Hardy: [24101],
      Hardyville: [23070],
      Harrisonburg: [22801],
      Hartfield: [23071],
      Hayes: [23072],
      Haymarket: [22069],
      Haysi: [24256],
      Haywood: [22722],
      'Head Waters': [24442],
      Heathsville: [22473],
      Henry: [24102],
      Herndon: [22070, 22071],
      'Highland Springs': [23075],
      Hightown: [24444],
      Hillsboro: [22132],
      Hillsville: [24343],
      Hiltons: [24258],
      Hinton: [22831],
      Hollins: [24019],
      Hopewell: [23860],
      Horntown: [23395],
      Horsey: [23396],
      'Hot Springs': [24445],
      Howardsville: [24562],
      Howertons: [22454],
      Huddleston: [24104],
      Hume: [22639],
      Huntly: [22640],
      Hurley: [24620],
      Hurt: [24563],
      Hustle: [22476],
      Independence: [24348],
      'Indian Neck': [23148],
      'Indian Valley': [24105],
      Ingram: [24597],
      Ironto: [24087],
      Irvington: [22480],
      Ivanhoe: [24350],
      Ivor: [23866],
      Jamaica: [23079],
      'James Store': [23080],
      Jarratt: [23867],
      Java: [24565],
      'Jefferson Manor': [22303],
      Jeffersonton: [22724],
      'Jenkins Bridge': [23399],
      Jetersville: [23083],
      'Jewell Valley': [24622],
      Jonesville: [24263],
      Keeling: [24566],
      Keene: [22946],
      Keezletown: [22832],
      Kenbridge: [23944],
      'Kents Store': [23084],
      Keokee: [24265],
      Keysville: [23947],
      Kilmarnock: [22482],
      'King And Queen C': [23085],
      'King George': [22485],
      'King William': [23086],
      Kinsale: [22488],
      'Lake Anne': [22090],
      Lakeridge: [22192],
      Lakeside: [23228],
      Lambsburg: [24351],
      Lancaster: [22503],
      Laneview: [22504],
      Lanexa: [23089],
      'Laurel Fork': [24352],
      Lebanon: [24266],
      'Lebanon Church': [22641],
      Leesburg: [22075],
      Lennig: [24577],
      Leon: [22725],
      Lexington: [24450],
      Lignum: [22726],
      Linden: [22642],
      Linville: [22834],
      Lithia: [24066],
      'Little Plymouth': [23091],
      'Locust Dale': [22948],
      'Locust Grove': [22508],
      'Locust Hill': [23092],
      Locustville: [23404],
      'Long Island': [24569],
      Loretto: [22509],
      Lottsburg: [22511],
      Louisa: [23093],
      Lovettsville: [22080],
      Lovingston: [22949],
      Lowesville: [22951],
      Lowry: [24570],
      Lunenburg: [23952],
      Luray: [22835],
      'Lynch Station': [24571],
      Lynchburg: [24501, 24503, 24504],
      Machipongo: [23405],
      'Madison Heights': [24572],
      'Manakin Sabot': [23103],
      Manassas: [22110],
      'Manassas Park': [22111],
      Manquin: [23106],
      Mappsville: [23407],
      Marion: [24354],
      Markham: [22643],
      Marshall: [22115],
      Martinsville: [24112],
      Mascot: [23108],
      'Mason Neck': [22079],
      Mathews: [23109],
      Maurertown: [22644],
      Mavisdale: [24627],
      'Mc Clure': [24269],
      'Mc Dowell': [24458],
      'Mc Gaheysville': [22840],
      'Mc Kenney': [23872],
      'Mc Lean': [22101],
      'Meadows Of Dan': [24120],
      Meadowview: [24361],
      Mears: [23409],
      Mechanicsville: [23111],
      Meherrin: [23954],
      Melfa: [23410],
      Mendota: [24270],
      Merrimac: [23185],
      Middlebrook: [24459],
      Middleburg: [22117],
      Middletown: [22645],
      Midland: [22728],
      Midlothian: [23112, 23113],
      Miles: [23025],
      Milford: [22514],
      'Millboro Spring': [24460],
      'Mine Run': [22568],
      Mineral: [23117],
      'Mission Home': [22940],
      Mitchells: [22729],
      Mobjack: [23118],
      Moneta: [24121],
      Monroe: [24574],
      Montebello: [24464],
      Monterey: [24465],
      Montevideo: [22846],
      Montezuma: [22821],
      Montford: [22960],
      Montpelier: [23192],
      Montross: [22520],
      Montvale: [24122],
      Moon: [23119],
      Morrisville: [22712],
      Mosby: [22042],
      Moseley: [23120],
      'Mount Crawford': [22841],
      'Mount Sidney': [24467],
      'Mount Solon': [22843],
      'Mountain Lake': [24136],
      'Mouth Of Wilson': [24363],
      Mustoe: [24468],
      Narrows: [24124],
      'Natural Bridge': [24578],
      'Natural Bridge S': [24579],
      'Naval Amphibious': [23521],
      Nelson: [24580],
      'New Canton': [23123],
      'New Castle': [24127],
      'New Church': [23415],
      'New Kent': [23124],
      'New Market': [22844],
      'New Point': [23125],
      Newport: [24128],
      'Newport News': [23601, 23602, 23603, 23604, 23605, 23606, 23607],
      Newsoms: [23874],
      Newtown: [23126],
      Nickelsville: [24271],
      Nokesville: [22123],
      'Nomini Grove': [22572],
      Nora: [24272],
      Norfolk: [
        23502, 23503, 23504, 23505, 23507, 23508, 23509, 23510, 23513, 23517,
        23518, 23523,
      ],
      North: [23128],
      'North Springfiel': [22151],
      Norton: [24273],
      'Oak Grove': [22443],
      'Oak Hall': [23416],
      Oakton: [22124],
      Oilville: [23129],
      Onancock: [23417],
      Onemo: [23130],
      Onley: [23418],
      'Orkney Springs': [22845],
      'Paeonian Springs': [22129],
      'Paint Bank': [24131],
      Painter: [23420],
      Pamplin: [23958],
      Paris: [22130],
      Parksley: [23421],
      Partlow: [22534],
      'Patrick Springs': [24133],
      Patterson: [24631],
      Pearisburg: [24134],
      Penhook: [24137],
      'Pennington Gap': [24277],
      Petersburg: [23805],
      Phenix: [23959],
      'Pilgrims Knob': [24634],
      Pilot: [24138],
      Pimmit: [22043],
      Pinero: [23061],
      'Piney River': [22964],
      Pittsville: [24139],
      'Plain View': [23156],
      Poquoson: [23662],
      'Port Republic': [24471],
      'Port Royal': [22535],
      Portsmouth: [23701, 23702, 23703, 23704, 23707, 23709],
      Pound: [24279],
      'Pounding Mill': [24637],
      Powhatan: [23139],
      Pratts: [22731],
      'Prince George': [23875],
      Prospect: [23960],
      'Providence Forge': [23140],
      Pulaski: [24301],
      Quantico: [22134],
      Quinton: [23141],
      'Raccoon Ford': [22701],
      Radiant: [22732],
      Randolph: [23962],
      Raphine: [24472],
      Rapidan: [22733],
      'Rappahannock Aca': [22538],
      Raven: [24639],
      Rawlings: [23876],
      'Red House': [23963],
      'Red Oak': [23964],
      Reedville: [22539],
      Regency: [23229],
      Reliance: [22649],
      Remington: [22734],
      Remlik: [23175],
      Reston: [22091, 22094],
      Reva: [22735],
      Rhoadesville: [22542],
      Rice: [23966],
      'Rich Creek': [24147],
      Richardsville: [22736],
      Richlands: [24641],
      Richmond: [
        23219, 23220, 23221, 23222, 23223, 23224, 23225, 23226, 23231, 23236,
        23237, 23294,
      ],
      Ridge: [23233],
      Ridgeway: [24148],
      Rileyville: [22650],
      Riner: [24149],
      Ringgold: [24586],
      Ripplemead: [24150],
      Rixeyville: [22737],
      Roanoke: [24011, 24012, 24013, 24014, 24015, 24016, 24017],
      'Rockbridge Baths': [24473],
      Rockfish: [22971],
      Rockville: [23146],
      'Rocky Gap': [24366],
      'Rocky Mount': [24151],
      'Rose Hill': [24281],
      Rosedale: [24280],
      Roseland: [22967],
      'Round Hill': [22141],
      Rowe: [24646],
      'Rural Retreat': [24368],
      Rustburg: [24588],
      'Ruther Glen': [22546],
      'Saint Charles': [24282],
      'Saint Davids Chu': [22652],
      'Saint Paul': [24283],
      Salem: [24153],
      Saltville: [24370],
      Saluda: [23149],
      Sandston: [23150],
      'Sandy Hook': [23153],
      'Sandy Level': [24161],
      Sanford: [23426],
      Saxe: [23967],
      Schuyler: [22969],
      Scottsburg: [24589],
      Scottsville: [24590],
      Seaford: [23696],
      Sedley: [23878],
      'Seven Corners': [22044],
      'Seven Mile Ford': [24373],
      Shadow: [23163],
      Shanghai: [23110],
      Shawsville: [24162],
      Shenandoah: [22849],
      'Shenandoah Caver': [22847],
      Sherando: [22952],
      Simpsons: [24072],
      Skippers: [23879],
      Skipwith: [23968],
      Smithfield: [23430],
      Snell: [22553],
      Somerset: [22972],
      'South Boston': [24592],
      'South Hill': [23970],
      Speedwell: [24374],
      Spencer: [24165],
      Sperryville: [22740],
      Spottswood: [24475],
      'Spout Spring': [24593],
      'Spring Grove': [23881],
      Springfield: [22150, 22153],
      'Sprouses Corner': [23936],
      Stafford: [22554],
      Staffordsville: [24167],
      Stanley: [22851],
      Stanleytown: [24168],
      'Star Tannery': [22654],
      'Stephens City': [22655],
      Stephenson: [22656],
      Sterling: [22170],
      Stevensburg: [22741],
      Stevensville: [23161],
      Stewartsville: [24179],
      Stonega: [24285],
      'Stony Creek': [23882],
      Strasburg: [22657],
      Stuart: [24171],
      'Stuarts Draft': [24477],
      Suffolk: [23432, 23433, 23434, 23435, 23436, 23437, 23438],
      'Sugar Grove': [24375],
      Sumerduck: [22742],
      Supply: [22559],
      Surry: [23883],
      Sutherland: [23885],
      Sutherlin: [24594],
      Swoope: [24479],
      'Swords Creek': [24649],
      Syria: [22743],
      Syringa: [23169],
      Tabb: [23693],
      Tamworth: [23027],
      Tangier: [23440],
      Tannersville: [24377],
      Tappahannock: [22560],
      Tazewell: [24651],
      Temperanceville: [23442],
      Thaxton: [24174],
      'The Plains': [22171],
      Timberlake: [24502],
      Timberville: [22853],
      Tiptop: [24630],
      Toano: [23168],
      'Toms Brook': [22660],
      Trammel: [24289],
      Triangle: [22172],
      Triplet: [23868],
      'Trout Dale': [24378],
      Troutville: [24175],
      Troy: [22974],
      'Tye River': [22922],
      'Union Hall': [24176],
      Unionville: [22567],
      University: [22903],
      Uno: [22738],
      Upperville: [22176],
      Valentines: [23887],
      Vansant: [24656],
      Verona: [24482],
      Vesuvius: [24483],
      Victoria: [23974],
      Vienna: [22180, 22181, 22182],
      Viewtown: [22746],
      Virgilina: [24598],
      'Virginia Beach': [
        23451, 23452, 23454, 23455, 23456, 23459, 23462, 23464,
      ],
      Wake: [23176],
      Wakefield: [23888],
      Walkerton: [23177],
      'Wallops Island': [23337],
      Walters: [23481],
      Warfield: [23889],
      Warner: [23179],
      Washington: [22747],
      'Water View': [23180],
      Waterford: [22190],
      Waverly: [23890],
      Waynesboro: [22980],
      'Weber City': [24290],
      Weems: [22576],
      Wellington: [22308],
      'West Augusta': [24485],
      'West End': [23230],
      'West Mclean': [22102],
      'West Point': [23181],
      'West Springfield': [22152],
      'Weyers Cave': [24486],
      Whitacre: [22625],
      'White Plains': [23893],
      'White Post': [22663],
      Whitethorne: [24060],
      Whitetop: [24292],
      Whitewood: [24657],
      'Wicomico Church': [22579],
      Williamsburg: [23188],
      Willis: [24380],
      Wilsons: [23894],
      Winchester: [22601],
      'Windmill Point': [22578],
      Windsor: [23487],
      Wingina: [24599],
      Wintergreen: [22958],
      Wirtz: [24184],
      Wise: [24293],
      Woodbridge: [22191],
      Woodford: [22580],
      Woodlawn: [24381],
      'Woodrow Wilson': [22939],
      Woodrum: [24401],
      Woodstock: [22664],
      Woodville: [22749],
      Woolwine: [24185],
      Wylliesburg: [23976],
      Wytheville: [24382],
      Yale: [23897],
      'Yancey Mills': [22932],
      Yorktown: [23690],
      Zuni: [23898],
    },
    name: 'Virginia',
  },
  VT: {
    cities: {
      Adamant: ['05640'],
      Albany: ['05820'],
      Alburg: ['05440'],
      Arlington: ['05250'],
      Averill: ['05901'],
      Bakersfield: ['05441'],
      Barnet: ['05821'],
      Barre: ['05641'],
      Barton: ['05822'],
      'Beecher Falls': ['05902'],
      'Bellows Falls': ['05101'],
      Belmont: ['05730'],
      Bennington: ['05201'],
      Bethel: ['05032'],
      'Bolton Valley': ['05477'],
      Bondville: ['05340'],
      Bradford: ['05033'],
      Brandon: ['05733'],
      Brattleboro: ['05301'],
      'Bread Loaf': ['05753'],
      Bridgewater: ['05034'],
      'Bridgewater Corn': ['05035'],
      Bridport: ['05734'],
      Bristol: ['05443'],
      'Bromley Mtn': ['05148'],
      Brookfield: ['05036'],
      Brownsville: ['05037'],
      Burlington: ['05401'],
      Cabot: ['05647'],
      Calais: ['05648'],
      Cambridge: ['05444'],
      Cambridgeport: ['05141'],
      Canaan: ['05903'],
      Castleton: ['05735'],
      Cavendish: ['05142'],
      'Center Rutland': ['05736'],
      Charlotte: ['05445'],
      Chelsea: ['05038'],
      Chester: ['05143'],
      Chittenden: ['05737'],
      Colchester: ['05446'],
      Concord: ['05824'],
      Corinth: ['05039'],
      Coventry: ['05825'],
      Craftsbury: ['05826'],
      'Craftsbury Commo': ['05827'],
      Cuttingsville: ['05738'],
      Danby: ['05739'],
      Danville: ['05828'],
      Derby: ['05829'],
      'Derby Line': ['05830'],
      Dorset: ['05251'],
      'East Arlington': ['05252'],
      'East Barre': ['05649'],
      'East Berkshire': ['05447'],
      'East Burke': ['05832'],
      'East Calais': ['05650'],
      'East Charleston': ['05833'],
      'East Corinth': ['05040'],
      'East Dorset': ['05253'],
      'East Dover': ['05341'],
      'East Fairfield': ['05448'],
      'East Hardwick': ['05836'],
      'East Haven': ['05837'],
      'East Montpelier': ['05651'],
      'East Randolph': ['05041'],
      'East Thetford': ['05043'],
      'East Wallingford': ['05742'],
      Eden: ['05652'],
      'Eden Mills': ['05653'],
      'Enosburg Falls': ['05450'],
      'Essex Junction': ['05452'],
      'Fair Haven': ['05743'],
      Fairfax: ['05454'],
      Fairfield: ['05455'],
      Fairlee: ['05045'],
      Ferrisburg: ['05456'],
      Florence: ['05744'],
      Franklin: ['05457'],
      Gaysville: ['05746'],
      Gilman: ['05904'],
      Glover: ['05839'],
      Grafton: ['05146'],
      'Grand Isle': ['05458'],
      Graniteville: ['05654'],
      Granville: ['05747'],
      Greensboro: ['05841'],
      'Greensboro Bend': ['05842'],
      Groton: ['05046'],
      Guildhall: ['05905'],
      Hancock: ['05748'],
      Hardwick: ['05843'],
      Hartland: ['05048'],
      'Highgate Center': ['05459'],
      Hinesburg: ['05461'],
      Hubbardton: ['05732'],
      Huntington: ['05462'],
      'Hyde Park': ['05655'],
      Irasburg: ['05845'],
      'Island Pond': ['05846'],
      'Isle La Motte': ['05463'],
      Jacksonville: ['05342'],
      Jamaica: ['05343'],
      'Jay Peak': ['05859'],
      'Jericho Center': ['05465'],
      Johnson: ['05656'],
      Killington: ['05751'],
      'Leicester Juncti': ['05778'],
      Lowell: ['05847'],
      Ludlow: ['05149'],
      Lunenburg: ['05906'],
      'Lyndon Center': ['05850'],
      Lyndonville: ['05851'],
      'Manchester Cente': ['05255'],
      Marshfield: ['05658'],
      'Middletown Sprin': ['05757'],
      Milton: ['05468'],
      'Montgomery Cente': ['05471'],
      Montpelier: ['05602'],
      Moretown: ['05660'],
      'Morgan Ctr': ['05853'],
      Morrisville: ['05661'],
      'Mount Holly': ['05758'],
      'Mount Snow': ['05356'],
      'New Haven': ['05472'],
      Newbury: ['05051'],
      Newfane: ['05345'],
      Newport: ['05855'],
      'Newport Center': ['05857'],
      'North Bennington': ['05257'],
      'North Clarendon': ['05759'],
      'North Concord': ['05858'],
      'North Ferrisburg': ['05473'],
      'North Hartland': ['05052'],
      'North Hero': ['05474'],
      'North Montpelier': ['05666'],
      'North Pomfret': ['05053'],
      'North Pownal': ['05260'],
      'North Springfiel': ['05150'],
      Norton: ['05907'],
      Norwich: ['05055'],
      Orleans: ['05860'],
      Orwell: ['05760'],
      Pawlet: ['05761'],
      Peacham: ['05862'],
      Perkinsville: ['05151'],
      Peru: ['05152'],
      Pittsfield: ['05762'],
      Pittsford: ['05763'],
      Plainfield: ['05667'],
      Plymouth: ['05056'],
      'Post Mills': ['05058'],
      Poultney: ['05764'],
      Pownal: ['05261'],
      Proctor: ['05765'],
      Proctorsville: ['05153'],
      Putney: ['05346'],
      Randolph: ['05060'],
      'Randolph Center': ['05061'],
      Reading: ['05062'],
      Readsboro: ['05350'],
      Richford: ['05476'],
      Ripton: ['05766'],
      Riverton: ['05663'],
      Rochester: ['05767'],
      Roxbury: ['05669'],
      Rutland: ['05701'],
      Ryegate: ['05042'],
      'Saint Albans': ['05478'],
      'Saint Johnsbury': ['05819'],
      Salisbury: ['05769'],
      'Saxtons River': ['05154'],
      Shaftsbury: ['05262'],
      Sharon: ['05065'],
      Sheffield: ['05866'],
      Shelburne: ['05482'],
      Sheldon: ['05483'],
      Shoreham: ['05770'],
      'Smugglers Notch': ['05464'],
      'South Burlington': ['05403'],
      'South Hero': ['05486'],
      'South Londonderr': ['05155'],
      'South Pomfret': ['05067'],
      'South Royalton': ['05068'],
      'South Ryegate': ['05069'],
      'South Strafford': ['05070'],
      'South Woodstock': ['05071'],
      Springfield: ['05156'],
      Stamford: ['05352'],
      Starksboro: ['05487'],
      Stockbridge: ['05772'],
      Stowe: ['05672'],
      Strafford: ['05072'],
      'Sugarbush Valley': ['05674'],
      Sutton: ['05867'],
      Swanton: ['05488'],
      Taftsville: ['05073'],
      'Thetford Center': ['05075'],
      Townshend: ['05353'],
      Troy: ['05868'],
      Tunbridge: ['05077'],
      Underhill: ['05489'],
      'Univ Of Vermont': ['05405'],
      Vergennes: ['05491'],
      Vernon: ['05354'],
      Vershire: ['05079'],
      Waitsfield: ['05673'],
      Wallingford: ['05773'],
      Wardsboro: ['05355'],
      Washgtin: ['05675'],
      Waterbury: ['05676'],
      'Waterbury Center': ['05677'],
      Waterville: ['05492'],
      Wells: ['05774'],
      'Wells River': ['05081'],
      'West Burke': ['05871'],
      'West Charleston': ['05872'],
      'West Danville': ['05873'],
      'West Fairlee': ['05083'],
      'West Glover': ['05875'],
      'West Halifax': ['05358'],
      'West Hartford': ['05084'],
      'West Pawlet': ['05775'],
      'West Rupert': ['05776'],
      'West Rutland': ['05777'],
      'West Topsham': ['05086'],
      'West Townshend': ['05359'],
      'West Wardsboro': ['05360'],
      Westfield: ['05874'],
      Westford: ['05494'],
      Weston: ['05161'],
      'White River Junc': ['05001'],
      Whitingham: ['05361'],
      Williamstown: ['05679'],
      Williamsville: ['05362'],
      Williston: ['05495'],
      Wilmington: ['05363'],
      Windsor: ['05089'],
      Winooski: ['05404'],
      Wolcott: ['05680'],
      Woodbury: ['05681'],
      Woodstock: ['05091'],
      Worcester: ['05682'],
    },
    name: 'Vermont',
  },
  WA: {
    cities: {
      Aberdeen: [98520],
      Acme: [98220],
      Addy: [99101],
      Algona: [98001],
      Allyn: [98524],
      Almira: [99103],
      'Amanda Park': [98526],
      Amboy: [98601],
      Anacortes: [98221],
      Anatone: [99401],
      'Anderson Island': [98303],
      Appleton: [98602],
      Ariel: [98603],
      Arlington: [98223],
      Ashford: [98304],
      Asotin: [99402],
      Auburn: [98002],
      'Bainbridge Islan': [98110],
      Baring: [98224],
      'Battle Ground': [98604],
      'Bear Creek': [98528],
      'Beaux Arts': [98004],
      Beaver: [98305],
      Bellevue: [98005, 98006, 98007, 98008],
      Bellingham: [98225, 98226],
      Benge: [99105],
      'Benton City': [99320],
      Beverly: [99321],
      Bickleton: [99322],
      'Black Diamond': [98010],
      Blaine: [98230],
      'Bonney Lake': [98390],
      Bothell: [98011, 98021],
      Bow: [98232],
      Boyds: [99107],
      Bremerton: [98310, 98312],
      Brewster: [98812],
      Bridgeport: [98813],
      Brier: [98036],
      Brinnon: [98320],
      'Brush Prairie': [98606],
      Buckley: [98321],
      Burien: [98146],
      Burlington: [98233],
      Camas: [98607],
      Carbonado: [98323],
      Carlton: [98814],
      Carnation: [98014],
      Carson: [98610],
      'Cascade Park': [98684],
      Cashmere: [98815],
      'Castle Rock': [98611],
      Cathlamet: [98612],
      Centerville: [98613],
      Centralia: [98531],
      Chattaroy: [99003],
      Chehalis: [98532],
      Chelan: [98816],
      Cheney: [99004],
      Chewelah: [99109],
      Chimacum: [98325],
      Cinebar: [98533],
      'Clallam Bay': [98326],
      Clarkston: [99403],
      Clayton: [99110],
      'Cle Elum': [98922],
      Clinton: [98236],
      Colbert: [99005],
      Colfax: [99111],
      'College Place': [99324],
      Colton: [99113],
      Colville: [99114],
      Concrete: [98237],
      Connell: [99326],
      Cook: [98605],
      'Copalis Beach': [98535],
      'Copalis Crossing': [98536],
      Cosmopolis: [98537],
      Cougar: [98616],
      'Coulee City': [99115],
      'Coulee Dam': [99116],
      Coupeville: [98239],
      Cowiche: [98923],
      Creston: [99117],
      Cunningham: [99327],
      Curlew: [99118],
      Curtis: [98538],
      Cusick: [99119],
      Custer: [98240],
      Danville: [99121],
      Darrington: [98241],
      Davenport: [99122],
      Dayton: [99328],
      'Deer Park': [99006],
      'Des Moines': [98198],
      Duvall: [98019],
      'East Wenatchee': [98802],
      Eastsound: [98245],
      Eatonville: [98328],
      Edmonds: [98026],
      Edwall: [99008],
      Elbe: [98330],
      'Electric City': [99123],
      Elk: [99009],
      Ellensburg: [98926],
      Elma: [98541],
      Eltopia: [99330],
      Endicott: [99125],
      Entiat: [98822],
      Enumclaw: [98022],
      Ephrata: [98823],
      Espanola: [99022],
      Ethel: [98542],
      Evans: [99126],
      Everett: [98201, 98203, 98204, 98205, 98208],
      Everson: [98247],
      'Fairchild Air Fo': [99011],
      Fairfield: [99012],
      'Fall City': [98024],
      Farmington: [99128],
      'Federal Way': [98003, 98023],
      Felida: [98685],
      Ferndale: [98248],
      Fife: [98424],
      Fircrest: [98466],
      Ford: [99013],
      Forks: [98331],
      'Fort Lewis': [98433],
      'Fox Island': [98333],
      Freeland: [98249],
      'Friday Harbor': [98250],
      Fruitland: [99129],
      Garfield: [99130],
      Gifford: [99131],
      'Gig Harbor': [98329, 98332, 98335],
      Glacier: [98244],
      Glenoma: [98336],
      Glenwood: [98619],
      Goldendale: [98620],
      Graham: [98338],
      'Grand Coulee': [99133],
      Grandview: [98930],
      Granger: [98932],
      'Granite Falls': [98252],
      Grapeview: [98546],
      Grayland: [98547],
      'Grays River': [98621],
      Greenacres: [99016],
      Greenbank: [98253],
      Hansville: [98340],
      Harrah: [98933],
      Harrington: [99134],
      Hartline: [99135],
      'Hazel Dell': [98665],
      Home: [98349],
      Hoodsport: [98548],
      Hoquiam: [98550],
      Humptulips: [98552],
      Hunters: [99137],
      Ilwaco: [98624],
      Inchelium: [99138],
      Ione: [99139],
      Issaquah: [98027],
      Kalama: [98625],
      Keller: [99140],
      Kelso: [98626],
      Kennewick: [99336, 99337],
      Kent: [98031, 98032, 98042],
      'Kettle Falls': [99141],
      Kingston: [98346],
      Kirkland: [98033, 98034],
      Klickitat: [98628],
      'La Center': [98629],
      'La Conner': [98257],
      Lacey: [98503, 98506],
      Lacrosse: [99143],
      'Lake Stevens': [98258],
      'Lakewood Center': [98439, 98498, 98499],
      Lamont: [99017],
      Langley: [98260],
      Latah: [99018],
      Leavenworth: [98826],
      'Liberty Lake': [99019],
      Lilliwaup: [98555],
      Lincoln: [99147],
      Lind: [99341],
      'Lk Forest Park': [98155],
      'Long Beach': [98631],
      Longbranch: [98351],
      Longview: [98632],
      Loomis: [98827],
      'Loon Lake': [99148],
      Lopez: [98261],
      Lowden: [99360],
      'Lummi Island': [98262],
      Lyle: [98635],
      Lyman: [98263],
      Lynden: [98264],
      Lynnwood: [98037],
      Mabton: [98935],
      Malaga: [98828],
      Malo: [99150],
      Mansfield: [98830],
      Manson: [98831],
      'Maple Valley': [98038],
      Marlin: [98832],
      Marysville: [98270, 98271],
      Matlock: [98560],
      Mattawa: [99344],
      Mazama: [98833],
      'Mc Cleary': [98557],
      Mead: [99021],
      'Mercer Island': [98040],
      Mesa: [99343],
      'Metaline Falls': [99153],
      Methow: [98834],
      Mica: [99023],
      'Mill Creek': [98012],
      Milton: [98354],
      Mineral: [98355],
      Moclips: [98562],
      Monroe: [98272],
      Montesano: [98563],
      Morton: [98356],
      'Moses Lake': [98837],
      Mossyrock: [98564],
      'Mount Vernon': [98273],
      'Mountlake Terrac': [98043],
      Moxee: [98936],
      Mukilteo: [98275],
      Naselle: [98638],
      'Newman Lake': [99025],
      Newport: [99156],
      'Nine Mile Falls': [99026],
      Nordland: [98358],
      'Normandy Park': [98148, 98166],
      'North Bend': [98045],
      Northport: [99157],
      'Oak Harbor': [98277],
      Oakesdale: [99158],
      Oakville: [98568],
      'Ocean City': [98569],
      'Ocean Park': [98640],
      Odessa: [99159],
      Okanogan: [98840],
      Olalla: [98359],
      Olga: [98279],
      Olympia: [98501, 98502],
      Omak: [98841],
      Onalaska: [98570],
      Orchards: [98662],
      Orondo: [98843],
      Oroville: [98844],
      Orting: [98360],
      'Otis Orchards': [99027],
      Outlook: [98938],
      Pacific: [98047],
      'Pacific Beach': [98571],
      Packwood: [98361],
      Palisades: [98845],
      Palouse: [99161],
      Parkland: [98444, 98445, 98446],
      Pasco: [99301],
      Pateros: [98846],
      Paterson: [99345],
      'Pe Ell': [98572],
      Peshastin: [98847],
      Plymouth: [99346],
      'Point Roberts': [98281],
      Pomeroy: [99347],
      'Port Angeles': [98362],
      'Port Hadlock': [98339],
      'Port Ludlow': [98365],
      'Port Townsend': [98368],
      Poulsbo: [98370],
      Prescott: [99348],
      Prosser: [99350],
      'Puget Sound Nava': [98314],
      Pullman: [99163],
      Puyallup: [98371, 98372, 98373, 98374],
      Quilcene: [98376],
      Quinault: [98575],
      Quincy: [98848],
      Rainier: [98576],
      Randle: [98377],
      Ravensdale: [98051],
      Raymond: [98577],
      Reardan: [99029],
      Redmond: [98052, 98053],
      Renton: [98055, 98056, 98058, 98059],
      Republic: [99166],
      Rice: [99167],
      Richland: [99352],
      Ridgefield: [98642],
      Ritzville: [99169],
      Riverside: [98849],
      Rochester: [98579],
      'Rock Island': [98850],
      Rockford: [99030],
      Rockport: [98283],
      Roosevelt: [99356],
      Rosalia: [99170],
      Rosburg: [98643],
      Roy: [98580],
      'Royal City': [99357],
      Ryderwood: [98581],
      'Saint John': [99171],
      Salkum: [98582],
      Seabeck: [98380],
      Seatac: [98158],
      Seattle: [
        98101, 98102, 98103, 98104, 98105, 98106, 98107, 98109, 98112, 98115,
        98116, 98117, 98118, 98119, 98121, 98122, 98125, 98126, 98133, 98134,
        98136, 98144, 98177, 98199,
      ],
      'Sedro Woolley': [98284],
      Sekiu: [98381],
      Selah: [98942],
      Sequim: [98382],
      Shelton: [98584],
      'Silver Creek': [98585],
      Silverdale: [98315, 98383],
      Silverlake: [98645],
      Skamokawa: [98647],
      Skykomish: [98288],
      Snohomish: [98290],
      Snoqualmie: [98065],
      'Soap Lake': [98851],
      'South Bend': [98586],
      'South Park Villa': [98366],
      Spanaway: [98387],
      Spangle: [99031],
      Spokane: [
        99201, 99202, 99203, 99204, 99205, 99206, 99207, 99208, 99212, 99216,
        99218, 99223,
      ],
      Sprague: [99032],
      Springdale: [99173],
      Stanwood: [98292],
      Stehekin: [98852],
      Steilacoom: [98388],
      Stevenson: [98648],
      Sultan: [98294],
      Sumas: [98295],
      Sunnyside: [98944],
      Suquamish: [98392],
      Tacoma: [
        98402, 98403, 98404, 98405, 98406, 98407, 98408, 98409, 98421, 98422,
        98443, 98465, 98467,
      ],
      Taholah: [98587],
      Tahuya: [98588],
      Tekoa: [99033],
      Tenino: [98589],
      'Terrace Heights': [98901],
      Thornton: [99176],
      Thorp: [98946],
      Tieton: [98947],
      Tokeland: [98590],
      Toledo: [98591],
      Tonasket: [98855],
      Toppenish: [98948],
      Toutle: [98649],
      'Trout Lake': [98650],
      Tukwila: [98108, 98168, 98178, 98188],
      Tumtum: [99034],
      Twisp: [98856],
      Underwood: [98651],
      Union: [98592],
      'Union Gap': [98903],
      Uniontown: [99179],
      Usk: [99180],
      Vader: [98593],
      Valley: [99181],
      Valleyford: [99036],
      Vancouver: [98660, 98661, 98663, 98664, 98682, 98686],
      Vashon: [98070],
      Vaughn: [98394],
      Veradale: [99037],
      Wahkiacus: [98670],
      Waitsburg: [99361],
      'Walla Walla': [99362],
      Wapato: [98951],
      Warden: [98857],
      Washougal: [98671],
      Washtucna: [99371],
      Waterville: [98858],
      Wauconda: [98859],
      Waverly: [99039],
      Wellpinit: [99040],
      Wenatchee: [98801],
      Westport: [98595],
      'Whidbey Island N': [98278],
      'White Pass': [98937],
      'White Salmon': [98672],
      'White Swan': [98952],
      'Wide Hollow': [98908],
      Wilbur: [99185],
      Winlock: [98596],
      Winthrop: [98862],
      Woodinville: [98072],
      Woodland: [98674],
      Woodway: [98020],
      Yacolt: [98675],
      Yakima: [98902],
      Yelm: [98597],
      Zillah: [98953],
    },
    name: 'Washington',
  },
  WI: {
    cities: {
      Abbotsford: [54405],
      Abrams: [54101],
      Adams: [53910],
      Adell: [53001],
      Albany: [53502],
      Algoma: [54201],
      Allenton: [53002],
      Allouez: [54301],
      Alma: [54610],
      'Alma Center': [54611],
      Almena: [54805],
      Almond: [54909],
      Altoona: [54720],
      Alvin: [54542],
      Amberg: [54102],
      Amherst: [54406],
      'Amherst Junction': [54407],
      Aniwa: [54408],
      Antigo: [54409],
      Appleton: [54911, 54914, 54915],
      Arcadia: [54612],
      Arena: [53503],
      Argyle: [53504],
      Arkansaw: [54721],
      Arkdale: [54613],
      Arlington: [53911],
      'Armstrong Creek': [54103],
      Arpin: [54410],
      Ashwaubenon: [54304],
      Athelstane: [54104],
      Auburndale: [54412],
      Augusta: [54722],
      Avalon: [53505],
      Avoca: [53506],
      Babcock: [54413],
      Bagley: [53801],
      'Baileys Harbor': [54202],
      Baldwin: [54002],
      'Balsam Lake': [54810],
      Bancroft: [54921],
      Bangor: [54614],
      Baraboo: [53913],
      Barnes: [54873],
      Barneveld: [53507],
      Barron: [54812],
      Barronett: [54813],
      'Bay City': [54723],
      'Bay View': [53207],
      Bayfield: [54814],
      'Bear Creek': [54922],
      Beaver: [54114],
      'Beaver Dam': [53916],
      Beldenville: [54003],
      Belgium: [53004],
      Belleville: [53508],
      Belmont: [53510],
      Benton: [53803],
      Berlin: [54923],
      'Big Bend': [53103],
      Birchwood: [54817],
      Birnamwood: [54414],
      'Black Earth': [53515],
      'Black River Fall': [54615],
      Blair: [54616],
      Blanchardville: [53516],
      'Bloom City': [54617],
      Bloomer: [54724],
      Bloomington: [53804],
      'Blue Mounds': [53517],
      'Blue River': [53518],
      Boscobel: [53805],
      'Boulder Junction': [54512],
      Bowler: [54416],
      Boyceville: [54725],
      Boyd: [54726],
      Brandon: [53919],
      Brantwood: [54513],
      Briggsville: [53920],
      Brillion: [54110],
      Bristol: [53104],
      Brodhead: [53520],
      Brookfield: [53005, 53045],
      Brooklyn: [53521],
      Browntown: [53522],
      Bruce: [54819],
      Brule: [54820],
      Brussels: [54204],
      Bryant: [54418],
      Burlington: [53105],
      Burnett: [53922],
      Butler: [53007],
      Butternut: [54514],
      Cable: [54821],
      Cadott: [54727],
      Caledonia: [53108],
      Cambria: [53923],
      Cambridge: [53523],
      Cameron: [54822],
      Campbellsport: [53010],
      Canton: [54868],
      Caroline: [54928],
      Cascade: [53011],
      Casco: [54205],
      Cashton: [54619],
      Cassville: [53806],
      Catawba: [54515],
      Cato: [54206],
      Cavour: [54511],
      Cazenovia: [53924],
      Cecil: [54111],
      'Cedar Grove': [53013],
      Cedarburg: [53012],
      'Center Valley': [54106],
      Centuria: [54824],
      Chaseburg: [54621],
      Chelsea: [54419],
      Chetek: [54728],
      Chili: [54420],
      Chilton: [53014],
      'Chippewa Falls': [54729],
      'Clam Falls': [54837],
      'Clam Lake': [54517],
      Clayton: [54004],
      'Clear Lake': [54005],
      Cleveland: [53015],
      Clinton: [53525],
      Clintonville: [54929],
      Cobb: [53526],
      Colby: [54421],
      Coleman: [54112],
      Colfax: [54730],
      Colgate: [53017],
      Coloma: [54930],
      Columbus: [53925],
      'Combined Locks': [54113],
      Comstock: [54826],
      Conover: [54519],
      Conrath: [54731],
      'Coon Valley': [54623],
      Cornell: [54732],
      Cornucopia: [54827],
      'Cottage Grove': [53527],
      Crandon: [54520],
      'Cross Plains': [53528],
      'Cuba City': [53807],
      Cudahy: [53110],
      Cumberland: [54829],
      Curtiss: [54422],
      Cushing: [54006],
      Custer: [54423],
      Cutler: [54618],
      Dairyland: [54830],
      Dallas: [54733],
      Dalton: [53926],
      Dane: [53529],
      Darien: [53114],
      Darlington: [53530],
      'De Forest': [53532],
      'De Pere': [54115],
      'Deer Park': [54007],
      Deerbrook: [54424],
      Deerfield: [53531],
      Delafield: [53018],
      Delavan: [53115],
      Delta: [54856],
      Denmark: [54208],
      Deronda: [54001],
      Dodge: [54625],
      Dodgeville: [53533],
      Dorchester: [54425],
      Dousman: [53118],
      Downing: [54734],
      Dresser: [54009],
      Drummond: [54832],
      Dunbar: [54119],
      Durand: [54736],
      Eagle: [53119],
      'Eagle River': [54521],
      Earl: [54875],
      'East Troy': [53120],
      Eastman: [54626],
      'Eau Claire': [54701, 54703],
      'Eau Galle': [54737],
      Eden: [53019],
      Edgerton: [53534],
      'Egg Harbor': [54209],
      Eland: [54427],
      Elcho: [54428],
      Eldorado: [54932],
      Eleva: [54738],
      'Elk Mound': [54739],
      'Elkhart Lake': [53020],
      Elkhorn: [53121],
      'Ellison Bay': [54210],
      Ellsworth: [54011],
      'Elm Grove': [53122],
      Elmwood: [54740],
      Elroy: [53929],
      Elton: [54430],
      Emerald: [54012],
      Endeavor: [53930],
      Ettrick: [54627],
      Evansville: [53536],
      Evergreen: [54840],
      Exeland: [54835],
      Fairchild: [54741],
      'Fall Creek': [54742],
      'Fall River': [53932],
      Fence: [54120],
      Fennimore: [53809],
      Fenwood: [54426],
      Ferryville: [54628],
      Fifield: [54524],
      'Fish Creek': [54212],
      Fitchburg: [53713],
      Florence: [54121],
      Fontana: [53125],
      'Forest Junction': [54123],
      Forestville: [54213],
      'Fort Atkinson': [53538],
      'Fountain City': [54629],
      'Fox Lake': [53933],
      Foxboro: [54836],
      'Francis Creek': [54214],
      Franklin: [53132],
      Franksville: [53126],
      Fremont: [54940],
      Friendship: [53934],
      Galesville: [54630],
      'Gays Mills': [54631],
      Genoa: [54632],
      'Genoa City': [53128],
      Germantown: [53022],
      Gillett: [54124],
      Gillingham: [53581],
      Gilman: [54433],
      Gleason: [54435],
      'Glen Haven': [53810],
      Glenbeulah: [53023],
      'Glenwood City': [54013],
      Glidden: [54527],
      Goodman: [54125],
      Gordon: [54838],
      Grafton: [53024],
      'Grand Marsh': [53936],
      'Grand View': [54839],
      Granton: [54436],
      Gratiot: [53541],
      'Green Bay': [54302, 54311, 54313],
      'Green Lake': [54941],
      Greendale: [53129],
      Greenfield: [53220, 53228],
      Greenleaf: [54126],
      Greenville: [54942],
      Greenwood: [54437],
      Gresham: [54128],
      'Hager City': [54014],
      'Hales Corners': [53130],
      Hamburg: [54411],
      Hammond: [54015],
      Hancock: [54943],
      Harshaw: [54529],
      Hartford: [53027],
      Hartland: [53029],
      Hatley: [54440],
      Hawkins: [54530],
      'Hazel Green': [53811],
      Hazelhurst: [54531],
      Helenville: [53137],
      Herbster: [54844],
      Hertel: [54845],
      Hewitt: [54441],
      'High Bridge': [54846],
      Highland: [53543],
      Hilbert: [54129],
      Hillpoint: [53937],
      Hillsdale: [54744],
      Holcombe: [54745],
      Hollandale: [53544],
      Holmen: [54636],
      Horicon: [53032],
      Hortonville: [54944],
      Howard: [54303],
      'Howards Grove': [53083],
      Hubertus: [53033],
      Hudson: [54016],
      Humbird: [54746],
      Hurley: [54534],
      Independence: [54747],
      Ingram: [54526],
      Iola: [54945],
      Irma: [54442],
      'Iron Belt': [54536],
      'Iron Ridge': [53035],
      'Iron River': [54847],
      Ixonia: [53036],
      Jackson: [53037],
      Janesville: [53545, 53546],
      Jefferson: [53549],
      'Jim Falls': [54748],
      'Johnson Creek': [53038],
      Juda: [53550],
      'Junction City': [54443],
      Juneau: [53039],
      Kansasville: [53139],
      Kaukauna: [54130],
      Kellnersville: [54215],
      Kendall: [54638],
      Kennan: [54537],
      Kenosha: [53140, 53142, 53143, 53144],
      Keshena: [54135],
      Kewaskum: [53040],
      Kewaunee: [54216],
      Kiel: [53042],
      Kimberly: [54136],
      King: [54946],
      Kingston: [53939],
      Knapp: [54749],
      Knowles: [53048],
      Kohler: [53044],
      Krakow: [54137],
      'La Crosse': [54601, 54603],
      'La Pointe': [54850],
      'La Valle': [53941],
      'Lac Du Flambeau': [54538],
      Ladysmith: [54848],
      'Lake Geneva': [53147],
      'Lake Mills': [53551],
      'Lake Nebagamon': [54849],
      'Lake Tomahawk': [54539],
      Lakewood: [54138],
      Lancaster: [53813],
      'Land O Lakes': [54540],
      Lannon: [53046],
      Laona: [54541],
      Larsen: [54947],
      Leopolis: [54948],
      Lily: [54445],
      Linden: [53553],
      'Little Chute': [54140],
      'Little Suamico': [54141],
      Livingston: [53554],
      Lodi: [53555],
      Loganville: [53943],
      'Lone Rock': [53556],
      Loretta: [54896],
      Lowell: [53557],
      Loyal: [54446],
      Lublin: [54447],
      Luck: [54853],
      Luxemburg: [54217],
      'Lyndon Station': [53944],
      Madison: [
        53703, 53704, 53705, 53706, 53711, 53714, 53715, 53717, 53718, 53719,
      ],
      'Maiden Rock': [54750],
      Malone: [53049],
      Manawa: [54949],
      'Manitowish Water': [54545],
      Manitowoc: [54220],
      Maple: [54854],
      Marathon: [54448],
      Marengo: [54855],
      Maribel: [54227],
      Marinette: [54143],
      Marion: [54950],
      Markesan: [53946],
      Marquette: [53947],
      Marshall: [53559],
      Marshfield: [54449],
      Mather: [54641],
      Mauston: [53948],
      Mayville: [53050],
      Mazomanie: [53560],
      'Mc Farland': [53558],
      Medford: [54451],
      Mellen: [54546],
      Melrose: [54642],
      Menasha: [54952],
      'Menomonee Falls': [53051],
      Menomonie: [54751],
      Mequon: [53092],
      Mercer: [54547],
      Merrill: [54452],
      Merrillan: [54754],
      Merrimac: [53561],
      Middleton: [53562],
      Milladore: [54454],
      Milltown: [54858],
      Milton: [53563],
      Milwaukee: [
        53202, 53203, 53204, 53205, 53206, 53208, 53209, 53210, 53212, 53216,
        53217, 53218, 53219, 53221, 53222, 53223, 53224, 53225, 53227, 53233,
      ],
      Mindoro: [54644],
      'Mineral Point': [53565],
      Minocqua: [54548],
      Minong: [54859],
      Mishicot: [54228],
      Modena: [54755],
      Monico: [54501],
      Monona: [53716],
      Monroe: [53566],
      Montello: [53949],
      Montfort: [53569],
      Monticello: [53570],
      Moquah: [54806],
      Mosinee: [54455],
      'Mount Calvary': [53057],
      'Mount Hope': [53816],
      'Mount Horeb': [53572],
      Mountain: [54149],
      Mukwonago: [53149],
      Muscoda: [53573],
      Muskego: [53150],
      Nashotah: [53058],
      Navarino: [54107],
      Necedah: [54646],
      Neenah: [54956],
      Neillsville: [54456],
      Nekoosa: [54457],
      Nelson: [54756],
      Neopit: [54150],
      Neosho: [53059],
      Neshkoro: [54960],
      'New Auburn': [54757],
      'New Berlin': [53146, 53151],
      'New Franken': [54229],
      'New Glarus': [53574],
      'New Holstein': [53061],
      'New Lisbon': [53950],
      'New London': [54961],
      'New Post': [54828],
      'New Richmond': [54017],
      Newton: [53063],
      Niagara: [54151],
      'North Fond Du La': [54937],
      'North Freedom': [53951],
      'North Prairie': [53153],
      'North Woods Beac': [54843],
      Northfield: [54635],
      Norwalk: [54648],
      'Oak Creek': [53154],
      Oakfield: [53065],
      Oconomowoc: [53066],
      Oconto: [54153],
      'Oconto Falls': [54154],
      Ogdensburg: [54962],
      Ogema: [54459],
      Ojibwa: [54862],
      Okauchee: [53069],
      Omro: [54963],
      Onalaska: [54650],
      Oneida: [54155],
      Ontario: [54651],
      Oostburg: [53070],
      Oregon: [53575],
      Orfordville: [53576],
      Osceola: [54020],
      Oshkosh: [54901, 54904],
      Osseo: [54758],
      Owen: [54460],
      Oxford: [53952],
      Palmyra: [53156],
      Pardeeville: [53954],
      'Park Falls': [54552],
      Pearson: [54462],
      'Pelican Lake': [54463],
      Pembine: [54156],
      Pence: [54550],
      Pepin: [54759],
      Peshtigo: [54157],
      Pewaukee: [53072],
      Phelps: [54554],
      Phillips: [54555],
      Pickerel: [54465],
      Pickett: [54964],
      'Pine River': [54965],
      Pittsville: [54466],
      Plain: [53577],
      Plainfield: [54966],
      Platteville: [53818],
      Plover: [54467],
      'Plum City': [54761],
      Plymouth: [53073],
      Poplar: [54864],
      'Port Edwards': [54469],
      'Port Washington': [53074],
      'Port Wing': [54865],
      Portage: [53901],
      Porterfield: [54159],
      Potosi: [53820],
      Pound: [54161],
      'Poy Sippi': [54967],
      Poynette: [53955],
      'Prairie Du Chien': [53821],
      'Prairie Du Sac': [53578],
      'Prairie Farm': [54762],
      Prentice: [54556],
      Prescott: [54021],
      Princeton: [54968],
      Pulaski: [54162],
      Racine: [53402, 53403, 53404, 53405, 53406],
      Radisson: [54867],
      Randolph: [53956],
      'Random Lake': [53075],
      Readstown: [54652],
      Redgranite: [54970],
      Reedsburg: [53959],
      Reedsville: [54230],
      Reeseville: [53579],
      Rewey: [53580],
      'Rib Lake': [54470],
      Richfield: [53076],
      Ridgeland: [54763],
      Ridgeway: [53582],
      Ringle: [54471],
      Rio: [53960],
      Ripon: [54971],
      'River Falls': [54022],
      Roberts: [54023],
      'Rock Springs': [53961],
      Rockland: [54653],
      Rosendale: [54974],
      Rosholt: [54473],
      Rothschild: [54474],
      Rubicon: [53078],
      Rudolph: [54475],
      'Saint Cloud': [53079],
      'Saint Croix Fall': [54024],
      'Saint Germain': [54558],
      'Saint Joseph': [54082],
      'Saint Nazianz': [54232],
      Salem: [53168],
      'Sand Creek': [54765],
      Sarona: [54870],
      'Sauk City': [53583],
      Saukville: [53080],
      Saxon: [54559],
      Sayner: [54560],
      Scandinavia: [54977],
      Schofield: [54476],
      Seymour: [54165],
      Sharon: [53585],
      Shawano: [54166],
      Sheboygan: [53081],
      'Sheboygan Falls': [53085],
      Sheldon: [54766],
      'Shell Lake': [54871],
      Shiocton: [54170],
      Shopiere: [53511],
      Shorewood: [53211],
      Shullsburg: [53586],
      Siren: [54872],
      'Sister Bay': [54234],
      Slinger: [53086],
      Sobieski: [54171],
      'Soldiers Grove': [54655],
      Somerset: [54025],
      'South Byron': [53006],
      'South Milwaukee': [53172],
      'South Wayne': [53587],
      Sparta: [54656],
      Spencer: [54479],
      Spooner: [54801],
      'Spring Green': [53588],
      'Spring Valley': [54767],
      Stanley: [54768],
      'Star Prairie': [54026],
      Stetsonville: [54480],
      Steuben: [54657],
      'Stevens Point': [54481],
      Stiles: [54139],
      Stitzer: [53825],
      Stockholm: [54769],
      Stoddard: [54658],
      'Stone Lake': [54876],
      Stoughton: [53589],
      Stratford: [54484],
      Strum: [54770],
      'Sturgeon Bay': [54235],
      Sturtevant: [53177],
      Sullivan: [53178],
      'Summit Lake': [54485],
      'Sun Prairie': [53590],
      Superior: [54880],
      Suring: [54174],
      Sussex: [53089],
      Taycheedah: [54935],
      Taylor: [54659],
      Theresa: [53091],
      Thorp: [54771],
      'Three Lakes': [54562],
      Tigerton: [54486],
      Tilleda: [54978],
      Tomahawk: [54487],
      Tony: [54563],
      Townsend: [54175],
      Trego: [54888],
      Trempealeau: [54661],
      Trevor: [53179],
      Tripoli: [54564],
      'Turtle Lake': [54889],
      'Twin Lakes': [53181],
      'Two Rivers': [54241],
      Underhill: [54176],
      'Union Grove': [53182],
      Unity: [54488],
      Upson: [54565],
      Valders: [54245],
      'Van Dyne': [54979],
      Verona: [53593],
      Vesper: [54489],
      Victory: [54624],
      Viola: [54664],
      Viroqua: [54665],
      Wabeno: [54566],
      Waldo: [53093],
      Wales: [53183],
      Walworth: [53184],
      Warrens: [54666],
      Washburn: [54891],
      'Washington Islan': [54246],
      Waterloo: [53594],
      Watertown: [53094],
      Waubeka: [53021],
      Waukesha: [53186, 53188],
      Waumandee: [54622],
      Waunakee: [53597],
      Waupaca: [54981],
      Waupun: [53963],
      Wausau: [54401],
      Wausaukee: [54177],
      Wautoma: [54982],
      Wauwatosa: [53213, 53226],
      Wauzeka: [53826],
      Webster: [54893],
      Wentworth: [54874],
      'West Allis': [53214],
      'West Bend': [53095],
      'West Lima': [54639],
      'West Milwaukee': [53215],
      'West Salem': [54669],
      Westboro: [54490],
      Westby: [54667],
      Westfield: [53964],
      Weyauwega: [54983],
      Weyerhaeuser: [54895],
      Wheeler: [54772],
      'White Lake': [54491],
      Whitehall: [54773],
      Whitelaw: [54247],
      Whitewater: [53190],
      'Wild Rose': [54984],
      Willard: [54493],
      'Williams Bay': [53191],
      Wilson: [54027],
      Wilton: [54670],
      Winchester: [54557],
      'Wind Lake': [53185],
      Windsor: [53598],
      Winneconne: [54986],
      'Wisconsin Dells': [53965],
      'Wisconsin Rapids': [54494],
      Withee: [54498],
      Wittenberg: [54499],
      Wonewoc: [53968],
      Woodman: [53827],
      Woodruff: [54568],
      Woodville: [54028],
      Wrightstown: [54180],
      Wyeville: [54660],
      Yuba: [54634],
    },
    name: 'Wisconsin',
  },
  WV: {
    cities: {
      24939: [24939],
      25242: [25242],
      25536: [25536],
      Abraham: [25918],
      Adrian: [26210],
      Advent: [25231],
      Albright: [26519],
      Alexander: [26218],
      Algoma: [24868],
      Alkol: [25501],
      'Alum Bridge': [26321],
      'Alum Creek': [25003],
      Alvy: [26322],
      Amboy: [26705],
      Ameagle: [25004],
      Amigo: [25811],
      Amma: [25005],
      Ansted: [25812],
      Anthony: [24938],
      'Apple Grove': [25502],
      Arbovale: [24915],
      Arbuckle: [25123],
      Arnett: [25007],
      Arnoldsburg: [25234],
      Arthur: [26816],
      Artie: [25008],
      Asbury: [24916],
      Asco: [24828],
      Ashford: [25009],
      Ashton: [25503],
      Athens: [24712],
      Auburn: [26325],
      Augusta: [26704],
      Auto: [24917],
      Baisden: [25608],
      Baker: [26801],
      'Bald Knob': [25010],
      Baldwin: [26351],
      Ballard: [24918],
      Ballengee: [24919],
      Bandytown: [25204],
      Barboursville: [25504],
      Barnabus: [25638],
      Barrett: [25013],
      Bartow: [24920],
      Baxter: [26560],
      Beaver: [25813],
      Beckley: [25801],
      Beeson: [24714],
      Belington: [26250],
      Belleville: [26133],
      Belva: [26656],
      'Bens Run': [26135],
      Bentree: [25018],
      Benwood: [26031],
      Berea: [26327],
      Bethany: [26032],
      Beverly: [26253],
      'Big Bend': [26136],
      'Big Chimney': [25302],
      'Big Creek': [25505],
      'Big Otter': [25113],
      'Big Run': [26561],
      Bim: [25021],
      'Birch River': [26610],
      Blacksville: [26521],
      Blandville: [26328],
      Bloomery: [26817],
      Bloomingrose: [25024],
      Blount: [25025],
      Bluewell: [24701],
      'Bob White': [25028],
      Boggs: [26299],
      Bolair: [26288],
      Bolt: [25817],
      Bomont: [25030],
      Bozoo: [24923],
      Bramwell: [24715],
      Branchland: [25506],
      Brandywine: [26802],
      Breeden: [25666],
      Brenton: [24818],
      Bridgeport: [26330],
      Bristol: [26332],
      Broaddus: [26416],
      Brohard: [26138],
      'Bruceton Mills': [26525],
      Buckeye: [24924],
      Buffalo: [25033],
      'Bunker Hill': [25413],
      Burlington: [26710],
      Burnwell: [25034],
      'Cabin Creek': [25035],
      Cabins: [26855],
      Cairo: [26337],
      Caldwell: [24925],
      Calvin: [26660],
      Camden: [26338],
      Cameron: [26033],
      'Camp Creek': [25820],
      Canvas: [26662],
      'Capon Bridge': [26711],
      Carbon: [25122],
      Cascade: [26542],
      'Cedar Grove': [25039],
      'Center Point': [26339],
      Century: [26214],
      Chapmanville: [25508],
      'Charles Town': [25414],
      Charleston: [25301, 25304, 25311, 25312, 25314],
      Charmco: [25958],
      'Cherry Run': [25427],
      Chester: [26034],
      Circleville: [26804],
      Clay: [25043],
      'Clear Creek': [25044],
      'Clear Fork': [24822],
      Clem: [26623],
      Cleveland: [26215],
      Clifftop: [25831],
      Clintonville: [24928],
      Clio: [25046],
      Clothier: [25047],
      'Coal Mountain': [24823],
      Coalton: [26257],
      Coburn: [26562],
      Colcord: [25048],
      Colliers: [26035],
      Comfort: [25049],
      'Cool Ridge': [25825],
      Copen: [26615],
      Core: [26529],
      Corinth: [26713],
      Corley: [26621],
      Costa: [25051],
      Cottageville: [25239],
      'Cove Gap': [25534],
      Cowen: [26206],
      'Coxs Mills': [26342],
      'Crab Orchard': [25827],
      Craigsville: [26205],
      Crawford: [26343],
      Crawley: [24931],
      Creston: [26141],
      'Cross Lanes': [25313],
      Crum: [25669],
      Culloden: [25510],
      Cunard: [25840],
      Cyclone: [24827],
      Dallas: [26036],
      Daniels: [25832],
      Danville: [25053],
      Davin: [25617],
      Davis: [26260],
      Davisville: [26142],
      Dawson: [24910],
      Dehue: [25654],
      Delray: [26714],
      Diamond: [25015],
      Diana: [26217],
      Dille: [26617],
      Dingess: [25671],
      Dixie: [25059],
      Dorcas: [26847],
      Dorothy: [25060],
      Dott: [24736],
      Drennen: [26667],
      Droop: [24946],
      'Dry Creek': [25062],
      Dryfork: [26263],
      Duck: [25063],
      Duhring: [24747],
      Dunbar: [25064],
      Duncan: [25252],
      Dunlow: [25511],
      Dunmore: [24934],
      Durbin: [26264],
      Earling: [25632],
      'East Gulf': [25915],
      'East Lynn': [25512],
      Edmond: [25837],
      Eglon: [26716],
      Elgood: [24740],
      Elizabeth: [26143],
      'Elk Garden': [26717],
      Elkins: [26241],
      Ellamore: [26267],
      'Elm Grove': [26003],
      Elmira: [26618],
      Elton: [25965],
      Enterprise: [26568],
      Erbacon: [26203],
      Evans: [25241],
      Fairdale: [25839],
      Fairview: [26570],
      'Falling Rock': [25079],
      'Falling Waters': [25419],
      'Falls Mill': [26620],
      Fanrock: [24834],
      Farmington: [26571],
      Fenwick: [26202],
      Ferrellsburg: [25524],
      Fisher: [26818],
      'Five Forks': [26145],
      'Flat Top': [25841],
      Floe: [25235],
      Flower: [26611],
      Fola: [25019],
      Follansbee: [26037],
      Folsom: [26348],
      'Fort Ashby': [26719],
      'Fort Gay': [25514],
      'Fort Seybert': [26806],
      'Fort Spring': [24936],
      Foster: [25081],
      Frame: [25071],
      Franklin: [26807],
      'Fraziers Bottom': [25082],
      Friendly: [26146],
      'Gallipolis Ferry': [25515],
      Gandeeville: [25243],
      'Gap Mills': [24941],
      Garrison: [25209],
      Gassaway: [26624],
      'Gauley Bridge': [25085],
      'Gauley Mills': [26208],
      Gay: [25244],
      Gem: [26335],
      Gerrardstown: [25420],
      Ghent: [25843],
      Gilbert: [25621],
      Gilboa: [26671],
      Given: [25245],
      Glace: [24942],
      Glady: [26268],
      Glen: [25088],
      'Glen Dale': [26038],
      'Glen Daniel': [25844],
      'Glen Easton': [26039],
      'Glen Fork': [25845],
      'Glen Rogers': [25848],
      Glendon: [26626],
      Glenwood: [25520],
      Gordon: [25093],
      Gormania: [26720],
      Grafton: [26354],
      Grantsville: [26147],
      'Grassy Meadows': [24943],
      'Great Cacapon': [25422],
      'Green Bank': [24944],
      'Green Spring': [26722],
      'Green Sulphur Sp': [25966],
      Greenville: [24945],
      Greenwood: [26360],
      Griffithsville: [25521],
      Hambleton: [26269],
      Hamlin: [25523],
      Hampden: [25623],
      Hancock: [25411],
      Hanover: [24839],
      Hansford: [25103],
      Harman: [26270],
      Harmony: [25246],
      'Harpers Ferry': [25425],
      Harrison: [25105],
      Harvey: [25901],
      Hastings: [26419],
      Hazelgreen: [26367],
      Heaters: [26627],
      Helvetia: [26224],
      Henderson: [25106],
      Hendricks: [26271],
      Herndon: [24726],
      Hernshaw: [25107],
      Herold: [26601],
      Hewett: [25108],
      Hico: [25854],
      'High View': [26808],
      Highland: [26346],
      Hinton: [25951],
      Hopemont: [26764],
      Horner: [26372],
      'Horse Shoe Run': [26769],
      Hundred: [26575],
      Hunt: [25635],
      Huntington: [25701, 25702, 25703, 25704, 25705],
      Hurricane: [25526],
      Huttonsville: [26273],
      Iaeger: [24844],
      Independence: [26374],
      'Indian Mills': [24935],
      Indore: [25111],
      Inwood: [25428],
      Jacksonburg: [26377],
      'Jane Lew': [26378],
      Jesse: [24849],
      Job: [26296],
      Jodie: [26674],
      Jolo: [24850],
      Josephine: [25857],
      Julian: [25529],
      Junction: [26824],
      'Kanawha Falls': [25115],
      'Kanawha Head': [26228],
      Kasson: [26405],
      Kearneysville: [25430],
      Kegley: [24731],
      Kenova: [25530],
      Kentuck: [25249],
      Kerens: [26276],
      Kermit: [25674],
      'Keslers Cross La': [26675],
      Kessler: [25984],
      Kieffer: [24950],
      Kimberly: [25118],
      Kincaid: [25119],
      Kingwood: [26537],
      Kirby: [26729],
      Lahmansville: [26731],
      Lake: [25121],
      Lanham: [25159],
      Lansing: [25862],
      Lashmeet: [24733],
      Lavalette: [25535],
      Lawton: [25864],
      'Left Hand': [25251],
      Lehew: [26865],
      Leivasy: [26676],
      Lenore: [25676],
      Lerona: [25971],
      Lesage: [25537],
      Lester: [25865],
      Letart: [25253],
      'Letter Gap': [25255],
      Levels: [25431],
      Lewisburg: [24901],
      Liberty: [25124],
      Lima: [26383],
      Linden: [25256],
      Lindside: [24951],
      Linn: [26384],
      Littleton: [26581],
      Lizemores: [25125],
      Lobata: [25678],
      Lockney: [25258],
      Lookout: [25868],
      Looneyville: [25259],
      'Lost City': [26810],
      'Lost Creek': [26385],
      'Lost River': [26811],
      Lumberport: [26386],
      Maben: [25870],
      Mabie: [26278],
      Macfarlan: [26148],
      Madison: [25130],
      Mahone: [26362],
      Maidsville: [26541],
      Malden: [25306],
      Mammoth: [25132],
      Manheim: [26425],
      Mannington: [26582],
      Marfrance: [25981],
      Marianna: [24859],
      Marmet: [25315],
      Martinsburg: [25401],
      Mason: [25260],
      Matheny: [24860],
      Mathias: [26812],
      Maxwelton: [24957],
      Maysel: [25133],
      Maysville: [26833],
      'Mc Dowell': [24810],
      'Mc Mechen': [26040],
      Meador: [25682],
      'Meadow Bluff': [24958],
      'Meadow Bridge': [25976],
      'Meadow Creek': [25977],
      Meadowbrook: [26404],
      Medley: [26734],
      Metz: [26585],
      Middlebourne: [26149],
      Midkiff: [25540],
      Milam: [26838],
      'Mill Creek': [26280],
      Millstone: [25261],
      Millwood: [25262],
      Milton: [25541],
      Mineralwells: [26150],
      Mingo: [26294],
      'Minnehaha Spring': [24954],
      Minnora: [25268],
      Mohawk: [24862],
      Monongah: [26554],
      Monterville: [26282],
      Montgomery: [25136],
      Montrose: [26283],
      Morrisvale: [25565],
      Moundsville: [26041],
      'Mount Alto': [25264],
      'Mount Carbon': [25139],
      'Mount Clare': [26408],
      'Mount Hope': [25880],
      'Mount Lookout': [26678],
      'Mount Storm': [26739],
      'Mount Zion': [26151],
      Moyers: [26813],
      Mullens: [25882],
      Munday: [26152],
      Murraysville: [26153],
      Myra: [25544],
      Myrtle: [25670],
      Naoma: [25140],
      Napier: [26631],
      Nebo: [25141],
      Nellis: [25142],
      Neola: [24986],
      Nettie: [26681],
      'New Creek': [26743],
      'New Cumberland': [26047],
      'New England': [26181],
      'New Martinsville': [26155],
      'New Milton': [26411],
      Newberne: [26409],
      Newburg: [26410],
      Newell: [26050],
      Nicut: [26633],
      Nimitz: [25978],
      Nitro: [25143],
      Nobe: [26137],
      Normantown: [25267],
      'North Parkersbur': [26104],
      'North Spring': [24869],
      'Nutter Fort Ston': [26301],
      Oceana: [24870],
      Odd: [25902],
      'Old Fields': [26845],
      Ona: [25545],
      Onego: [26886],
      Orgas: [25148],
      Orlando: [26412],
      Ovapa: [25150],
      'Paden City': [26159],
      Palermo: [25546],
      Palestine: [26160],
      Parkersburg: [26101],
      Parsons: [26287],
      'Patterson Creek': [26753],
      'Paw Paw': [25434],
      Paynesville: [24873],
      'Pecks Mill': [25547],
      'Pence Springs': [24962],
      Perkins: [26634],
      Peterstown: [24963],
      Petroleum: [26161],
      Peytona: [25154],
      Pickaway: [24976],
      Pickens: [26230],
      Piedmont: [26750],
      Pigeon: [25164],
      Pineville: [24874],
      Pipestem: [25979],
      Pliny: [25158],
      Poe: [26683],
      'Point Pleasant': [25550],
      Points: [25437],
      'Pond Gap': [25160],
      Pool: [26684],
      Powellton: [25161],
      Prichard: [25555],
      Proctor: [26055],
      Pullman: [26421],
      Purgitsville: [26852],
      Pursglove: [26546],
      Quick: [25045],
      Rachel: [26587],
      Racine: [25165],
      Radnor: [25517],
      Rainelle: [25962],
      Ramage: [25114],
      Ramsey: [25912],
      Ranger: [25557],
      Ranson: [25438],
      Ravencliff: [25913],
      Ravenswood: [26164],
      Reader: [26167],
      'Red Creek': [26289],
      'Red House': [25168],
      Reedsville: [26547],
      Reedy: [25270],
      Renick: [24966],
      Replete: [26222],
      Richwood: [26261],
      Ridgeview: [25169],
      Riffle: [26619],
      Rig: [26836],
      Rio: [26755],
      Ripley: [25271],
      Riverton: [26814],
      Rivesville: [26588],
      Roanoke: [26423],
      Robertsburg: [25172],
      Robinette: [25607],
      Robson: [25173],
      'Rock Castle': [25272],
      'Rock Cave': [26234],
      'Rock Creek': [25174],
      Rockport: [26169],
      Romance: [25248],
      Romney: [26757],
      Ronceverte: [24970],
      Rosedale: [26636],
      Runa: [26679],
      Russelville: [26680],
      'Saint Albans': [25177],
      'Saint Marys': [26170],
      Salem: [26426],
      'Salt Rock': [25559],
      'Sand Ridge': [25274],
      Sandstone: [25985],
      Sandyville: [25275],
      Saulsville: [25876],
      Saxon: [25180],
      Scarbro: [25917],
      Scherr: [26726],
      'Scott Depot': [25560],
      Secondcreek: [24974],
      Selbyville: [26236],
      'Seneca Rocks': [26884],
      Seth: [25181],
      Shanks: [26761],
      'Shenandoah Junct': [25442],
      Shepherdstown: [25443],
      Sherman: [26173],
      Shinnston: [26431],
      Shock: [26638],
      Sias: [25563],
      Simon: [24882],
      Sissonville: [25320],
      Sistersville: [26175],
      'Slab Fork': [25920],
      Slanesville: [25444],
      Slatyfork: [26291],
      Smithfield: [26437],
      Smithville: [26178],
      Smoot: [24977],
      Sod: [25564],
      'South Charleston': [25303, 25309],
      Southside: [25187],
      Spanishburg: [25922],
      Spencer: [25276],
      'Spring Dale': [25986],
      Springfield: [26763],
      Squire: [24884],
      'Star City': [26505],
      'Statts Mills': [25279],
      Stephenson: [25928],
      Stickney: [25189],
      'Stony Bottom': [24927],
      'Stouts Mills': [26439],
      'Strange Creek': [26639],
      Streeter: [25969],
      Stumptown: [25280],
      'Sugar Grove': [26815],
      Sullivan: [25847],
      Sumerco: [25567],
      Summersville: [26651],
      'Summit Point': [25446],
      Surveyor: [25932],
      'Sweet Springs': [24980],
      Sweetland: [25568],
      Swiss: [26690],
      Sylvester: [25193],
      Talcott: [24981],
      Tallmansville: [26237],
      Tanner: [26179],
      Tariff: [25281],
      Tennerton: [26201],
      Tesla: [26629],
      Thacker: [25694],
      Thomas: [26292],
      Thornton: [26440],
      'Three Churches': [26765],
      Thurmond: [25936],
      Tioga: [26691],
      'Toll Gate': [26415],
      Tornado: [25202],
      Triadelphia: [26059],
      Trout: [24991],
      Troy: [26443],
      True: [25988],
      Tunnelton: [26444],
      'Turtle Creek': [25203],
      Uler: [25266],
      Union: [24983],
      'Upper Tract': [26866],
      Upperglade: [26266],
      'Valley Bend': [26293],
      'Valley Fork': [25283],
      'Valley Grove': [26060],
      Vallscreek: [24819],
      Van: [25206],
      Verner: [25650],
      Victor: [25938],
      Vienna: [26105],
      Volga: [26238],
      Wadestown: [26589],
      Waiteville: [24984],
      Walker: [26180],
      Walkersville: [26447],
      Wallace: [26448],
      Wallback: [25285],
      Walton: [25286],
      Wana: [26590],
      Wardensville: [26851],
      Waverly: [26184],
      Wayne: [25570],
      Wayside: [24985],
      Weirton: [26062],
      Welch: [24801],
      Wellsburg: [26070],
      Wendel: [26347],
      'West Columbia': [25287],
      'West Hamlin': [25571],
      'West Logan': [25601],
      'West Milford': [26451],
      'West Union': [26456],
      Weston: [26452],
      Wharncliffe: [25651],
      'White Oak': [25989],
      Whittaker: [25083],
      Wick: [26185],
      Wilbur: [26320],
      Wildcat: [26376],
      'Wiley Ford': [26767],
      Wileyville: [26186],
      'Williams Mountai': [25163],
      Williamson: [25661],
      Williamstown: [26187],
      'Willow Island': [26134],
      Wilsie: [26641],
      Wilsondale: [25699],
      'Winding Gulf': [25908],
      Winfield: [25213],
      Winifrede: [25214],
      'Wolf Summit': [26462],
      Wolfcreek: [24993],
      Woodville: [25572],
      Worthington: [26591],
      Wymer: [26254],
      Yawkey: [25573],
    },
    name: 'West Virginia',
  },
  WY: {
    cities: {
      82057: [82057],
      Acme: [82839],
      Afton: [83110],
      Aladdin: [82710],
      Albin: [82050],
      Alcova: [82620],
      Arapahoe: [82510],
      Arminto: [82630],
      Arvada: [82831],
      Auburn: [83111],
      Baggs: [82321],
      Bairoil: [82322],
      Banner: [82832],
      Basin: [82410],
      Bedford: [83112],
      Beulah: [82712],
      Bondurant: [82922],
      Boulder: [82923],
      Buffalo: [82834],
      Buford: [82052],
      Burlington: [82411],
      Burns: [82053],
      Carpenter: [82054],
      Casper: [82601, 82604, 82609],
      Centennial: [82055],
      Cheyenne: [82001, 82007, 82009],
      Chugwater: [82210],
      Clearmont: [82835],
      Cody: [82414],
      Cokeville: [83114],
      'Colter Bay': [83001],
      Cora: [82925],
      Crowheart: [82512],
      Daniel: [83115],
      Dayton: [82836],
      Deaver: [82421],
      'Devils Tower': [82714],
      Dixon: [82323],
      Douglas: [82633],
      Dubois: [82513],
      Encampment: [82325],
      Ethete: [82520],
      Etna: [83118],
      Evanston: [82930],
      Evansville: [82636],
      'Fishing Bridge': [82190],
      'Fort Bridger': [82933],
      'Fort Laramie': [82212],
      'Fort Washakie': [82514],
      'Four Corners': [82715],
      Freedom: [83120],
      Garrett: [82058],
      'Gas Hills': [82501],
      Gillette: [82716, 82731],
      Glendo: [82213],
      Glenrock: [82637],
      'Grass Creek': [82443],
      'Green River': [82935],
      Greybull: [82426],
      Grover: [83122],
      Guernsey: [82214],
      Hanna: [82327],
      Hartville: [82215],
      'Hawk Springs': [82217],
      Hulett: [82720],
      Hyattville: [82428],
      'Jay Em': [82219],
      'Jeffrey City': [82310],
      Jelm: [82063],
      Kaycee: [82639],
      Keeline: [82220],
      Kelly: [83011],
      Kemmerer: [83101],
      Kinnear: [82516],
      'La Barge': [83123],
      Lagrange: [82221],
      'Lance Creek': [82222],
      Laramie: [82051, 82070],
      Lingle: [82223],
      Lonetree: [82936],
      'Lost Springs': [82224],
      Lovell: [82431],
      Lusk: [82225],
      Lyman: [82937],
      Lysite: [82642],
      Manderson: [82432],
      Marbleton: [83113],
      'Mc Fadden': [82080],
      'Mc Kinnon': [82938],
      'Medicine Bow': [82329],
      Meeteetse: [82433],
      Meriden: [82081],
      Midwest: [82643],
      Moose: [83012],
      Moran: [83013],
      Newcastle: [82701],
      Osage: [82723],
      Oshoto: [82724],
      Otto: [82434],
      Parkman: [82838],
      Pavillion: [82523],
      'Pine Bluffs': [82082],
      'Pine Haven': [82721],
      Pinedale: [82941],
      Powell: [82435],
      Ranchester: [82844],
      Rawlins: [82301],
      Recluse: [82725],
      'Rock River': [82083],
      'Rock Springs': [82901],
      Rozet: [82727],
      'Ryan Park': [82331],
      Savery: [82332],
      Shawnee: [82229],
      Shell: [82441],
      Sheridan: [82801],
      Shoshoni: [82649],
      Sinclair: [82334],
      Smoot: [83126],
      Story: [82842],
      Sundance: [82729],
      'Ten Sleep': [82442],
      Thayne: [83127],
      'Tie Siding': [82084],
      Torrington: [82240],
      Upton: [82730],
      'Van Tassell': [82242],
      Veteran: [82243],
      Wamsutter: [82336],
      Wapiti: [82450],
      Wheatland: [82201],
      Wilson: [83014],
      Worland: [82401],
      Wright: [82732],
      Yoder: [82244],
    },
    name: 'Wyoming',
  },
  FM: {
    cities: {
      Pohnpei: [96941],
      Chuuk: [96942],
      Yap: [96943],
      Kosrae: [96944],
    },
    name: 'Federated States Of Micronesia',
  },
  GU: {
    cities: {
      Hagatna: [96910],
      Dededo: [96912],
      Barrigada: [96913],
      'Santa Rita': [96915],
      Merizo: [96916],
      Inarajan: [96917],
      'Agana Heights': [96919],
      Barrigada: [96921],
      Mangilao: [96923],
      Agat: [96928],
      Yigo: [96929],
      Tamuning: [96931],
      Hagatna: [96932],
    },
    name: 'Guam',
  },
  MH: {
    cities: {
      Majuro: [96960],
      Ebeye: [96970],
    },
    name: 'Marshall Islands',
  },
  MP: {
    cities: {
      Saipan: [96950],
      Rota: [96951],
      Tinian: [96952],
    },
    name: 'Northern Mariana Islands',
  },
  PW: {
    cities: {
      Ngerulmud: [96939],
      Koror: [96940],
    },
    name: 'Palau',
  },
  PR: {
    cities: {
      Adjuntas: ['00601'],
      Aguada: ['00602'],
      Aguadilla: ['00603', '00604', '00605'],
      Maricao: ['00606'],
      Anasco: ['00610'],
      Angeles: ['00611'],
      Arecibo: ['00612'],
      Arecibo: ['00613', '00614'],
      Bajadero: ['00616'],
      Barceloneta: ['00617'],
      Boqueron: ['00622'],
      'Cabo Rojo': ['00623'],
      Penuelas: ['00624'],
      Camuy: ['00627'],
      Castaner: ['00631'],
      Rosario: ['00636'],
      'Sabana Grande': ['00637'],
      Ciales: ['00638'],
      Utuado: ['00641'],
      Dorado: ['00646'],
      Ensenada: ['00647'],
      Florida: ['00650'],
      Garrochales: ['00652'],
      Guanica: ['00653'],
      Guayanilla: ['00656'],
      Hatillo: ['00659'],
      Hormigueros: ['00660'],
      Isabela: ['00662'],
      Jayuya: ['00664'],
      Lajas: ['00667'],
      Lares: ['00669'],
      'Las Marias': ['00670'],
      Manati: ['00674'],
      Moca: ['00676'],
      Rincon: ['00677'],
      Quebradillas: ['00678'],
      Mayaguez: ['00680'],
      Mayaguez: ['00681'],
      Mayaguez: ['00682'],
      'San German': ['00683'],
      'San Sebastian': ['00685'],
      Morovis: ['00687'],
      'Sabana Hoyos': ['00688'],
      'San Antonio': ['00690'],
      'Vega Alta': ['00692'],
      'Vega Baja': ['00693'],
      'Vega Baja': ['00694'],
      Yauco: ['00698'],
      'Aguas Buenas': ['00703'],
      Aguirre: ['00704'],
      Aibonito: ['00705'],
      Maunabo: ['00707'],
      Arroyo: ['00714'],
      Mercedita: ['00715'],
      Ponce: [
        '00716',
        '00717',
        '00728',
        '00730',
        '00731',
        '00732',
        '00733',
        '00734',
      ],
      Naguabo: ['00718'],
      Naranjito: ['00719'],
      Orocovis: ['00720'],
      Palmer: ['00721'],
      Patillas: ['00723'],
      Caguas: ['00725'],
      Caguas: ['00726'],
      Caguas: ['00727'],
      Canovanas: ['00729'],
      Ceiba: ['00735'],
      Cayey: ['00736', '00737'],
      Fajardo: ['00738'],
      Cidra: ['00739'],
      'Puerto Real': ['00740'],
      'Punta Santiago': ['00741'],
      'Roosevelt Roads': ['00742'],
      'Rio Blanco': ['00744'],
      'Rio Grande': ['00745'],
      Salinas: ['00751'],
      'San Lorenzo': ['00754'],
      'Santa Isabel': ['00757'],
      Vieques: ['00765'],
      Villalba: ['00766'],
      Yabucoa: ['00767'],
      Coamo: ['00769'],
      'Las Piedras': ['00771'],
      Loiza: ['00772'],
      Luquillo: ['00773'],
      Culebra: ['00775'],
      Juncos: ['00777'],
      Gurabo: ['00778'],
      'Coto Laurel': ['00780'],
      Comerio: ['00782'],
      Corozal: ['00783'],
      Guayama: ['00784', '00785'],
      'La Plata': ['00786'],
      Humacao: ['00791', '00792'],
      Barranquitas: ['00794'],
      'Juana Diaz': ['00795'],
      'Fort Buchanan': ['00934'],
      'San Juan': [
        '00901',
        '00902',
        '00906',
        '00907',
        '00908',
        '00909',
        '00910',
        '00911',
        '00912',
        '00913',
        '00914',
        '00915',
        '00916',
        '00917',
        '00918',
        '00919',
        '00920',
        '00921',
        '00922',
        '00923',
        '00924',
        '00925',
        '00926',
        '00927',
        '00928',
        '00929',
        '00930',
        '00931',
        '00933',
        '00935',
        '00936',
        '00937',
        '00939',
        '00940',
      ],
      'Toa Baja': ['00949', '00950', '00951'],
      'Sabana Seca': ['00952'],
      'Toa Alta': ['00953', '00954'],
      'San Juan': ['00955'],
      Bayamon: ['00956', '00957', '00958', '00959', '00960', '00961'],
      Catano: ['00962', '00963'],
      Guaynabo: ['00965', '00966', '00968', '00969', '00970', '00971'],
      'San Juan	San Juan': ['00975'],
      'Trujillo Alto': ['00976', '00977'],
      'Saint Just': ['00978'],
      Carolina: [
        '00979',
        '00981',
        '00982',
        '00983',
        '00984',
        '00985',
        '00986',
        '00987',
        '00988',
      ],
    },
    name: 'Puerto Rico',
  },
  VI: {
    cities: {
      'St Thomas': ['00801', '00802', '00803', '00804', '00805'],
      Christiansted: ['00820', '00821', '00822', '00823', '00824'],
      'St John': ['00830', '00831'],
      Frederiksted: ['00840', '00841'],
      Kingshill: ['00850', '00851'],
    },
    name: 'Virgin Islands',
  },
  AS: {
    cities: {
      'Pago Pago': [96799],
    },
    name: 'American Samoa',
  },
  'UM-89': {
    cities: {
      'Kingman Reef': [96898],
    },
    name: 'Kingman Reef',
  },
  'UM-71': {
    cities: {
      'Midway Atoll': [96898],
    },
    name: 'Midway Atoll',
  },
  'UM-81': {
    cities: {
      'Baker Island': [96898],
    },
    name: 'Baker Island',
  },
  'UM-84': {
    cities: {
      'Howland Island': [96898],
    },
    name: 'Howland Island',
  },
  'UM-86': {
    cities: {
      'Jarvis Island': [96898],
    },
    name: 'Jarvis Island',
  },
  'UM-67': {
    cities: {
      'Johnston Island': [96898],
    },
    name: 'Johnston Island',
  },
  'UM-76': {
    cities: {
      'Navassa Island': [96898],
    },
    name: 'Navassa Island',
  },
  'UM-95': {
    cities: {
      'Palmyra Atoll': [96898],
    },
    name: 'Palmyra Atoll',
  },
  UM: {
    cities: {
      'United States Minor Outlying Islands': [96898],
    },
    name: 'United States Minor Outlying Islands',
  },
  'UM-79': {
    cities: {
      'Wake Island': [96898],
    },
    name: 'Wake Island',
  },
};

export default STATES;
